webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(4);
	__webpack_require__(59);
	module.exports = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(91)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {;(function(window){
	var hadGlobal = 'Modernizr' in window;
	var oldGlobal = window.Modernizr;
	/*! modernizr 3.11.7 (Custom Build) | MIT *
	 * https://modernizr.com/download/?-audio-backgroundsize-borderimage-borderradius-boxshadow-canvas-canvastext-cssanimations-csscolumns-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-flexbox-fontface-generatedcontent-geolocation-hashchange-history-hsla-indexeddb-inlinesvg-input-inputtypes-localstorage-multiplebgs-opacity-postmessage-rgba-sessionstorage-smil-svg-svgclippaths-textshadow-video-webgl-websockets-websqldatabase-webworkers-addtest-domprefixes-hasevent-mq-prefixed-prefixes-setclasses-testallprops-testprop-teststyles !*/
	!function(e,t,n,r){function a(e,t){return typeof e===t}function o(e){var t=C.className,n=Modernizr._config.classPrefix||"";if(P&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(t+=" "+n+e.join(" "+n)),P?C.className.baseVal=t:C.className=t)}function s(e,t){if("object"==typeof e)for(var n in e)A(e,n)&&s(n,e[n]);else{e=e.toLowerCase();var r=e.split("."),a=Modernizr[r[0]];if(2===r.length&&(a=a[r[1]]),void 0!==a)return Modernizr;t="function"==typeof t?t():t,1===r.length?Modernizr[r[0]]=t:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=t),o([(t&&!1!==t?"":"no-")+r.join("-")]),Modernizr._trigger(e,t)}return Modernizr}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):P?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function d(){var e=n.body;return e||(e=i(P?"svg":"body"),e.fake=!0),e}function c(e,t,r,a){var o,s,c,l,u="modernizr",f=i("div"),p=d();if(parseInt(r,10))for(;r--;)c=i("div"),c.id=a?a[r]:u+(r+1),f.appendChild(c);return o=i("style"),o.type="text/css",o.id="s"+u,(p.fake?p:f).appendChild(o),p.appendChild(f),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(n.createTextNode(e)),f.id=u,p.fake&&(p.style.background="",p.style.overflow="hidden",l=C.style.overflow,C.style.overflow="hidden",C.appendChild(p)),s=t(f,e),p.fake&&p.parentNode?(p.parentNode.removeChild(p),C.style.overflow=l,C.offsetHeight):f.parentNode.removeChild(f),!!s}function l(e,n,r){var a;if("getComputedStyle"in t){a=getComputedStyle.call(t,e,n);var o=t.console;if(null!==a)r&&(a=a.getPropertyValue(r));else if(o){var s=o.error?"error":"log";o[s].call(o,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else a=!n&&e.currentStyle&&e.currentStyle[r];return a}function u(e,t){return!!~(""+e).indexOf(t)}function f(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function p(e,n){var a=e.length;if("CSS"in t&&"supports"in t.CSS){for(;a--;)if(t.CSS.supports(f(e[a]),n))return!0;return!1}if("CSSSupportsRule"in t){for(var o=[];a--;)o.push("("+f(e[a])+":"+n+")");return o=o.join(" or "),c("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"===l(e,null,"position")})}return r}function v(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function g(e,t,n,o){function s(){c&&(delete O.style,delete O.modElem)}if(o=!a(o,"undefined")&&o,!a(n,"undefined")){var d=p(e,n);if(!a(d,"undefined"))return d}for(var c,l,f,g,m,h=["modernizr","tspan","samp"];!O.style&&h.length;)c=!0,O.modElem=i(h.shift()),O.style=O.modElem.style;for(f=e.length,l=0;l<f;l++)if(g=e[l],m=O.style[g],u(g,"-")&&(g=v(g)),O.style[g]!==r){if(o||a(n,"undefined"))return s(),"pfx"!==t||g;try{O.style[g]=n}catch(e){}if(O.style[g]!==m)return s(),"pfx"!==t||g}return s(),!1}function m(e,t){return function(){return e.apply(t,arguments)}}function h(e,t,n){var r;for(var o in e)if(e[o]in t)return!1===n?e[o]:(r=t[e[o]],a(r,"function")?m(r,n||t):r);return!1}function y(e,t,n,r,o){var s=e.charAt(0).toUpperCase()+e.slice(1),i=(e+" "+$.join(s+" ")+s).split(" ");return a(t,"string")||a(t,"undefined")?g(i,t,r,o):(i=(e+" "+_.join(s+" ")+s).split(" "),h(i,t,n))}function T(e,t,n){return y(e,r,r,t,n)}function b(e,t){var n=e.deleteDatabase(t);n.onsuccess=function(){s("indexeddb.deletedatabase",!0)},n.onerror=function(){s("indexeddb.deletedatabase",!1)}}var w=[],x={_version:"3.11.7",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){w.push({name:e,fn:t,options:n})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=x,Modernizr=new Modernizr;var S=[],C=n.documentElement,P="svg"===C.nodeName.toLowerCase(),k="Moz O ms Webkit",_=x._config.usePrefixes?k.toLowerCase().split(" "):[];x._domPrefixes=_;var E=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];x._prefixes=E;var A;!function(){var e={}.hasOwnProperty;A=a(e,"undefined")||a(e.call,"undefined")?function(e,t){return t in e&&a(e.constructor.prototype[t],"undefined")}:function(t,n){return e.call(t,n)}}(),x._l={},x.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},x._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e;for(e=0;e<n.length;e++)(0,n[e])(t)},0),delete this._l[e]}},Modernizr._q.push(function(){x.addTest=s});var R=function(){function e(e,n){var a;return!!e&&(n&&"string"!=typeof n||(n=i(n||"div")),e="on"+e,a=e in n,!a&&t&&(n.setAttribute||(n=i("div")),n.setAttribute(e,""),a="function"==typeof n[e],n[e]!==r&&(n[e]=r),n.removeAttribute(e)),a)}var t=!("onblur"in C);return e}();x.hasEvent=R;var z=function(){var e=t.matchMedia||t.msMatchMedia;return e?function(t){var n=e(t);return n&&n.matches||!1}:function(e){var t=!1;return c("@media "+e+" { #modernizr { position: absolute; } }",function(e){t="absolute"===l(e,null,"position")}),t}}();x.mq=z;var $=x._config.usePrefixes?k.split(" "):[];x._cssomPrefixes=$;var N={elem:i("modernizr")};Modernizr._q.push(function(){delete N.elem});var O={style:N.elem.style};Modernizr._q.unshift(function(){delete O.style}),x.testAllProps=y;var B=function(e){var n,a=E.length,o=t.CSSRule;if(void 0===o)return r;if(!e)return!1;if(e=e.replace(/^@/,""),(n=e.replace(/-/g,"_").toUpperCase()+"_RULE")in o)return"@"+e;for(var s=0;s<a;s++){var i=E[s];if(i.toUpperCase()+"_"+n in o)return"@-"+i.toLowerCase()+"-"+e}return!1};x.atRule=B;var L=x.prefixed=function(e,t,n){return 0===e.indexOf("@")?B(e):(-1!==e.indexOf("-")&&(e=v(e)),t?y(e,t,n):y(e,"pfx"))};x.testAllProps=T;var I=x.testProp=function(e,t,n){return g([e],r,t,n)},M=x.testStyles=c;!function(){var e=i("audio");Modernizr.addTest("audio",function(){var t=!1;try{t=!!e.canPlayType,t&&(t=new Boolean(t))}catch(e){}return t});try{e.canPlayType&&(Modernizr.addTest("audio.ogg",e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,"")),Modernizr.addTest("audio.mp3",e.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/,"")),Modernizr.addTest("audio.opus",e.canPlayType('audio/ogg; codecs="opus"')||e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/,"")),Modernizr.addTest("audio.wav",e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,"")),Modernizr.addTest("audio.m4a",(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,"")))}catch(e){}}(),Modernizr.addTest("canvas",function(){var e=i("canvas");return!(!e.getContext||!e.getContext("2d"))}),Modernizr.addTest("canvastext",function(){return!1!==Modernizr.canvas&&"function"==typeof i("canvas").getContext("2d").fillText}),Modernizr.addTest("geolocation","geolocation"in navigator),Modernizr.addTest("hashchange",function(){return!1!==R("hashchange",t)&&(n.documentMode===r||n.documentMode>7)}),Modernizr.addTest("history",function(){var e=navigator.userAgent;return!!e&&((-1===e.indexOf("Android 2.")&&-1===e.indexOf("Android 4.0")||-1===e.indexOf("Mobile Safari")||-1!==e.indexOf("Chrome")||-1!==e.indexOf("Windows Phone")||"file:"===location.protocol)&&(t.history&&"pushState"in t.history))}),Modernizr.addAsyncTest(function(){var e;try{e=L("indexedDB",t)}catch(e){}if(e){var n,r="modernizr-"+Math.random();try{n=e.open(r)}catch(e){return void s("indexeddb",!1)}n.onerror=function(t){!n.error||"InvalidStateError"!==n.error.name&&"UnknownError"!==n.error.name?(s("indexeddb",!0),b(e,r)):(s("indexeddb",!1),t.preventDefault())},n.onsuccess=function(){s("indexeddb",!0),b(e,r)}}else s("indexeddb",!1)});var V=i("input"),j="autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),W={};Modernizr.input=function(e){for(var n=0,r=e.length;n<r;n++)W[e[n]]=!!(e[n]in V);return W.list&&(W.list=!(!i("datalist")||!t.HTMLDataListElement)),W}(j),function(){for(var e,t,a,o=["search","tel","url","email","datetime","date","month","week","time","datetime-local","number","range","color"],s=0;s<o.length;s++)V.setAttribute("type",e=o[s]),a="text"!==V.type&&"style"in V,a&&(V.value="1)",V.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(e)&&V.style.WebkitAppearance!==r?(C.appendChild(V),t=n.defaultView,a=t.getComputedStyle&&"textfield"!==t.getComputedStyle(V,null).WebkitAppearance&&0!==V.offsetHeight,C.removeChild(V)):/^(search|tel)$/.test(e)||(a=/^(url|email)$/.test(e)?V.checkValidity&&!1===V.checkValidity():"1)"!==V.value)),Modernizr.addTest("inputtypes."+e,!!a)}();var q=!0;try{t.postMessage({toString:function(){q=!1}},"*")}catch(e){}Modernizr.addTest("postmessage",new Boolean("postMessage"in t)),Modernizr.addTest("postmessage.structuredclones",q),Modernizr.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect),function(){var e=i("video");Modernizr.addTest("video",function(){var t=!1;try{t=!!e.canPlayType,t&&(t=new Boolean(t))}catch(e){}return t});try{e.canPlayType&&(Modernizr.addTest("video.ogg",e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,"")),Modernizr.addTest("video.h264",e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,"")),Modernizr.addTest("video.h265",e.canPlayType('video/mp4; codecs="hev1"').replace(/^no$/,"")),Modernizr.addTest("video.webm",e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")),Modernizr.addTest("video.vp9",e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,"")),Modernizr.addTest("video.hls",e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,"")),Modernizr.addTest("video.av1",e.canPlayType('video/mp4; codecs="av01"').replace(/^no$/,"")))}catch(e){}}(),Modernizr.addTest("webgl",function(){return"WebGLRenderingContext"in t});var U=!1;try{U="WebSocket"in t&&2===t.WebSocket.CLOSING}catch(e){}Modernizr.addTest("websockets",U),Modernizr.addTest("cssanimations",T("animationName","a",!0)),Modernizr.addTest("backgroundsize",T("backgroundSize","100%",!0)),Modernizr.addTest("borderimage",T("borderImage","url() 1",!0)),Modernizr.addTest("borderradius",T("borderRadius","0px",!0)),Modernizr.addTest("boxshadow",T("boxShadow","1px 1px",!0)),function(){Modernizr.addTest("csscolumns",function(){var e=!1,t=T("columnCount");try{e=!!t,e&&(e=new Boolean(e))}catch(e){}return e});for(var e,t,n=["Width","Span","Fill","Gap","Rule","RuleColor","RuleStyle","RuleWidth","BreakBefore","BreakAfter","BreakInside"],r=0;r<n.length;r++)e=n[r].toLowerCase(),t=T("column"+n[r]),"breakbefore"!==e&&"breakafter"!==e&&"breakinside"!==e||(t=t||T(n[r])),Modernizr.addTest("csscolumns."+e,t)}(),Modernizr.addTest("flexbox",T("flexBasis","1px",!0)),function(){var e=navigator.userAgent,t=e.match(/w(eb)?osbrowser/gi),n=e.match(/windows phone/gi)&&e.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9;return t||n}()?Modernizr.addTest("fontface",!1):M('@font-face {font-family:"font";src:url("https://")}',function(e,t){var r=n.getElementById("smodernizr"),a=r.sheet||r.styleSheet,o=a?a.cssRules&&a.cssRules[0]?a.cssRules[0].cssText:a.cssText||"":"",s=/src/i.test(o)&&0===o.indexOf(t.split(" ")[0]);Modernizr.addTest("fontface",s)}),M('#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}',function(e){Modernizr.addTest("generatedcontent",e.offsetHeight>=6)}),Modernizr.addTest("cssgradients",function(){for(var e,t="background-image:",n="",r=0,a=E.length-1;r<a;r++)e=0===r?"to ":"",n+=t+E[r]+"linear-gradient("+e+"left top, #9f9, white);";Modernizr._config.usePrefixes&&(n+=t+"-webkit-gradient(linear,left top,right bottom,from(#9f9),to(white));");var o=i("a"),s=o.style;return s.cssText=n,(""+s.backgroundImage).indexOf("gradient")>-1}),Modernizr.addTest("hsla",function(){var e=i("a").style;return e.cssText="background-color:hsla(120,40%,100%,.5)",u(e.backgroundColor,"rgba")||u(e.backgroundColor,"hsla")}),Modernizr.addTest("multiplebgs",function(){var e=i("a").style;return e.cssText="background:url(https://),url(https://),red url(https://)",/(url\s*\(.*?){3}/.test(e.background)}),Modernizr.addTest("opacity",function(){var e=i("a").style;return e.cssText=E.join("opacity:.55;"),/^0.55$/.test(e.opacity)}),Modernizr.addTest("cssreflections",T("boxReflect","above",!0)),Modernizr.addTest("rgba",function(){var e=i("a").style;return e.cssText="background-color:rgba(150,255,150,.5)",(""+e.backgroundColor).indexOf("rgba")>-1}),Modernizr.addTest("textshadow",I("textShadow","1px 1px")),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&T("transform","scale(1)",!0)});var G="CSS"in t&&"supports"in t.CSS,D="supportsCSS"in t;Modernizr.addTest("supports",G||D),Modernizr.addTest("csstransforms3d",function(){return!!T("perspective","1px",!0)}),Modernizr.addTest("csstransitions",T("transition","all",!0)),Modernizr.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(e){return!1}}),Modernizr.addTest("sessionstorage",function(){var e="modernizr";try{return sessionStorage.setItem(e,e),sessionStorage.removeItem(e),!0}catch(e){return!1}}),Modernizr.addTest("websqldatabase","openDatabase"in t);var H={}.toString;Modernizr.addTest("svgclippaths",function(){return!!n.createElementNS&&/SVGClipPath/.test(H.call(n.createElementNS("http://www.w3.org/2000/svg","clipPath")))}),Modernizr.addTest("inlinesvg",function(){var e=i("div");return e.innerHTML="<svg/>","http://www.w3.org/2000/svg"===("undefined"!=typeof SVGRect&&e.firstChild&&e.firstChild.namespaceURI)}),Modernizr.addTest("smil",function(){return!!n.createElementNS&&/SVGAnimate/.test(H.call(n.createElementNS("http://www.w3.org/2000/svg","animate")))}),Modernizr.addTest("webworkers","Worker"in t),function(){var e,t,n,r,o,s,i;for(var d in w)if(w.hasOwnProperty(d)){if(e=[],t=w[d],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(r=a(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)s=e[o],i=s.split("."),1===i.length?Modernizr[i[0]]=r:(Modernizr[i[0]]&&(!Modernizr[i[0]]||Modernizr[i[0]]instanceof Boolean)||(Modernizr[i[0]]=new Boolean(Modernizr[i[0]])),Modernizr[i[0]][i[1]]=r),S.push((r?"":"no-")+i.join("-"))}}(),o(S),delete x.addTest,delete x.addAsyncTest;for(var F=0;F<Modernizr._q.length;F++)Modernizr._q[F]();e.Modernizr=Modernizr}(window,window,document);
	module.exports = window.Modernizr;
	if (hadGlobal) { window.Modernizr = oldGlobal; }
	else { delete window.Modernizr; }
	})(window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * FormValidation (http://formvalidation.io)
	 * The best jQuery plugin to validate form fields. Support Bootstrap, Foundation, Pure, SemanticUI, UIKit and custom frameworks
	 *
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	
	// Register the namespace
	window.FormValidation = {
	    AddOn:     {},  // Add-ons
	    Framework: {},  // Supported frameworks
	    I18n:      {},  // i18n
	    Validator: {}   // Available validators
	};
	
	if (typeof jQuery === 'undefined') {
	    throw new Error('FormValidation requires jQuery');
	}
	
	(function($) {
	    var version = $.fn.jquery.split(' ')[0].split('.');
	    if ((+version[0] < 2 && +version[1] < 9) || (+version[0] === 1 && +version[1] === 9 && +version[2] < 1)) {
	        throw new Error('FormValidation requires jQuery version 1.9.1 or higher');
	    }
	}(jQuery));
	
	(function($) {
	    // TODO: Remove backward compatibility
	    /**
	     * Constructor
	     *
	     * @param {jQuery|String} form The form element or selector
	     * @param {Object} options The options
	     * @param {String} [namespace] The optional namespace which is used for data-{namespace}-xxx attributes and internal data.
	     * Currently, it's used to support backward version
	     * @constructor
	     */
	    FormValidation.Base = function(form, options, namespace) {
	        this.$form      = $(form);
	        this.options    = $.extend({}, $.fn.formValidation.DEFAULT_OPTIONS, options);
	        this._namespace = namespace || 'fv';
	
	        this.$invalidFields = $([]);    // Array of invalid fields
	        this.$submitButton  = null;     // The submit button which is clicked to submit form
	        this.$hiddenButton  = null;
	
	        // Validating status
	        this.STATUS_NOT_VALIDATED = 'NOT_VALIDATED';
	        this.STATUS_VALIDATING    = 'VALIDATING';
	        this.STATUS_INVALID       = 'INVALID';
	        this.STATUS_VALID         = 'VALID';
	        this.STATUS_IGNORED       = 'IGNORED';
	
	        // Default message
	        this.DEFAULT_MESSAGE      = $.fn.formValidation.DEFAULT_MESSAGE;
	
	        // Determine the event that is fired when user change the field value
	        // Most modern browsers supports input event except IE 7, 8.
	        // IE 9 supports input event but the event is still not fired if I press the backspace key.
	        // Get IE version
	        // https://gist.github.com/padolsey/527683/#comment-7595
	        this._ieVersion = (function() {
	            var v = 3, div = document.createElement('div'), a = div.all || [];
	            while (div.innerHTML = '<!--[if gt IE '+(++v)+']><br><![endif]-->', a[0]) {}
	            return v > 4 ? v : document.documentMode;
	        }());
	
	        var el = document.createElement('div');
	        this._changeEvent = (this._ieVersion === 9 || !('oninput' in el)) ? 'keyup' : 'input';
	
	        // The flag to indicate that the form is ready to submit when a remote/callback validator returns
	        this._submitIfValid = null;
	
	        // Field elements
	        this._cacheFields = {};
	
	        this._init();
	    };
	
	    FormValidation.Base.prototype = {
	        constructor: FormValidation.Base,
	
	        /**
	         * Check if the number of characters of field value exceed the threshold or not
	         *
	         * @param {jQuery} $field The field element
	         * @returns {Boolean}
	         */
	        _exceedThreshold: function($field) {
	            var ns        = this._namespace,
	                field     = $field.attr('data-' + ns + '-field'),
	                threshold = this.options.fields[field].threshold || this.options.threshold;
	            if (!threshold) {
	                return true;
	            }
	            var cannotType = $.inArray($field.attr('type'), ['button', 'checkbox', 'file', 'hidden', 'image', 'radio', 'reset', 'submit']) !== -1;
	            return (cannotType || $field.val().length >= threshold);
	        },
	
	        /**
	         * Init form
	         */
	        _init: function() {
	            var that    = this,
	                ns      = this._namespace,
	                options = {
	                    addOns:         {},
	                    autoFocus:      this.$form.attr('data-' + ns + '-autofocus'),
	                    button: {
	                        selector: this.$form.attr('data-' + ns + '-button-selector') || this.$form.attr('data-' + ns + '-submitbuttons'), // Support backward
	                        disabled: this.$form.attr('data-' + ns + '-button-disabled')
	                    },
	                    control: {
	                        valid:   this.$form.attr('data-' + ns + '-control-valid'),
	                        invalid: this.$form.attr('data-' + ns + '-control-invalid')
	                    },
	                    err: {
	                        clazz:     this.$form.attr('data-' + ns + '-err-clazz'),
	                        container: this.$form.attr('data-' + ns + '-err-container') || this.$form.attr('data-' + ns + '-container'), // Support backward
	                        parent:    this.$form.attr('data-' + ns + '-err-parent')
	                    },
	                    events: {
	                        formInit:         this.$form.attr('data-' + ns + '-events-form-init'),
	                        formPreValidate:  this.$form.attr('data-' + ns + '-events-form-prevalidate'),
	                        formError:        this.$form.attr('data-' + ns + '-events-form-error'),
	                        formReset:        this.$form.attr('data-' + ns + '-events-form-reset'),
	                        formSuccess:      this.$form.attr('data-' + ns + '-events-form-success'),
	                        fieldAdded:       this.$form.attr('data-' + ns + '-events-field-added'),
	                        fieldRemoved:     this.$form.attr('data-' + ns + '-events-field-removed'),
	                        fieldInit:        this.$form.attr('data-' + ns + '-events-field-init'),
	                        fieldError:       this.$form.attr('data-' + ns + '-events-field-error'),
	                        fieldReset:       this.$form.attr('data-' + ns + '-events-field-reset'),
	                        fieldSuccess:     this.$form.attr('data-' + ns + '-events-field-success'),
	                        fieldStatus:      this.$form.attr('data-' + ns + '-events-field-status'),
	                        localeChanged:    this.$form.attr('data-' + ns + '-events-locale-changed'),
	                        validatorError:   this.$form.attr('data-' + ns + '-events-validator-error'),
	                        validatorSuccess: this.$form.attr('data-' + ns + '-events-validator-success'),
	                        validatorIgnored: this.$form.attr('data-' + ns + '-events-validator-ignored')
	                    },
	                    excluded:      this.$form.attr('data-' + ns + '-excluded'),
	                    icon: {
	                        valid:      this.$form.attr('data-' + ns + '-icon-valid')      || this.$form.attr('data-' + ns + '-feedbackicons-valid'),      // Support backward
	                        invalid:    this.$form.attr('data-' + ns + '-icon-invalid')    || this.$form.attr('data-' + ns + '-feedbackicons-invalid'),    // Support backward
	                        validating: this.$form.attr('data-' + ns + '-icon-validating') || this.$form.attr('data-' + ns + '-feedbackicons-validating'), // Support backward
	                        feedback:   this.$form.attr('data-' + ns + '-icon-feedback')
	                    },
	                    live:          this.$form.attr('data-' + ns + '-live'),
	                    locale:        this.$form.attr('data-' + ns + '-locale'),
	                    message:       this.$form.attr('data-' + ns + '-message'),
	                    onPreValidate: this.$form.attr('data-' + ns + '-onprevalidate'),
	                    onError:       this.$form.attr('data-' + ns + '-onerror'),
	                    onReset:       this.$form.attr('data-' + ns + '-onreset'),
	                    onSuccess:     this.$form.attr('data-' + ns + '-onsuccess'),
	                    row: {
	                        selector: this.$form.attr('data-' + ns + '-row-selector') || this.$form.attr('data-' + ns + '-group'), // Support backward
	                        valid:    this.$form.attr('data-' + ns + '-row-valid'),
	                        invalid:  this.$form.attr('data-' + ns + '-row-invalid'),
	                        feedback: this.$form.attr('data-' + ns + '-row-feedback')
	                    },
	                    threshold:     this.$form.attr('data-' + ns + '-threshold'),
	                    trigger:       this.$form.attr('data-' + ns + '-trigger'),
	                    verbose:       this.$form.attr('data-' + ns + '-verbose'),
	                    fields:        {}
	                };
	
	            this.$form
	                // Disable client side validation in HTML 5
	                .attr('novalidate', 'novalidate')
	                .addClass(this.options.elementClass)
	                // Disable the default submission first
	                .on('submit.' + ns, function(e) {
	                    e.preventDefault();
	                    that.validate();
	                })
	                .on('click.' + ns, this.options.button.selector, function() {
	                    that.$submitButton  = $(this);
	                    // The user just click the submit button
	                    that._submitIfValid = true;
	                });
	
	            if (this.options.declarative === true || this.options.declarative === 'true') {
	                // Find all fields which have either "name" or "data-{namespace}-field" attribute
	                this.$form
	                    .find('[name], [data-' + ns + '-field]')
	                    .each(function() {
	                        var $field = $(this),
	                            field  = $field.attr('name') || $field.attr('data-' + ns + '-field'),
	                            opts   = that._parseOptions($field);
	                        if (opts) {
	                            $field.attr('data-' + ns + '-field', field);
	                            options.fields[field] = $.extend({}, opts, options.fields[field]);
	                        }
	                    });
	            }
	
	            this.options = $.extend(true, this.options, options);
	
	            // Normalize the err.parent option
	            if ('string' === typeof this.options.err.parent) {
	                this.options.err.parent = new RegExp(this.options.err.parent);
	            }
	
	            // Support backward
	            if (this.options.container) {
	                this.options.err.container = this.options.container;
	                delete this.options.container;
	            }
	            if (this.options.feedbackIcons) {
	                this.options.icon = $.extend(true, this.options.icon, this.options.feedbackIcons);
	                delete this.options.feedbackIcons;
	            }
	            if (this.options.group) {
	                this.options.row.selector = this.options.group;
	                delete this.options.group;
	            }
	            if (this.options.submitButtons) {
	                this.options.button.selector = this.options.submitButtons;
	                delete this.options.submitButtons;
	            }
	
	            // If the locale is not found, reset it to default one
	            if (!FormValidation.I18n[this.options.locale]) {
	                this.options.locale = $.fn.formValidation.DEFAULT_OPTIONS.locale;
	            }
	
	            // Parse the add-on options from HTML attributes
	            if (this.options.declarative === true || this.options.declarative === 'true') {
	                this.options = $.extend(true, this.options, { addOns: this._parseAddOnOptions() });
	            }
	
	            // When pressing Enter on any field in the form, the first submit button will do its job.
	            // The form then will be submitted.
	            // I create a first hidden submit button
	            this.$hiddenButton = $('<button/>')
	                                    .attr('type', 'submit')
	                                    .prependTo(this.$form)
	                                    .addClass('fv-hidden-submit')
	                                    .css({ display: 'none', width: 0, height: 0 });
	
	            this.$form
	                .on('click.' +  this._namespace, '[type="submit"]', function(e) {
	                    // #746: Check if the button click handler returns false
	                    if (!e.isDefaultPrevented()) {
	                        var $target = $(e.target),
	                            // The button might contain HTML tag
	                            $button = $target.is('[type="submit"]') ? $target.eq(0) : $target.parent('[type="submit"]').eq(0);
	
	                        // Don't perform validation when clicking on the submit button/input which
	                        // aren't defined by the 'button.selector' option
	                        if (that.options.button.selector && !$button.is(that.options.button.selector) && !$button.is(that.$hiddenButton)) {
	                            that.$form.off('submit.' + that._namespace).submit();
	                            // Fix the issue where 'formnovalidate' causes IE to send two postbacks to server
	                            return false;
	                        }
	                    }
	                });
	
	            for (var field in this.options.fields) {
	                this._initField(field);
	            }
	
	            // Init the add-ons
	            for (var addOn in this.options.addOns) {
	                if ('function' === typeof FormValidation.AddOn[addOn].init) {
	                    FormValidation.AddOn[addOn].init(this, this.options.addOns[addOn]);
	                }
	            }
	
	            this.$form.trigger($.Event(this.options.events.formInit), {
	                bv: this,   // Support backward
	                fv: this,
	                options: this.options
	            });
	
	            // Prepare the events
	            if (this.options.onPreValidate) {
	                this.$form.on(this.options.events.formPreValidate, function(e) {
	                    FormValidation.Helper.call(that.options.onPreValidate, [e]);
	                });
	            }
	            if (this.options.onSuccess) {
	                this.$form.on(this.options.events.formSuccess, function(e) {
	                    FormValidation.Helper.call(that.options.onSuccess, [e]);
	                });
	            }
	            if (this.options.onError) {
	                this.$form.on(this.options.events.formError, function(e) {
	                    FormValidation.Helper.call(that.options.onError, [e]);
	                });
	            }
	            if (this.options.onReset) {
	                this.$form.on(this.options.events.formReset, function(e) {
	                    FormValidation.Helper.call(that.options.onReset, [e]);
	                });
	            }
	        },
	
	        /**
	         * Init field
	         *
	         * @param {String|jQuery} field The field name or field element
	         */
	        _initField: function(field) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    fields = this.getFieldElements(field);
	                    fields.attr('data-' + ns + '-field', field);
	                    break;
	                default:
	                    break;
	            }
	
	            // We don't need to validate non-existing fields
	            if (fields.length === 0) {
	                return;
	            }
	
	            if (this.options.fields[field] === null || this.options.fields[field].validators === null) {
	                return;
	            }
	
	            var validators = this.options.fields[field].validators,
	                validatorName,
	                alias;
	            for (validatorName in validators) {
	                alias = validators[validatorName].alias || validatorName;
	                if (!FormValidation.Validator[alias]) {
	                    delete this.options.fields[field].validators[validatorName];
	                }
	            }
	            if (this.options.fields[field].enabled === null) {
	                this.options.fields[field].enabled = true;
	            }
	
	            var that      = this,
	                total     = fields.length,
	                type      = fields.attr('type'),
	                updateAll = (total === 1) || ('radio' === type) || ('checkbox' === type),
	                trigger   = this._getFieldTrigger(fields.eq(0)),
	                clazz     = this.options.err.clazz.split(' ').join('.'),
	                events    = $.map(trigger, function(item) {
	                    return item + '.update.' + ns;
	                }).join(' ');
	
	            for (var i = 0; i < total; i++) {
	                var $field    = fields.eq(i),
	                    row       = this.options.fields[field].row || this.options.row.selector,
	                    $parent   = $field.closest(row),
	                    // Allow user to indicate where the error messages are shown
	                    // Support backward
	                    container = ('function' === typeof (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container))
	                                ? (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container).call(this, $field, this)
	                                : (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container),
	                    $message  = (container && container !== 'tooltip' && container !== 'popover') ? $(container) : this._getMessageContainer($field, row);
	
	                if (container && container !== 'tooltip' && container !== 'popover') {
	                    $message.addClass(this.options.err.clazz);
	                }
	
	                // Remove all error messages and feedback icons
	                $message.find('.' + clazz + '[data-' + ns + '-validator][data-' + ns + '-for="' + field + '"]').remove();
	                $parent.find('i[data-' + ns + '-icon-for="' + field + '"]').remove();
	
	                // Whenever the user change the field value, mark it as not validated yet
	                $field.off(events).on(events, function() {
	                    that.updateStatus($(this), that.STATUS_NOT_VALIDATED);
	                });
	
	                // Create help block elements for showing the error messages
	                $field.data(ns + '.messages', $message);
	                for (validatorName in validators) {
	                    $field.data(ns + '.result.' + validatorName, this.STATUS_NOT_VALIDATED);
	
	                    if (!updateAll || i === total - 1) {
	                        $('<small/>')
	                            .css('display', 'none')
	                            .addClass(this.options.err.clazz)
	                            .attr('data-' + ns + '-validator', validatorName)
	                            .attr('data-' + ns + '-for', field)
	                            .attr('data-' + ns + '-result', this.STATUS_NOT_VALIDATED)
	                            .html(this._getMessage(field, validatorName))
	                            .appendTo($message);
	                    }
	
	                    // Init the validator
	                    alias = validators[validatorName].alias || validatorName;
	                    if ('function' === typeof FormValidation.Validator[alias].init) {
	                        FormValidation.Validator[alias].init(this, $field, this.options.fields[field].validators[validatorName], validatorName);
	                    }
	                }
	
	                // Prepare the feedback icons
	                if (this.options.fields[field].icon !== false && this.options.fields[field].icon !== 'false'
	                    && this.options.icon
	                    && this.options.icon.valid && this.options.icon.invalid && this.options.icon.validating
	                    && (!updateAll || i === total - 1))
	                {
	                    // $parent.removeClass(this.options.row.valid).removeClass(this.options.row.invalid).addClass(this.options.row.feedback);
	                    // Keep error messages which are populated from back-end
	                    $parent.addClass(this.options.row.feedback);
	                    var $icon = $('<i/>')
	                                    .css('display', 'none')
	                                    .addClass(this.options.icon.feedback)
	                                    .attr('data-' + ns + '-icon-for', field)
	                                    .insertAfter($field);
	
	                    // Store the icon as a data of field element
	                    (!updateAll ? $field : fields).data(ns + '.icon', $icon);
	
	                    if ('tooltip' === container || 'popover' === container) {
	                        (!updateAll ? $field : fields)
	                            .on(this.options.events.fieldError, function() {
	                                $parent.addClass('fv-has-tooltip');
	                            })
	                            .on(this.options.events.fieldSuccess, function() {
	                                $parent.removeClass('fv-has-tooltip');
	                            });
	
	                        $field
	                            // Show tooltip/popover message when field gets focus
	                            .off('focus.container.' + ns)
	                            .on('focus.container.' + ns, function() {
	                                that._showTooltip($(this), container);
	                            })
	                            // and hide them when losing focus
	                            .off('blur.container.' + ns)
	                            .on('blur.container.' + ns, function() {
	                                that._hideTooltip($(this), container);
	                            });
	                    }
	
	                    if ('string' === typeof this.options.fields[field].icon && this.options.fields[field].icon !== 'true') {
	                        $icon.appendTo($(this.options.fields[field].icon));
	                    } else {
	                        this._fixIcon($field, $icon);
	                    }
	                }
	            }
	
	            // Sort the validators by priority
	            var sortedByPriority = [];
	            for (validatorName in validators) {
	                alias = validators[validatorName].alias || validatorName;
	
	                // Determine the priority
	                validators[validatorName].priority = parseInt(validators[validatorName].priority
	                                                            || FormValidation.Validator[alias].priority
	                                                            || 1, 10);
	                sortedByPriority.push({
	                    validator: validatorName,
	                    priority: validators[validatorName].priority
	                });
	            }
	            sortedByPriority = sortedByPriority.sort(function(a, b) {
	                return a.priority - b.priority;
	            });
	
	            // Prepare the events
	            fields
	                .data(ns + '.validators', sortedByPriority)
	                .on(this.options.events.fieldSuccess, function(e, data) {
	                    var onSuccess = that.getOptions(data.field, null, 'onSuccess');
	                    if (onSuccess) {
	                        FormValidation.Helper.call(onSuccess, [e, data]);
	                    }
	                })
	                .on(this.options.events.fieldError, function(e, data) {
	                    var onError = that.getOptions(data.field, null, 'onError');
	                    if (onError) {
	                        FormValidation.Helper.call(onError, [e, data]);
	                    }
	                })
	                .on(this.options.events.fieldReset, function(e, data) {
	                    var onReset = that.getOptions(data.field, null, 'onReset');
	                    if (onReset) {
	                        FormValidation.Helper.call(onReset, [e, data]);
	                    }
	                })
	                .on(this.options.events.fieldStatus, function(e, data) {
	                    var onStatus = that.getOptions(data.field, null, 'onStatus');
	                    if (onStatus) {
	                        FormValidation.Helper.call(onStatus, [e, data]);
	                    }
	                })
	                .on(this.options.events.validatorError, function(e, data) {
	                    var onError = that.getOptions(data.field, data.validator, 'onError');
	                    if (onError) {
	                        FormValidation.Helper.call(onError, [e, data]);
	                    }
	                })
	                .on(this.options.events.validatorIgnored, function(e, data) {
	                    var onIgnored = that.getOptions(data.field, data.validator, 'onIgnored');
	                    if (onIgnored) {
	                        FormValidation.Helper.call(onIgnored, [e, data]);
	                    }
	                })
	                .on(this.options.events.validatorSuccess, function(e, data) {
	                    var onSuccess = that.getOptions(data.field, data.validator, 'onSuccess');
	                    if (onSuccess) {
	                        FormValidation.Helper.call(onSuccess, [e, data]);
	                    }
	                });
	
	            // Set live mode
	            this.onLiveChange(fields, 'live', function() {
	                if (that._exceedThreshold($(this))) {
	                    that.validateField($(this));
	                }
	            });
	
	            fields.trigger($.Event(this.options.events.fieldInit), {
	                bv: this,   // Support backward
	                fv: this,
	                field: field,
	                element: fields
	            });
	        },
	
	        /**
	         * Check if the field is excluded.
	         * Returning true means that the field will not be validated
	         *
	         * @param {jQuery} $field The field element
	         * @returns {Boolean}
	         */
	        _isExcluded: function($field) {
	            var ns           = this._namespace,
	                excludedAttr = $field.attr('data-' + ns + '-excluded'),
	                // I still need to check the 'name' attribute while initializing the field
	                field        = $field.attr('data-' + ns + '-field') || $field.attr('name');
	
	            switch (true) {
	                case (!!field && this.options.fields && this.options.fields[field] && (this.options.fields[field].excluded === 'true' || this.options.fields[field].excluded === true)):
	                case (excludedAttr === 'true'):
	                case (excludedAttr === ''):
	                    return true;
	
	                case (!!field && this.options.fields && this.options.fields[field] && (this.options.fields[field].excluded === 'false' || this.options.fields[field].excluded === false)):
	                case (excludedAttr === 'false'):
	                    return false;
	
	                case (!!field && this.options.fields && this.options.fields[field] && 'function' === typeof this.options.fields[field].excluded):
	                    return this.options.fields[field].excluded.call(this, $field, this);
	
	                case (!!field && this.options.fields && this.options.fields[field] && 'string' === typeof this.options.fields[field].excluded):
	                case (excludedAttr):
	                    return FormValidation.Helper.call(this.options.fields[field].excluded, [$field, this]);
	
	                default:
	                    if (this.options.excluded) {
	                        // Convert to array first
	                        if ('string' === typeof this.options.excluded) {
	                            this.options.excluded = $.map(this.options.excluded.split(','), function(item) {
	                                // Trim the spaces
	                                return $.trim(item);
	                            });
	                        }
	
	                        var length = this.options.excluded.length;
	                        for (var i = 0; i < length; i++) {
	                            if (('string' === typeof this.options.excluded[i] && $field.is(this.options.excluded[i]))
	                                || ('function' === typeof this.options.excluded[i] && this.options.excluded[i].call(this, $field, this) === true))
	                            {
	                                return true;
	                            }
	                        }
	                    }
	                    return false;
	            }
	        },
	
	        /**
	         * Get a field changed trigger event
	         *
	         * @param {jQuery} $field The field element
	         * @returns {String[]} The event names triggered on field change
	         */
	        _getFieldTrigger: function($field) {
	            var ns      = this._namespace,
	                trigger = $field.data(ns + '.trigger');
	            if (trigger) {
	                return trigger;
	            }
	
	            // IE10/11 auto fires input event of elements using the placeholder attribute
	            // https://connect.microsoft.com/IE/feedback/details/856700/
	            var type  = $field.attr('type'),
	                name  = $field.attr('data-' + ns + '-field'),
	                event = ('radio' === type || 'checkbox' === type || 'file' === type || 'SELECT' === $field.get(0).tagName)
	                        ? 'change'
	                        : (this._ieVersion >= 10 && $field.attr('placeholder') ? 'keyup' : this._changeEvent);
	            trigger   = ((this.options.fields[name] ? this.options.fields[name].trigger : null) || this.options.trigger || event).split(' ');
	
	            // Since the trigger data is used many times, I need to cache it to use later
	            $field.data(ns + '.trigger', trigger);
	
	            return trigger;
	        },
	
	        /**
	         * Get the error message for given field and validator
	         *
	         * @param {String} field The field name
	         * @param {String} validatorName The validator name
	         * @returns {String}
	         */
	        _getMessage: function(field, validatorName) {
	            if (!this.options.fields[field] || !this.options.fields[field].validators) {
	                return '';
	            }
	            var validators = this.options.fields[field].validators,
	                alias      = (validators[validatorName] && validators[validatorName].alias) ? validators[validatorName].alias : validatorName;
	            if (!FormValidation.Validator[alias]) {
	                return '';
	            }
	
	            switch (true) {
	                case !!validators[validatorName].message:
	                    return validators[validatorName].message;
	                case !!this.options.fields[field].message:
	                    return this.options.fields[field].message;
	                case !!this.options.message:
	                    return this.options.message;
	                case (!!FormValidation.I18n[this.options.locale] && !!FormValidation.I18n[this.options.locale][alias] && !!FormValidation.I18n[this.options.locale][alias]['default']):
	                    return FormValidation.I18n[this.options.locale][alias]['default'];
	                default:
	                    return this.DEFAULT_MESSAGE;
	            }
	        },
	
	        /**
	         * Get the element to place the error messages
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} row
	         * @returns {jQuery}
	         */
	        _getMessageContainer: function($field, row) {
	            if (!this.options.err.parent) {
	                throw new Error('The err.parent option is not defined');
	            }
	
	            var $parent = $field.parent();
	            if ($parent.is(row)) {
	                return $parent;
	            }
	
	            var cssClasses = $parent.attr('class');
	            if (!cssClasses) {
	                return this._getMessageContainer($parent, row);
	            }
	
	            if (this.options.err.parent.test(cssClasses)) {
	                return $parent;
	            }
	
	            return this._getMessageContainer($parent, row);
	        },
	
	        /**
	         * Parse the add-on options from HTML attributes
	         *
	         * @returns {Object}
	         */
	        _parseAddOnOptions: function() {
	            var ns     = this._namespace,
	                names  = this.$form.attr('data-' + ns + '-addons'),
	                addOns = this.options.addOns || {};
	
	            if (names) {
	                names = names.replace(/\s/g, '').split(',');
	                for (var i = 0; i < names.length; i++) {
	                    if (!addOns[names[i]]) {
	                        addOns[names[i]] = {};
	                    }
	                }
	            }
	
	            // Try to parse each add-on options
	            var addOn, attrMap, attr, option;
	            for (addOn in addOns) {
	                if (!FormValidation.AddOn[addOn]) {
	                    // Add-on is not found
	                    delete addOns[addOn];
	                    continue;
	                }
	
	                attrMap = FormValidation.AddOn[addOn].html5Attributes;
	                if (attrMap) {
	                    for (attr in attrMap) {
	                        option = this.$form.attr('data-' + ns + '-addons-' + addOn.toLowerCase() + '-' + attr.toLowerCase());
	                        if (option) {
	                            addOns[addOn][attrMap[attr]] = option;
	                        }
	                    }
	                }
	            }
	
	            return addOns;
	        },
	
	        /**
	         * Parse the validator options from HTML attributes
	         *
	         * @param {jQuery} $field The field element
	         * @returns {Object}
	         */
	        _parseOptions: function($field) {
	            var ns           = this._namespace,
	                field        = $field.attr('name') || $field.attr('data-' + ns + '-field'),
	                validators   = {},
	                aliasAttr    = new RegExp('^data-' + ns + '-([a-z]+)-alias$'),
	                validatorSet = $.extend({}, FormValidation.Validator),
	                validator,
	                v,          // Validator name
	                attrName,
	                enabled,
	                optionName,
	                optionAttrName,
	                optionValue,
	                html5AttrName,
	                html5AttrMap;
	
	            // Determine whether the alias validator is used by checking the data-fv-validator-alias attribute
	            $.each($field.get(0).attributes, function(i, attribute) {
	                if (attribute.value && aliasAttr.test(attribute.name)) {
	                    v = attribute.name.split('-')[2];
	                    if (validatorSet[attribute.value]) {
	                        validatorSet[v]       = validatorSet[attribute.value];
	                        validatorSet[v].alias = attribute.value;
	                    }
	                }
	            });
	
	            for (v in validatorSet) {
	                validator    = validatorSet[v];
	                attrName     = 'data-' + ns + '-' + v.toLowerCase(),
	                enabled      = $field.attr(attrName) + '';
	                html5AttrMap = ('function' === typeof validator.enableByHtml5) ? validator.enableByHtml5($field) : null;
	
	                if ((html5AttrMap && enabled !== 'false')
	                    || (html5AttrMap !== true && ('' === enabled || 'true' === enabled || attrName === enabled.toLowerCase())))
	                {
	                    // Try to parse the options via attributes
	                    validator.html5Attributes = $.extend({}, {
	                                                    message: 'message',
	                                                    onerror: 'onError',
	                                                    onreset: 'onReset',
	                                                    onsuccess: 'onSuccess',
	                                                    priority: 'priority',
	                                                    transformer: 'transformer'
	                                                }, validator.html5Attributes);
	                    validators[v] = $.extend({}, html5AttrMap === true ? {} : html5AttrMap, validators[v]);
	                    if (validator.alias) {
	                        validators[v].alias = validator.alias;
	                    }
	
	                    for (html5AttrName in validator.html5Attributes) {
	                        optionName     = validator.html5Attributes[html5AttrName];
	                        optionAttrName = 'data-' + ns + '-' + v.toLowerCase() + '-' + html5AttrName;
	                        optionValue    = $field.attr(optionAttrName);
	                        if (optionValue) {
	                            if ('true' === optionValue || optionAttrName === optionValue.toLowerCase()) {
	                                optionValue = true;
	                            } else if ('false' === optionValue) {
	                                optionValue = false;
	                            }
	                            validators[v][optionName] = optionValue;
	                        }
	                    }
	                }
	            }
	
	            var opts = {
	                    autoFocus:   $field.attr('data-' + ns + '-autofocus'),
	                    err:         $field.attr('data-' + ns + '-err-container') || $field.attr('data-' + ns + '-container'), // Support backward
	                    enabled:     $field.attr('data-' + ns + '-enabled'),
	                    excluded:    $field.attr('data-' + ns + '-excluded'),
	                    icon:        $field.attr('data-' + ns + '-icon') || $field.attr('data-' + ns + '-feedbackicons') || (this.options.fields && this.options.fields[field] ? this.options.fields[field].feedbackIcons : null), // Support backward
	                    message:     $field.attr('data-' + ns + '-message'),
	                    onError:     $field.attr('data-' + ns + '-onerror'),
	                    onReset:     $field.attr('data-' + ns + '-onreset'),
	                    onStatus:    $field.attr('data-' + ns + '-onstatus'),
	                    onSuccess:   $field.attr('data-' + ns + '-onsuccess'),
	                    row:         $field.attr('data-' + ns + '-row') || $field.attr('data-' + ns + '-group') || (this.options.fields && this.options.fields[field] ? this.options.fields[field].group : null), // Support backward
	                    selector:    $field.attr('data-' + ns + '-selector'),
	                    threshold:   $field.attr('data-' + ns + '-threshold'),
	                    transformer: $field.attr('data-' + ns + '-transformer'),
	                    trigger:     $field.attr('data-' + ns + '-trigger'),
	                    verbose:     $field.attr('data-' + ns + '-verbose'),
	                    validators:  validators
	                },
	                emptyOptions    = $.isEmptyObject(opts),        // Check if the field options are set using HTML attributes
	                emptyValidators = $.isEmptyObject(validators);  // Check if the field validators are set using HTML attributes
	
	            if (!emptyValidators || (!emptyOptions && this.options.fields && this.options.fields[field])) {
	                //opts.validators = validators;
	                return opts;
	            } else {
	                return null;
	            }
	        },
	
	        /**
	         * Called when all validations are completed
	         */
	        _submit: function() {
	            var isValid = this.isValid();
	            if (isValid === null) {
	                return;
	            }
	
	            var eventType = isValid ? this.options.events.formSuccess : this.options.events.formError,
	                e         = $.Event(eventType);
	
	            this.$form.trigger(e);
	
	            // Call default handler
	            // Check if whether the submit button is clicked
	            if (this.$submitButton) {
	                isValid ? this._onSuccess(e) : this._onError(e);
	            }
	        },
	
	        // ~~~~~~
	        // Events
	        // ~~~~~~
	
	        /**
	         * The default handler of error.form.fv event.
	         * It will be called when there is a invalid field
	         *
	         * @param {jQuery.Event} e The jQuery event object
	         */
	        _onError: function(e) {
	            if (e.isDefaultPrevented()) {
	                return;
	            }
	
	            if ('submitted' === this.options.live) {
	                // Enable live mode
	                this.options.live = 'enabled';
	
	                var that = this;
	                for (var field in this.options.fields) {
	                    (function(f) {
	                        var fields  = that.getFieldElements(f);
	                        if (fields.length) {
	                            that.onLiveChange(fields, 'live', function() {
	                                if (that._exceedThreshold($(this))) {
	                                    that.validateField($(this));
	                                }
	                            });
	                        }
	                    })(field);
	                }
	            }
	
	            // Determined the first invalid field which will be focused on automatically
	            var ns = this._namespace;
	            for (var i = 0; i < this.$invalidFields.length; i++) {
	                var $field    = this.$invalidFields.eq(i),
	                    autoFocus = this.isOptionEnabled($field.attr('data-' + ns + '-field'), 'autoFocus');
	                if (autoFocus) {
	                    // Focus the field
	                    $field.focus();
	                    break;
	                }
	            }
	        },
	
	        /**
	         * Called after validating a field element
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} [validatorName] The validator name
	         */
	        _onFieldValidated: function($field, validatorName) {
	            var ns            = this._namespace,
	                field         = $field.attr('data-' + ns + '-field'),
	                validators    = this.options.fields[field].validators,
	                counter       = {},
	                numValidators = 0,
	                data          = {
	                    bv: this,   // Support backward
	                    fv: this,
	                    field: field,
	                    element: $field,
	                    validator: validatorName,
	                    result: $field.data(ns + '.response.' + validatorName)
	                };
	
	            // Trigger an event after given validator completes
	            if (validatorName) {
	                switch ($field.data(ns + '.result.' + validatorName)) {
	                    case this.STATUS_INVALID:
	                        $field.trigger($.Event(this.options.events.validatorError), data);
	                        break;
	                    case this.STATUS_VALID:
	                        $field.trigger($.Event(this.options.events.validatorSuccess), data);
	                        break;
	                    case this.STATUS_IGNORED:
	                        $field.trigger($.Event(this.options.events.validatorIgnored), data);
	                        break;
	                    default:
	                        break;
	                }
	            }
	
	            counter[this.STATUS_NOT_VALIDATED] = 0;
	            counter[this.STATUS_VALIDATING]    = 0;
	            counter[this.STATUS_INVALID]       = 0;
	            counter[this.STATUS_VALID]         = 0;
	            counter[this.STATUS_IGNORED]       = 0;
	
	            for (var v in validators) {
	                if (validators[v].enabled === false) {
	                    continue;
	                }
	
	                numValidators++;
	                var result = $field.data(ns + '.result.' + v);
	                if (result) {
	                    counter[result]++;
	                }
	            }
	
	            // The sum of valid fields now also include ignored fields
	            if (counter[this.STATUS_VALID] + counter[this.STATUS_IGNORED] === numValidators) {
	                // Remove from the list of invalid fields
	                this.$invalidFields = this.$invalidFields.not($field);
	
	                $field.trigger($.Event(this.options.events.fieldSuccess), data);
	            }
	            // If all validators are completed and there is at least one validator which doesn't pass
	            else if ((counter[this.STATUS_NOT_VALIDATED] === 0 || !this.isOptionEnabled(field, 'verbose')) && counter[this.STATUS_VALIDATING] === 0 && counter[this.STATUS_INVALID] > 0) {
	                // Add to the list of invalid fields
	                this.$invalidFields = this.$invalidFields.add($field);
	
	                $field.trigger($.Event(this.options.events.fieldError), data);
	            }
	        },
	
	        /**
	         * The default handler of success.form.fv event.
	         * It will be called when all the fields are valid
	         *
	         * @param {jQuery.Event} e The jQuery event object
	         */
	        _onSuccess: function(e) {
	            if (e.isDefaultPrevented()) {
	                return;
	            }
	
	            // Submit the form
	            this.disableSubmitButtons(true).defaultSubmit();
	        },
	
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	        // Abstract methods
	        // Need to be implemented by sub-class that supports specific framework
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	        /**
	         * Specific framework might need to adjust the icon position
	         *
	         * @param {jQuery} $field The field element
	         * @param {jQuery} $icon The icon element
	         */
	        _fixIcon: function($field, $icon) {
	        },
	
	        /**
	         * Create a tooltip or popover
	         * It will be shown when focusing on the field
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} message The message
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _createTooltip: function($field, message, type) {
	        },
	
	        /**
	         * Destroy the tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _destroyTooltip: function($field, type) {
	        },
	
	        /**
	         * Hide a tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _hideTooltip: function($field, type) {
	        },
	
	        /**
	         * Show a tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _showTooltip: function($field, type) {
	        },
	
	        // ~~~~~~~~~~~~~~
	        // Public methods
	        // ~~~~~~~~~~~~~~
	
	        /**
	         * Submit the form using default submission.
	         * It also does not perform any validations when submitting the form
	         */
	        defaultSubmit: function() {
	            var ns = this._namespace;
	            if (this.$submitButton) {
	                // Create hidden input to send the submit buttons
	                $('<input/>')
	                    .attr({
	                        'type': 'hidden',
	                        name: this.$submitButton.attr('name')
	                    })
	                    .attr('data-' + ns + '-submit-hidden', '')
	                    .val(this.$submitButton.val())
	                    .appendTo(this.$form);
	            }
	
	            // Submit form
	            this.$form.off('submit.' + ns).submit();
	        },
	
	        /**
	         * Disable/enable submit buttons
	         *
	         * @param {Boolean} disabled Can be true or false
	         * @returns {FormValidation.Base}
	         */
	        disableSubmitButtons: function(disabled) {
	            if (!disabled) {
	                this.$form
	                    .find(this.options.button.selector)
	                        .removeAttr('disabled')
	                        .removeClass(this.options.button.disabled);
	            } else if (this.options.live !== 'disabled') {
	                // Don't disable if the live validating mode is disabled
	                this.$form
	                    .find(this.options.button.selector)
	                        .attr('disabled', 'disabled')
	                        .addClass(this.options.button.disabled);
	            }
	
	            return this;
	        },
	
	        /**
	         * Retrieve the field elements by given name
	         *
	         * @param {String} field The field name
	         * @returns {null|jQuery[]}
	         */
	        getFieldElements: function(field) {
	            if (!this._cacheFields[field]) {
	                if (this.options.fields[field] && this.options.fields[field].selector) {
	                    // Look for the field inside the form first
	                    var f = this.$form.find(this.options.fields[field].selector);
	                    // If not found, search in entire document
	                    this._cacheFields[field] = f.length ? f : $(this.options.fields[field].selector);
	                } else {
	                    this._cacheFields[field] = this.$form.find('[name="' + field + '"]');
	                }
	            }
	
	            return this._cacheFields[field];
	        },
	
	        /**
	         * Get the field value after applying transformer
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {String} validatorName The validator name
	         * @returns {String}
	         */
	        getFieldValue: function(field, validatorName) {
	            var $field, ns = this._namespace;
	            if ('string' === typeof field) {
	                $field = this.getFieldElements(field);
	                if ($field.length === 0) {
	                    return null;
	                }
	            } else {
	                $field = field;
	                field  = $field.attr('data-' + ns + '-field');
	            }
	
	            if (!field || !this.options.fields[field]) {
	                return $field.val();
	            }
	
	            var transformer = (this.options.fields[field].validators && this.options.fields[field].validators[validatorName]
	                                ? this.options.fields[field].validators[validatorName].transformer : null)
	                                || this.options.fields[field].transformer;
	            return transformer ? FormValidation.Helper.call(transformer, [$field, validatorName, this]) : $field.val();
	        },
	
	        /**
	         * Get the namespace
	         *
	         * @returns {String}
	         */
	        getNamespace: function() {
	            return this._namespace;
	        },
	
	        /**
	         * Get the field options
	         *
	         * @param {String|jQuery} [field] The field name or field element. If it is not set, the method returns the form options
	         * @param {String} [validator] The name of validator. It null, the method returns form options
	         * @param {String} [option] The option name
	         * @return {String|Object}
	         */
	        getOptions: function(field, validator, option) {
	            var ns = this._namespace;
	            if (!field) {
	                return option ? this.options[option] : this.options;
	            }
	            if ('object' === typeof field) {
	                field = field.attr('data-' + ns + '-field');
	            }
	            if (!this.options.fields[field]) {
	                return null;
	            }
	
	            var options = this.options.fields[field];
	            if (!validator) {
	                return option ? options[option] : options;
	            }
	            if (!options.validators || !options.validators[validator]) {
	                return null;
	            }
	
	            return option ? options.validators[validator][option] : options.validators[validator];
	        },
	
	        /**
	         * Get the validating result of field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {String} validatorName The validator name
	         * @returns {String} The status. Can be 'NOT_VALIDATED', 'VALIDATING', 'INVALID', 'VALID' or 'IGNORED'
	         */
	        getStatus: function(field, validatorName) {
	            var ns = this._namespace;
	            switch (typeof field) {
	                case 'object':
	                    return field.data(ns + '.result.' + validatorName);
	                case 'string':
	                /* falls through */
	                default:
	                    return this.getFieldElements(field).eq(0).data(ns + '.result.' + validatorName);
	            }
	        },
	
	        /**
	         * Check whether or not a field option is enabled
	         *
	         * @param {String} field The field name
	         * @param {String} option The option name, "verbose", "autoFocus", for example
	         * @returns {Boolean}
	         */
	        isOptionEnabled: function(field, option) {
	            if (this.options.fields[field] && (this.options.fields[field][option] === 'true' || this.options.fields[field][option] === true)) {
	                return true;
	            }
	            if (this.options.fields[field] && (this.options.fields[field][option] === 'false' || this.options.fields[field][option] === false)) {
	                return false;
	            }
	            return this.options[option] === 'true' || this.options[option] === true;
	        },
	
	        /**
	         * Check the form validity
	         *
	         * @returns {Boolean|null} Returns one of three values
	         * - true, if all fields are valid
	         * - false, if there is one invalid field
	         * - null, if there is at least one field which is not validated yet or being validated
	         */
	        isValid: function() {
	            for (var field in this.options.fields) {
	                var isValidField = this.isValidField(field);
	                if (isValidField === null) {
	                    return null;
	                }
	                if (isValidField === false) {
	                    return false;
	                }
	            }
	
	            return true;
	        },
	
	        /**
	         * Check if all fields inside a given container are valid.
	         * It's useful when working with a wizard-like such as tab, collapse
	         *
	         * @param {String|jQuery} container The container selector or element
	         * @returns {Boolean|null} Returns one of three values
	         * - true, if all fields inside the container are valid
	         * - false, if there is one invalid field inside the container
	         * - null, if the container consists of at least one field which is not validated yet or being validated
	         */
	        isValidContainer: function(container) {
	            var that       = this,
	                ns         = this._namespace,
	                fields     = [],
	                $container = ('string' === typeof container) ? $(container) : container;
	            if ($container.length === 0) {
	                return true;
	            }
	
	            $container.find('[data-' + ns + '-field]').each(function() {
	                var $field = $(this);
	                if (!that._isExcluded($field)) {
	                    fields.push($field);
	                }
	            });
	
	            var total = fields.length,
	                clazz = this.options.err.clazz.split(' ').join('.');
	            for (var i = 0; i < total; i++) {
	                var $f      = fields[i],
	                    field   = $f.attr('data-' + ns + '-field'),
	                    $errors = $f.data(ns + '.messages')
	                                .find('.' + clazz + '[data-' + ns + '-validator][data-' + ns + '-for="' + field + '"]');
	
	                if (this.options.fields && this.options.fields[field]
	                    && (this.options.fields[field].enabled === 'false' || this.options.fields[field].enabled === false))
	                {
	                    continue;
	                }
	
	                if ($errors.filter('[data-' + ns + '-result="' + this.STATUS_INVALID + '"]').length > 0) {
	                    return false;
	                }
	
	                // If the field is not validated
	                if ($errors.filter('[data-' + ns + '-result="' + this.STATUS_NOT_VALIDATED + '"]').length > 0
	                    || $errors.filter('[data-' + ns + '-result="' + this.STATUS_VALIDATING + '"]').length > 0)
	                {
	                    return null;
	                }
	            }
	
	            return true;
	        },
	
	        /**
	         * Check if the field is valid or not
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @returns {Boolean|null} Returns one of three values
	         * - true, if the field passes all validators
	         * - false, if the field doesn't pass any validator
	         * - null, if there is at least one validator which isn't validated yet or being validated
	         */
	        isValidField: function(field) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	            if (fields.length === 0 || !this.options.fields[field]
	                || this.options.fields[field].enabled === 'false' || this.options.fields[field].enabled === false)
	            {
	                return true;
	            }
	
	            var type  = fields.attr('type'),
	                total = ('radio' === type || 'checkbox' === type) ? 1 : fields.length,
	                $field, validatorName, status;
	            for (var i = 0; i < total; i++) {
	                $field = fields.eq(i);
	                if (this._isExcluded($field)) {
	                    continue;
	                }
	
	                for (validatorName in this.options.fields[field].validators) {
	                    if (this.options.fields[field].validators[validatorName].enabled === false) {
	                        continue;
	                    }
	
	                    status = $field.data(ns + '.result.' + validatorName);
	                    if (status === this.STATUS_VALIDATING || status === this.STATUS_NOT_VALIDATED) {
	                        return null;
	                    } else if (status === this.STATUS_INVALID) {
	                        return false;
	                    }
	                }
	            }
	
	            return true;
	        },
	
	        /**
	         * Detach a handler function for a field live change event
	         *
	         * @param {jQuery[]} $fields The field elements
	         * @param {String} namespace The event namespace
	         * @returns {FormValidation.Base}
	         */
	        offLiveChange: function($fields, namespace) {
	            if ($fields === null || $fields.length === 0) {
	                return this;
	            }
	
	            var ns      = this._namespace,
	                trigger = this._getFieldTrigger($fields.eq(0)),
	                events  = $.map(trigger, function(item) {
	                    return item + '.' + namespace + '.' + ns;
	                }).join(' ');
	
	            $fields.off(events);
	            return this;
	        },
	
	        /**
	         * Attach a handler function for a field live change event
	         *
	         * @param {jQuery[]} $fields The field elements
	         * @param {String} namespace The event namespace
	         * @param {Function} handler The handler function
	         * @returns {FormValidation.Base}
	         */
	        onLiveChange: function($fields, namespace, handler) {
	            if ($fields === null || $fields.length === 0) {
	                return this;
	            }
	
	            var ns      = this._namespace,
	                trigger = this._getFieldTrigger($fields.eq(0)),
	                events  = $.map(trigger, function(item) {
	                    return item + '.' + namespace + '.' + ns;
	                }).join(' ');
	
	            switch (this.options.live) {
	                case 'submitted':
	                    break;
	                case 'disabled':
	                    $fields.off(events);
	                    break;
	                case 'enabled':
	                /* falls through */
	                default:
	                    $fields.off(events).on(events, function(e) {
	                        handler.apply(this, arguments);
	                    });
	                    break;
	            }
	
	            return this;
	        },
	
	        /**
	         * Update the error message
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {String} validator The validator name
	         * @param {String} message The message
	         * @returns {FormValidation.Base}
	         */
	        updateMessage: function(field, validator, message) {
	            var ns      = this._namespace,
	                $fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    $fields = field;
	                    field   = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    $fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            var clazz = this.options.err.clazz.split(' ').join('.');
	            $fields.each(function() {
	                $(this)
	                    .data(ns + '.messages')
	                    .find('.' + clazz + '[data-' + ns + '-validator="' + validator + '"][data-' + ns + '-for="' + field + '"]').html(message);
	            });
	
	            return this;
	        },
	
	        /**
	         * Update all validating results of field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {String} status The status. Can be 'NOT_VALIDATED', 'VALIDATING', 'INVALID', 'VALID' or 'IGNORED'
	         * @param {String} [validatorName] The validator name. If null, the method updates validity result for all validators
	         * @returns {FormValidation.Base}
	         */
	        updateStatus: function(field, status, validatorName) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            if (!field || !this.options.fields[field]) {
	                return this;
	            }
	
	            if (status === this.STATUS_NOT_VALIDATED) {
	                // Reset the flag
	                // To prevent the form from doing submit when a deferred validator returns true while typing
	                this._submitIfValid = false;
	            }
	
	            var that  = this,
	                type  = fields.attr('type'),
	                row   = this.options.fields[field].row || this.options.row.selector,
	                total = ('radio' === type || 'checkbox' === type) ? 1 : fields.length,
	                clazz = this.options.err.clazz.split(' ').join('.');
	
	            for (var i = 0; i < total; i++) {
	                var $field       = fields.eq(i);
	                if (this._isExcluded($field)) {
	                    continue;
	                }
	
	                var $parent      = $field.closest(row),
	                    $message     = $field.data(ns + '.messages'),
	                    $allErrors   = $message.find('.' + clazz + '[data-' + ns + '-validator][data-' + ns + '-for="' + field + '"]'),
	                    $errors      = validatorName ? $allErrors.filter('[data-' + ns + '-validator="' + validatorName + '"]') : $allErrors,
	                    $icon        = $field.data(ns + '.icon'),
	                    // Support backward
	                    container    = ('function' === typeof (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container))
	                                    ? (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container).call(this, $field, this)
	                                    : (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container),
	                    isValidField = null,
	                    isValidating,
	                    isNotValidated;
	
	                // Update status
	                if (validatorName) {
	                    $field.data(ns + '.result.' + validatorName, status);
	                } else {
	                    for (var v in this.options.fields[field].validators) {
	                        $field.data(ns + '.result.' + v, status);
	                    }
	                }
	
	                // Show/hide error elements and feedback icons
	                $errors.attr('data-' + ns + '-result', status);
	
	                switch (status) {
	                    case this.STATUS_VALIDATING:
	                        isValidField = null;
	                        this.disableSubmitButtons(true);
	                        $field.removeClass(this.options.control.valid).removeClass(this.options.control.invalid);
	                        $parent.removeClass(this.options.row.valid).removeClass(this.options.row.invalid);
	                        if ($icon) {
	                            $icon.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).addClass(this.options.icon.validating).show();
	                        }
	                        break;
	
	                    case this.STATUS_INVALID:
	                        isValidField = false;
	                        this.disableSubmitButtons(true);
	                        $field.removeClass(this.options.control.valid).addClass(this.options.control.invalid);
	                        $parent.removeClass(this.options.row.valid).addClass(this.options.row.invalid);
	                        if ($icon) {
	                            $icon.removeClass(this.options.icon.valid).removeClass(this.options.icon.validating).addClass(this.options.icon.invalid).show();
	                        }
	                        break;
	
	                    case this.STATUS_IGNORED:       // Treat ignored fields like they are valid with some specialties
	                    case this.STATUS_VALID:
	                        isValidating   = ($allErrors.filter('[data-' + ns + '-result="' + this.STATUS_VALIDATING +'"]').length > 0);
	                        isNotValidated = ($allErrors.filter('[data-' + ns + '-result="' + this.STATUS_NOT_VALIDATED +'"]').length > 0);
	
	                        var numIgnored = $allErrors.filter('[data-' + ns + '-result="' + this.STATUS_IGNORED +'"]').length;
	
	                        // If the field is valid (passes all validators)
	                        isValidField   = (isValidating || isNotValidated)     // There are some validators that have not done
	                                        ? null
	                                        // All validators are completed
	                                        : ($allErrors.filter('[data-' + ns + '-result="' + this.STATUS_VALID +'"]').length + numIgnored === $allErrors.length);
	
	                        $field.removeClass(this.options.control.valid).removeClass(this.options.control.invalid);
	
	                        if (isValidField === true) {
	                            this.disableSubmitButtons(this.isValid() === false);
	                            if (status === this.STATUS_VALID) {
	                                $field.addClass(this.options.control.valid);
	                            }
	                        } else if (isValidField === false) {
	                            this.disableSubmitButtons(true);
	                            if (status === this.STATUS_VALID) {
	                                $field.addClass(this.options.control.invalid);
	                            }
	                        }
	
	                        if ($icon) {
	                            $icon.removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).removeClass(this.options.icon.valid);
	                            if (status === this.STATUS_VALID || numIgnored !== $allErrors.length) {
	                                $icon.addClass(isValidating
	                                                ? this.options.icon.validating
	                                                : (isValidField === null ? '' : (isValidField ? this.options.icon.valid : this.options.icon.invalid)))
	                                     .show();
	                            }
	                        }
	
	                        var isValidContainer = this.isValidContainer($parent);
	                        if (isValidContainer !== null) {
	                            $parent.removeClass(this.options.row.valid).removeClass(this.options.row.invalid);
	                            if (status === this.STATUS_VALID || numIgnored !== $allErrors.length) {
	                                $parent.addClass(isValidContainer ? this.options.row.valid : this.options.row.invalid);
	                            }
	                        }
	                        break;
	
	                    case this.STATUS_NOT_VALIDATED:
	                    /* falls through */
	                    default:
	                        isValidField = null;
	                        this.disableSubmitButtons(false);
	                        $field.removeClass(this.options.control.valid).removeClass(this.options.control.invalid);
	                        $parent.removeClass(this.options.row.valid).removeClass(this.options.row.invalid);
	                        if ($icon) {
	                            $icon.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).hide();
	                        }
	                        break;
	                }
	
	                if ($icon && ('tooltip' === container || 'popover' === container)) {
	                    (isValidField === false)
	                        // Only show the first error message
	                        ? this._createTooltip($field, $allErrors.filter('[data-' + ns + '-result="' + that.STATUS_INVALID + '"]').eq(0).html(), container)
	                        : this._destroyTooltip($field, container);
	                } else {
	                    (status === this.STATUS_INVALID) ? $errors.show() : $errors.hide();
	                }
	
	                // Trigger an event
	                $field.trigger($.Event(this.options.events.fieldStatus), {
	                    bv: this,   // Support backward
	                    fv: this,
	                    field: field,
	                    element: $field,
	                    status: status,
	                    validator: validatorName
	                });
	                this._onFieldValidated($field, validatorName);
	            }
	
	            return this;
	        },
	
	        /**
	         * Validate the form
	         *
	         * @returns {FormValidation.Base}
	         */
	        validate: function() {
	            if ($.isEmptyObject(this.options.fields)) {
	                this._submit();
	                return this;
	            }
	            this.$form.trigger($.Event(this.options.events.formPreValidate));
	
	            this.disableSubmitButtons(true);
	            this._submitIfValid = false;
	            for (var field in this.options.fields) {
	                this.validateField(field);
	            }
	
	            this._submit();
	            this._submitIfValid = true;
	
	            return this;
	        },
	
	        /**
	         * Validate given field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @returns {FormValidation.Base}
	         */
	        validateField: function(field) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            if (fields.length === 0 || !this.options.fields[field]
	                || this.options.fields[field].enabled === 'false' || this.options.fields[field].enabled === false)
	            {
	                return this;
	            }
	
	            var that       = this,
	                type       = fields.attr('type'),
	                total      = (('radio' === type || 'checkbox' === type) && this.options.live !== 'disabled') ? 1 : fields.length,
	                updateAll  = ('radio' === type || 'checkbox' === type),
	                validators = this.options.fields[field].validators,
	                verbose    = this.isOptionEnabled(field, 'verbose'),
	                validatorName,
	                alias,
	                validateResult;
	
	            for (var i = 0; i < total; i++) {
	                var $field = fields.eq(i);
	                if (this._isExcluded($field)) {
	                    continue;
	                }
	
	                var stop             = false,
	                    sortedByPriority = $field.data(ns + '.validators'),
	                    numValidators    = sortedByPriority.length;
	
	                for (var j = 0; j < numValidators; j++) {
	                    validatorName = sortedByPriority[j].validator;
	                    if ($field.data(ns + '.dfs.' + validatorName)) {
	                        $field.data(ns + '.dfs.' + validatorName).reject();
	                    }
	                    if (stop) {
	                        break;
	                    }
	
	                    // Don't validate field if it is already done
	                    var result = $field.data(ns + '.result.' + validatorName);
	                    if (result === this.STATUS_VALID || result === this.STATUS_INVALID) {
	                        this._onFieldValidated($field, validatorName);
	                        continue;
	                    } else if (validators[validatorName].enabled === false) {
	                        // Changed in v0.6.2:
	                        // When the field validator is disabled, it should be treated as STATUS_IGNORED instead of STATUS_VALID
	                        // By doing that, the field with only disabled and ignored validators will not have success/error class
	                        this.updateStatus(updateAll ? field : $field, this.STATUS_IGNORED, validatorName);
	                        continue;
	                    }
	
	                    $field.data(ns + '.result.' + validatorName, this.STATUS_VALIDATING);
	
	                    // Check whether or not the validator is just an alias of another
	                    alias          = validators[validatorName].alias || validatorName;
	                    validateResult = FormValidation.Validator[alias].validate(this, $field, validators[validatorName], validatorName);
	
	                    // validateResult can be a $.Deferred object ...
	                    if ('object' === typeof validateResult && validateResult.resolve) {
	                        this.updateStatus(updateAll ? field : $field, this.STATUS_VALIDATING, validatorName);
	                        $field.data(ns + '.dfs.' + validatorName, validateResult);
	
	                        validateResult.done(function($f, v, response) {
	                            // v is validator name
	                            $f.removeData(ns + '.dfs.' + v).data(ns + '.response.' + v, response);
	                            if (response.message) {
	                                that.updateMessage($f, v, response.message);
	                            }
	
	                            that.updateStatus(updateAll ? $f.attr('data-' + ns + '-field') : $f,
	                                              response.valid === true ? that.STATUS_VALID : (response.valid === false ? that.STATUS_INVALID : that.STATUS_IGNORED),
	                                              v);
	
	                            if (response.valid && that._submitIfValid === true) {
	                                // If a remote validator returns true and the form is ready to submit, then do it
	                                that._submit();
	                            } else if (response.valid === false && !verbose) {
	                                stop = true;
	                            }
	                        });
	                    }
	                    // ... or object { valid: true/false/null, message: 'dynamic message', otherKey: value, ... }
	                    else if ('object' === typeof validateResult && validateResult.valid !== undefined) {
	                        $field.data(ns + '.response.' + validatorName, validateResult);
	                        if (validateResult.message) {
	                            this.updateMessage(updateAll ? field : $field, validatorName, validateResult.message);
	                        }
	                        this.updateStatus(updateAll ? field : $field,
	                                          validateResult.valid === true ? this.STATUS_VALID : (validateResult.valid === false ? this.STATUS_INVALID : this.STATUS_IGNORED),
	                                          validatorName);
	                        if (validateResult.valid === false && !verbose) {
	                            break;
	                        }
	                    }
	                    // ... or a boolean value
	                    else if ('boolean' === typeof validateResult) {
	                        $field.data(ns + '.response.' + validatorName, validateResult);
	                        this.updateStatus(updateAll ? field : $field, validateResult ? this.STATUS_VALID : this.STATUS_INVALID, validatorName);
	                        if (!validateResult && !verbose) {
	                            break;
	                        }
	                    }
	                    // ... or null
	                    // to indicate that the field should be ignored for current validator
	                    else if (null === validateResult) {
	                        $field.data(ns + '.response.' + validatorName, validateResult);
	                        this.updateStatus(updateAll ? field : $field, this.STATUS_IGNORED, validatorName);
	                    }
	                }
	            }
	
	            return this;
	        },
	
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	        // Useful APIs which aren't used internally
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	        /**
	         * Add a new field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {Object} [options] The validator rules
	         * @returns {FormValidation.Base}
	         */
	        addField: function(field, options) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field') || field.attr('name');
	                    break;
	                case 'string':
	                    delete this._cacheFields[field];
	                    fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            fields.attr('data-' + ns + '-field', field);
	
	            var type  = fields.attr('type'),
	                total = ('radio' === type || 'checkbox' === type) ? 1 : fields.length;
	
	            for (var i = 0; i < total; i++) {
	                var $field = fields.eq(i);
	
	                // Try to parse the options from HTML attributes
	                var opts = this._parseOptions($field);
	                opts = (opts === null) ? options : $.extend(true, opts, options);
	
	                this.options.fields[field] = $.extend(true, this.options.fields[field], opts);
	
	                // Update the cache
	                this._cacheFields[field] = this._cacheFields[field] ? this._cacheFields[field].add($field) : $field;
	
	                // Init the element
	                this._initField(('checkbox' === type || 'radio' === type) ? field : $field);
	            }
	
	            this.disableSubmitButtons(false);
	            // Trigger an event
	            this.$form.trigger($.Event(this.options.events.fieldAdded), {
	                field: field,
	                element: fields,
	                options: this.options.fields[field]
	            });
	
	            return this;
	        },
	
	        /**
	         * Destroy the plugin
	         * It will remove all error messages, feedback icons and turn off the events
	         */
	        destroy: function() {
	            var ns = this._namespace, i, field, fields, $field, validator, $icon, row, alias;
	
	            // Destroy the validators first
	            for (field in this.options.fields) {
	                fields = this.getFieldElements(field);
	                for (i = 0; i < fields.length; i++) {
	                    $field = fields.eq(i);
	                    for (validator in this.options.fields[field].validators) {
	                        if ($field.data(ns + '.dfs.' + validator)) {
	                            $field.data(ns + '.dfs.' + validator).reject();
	                        }
	                        $field.removeData(ns + '.result.' + validator)
	                              .removeData(ns + '.response.' + validator)
	                              .removeData(ns + '.dfs.' + validator);
	
	                        // Destroy the validator
	                        alias = this.options.fields[field].validators[validator].alias || validator;
	                        if ('function' === typeof FormValidation.Validator[alias].destroy) {
	                            FormValidation.Validator[alias].destroy(this, $field, this.options.fields[field].validators[validator], validator);
	                        }
	                    }
	                }
	            }
	
	            // Remove messages and icons
	            var clazz = this.options.err.clazz.split(' ').join('.');
	            for (field in this.options.fields) {
	                fields = this.getFieldElements(field);
	                row    = this.options.fields[field].row || this.options.row.selector;
	                for (i = 0; i < fields.length; i++) {
	                    $field = fields.eq(i);
	                    // Remove all error messages
	                    var $messages = $field.data(ns + '.messages');
	                    if ($messages) {
	                        $messages.find('.' + clazz + '[data-' + ns + '-validator][data-' + ns + '-for="' + field + '"]').remove();
	                    }
	                    $field
	                        .removeData(ns + '.messages')
	                        .removeData(ns + '.validators')
	                        // Remove feedback classes
	                        .closest(row)
	                            .removeClass(this.options.row.valid)
	                            .removeClass(this.options.row.invalid)
	                            .removeClass(this.options.row.feedback)
	                            .end()
	                        // Turn off events
	                        .off('.' + ns)
	                        .removeAttr('data-' + ns + '-field');
	
	                    // Remove feedback icons, tooltip/popover container
	                    // Support backward
	                    var container = ('function' === typeof (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container))
	                                    ? (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container).call(this, $field, this)
	                                    : (this.options.fields[field].container || this.options.fields[field].err || this.options.err.container);
	                    if ('tooltip' === container || 'popover' === container) {
	                        this._destroyTooltip($field, container);
	                    }
	
	                    $icon = $field.data(ns + '.icon');
	                    if ($icon) {
	                        $icon.remove();
	                    }
	                    $field.removeData(ns + '.icon')
	                          // It's safe to remove trigger data here, because it might be used when destroying the validator
	                          .removeData(ns + '.trigger');
	                }
	            }
	
	            // Destroy the add-ons
	            for (var addOn in this.options.addOns) {
	                if ('function' === typeof FormValidation.AddOn[addOn].destroy) {
	                    FormValidation.AddOn[addOn].destroy(this, this.options.addOns[addOn]);
	                }
	            }
	
	            this.disableSubmitButtons(false);   // Enable submit buttons
	            this.$hiddenButton.remove();        // Remove the hidden button
	
	            this.$form
	                .removeClass(this.options.elementClass)
	                .off('.' + ns)
	                .removeData('bootstrapValidator')   // Support backward
	                .removeData('formValidation')
	                // Remove generated hidden elements
	                .find('[data-' + ns + '-submit-hidden]').remove().end()
	                .find('[type="submit"]')
	                    .off('click.' + ns);
	        },
	
	        /**
	         * Enable/Disable all validators to given field
	         *
	         * @param {String} field The field name
	         * @param {Boolean} enabled Enable/Disable field validators
	         * @param {String} [validatorName] The validator name. If null, all validators will be enabled/disabled
	         * @returns {FormValidation.Base}
	         */
	        enableFieldValidators: function(field, enabled, validatorName) {
	            var validators = this.options.fields[field].validators;
	
	            // Enable/disable particular validator
	            if (validatorName
	                && validators
	                && validators[validatorName] && validators[validatorName].enabled !== enabled)
	            {
	                this.options.fields[field].validators[validatorName].enabled = enabled;
	                this.updateStatus(field, this.STATUS_NOT_VALIDATED, validatorName);
	            }
	            // Enable/disable all validators
	            else if (!validatorName && this.options.fields[field].enabled !== enabled) {
	                this.options.fields[field].enabled = enabled;
	                for (var v in validators) {
	                    this.enableFieldValidators(field, enabled, v);
	                }
	            }
	
	            return this;
	        },
	
	        /**
	         * Some validators have option which its value is dynamic.
	         * For example, the zipCode validator has the country option which might be changed dynamically by a select element.
	         *
	         * @param {jQuery|String} field The field name or element
	         * @param {String|Function} option The option which can be determined by:
	         * - a string
	         * - name of field which defines the value
	         * - name of function which returns the value
	         * - a function returns the value
	         *
	         * The callback function has the format of
	         *      callback: function(value, validator, $field) {
	         *          // value is the value of field
	         *          // validator is the BootstrapValidator instance
	         *          // $field is the field element
	         *      }
	         *
	         * @returns {String}
	         */
	        getDynamicOption: function(field, option) {
	            var $field = ('string' === typeof field) ? this.getFieldElements(field) : field,
	                value  = $field.val();
	
	            // Option can be determined by
	            // ... a function
	            if ('function' === typeof option) {
	                return FormValidation.Helper.call(option, [value, this, $field]);
	            }
	            // ... value of other field
	            else if ('string' === typeof option) {
	                var $f = this.getFieldElements(option);
	                if ($f.length) {
	                    return $f.val();
	                }
	                // ... return value of callback
	                else {
	                    return FormValidation.Helper.call(option, [value, this, $field]) || option;
	                }
	            }
	
	            return null;
	        },
	
	        /**
	         * Get the form element
	         *
	         * @returns {jQuery}
	         */
	        getForm: function() {
	            return this.$form;
	        },
	
	        /**
	         * Get the list of invalid fields
	         *
	         * @returns {jQuery[]}
	         */
	        getInvalidFields: function() {
	            return this.$invalidFields;
	        },
	
	        /**
	         * Get the current locale
	         *
	         * @return {String}
	         */
	        getLocale: function() {
	            return this.options.locale;
	        },
	
	        /**
	         * Get the error messages
	         *
	         * @param {String|jQuery} [field] The field name or field element
	         * If the field is not defined, the method returns all error messages of all fields
	         * @param {String} [validator] The name of validator
	         * If the validator is not defined, the method returns error messages of all validators
	         * @returns {String[]}
	         */
	        getMessages: function(field, validator) {
	            var that     = this,
	                ns       = this._namespace,
	                messages = [],
	                $fields  = $([]);
	
	            switch (true) {
	                case (field && 'object' === typeof field):
	                    $fields = field;
	                    break;
	                case (field && 'string' === typeof field):
	                    var f = this.getFieldElements(field);
	                    if (f.length > 0) {
	                        var type = f.attr('type');
	                        $fields = ('radio' === type || 'checkbox' === type) ? f.eq(0) : f;
	                    }
	                    break;
	                default:
	                    $fields = this.$invalidFields;
	                    break;
	            }
	
	            var filter = validator ? '[data-' + ns + '-validator="' + validator + '"]' : '',
	                clazz  = this.options.err.clazz.split(' ').join('.');
	            $fields.each(function() {
	                messages = messages.concat(
	                    $(this)
	                        .data(ns + '.messages')
	                        .find('.' + clazz + '[data-' + ns + '-for="' + $(this).attr('data-' + ns + '-field') + '"][data-' + ns + '-result="' + that.STATUS_INVALID + '"]' + filter)
	                        .map(function() {
	                            var v = $(this).attr('data-' + ns + '-validator'),
	                                f = $(this).attr('data-' + ns + '-for');
	                            return (that.options.fields[f].validators[v].enabled === false) ? '' : $(this).html();
	                        })
	                        .get()
	                );
	            });
	
	            return messages;
	        },
	
	        /**
	         * Returns the clicked submit button
	         *
	         * @returns {jQuery}
	         */
	        getSubmitButton: function() {
	            return this.$submitButton;
	        },
	
	        /**
	         * Remove a given field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @returns {FormValidation.Base}
	         */
	        removeField: function(field) {
	            var ns     = this._namespace,
	                fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    fields = field;
	                    field  = field.attr('data-' + ns + '-field') || field.attr('name');
	                    fields.attr('data-' + ns + '-field', field);
	                    break;
	                case 'string':
	                    fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            if (fields.length === 0) {
	                return this;
	            }
	
	            var type  = fields.attr('type'),
	                total = ('radio' === type || 'checkbox' === type) ? 1 : fields.length;
	
	            for (var i = 0; i < total; i++) {
	                var $field = fields.eq(i);
	
	                // Remove from the list of invalid fields
	                this.$invalidFields = this.$invalidFields.not($field);
	
	                // Update the cache
	                this._cacheFields[field] = this._cacheFields[field].not($field);
	            }
	
	            if (!this._cacheFields[field] || this._cacheFields[field].length === 0) {
	                delete this.options.fields[field];
	            }
	            if ('checkbox' === type || 'radio' === type) {
	                this._initField(field);
	            }
	
	            this.disableSubmitButtons(false);
	            // Trigger an event
	            this.$form.trigger($.Event(this.options.events.fieldRemoved), {
	                field: field,
	                element: fields
	            });
	
	            return this;
	        },
	
	        /**
	         * Reset given field
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {Boolean} [resetValue] If true, the method resets field value to empty or remove checked/selected attribute (for radio/checkbox)
	         * @returns {FormValidation.Base}
	         */
	        resetField: function(field, resetValue) {
	            var ns      = this._namespace,
	                $fields = $([]);
	            switch (typeof field) {
	                case 'object':
	                    $fields = field;
	                    field   = field.attr('data-' + ns + '-field');
	                    break;
	                case 'string':
	                    $fields = this.getFieldElements(field);
	                    break;
	                default:
	                    break;
	            }
	
	            var i     = 0,
	                total = $fields.length;
	            if (this.options.fields[field]) {
	                for (i = 0; i < total; i++) {
	                    for (var validator in this.options.fields[field].validators) {
	                        $fields.eq(i).removeData(ns + '.dfs.' + validator);
	                    }
	                }
	            }
	
	            if (resetValue) {
	                var type = $fields.attr('type');
	                ('radio' === type || 'checkbox' === type) ? $fields.prop('checked', false).removeAttr('selected') : $fields.val('');
	            }
	
	            // Mark field as not validated yet
	            this.updateStatus(field, this.STATUS_NOT_VALIDATED);
	
	            for (i = 0; i < total; i++) {
	                $fields.eq(i).trigger($.Event(this.options.events.fieldReset), {
	                    fv: this,
	                    field: field,
	                    element: $fields.eq(i),
	                    resetValue: resetValue
	                });
	            }
	
	            return this;
	        },
	
	        /**
	         * Reset the form
	         *
	         * @param {Boolean} [resetValue] If true, the method resets field value to empty or remove checked/selected attribute (for radio/checkbox)
	         * @returns {FormValidation.Base}
	         */
	        resetForm: function(resetValue) {
	            for (var field in this.options.fields) {
	                this.resetField(field, resetValue);
	            }
	
	            this.$invalidFields = $([]);
	            this.$submitButton  = null;
	
	            // Enable submit buttons
	            this.disableSubmitButtons(false);
	
	            this.$form.trigger($.Event(this.options.events.formReset), {
	                fv: this,
	                resetValue: resetValue
	            });
	
	            return this;
	        },
	
	        /**
	         * Revalidate given field
	         * It's used when you need to revalidate the field which its value is updated by other plugin
	         *
	         * @param {String|jQuery} field The field name of field element
	         * @returns {FormValidation.Base}
	         */
	        revalidateField: function(field) {
	            this.updateStatus(field, this.STATUS_NOT_VALIDATED)
	                .validateField(field);
	
	            return this;
	        },
	
	        /**
	         * Set the locale
	         *
	         * @param {String} locale The locale in format of countrycode_LANGUAGECODE
	         * @returns {FormValidation.Base}
	         */
	        setLocale: function(locale) {
	            this.options.locale = locale;
	            this.$form.trigger($.Event(this.options.events.localeChanged), {
	                locale: locale,
	                bv: this,   // Support backward
	                fv: this
	            });
	
	            return this;
	        },
	
	        /**
	         * Update the option of a specific validator
	         *
	         * @param {String|jQuery} field The field name or field element
	         * @param {String} validator The validator name
	         * @param {String} option The option name
	         * @param {String} value The value to set
	         * @returns {FormValidation.Base}
	         */
	        updateOption: function(field, validator, option, value) {
	            var ns = this._namespace;
	            if ('object' === typeof field) {
	                field = field.attr('data-' + ns + '-field');
	            }
	            if (this.options.fields[field] && this.options.fields[field].validators[validator]) {
	                this.options.fields[field].validators[validator][option] = value;
	                this.updateStatus(field, this.STATUS_NOT_VALIDATED, validator);
	            }
	
	            return this;
	        },
	
	        /**
	         * Validate given container
	         * It can be used with isValidContainer() when you want to work with wizard form
	         *
	         * @param {String|jQuery} container The container selector or element
	         * @returns {FormValidation.Base}
	         */
	        validateContainer: function(container) {
	            var that       = this,
	                ns         = this._namespace,
	                fields     = [],
	                $container = ('string' === typeof container) ? $(container) : container;
	            if ($container.length === 0) {
	                return this;
	            }
	
	            $container.find('[data-' + ns + '-field]').each(function() {
	                var $field = $(this);
	                if (!that._isExcluded($field)) {
	                    fields.push($field);
	                }
	            });
	
	            var total = fields.length;
	            for (var i = 0; i < total; i++) {
	                this.validateField(fields[i]);
	            }
	
	            return this;
	        }
	    };
	
	    // Plugin definition
	    $.fn.formValidation = function(option) {
	        var params = arguments;
	        return this.each(function() {
	            var $this   = $(this),
	                data    = $this.data('formValidation'),
	                options = 'object' === typeof option && option;
	            if (!data) {
	                var framework = (options.framework || $this.attr('data-fv-framework') || 'bootstrap').toLowerCase(),
	                    clazz     = framework.substr(0, 1).toUpperCase() + framework.substr(1);
	
	                if (typeof FormValidation.Framework[clazz] === 'undefined') {
	                    throw new Error('The class FormValidation.Framework.' + clazz + ' is not implemented');
	                }
	
	                data = new FormValidation.Framework[clazz](this, options);
	                $this.addClass('fv-form-' + framework)
	                     .data('formValidation', data);
	            }
	
	            // Allow to call plugin method
	            if ('string' === typeof option) {
	                data[option].apply(data, Array.prototype.slice.call(params, 1));
	            }
	        });
	    };
	
	    $.fn.formValidation.Constructor = FormValidation.Base;
	
	    // Default message
	    $.fn.formValidation.DEFAULT_MESSAGE = 'This value is not valid';
	
	    // The default options sorted in alphabetical order
	    $.fn.formValidation.DEFAULT_OPTIONS = {
	        // The first invalid field will be focused automatically
	        autoFocus: true,
	
	        // Support declarative usage (setting options via HTML 5 attributes)
	        // Setting to false can improve the performance
	        declarative: true,
	
	        // The form CSS class
	        elementClass: 'fv-form',
	
	        // Use custom event name to avoid window.onerror being invoked by jQuery
	        // See #630
	        events: {
	            // Support backward
	            formInit: 'init.form.fv',
	            formPreValidate: 'prevalidate.form.fv',
	            formError: 'err.form.fv',
	            formReset: 'rst.form.fv',
	            formSuccess: 'success.form.fv',
	            fieldAdded: 'added.field.fv',
	            fieldRemoved: 'removed.field.fv',
	            fieldInit: 'init.field.fv',
	            fieldError: 'err.field.fv',
	            fieldReset: 'rst.field.fv',
	            fieldSuccess: 'success.field.fv',
	            fieldStatus: 'status.field.fv',
	            localeChanged: 'changed.locale.fv',
	            validatorError: 'err.validator.fv',
	            validatorSuccess: 'success.validator.fv',
	            validatorIgnored: 'ignored.validator.fv'
	        },
	
	        // Indicate fields which won't be validated
	        // By default, the plugin will not validate the following kind of fields:
	        // - disabled
	        // - hidden
	        // - invisible
	        //
	        // The setting consists of jQuery filters. Accept 3 formats:
	        // - A string. Use a comma to separate filter
	        // - An array. Each element is a filter
	        // - An array. Each element can be a callback function
	        //      function($field, validator) {
	        //          $field is jQuery object representing the field element
	        //          validator is the BootstrapValidator instance
	        //          return true or false;
	        //      }
	        //
	        // The 3 following settings are equivalent:
	        //
	        // 1) ':disabled, :hidden, :not(:visible)'
	        // 2) [':disabled', ':hidden', ':not(:visible)']
	        // 3) [':disabled', ':hidden', function($field) {
	        //        return !$field.is(':visible');
	        //    }]
	        excluded: [':disabled', ':hidden', ':not(:visible)'],
	
	        // Map the field name with validator rules
	        fields: null,
	
	        // Live validating option
	        // Can be one of 3 values:
	        // - enabled: The plugin validates fields as soon as they are changed
	        // - disabled: Disable the live validating. The error messages are only shown after the form is submitted
	        // - submitted: The live validating is enabled after the form is submitted
	        live: 'enabled',
	
	        // Locale in the format of languagecode_COUNTRYCODE
	        locale: 'en_US',
	
	        // Default invalid message
	        message: null,
	
	        // The field will not be live validated if its length is less than this number of characters
	        threshold: null,
	
	        // Whether to be verbose when validating a field or not.
	        // Possible values:
	        // - true:  when a field has multiple validators, all of them will be checked, and respectively - if errors occur in
	        //          multiple validators, all of them will be displayed to the user
	        // - false: when a field has multiple validators, validation for this field will be terminated upon the first encountered error.
	        //          Thus, only the very first error message related to this field will be displayed to the user
	        verbose: true,
	
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	        // These options mostly are overridden by specific framework
	        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	
	        button: {
	            // The submit buttons selector
	            // These buttons will be disabled to prevent the valid form from multiple submissions
	            // Don't perform validation when clicking on the submit button/input which have formnovalidate attribute
	            selector: '[type="submit"]:not([formnovalidate])',
	
	            // The disabled class
	            disabled: ''
	        },
	
	        control: {
	            // The CSS class for valid control
	            valid: '',
	
	            // The CSS class for invalid control
	            invalid: ''
	        },
	
	        err: {
	            // The CSS class of each message element
	            clazz: '',
	
	            // The error messages container. It can be:
	            // - 'tooltip' if you want to use Bootstrap tooltip to show error messages
	            // - 'popover' if you want to use Bootstrap popover to show error messages
	            // - a CSS selector indicating the container
	            // In the first two cases, since the tooltip/popover should be small enough, the plugin only shows only one error message
	            // You also can define the message container for particular field
	            container: null,
	
	            // Used to determine where the messages are placed
	            parent: null
	        },
	
	        // Shows ok/error/loading icons based on the field validity.
	        icon: {
	            valid: null,
	            invalid: null,
	            validating: null,
	            feedback: ''
	        },
	
	        row: {
	            // The CSS selector for indicating the element consists of the field
	            // You should adjust this option if your form group consists of many fields which not all of them need to be validated
	            selector: null,
	            valid: '',
	            invalid: '',
	            feedback: ''
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * FormValidation (http://formvalidation.io)
	 * The best jQuery plugin to validate form fields. Support Bootstrap, Foundation, Pure, SemanticUI, UIKit and custom frameworks
	 *
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	
	/**
	 * This class supports validating Bootstrap form (http://getbootstrap.com/)
	 */
	(function($) {
	    FormValidation.Framework.Bootstrap = function(element, options, namespace) {
	        options = $.extend(true, {
	            button: {
	                selector: '[type="submit"]:not([formnovalidate])',
	                // The class of disabled button
	                // http://getbootstrap.com/css/#buttons-disabled
	                disabled: 'disabled'
	            },
	            err: {
	                // http://getbootstrap.com/css/#forms-help-text
	                clazz: 'help-block',
	                parent: '^(.*)col-(xs|sm|md|lg)-(offset-){0,1}[0-9]+(.*)$'
	            },
	            // This feature requires Bootstrap v3.1.0 or later (http://getbootstrap.com/css/#forms-control-validation).
	            // Since Bootstrap doesn't provide any methods to know its version, this option cannot be on/off automatically.
	            // In other word, to use this feature you have to upgrade your Bootstrap to v3.1.0 or later.
	            //
	            // Examples:
	            // - Use Glyphicons icons:
	            //  icon: {
	            //      valid: 'glyphicon glyphicon-ok',
	            //      invalid: 'glyphicon glyphicon-remove',
	            //      validating: 'glyphicon glyphicon-refresh',
	            //      feedback: 'form-control-feedback'
	            //  }
	            // - Use FontAwesome icons:
	            //  icon: {
	            //      valid: 'fa fa-check',
	            //      invalid: 'fa fa-times',
	            //      validating: 'fa fa-refresh',
	            //      feedback: 'form-control-feedback'
	            //  }
	            icon: {
	                valid: null,
	                invalid: null,
	                validating: null,
	                feedback: 'form-control-feedback'
	            },
	            row: {
	                // By default, each field is placed inside the <div class="form-group"></div>
	                // http://getbootstrap.com/css/#forms
	                selector: '.form-group',
	                valid: 'has-success',
	                invalid: 'has-error',
	                feedback: 'has-feedback'
	            }
	        }, options);
	
	        FormValidation.Base.apply(this, [element, options, namespace]);
	    };
	
	    FormValidation.Framework.Bootstrap.prototype = $.extend({}, FormValidation.Base.prototype, {
	        /**
	         * Specific framework might need to adjust the icon position
	         *
	         * @param {jQuery} $field The field element
	         * @param {jQuery} $icon The icon element
	         */
	        _fixIcon: function($field, $icon) {
	            var ns      = this._namespace,
	                type    = $field.attr('type'),
	                field   = $field.attr('data-' + ns + '-field'),
	                row     = this.options.fields[field].row || this.options.row.selector,
	                $parent = $field.closest(row);
	
	            // Place it after the container of checkbox/radio
	            // so when clicking the icon, it doesn't effect to the checkbox/radio element
	            if ('checkbox' === type || 'radio' === type) {
	                var $fieldParent = $field.parent();
	                if ($fieldParent.hasClass(type)) {
	                    $icon.insertAfter($fieldParent);
	                } else if ($fieldParent.parent().hasClass(type)) {
	                    $icon.insertAfter($fieldParent.parent());
	                }
	            }
	
	            // Fix feedback icons in input-group
	            if ($parent.find('.input-group').length !== 0) {
	                $icon.addClass('fv-bootstrap-icon-input-group')
	                     .insertAfter($parent.find('.input-group').eq(0));
	            }
	        },
	
	        /**
	         * Create a tooltip or popover
	         * It will be shown when focusing on the field
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} message The message
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _createTooltip: function($field, message, type) {
	            var ns    = this._namespace,
	                $icon = $field.data(ns + '.icon');
	            if ($icon) {
	                switch (type) {
	                    case 'popover':
	                        $icon
	                            .css({
	                                'cursor': 'pointer',
	                                'pointer-events': 'auto'
	                            })
	                            .popover('destroy')
	                            .popover({
	                                container: 'body',
	                                content: message,
	                                html: true,
	                                placement: 'auto top',
	                                trigger: 'hover click'
	                            });
	                        break;
	
	                    case 'tooltip':
	                    /* falls through */
	                    default:
	                        $icon
	                            .css({
	                                'cursor': 'pointer',
	                                'pointer-events': 'auto'
	                            })
	                            .tooltip('destroy')
	                            .tooltip({
	                                container: 'body',
	                                html: true,
	                                placement: 'auto top',
	                                title: message
	                            });
	                        break;
	                }
	            }
	        },
	
	        /**
	         * Destroy the tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _destroyTooltip: function($field, type) {
	            var ns    = this._namespace,
	                $icon = $field.data(ns + '.icon');
	            if ($icon) {
	                switch (type) {
	                    case 'popover':
	                        $icon
	                            .css({
	                                'cursor': '',
	                                'pointer-events': 'none'
	                            })
	                            .popover('destroy');
	                        break;
	
	                    case 'tooltip':
	                    /* falls through */
	                    default:
	                        $icon
	                            .css({
	                                'cursor': '',
	                                'pointer-events': 'none'
	                            })
	                            .tooltip('destroy');
	                        break;
	                }
	            }
	        },
	
	        /**
	         * Hide a tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _hideTooltip: function($field, type) {
	            var ns    = this._namespace,
	                $icon = $field.data(ns + '.icon');
	            if ($icon) {
	                switch (type) {
	                    case 'popover':
	                        $icon.popover('hide');
	                        break;
	
	                    case 'tooltip':
	                    /* falls through */
	                    default:
	                        $icon.tooltip('hide');
	                        break;
	                }
	            }
	        },
	
	        /**
	         * Show a tooltip or popover
	         *
	         * @param {jQuery} $field The field element
	         * @param {String} type Can be 'tooltip' or 'popover'
	         */
	        _showTooltip: function($field, type) {
	            var ns    = this._namespace,
	                $icon = $field.data(ns + '.icon');
	            if ($icon) {
	                switch (type) {
	                    case 'popover':
	                        $icon.popover('show');
	                        break;
	
	                    case 'tooltip':
	                    /* falls through */
	                    default:
	                        $icon.tooltip('show');
	                        break;
	                }
	            }
	        }
	    });
	
	    /**
	     * Plugin definition
	     * Support backward
	     * @deprecated It will be removed soon. Instead of using $(form).bootstrapValidator(), use
	     *  $(form).formValidation({
	     *      framework: 'bootstrap'  // It's equivalent to use data-fv-framework="bootstrap" for <form>
	     *  });
	     */
	    $.fn.bootstrapValidator = function(option) {
	        var params = arguments;
	        return this.each(function() {
	            var $this   = $(this),
	                data    = $this.data('formValidation') || $this.data('bootstrapValidator'),
	                options = 'object' === typeof option && option;
	            if (!data) {
	                data = new FormValidation.Framework.Bootstrap(this, $.extend({}, {
	                    events: {
	                        // Support backward
	                        formInit: 'init.form.bv',
	                        formPreValidate: 'prevalidate.form.bv',
	                        formError: 'error.form.bv',
	                        formSuccess: 'success.form.bv',
	                        fieldAdded: 'added.field.bv',
	                        fieldRemoved: 'removed.field.bv',
	                        fieldInit: 'init.field.bv',
	                        fieldError: 'error.field.bv',
	                        fieldSuccess: 'success.field.bv',
	                        fieldStatus: 'status.field.bv',
	                        localeChanged: 'changed.locale.bv',
	                        validatorError: 'error.validator.bv',
	                        validatorSuccess: 'success.validator.bv'
	                    }
	                }, options), 'bv');
	
	                $this.addClass('fv-form-bootstrap')
	                     .data('formValidation', data)
	                     .data('bootstrapValidator', data);
	            }
	
	            // Allow to call plugin method
	            if ('string' === typeof option) {
	                data[option].apply(data, Array.prototype.slice.call(params, 1));
	            }
	        });
	    };
	
	    $.fn.bootstrapValidator.Constructor = FormValidation.Framework.Bootstrap;
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * FormValidation (http://formvalidation.io)
	 * The best jQuery plugin to validate form fields. Support Bootstrap, Foundation, Pure, SemanticUI, UIKit and custom frameworks
	 *
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	
	(function($) {
	    // Helper methods, which can be used in validator class
	    FormValidation.Helper = {
	        /**
	         * Execute a callback function
	         *
	         * @param {String|Function} functionName Can be
	         * - name of global function
	         * - name of namespace function (such as A.B.C)
	         * - a function
	         * @param {Array} args The callback arguments
	         */
	        call: function(functionName, args) {
	            if ('function' === typeof functionName) {
	                return functionName.apply(this, args);
	            } else if ('string' === typeof functionName) {
	                if ('()' === functionName.substring(functionName.length - 2)) {
	                    functionName = functionName.substring(0, functionName.length - 2);
	                }
	                var ns      = functionName.split('.'),
	                    func    = ns.pop(),
	                    context = window;
	                for (var i = 0; i < ns.length; i++) {
	                    context = context[ns[i]];
	                }
	
	                return (typeof context[func] === 'undefined') ? null : context[func].apply(this, args);
	            }
	        },
	
	        /**
	         * Validate a date
	         *
	         * @param {Number} year The full year in 4 digits
	         * @param {Number} month The month number
	         * @param {Number} day The day number
	         * @param {Boolean} [notInFuture] If true, the date must not be in the future
	         * @returns {Boolean}
	         */
	        date: function(year, month, day, notInFuture) {
	            if (isNaN(year) || isNaN(month) || isNaN(day)) {
	                return false;
	            }
	            if (day.length > 2 || month.length > 2 || year.length > 4) {
	                return false;
	            }
	
	            day   = parseInt(day, 10);
	            month = parseInt(month, 10);
	            year  = parseInt(year, 10);
	
	            if (year < 1000 || year > 9999 || month <= 0 || month > 12) {
	                return false;
	            }
	            var numDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	            // Update the number of days in Feb of leap year
	            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
	                numDays[1] = 29;
	            }
	
	            // Check the day
	            if (day <= 0 || day > numDays[month - 1]) {
	                return false;
	            }
	
	            if (notInFuture === true) {
	                var currentDate  = new Date(),
	                    currentYear  = currentDate.getFullYear(),
	                    currentMonth = currentDate.getMonth(),
	                    currentDay   = currentDate.getDate();
	                return (year < currentYear
	                || (year === currentYear && month - 1 < currentMonth)
	                || (year === currentYear && month - 1 === currentMonth && day < currentDay));
	            }
	
	            return true;
	        },
	
	        /**
	         * Format a string
	         * It's used to format the error message
	         * format('The field must between %s and %s', [10, 20]) = 'The field must between 10 and 20'
	         *
	         * @param {String} message
	         * @param {Array} parameters
	         * @returns {String}
	         */
	        format: function(message, parameters) {
	            if (!$.isArray(parameters)) {
	                parameters = [parameters];
	            }
	
	            for (var i in parameters) {
	                message = message.replace('%s', parameters[i]);
	            }
	
	            return message;
	        },
	
	        /**
	         * Implement Luhn validation algorithm
	         * Credit to https://gist.github.com/ShirtlessKirk/2134376
	         *
	         * @see http://en.wikipedia.org/wiki/Luhn
	         * @param {String} value
	         * @returns {Boolean}
	         */
	        luhn: function(value) {
	            var length  = value.length,
	                mul     = 0,
	                prodArr = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]],
	                sum     = 0;
	
	            while (length--) {
	                sum += prodArr[mul][parseInt(value.charAt(length), 10)];
	                mul ^= 1;
	            }
	
	            return (sum % 10 === 0 && sum > 0);
	        },
	
	        /**
	         * Implement modulus 11, 10 (ISO 7064) algorithm
	         *
	         * @param {String} value
	         * @returns {Boolean}
	         */
	        mod11And10: function(value) {
	            var check  = 5,
	                length = value.length;
	            for (var i = 0; i < length; i++) {
	                check = (((check || 10) * 2) % 11 + parseInt(value.charAt(i), 10)) % 10;
	            }
	            return (check === 1);
	        },
	
	        /**
	         * Implements Mod 37, 36 (ISO 7064) algorithm
	         * Usages:
	         * mod37And36('A12425GABC1234002M')
	         * mod37And36('002006673085', '0123456789')
	         *
	         * @param {String} value
	         * @param {String} [alphabet]
	         * @returns {Boolean}
	         */
	        mod37And36: function(value, alphabet) {
	            alphabet = alphabet || '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	            var modulus = alphabet.length,
	                length  = value.length,
	                check   = Math.floor(modulus / 2);
	            for (var i = 0; i < length; i++) {
	                check = (((check || modulus) * 2) % (modulus + 1) + alphabet.indexOf(value.charAt(i))) % modulus;
	            }
	            return (check === 1);
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * notEmpty validator
	 *
	 * @link        http://formvalidation.io/validators/notEmpty/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            notEmpty: {
	                'default': 'Please enter a value'
	            }
	        }
	    });
	
	    FormValidation.Validator.notEmpty = {
	        enableByHtml5: function($field) {
	            var required = $field.attr('required') + '';
	            return ('required' === required || 'true' === required);
	        },
	
	        /**
	         * Check if input value is empty or not
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options
	         * @returns {Boolean}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var type = $field.attr('type');
	            if ('radio' === type || 'checkbox' === type) {
	                var ns = validator.getNamespace();
	                return validator
	                            .getFieldElements($field.attr('data-' + ns + '-field'))
	                            .filter(':checked')
	                            .length > 0;
	            }
	
	            if ('number' === type && $field.get(0).validity && $field.get(0).validity.badInput === true) {
	                return true;
	            }
	
	            var value = validator.getFieldValue($field, validatorName);
	            return $.trim(value) !== '';
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	// Functions to set get or check cookies variables
	exports.Set = function (cname, cvalue, exdays) {
	  var d = new Date();
	  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	  var expstoUTCString = d.toUTCString();
	  var expires = 'expires=' + expstoUTCString;
	  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	};
	exports.Get = function (cname) {
	  var name = cname + '=';
	  var ca = document.cookie.split(';');
	  for (var i = 0; i < ca.length; i += 1) {
	    var c = ca[i];
	    while (c.charAt(0) === ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) === 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return '';
	};
	exports.Check = function (cookiename) {
	  var value = exports.Get(cookiename);
	  var result = '';
	  if (value !== '') {
	    result = value;
	  } else {
	    result = '';
	  }
	  return result;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BeFine = function BeFine(el) {
	  _classCallCheck(this, BeFine);
	
	  this.el = el;
	  this.el.value = 1;
	}
	/* eslint-disable class-methods-use-this */
	/* eslint-enable class-methods-use-this */
	;
	
	exports.default = BeFine;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _treffcook = __webpack_require__(9);
	
	var _treffcook2 = _interopRequireDefault(_treffcook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CookiesRules = function () {
	  function CookiesRules(el) {
	    _classCallCheck(this, CookiesRules);
	
	    this.el = el;
	    this.isLanding = parseInt(this.el.getAttribute('data-il'), 10);
	    if (!document.cookie.includes('_notracking')) {
	      _treffcook2.default.Set('_notracking', 1, 30);
	    }
	    this.confirmBtn = document.querySelector('#confirm-btn');
	    this.configBtn = document.querySelector('#config-btn');
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(CookiesRules, [{
	    key: 'init',
	    value: function init() {
	      var cStatus = _treffcook2.default.Get('_epr');
	      if (this.isLanding === 1) {
	        if (!cStatus || cStatus !== '3e4d891a5df3d6d0d7dd9432a1bc6470') {
	          this.el.closest('#cookies-conditions').removeAttribute('style');
	        }
	      } else {
	        $(window).on('load', function () {
	          if (!cStatus || cStatus !== '3e4d891a5df3d6d0d7dd9432a1bc6470') {
	            $('#cookies-conditions-bg').show();
	            $('#cookies-conditions').show();
	          }
	        });
	      }
	      $('body').on('click', '#config-btn', function () {
	        $('#back-btn').show();
	        $('.step-1').hide();
	        $('.step-2').show();
	      });
	      $('body').on('click', '#back-btn', function () {
	        $('.step-1').show();
	        $('.step-2').hide();
	        $('#back-btn').hide();
	      });
	      $('body').on('click', '#confirm-btn', function () {
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          type: 'json',
	          data: {
	            mode: 'ePrGDPR',
	            action: 'a'
	          },
	          success: function success(response) {
	            var result = $.parseJSON(response);
	            window.consentGranted(true, true, 'Grant all');
	            _treffcook2.default.Set('_notracking', 0, 30);
	            _treffcook2.default.Set('_epr', result.all, 30);
	            _treffcook2.default.Set('_epr_stat', result.stat, 30);
	            _treffcook2.default.Set('_epr_mar', result.mar, 30);
	            $('#cookies-conditions').hide();
	            $('#cookies-conditions-bg').hide();
	          }
	        });
	      });
	      $('body').on('click', '#save-btn', function () {
	        var valMar = $('input[name=mar]').is(':checked');
	        var valFun = $('input[name=fun]').is(':checked');
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          type: 'json',
	          data: {
	            mode: 'ePrGDPR',
	            action: 's',
	            mar: valMar,
	            stat: valFun
	          },
	          success: function success(response) {
	            var result = $.parseJSON(response);
	            var consentStatistics = result.statistics;
	            var consentMarketing = result.marketing;
	            window.consentGranted(consentStatistics, consentMarketing, 'Grant selected');
	            _treffcook2.default.Set('_epr', result.all, 30);
	            _treffcook2.default.Set('_epr_stat', result.stat, 30);
	            if (result.stat !== 0) {
	              _treffcook2.default.Set('_notracking', 0, 30);
	            } else {
	              _treffcook2.default.Set('_notracking', 1, 30);
	            }
	            _treffcook2.default.Set('_epr_mar', result.mar, 30);
	            $('#cookies-conditions').hide();
	            $('#cookies-conditions-bg').hide();
	          }
	        });
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return CookiesRules;
	}();
	
	exports.default = CookiesRules;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExternalLinks = function () {
	  function ExternalLinks() {
	    _classCallCheck(this, ExternalLinks);
	
	    this.links = document.querySelectorAll('a');
	  }
	
	  _createClass(ExternalLinks, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      [].forEach.call(this.links, function (link) {
	        if (_this._getExternal(link)) {
	          _this._setTarget(link);
	        }
	      });
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_getExternal',
	    value: function _getExternal(link) {
	      // eslint-disable-line
	      /**
	       * NOTE: Due to a very inconsistent implementation of the link targets
	       * checking the href attribute to decide if a link is external or not is
	       * currently not feasable (or too cumbersome)
	       */
	
	      // const href = link.getAttribute('href');
	      var rel = link.getAttribute('rel');
	
	      // const protocol = new RegExp(/^https?/);
	      // const host = new RegExp(`/${window.location.host}/`);
	      // const mailto = new RegExp(/(^mailto)/);
	
	      var external = false;
	
	      if (rel != null && /(external)/.test(rel)) {
	        external = true;
	      }
	
	      // if (protocol.test(href) && !host.test(href) && !mailto.test(href)) {
	      //   external = true;
	      // }
	
	      return external;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }, {
	    key: '_setTarget',
	    value: function _setTarget(link) {
	      // eslint-disable-line
	      link.addEventListener('click', this._onClick.bind(this), false);
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      // eslint-disable-line
	      event.preventDefault();
	      event.stopPropagation();
	
	      var newWindow = window.open(event.target.getAttribute('href'), '_blank');
	      newWindow.opener = null;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ExternalLinks;
	}();
	
	exports.default = ExternalLinks;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modernizr = __webpack_require__(3);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(6);
	
	__webpack_require__(97);
	
	__webpack_require__(98);
	
	__webpack_require__(99);
	
	__webpack_require__(100);
	
	__webpack_require__(101);
	
	__webpack_require__(8);
	
	__webpack_require__(102);
	
	__webpack_require__(103);
	
	__webpack_require__(104);
	
	__webpack_require__(105);
	
	var _validators = __webpack_require__(76);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable class-methods-use-this */
	var Formvalidation = function () {
	  function Formvalidation(el) {
	    _classCallCheck(this, Formvalidation);
	
	    this.el = el;
	    this.init();
	  }
	
	  _createClass(Formvalidation, [{
	    key: 'init',
	    value: function init() {
	      this.icons = this._getIcons();
	      this.framework = 'bootstrap';
	      this.trigger = 'blur';
	      this.fields = this._getFieldsToValidate(this.el.getAttribute('data-module-form'));
	      // Open userpic upload modal when redirections with query key = picupload
	      if (this.el.getAttribute('data-module-form') === 'ownProfile') {
	        if (this.el.getAttribute('data-activate-upload') === 'on') {
	          document.getElementById('uploadcontainer-button').click();
	        }
	      }
	      if (this._getBreakpoint() === 'screen-sm') {
	        this._fvSmall();
	      } else {
	        this._fvMedium();
	      }
	    }
	  }, {
	    key: '_fvSmall',
	    value: function _fvSmall() {
	      $(this.el).on('init.field.fv', function (e, data) {
	        var $parent = data.element.parent();
	
	        data.element.focus(function () {
	          if ($parent.hasClass('has-error')) {
	            data.fv.resetField(data.element);
	            data.element.tooltip('destroy');
	          }
	        });
	      }).formValidation({
	        framework: this.framework,
	
	        icon: this.icons,
	
	        fields: this.fields,
	
	        trigger: this.trigger
	      });
	    }
	  }, {
	    key: '_fvMedium',
	    value: function _fvMedium() {
	      var _this = this;
	
	      $(this.el).on('init.field.fv', function (e, data) {
	        var $parent = data.element.parent();
	
	        data.element.focus(function () {
	          if ($parent.hasClass('has-error')) {
	            data.fv.resetField(data.element);
	            data.element.tooltip('destroy');
	          }
	        });
	      }).formValidation({
	        framework: this.framework,
	
	        icon: this.icons,
	
	        err: {
	          container: 'tooltip'
	        },
	
	        fields: this.fields,
	
	        trigger: this.trigger
	      })
	      // Revalidate when changing place
	      .on('change', '#Geosearch', function () {
	        var elem = $(_this.el);
	        setTimeout(function () {
	          elem.formValidation('revalidateField', 'Geosearch');
	        }, 200);
	      }).on('err.field.fv', function (e, data) {
	        // console.log('dataset', data.element.data('fv.icon'));
	        var $input = data.element[0];
	        var placement = $input.getAttribute('data-fv-tooltip-placement');
	        var $icon = data.element.data('fv.icon');
	        var title = $icon.data('bs.tooltip') === undefined ? '' : $icon.data('bs.tooltip').getTitle();
	
	        $icon.tooltip('destroy');
	
	        data.element.tooltip({
	          html: true,
	
	          placement: placement,
	
	          template: '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',
	
	          title: title,
	
	          container: 'body'
	        });
	
	        data.fv.disableSubmitButtons(false);
	      }).on('success.field.fv', function (e, data) {
	        data.element.tooltip('destroy');
	
	        data.fv.disableSubmitButtons(false);
	      })
	      // Revalidate the agb_ok by changes
	      .on('change', '[name="agb_ok"]', function () {
	        $(_this.el).formValidation('revalidateField', 'agb_ok');
	      })
	      // Revalidate Country by onload
	      .on('keyup', '[name="PLZ"]', function () {
	        // console.log('REV PLZ');
	        $(_this.el).formValidation('revalidateField', 'PLZ');
	      }).on('mouseenter', '#nextBtn', function () {
	        $(_this.el).formValidation('validate');
	      });
	    }
	  }, {
	    key: '_getProvinces',
	    value: function _getProvinces() {
	      var state = $(this.el).find('[name=State]');
	      $.post('/ajax.php', {
	        mode: 'getStates',
	        adduser: $('#Country').val()
	      }, function (response) {
	        $.each(response.states, function (idx, val) {
	          var defaultSelected = idx === response.defaultState ? ' selected="selected"' : '';
	          state.append('<option value="' + idx + '"' + defaultSelected + '>' + val + '</option>\n');
	        });
	      }, 'json');
	      state.attr('disabled', false).slideDown('fast');
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_getIcons',
	    value: function _getIcons() {
	      var icons = {
	        valid: 'fa fa-check',
	
	        invalid: 'fa fa-times',
	
	        validating: 'fa fa-refresh'
	      };
	
	      return icons;
	    }
	  }, {
	    key: '_getBreakpoint',
	    value: function _getBreakpoint() {
	      var breakpoint = void 0;
	
	      if (_modernizr2.default.mq('(min-width: 992px)')) {
	        breakpoint = 'screen-lg';
	      } else if (_modernizr2.default.mq('(min-width: 768px)')) {
	        breakpoint = 'screen-md';
	      } else {
	        breakpoint = 'screen-sm';
	      }
	
	      return breakpoint;
	    }
	  }, {
	    key: '_getFieldsToValidate',
	    value: function _getFieldsToValidate(form) {
	      var fields = void 0;
	
	      switch (form) {
	        case 'sendMessage':
	          fields = this._sendMessageFormFields();
	          break;
	        case 'resetPassword':
	          fields = this._resetPasswordFormFields();
	          break;
	        case 'sendUsername':
	          fields = this._sendUsernameFormFields();
	          break;
	        case 'contact':
	          fields = this._contactFormFields();
	          break;
	        case 'ownProfile':
	          fields = this._ownProfileFormFields();
	          break;
	        default:
	          fields = this._signupFormFields();
	      }
	
	      return fields;
	    }
	  }, {
	    key: '_ownProfileFormFields',
	    value: function _ownProfileFormFields() {
	      var fields = {
	        Email: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Email]').attr('data-fv-notempty-message')
	            },
	
	            regexp: {
	              regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line
	
	              message: $(this.el).find('[name=Email]').attr('data-fv-regexp-message')
	            }
	          }
	        },
	
	        Geosearch: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Geosearch]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_sendMessageFormFields',
	    value: function _sendMessageFormFields() {
	      var fields = {
	        subject: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=subject]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        message: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=message]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_resetPasswordFormFields',
	    value: function _resetPasswordFormFields() {
	      var fields = {
	        passwd: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=passwd]').attr('data-fv-notempty-message')
	            },
	
	            stringLength: {
	              min: 6,
	
	              message: $(this.el).find('[name=passwd]').attr('data-fv-stringlength-message')
	            }
	          }
	        },
	
	        passwdRepeat: {
	          verbose: false,
	
	          validators: {
	            identical: {
	              field: 'passwd',
	
	              message: $(this.el).find('[name=passwdRepeat]').attr('data-fv-identical-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_sendUsernameFormFields',
	    value: function _sendUsernameFormFields() {
	      var fields = {
	        Email: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Email]').attr('data-fv-notempty-message')
	            },
	
	            regexp: {
	              regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line
	
	              message: $(this.el).find('[name=Email]').attr('data-fv-regexp-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_contactFormFields',
	    value: function _contactFormFields() {
	      var fields = {
	        realname: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=realname]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        email: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=email]').attr('data-fv-notempty-message')
	            },
	
	            regexp: {
	              regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line
	
	              message: $(this.el).find('[name=email]').attr('data-fv-regexp-message')
	            }
	          }
	        },
	
	        subject: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=subject]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        question: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=question]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_signupFormFields',
	    value: function _signupFormFields() {
	      var fields = {
	        RegUsername: {
	          row: '.col-xs-6',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=RegUsername]').attr('data-fv-notempty-message')
	            },
	
	            callback: {
	              message: $(this.el).find('[name=RegUsername]').attr('data-fv-callback-message'),
	
	              callback: _validators2.default.checkUsername
	            }
	          }
	        },
	
	        RegPassword: {
	          row: '.col-xs-6',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=RegPassword]').attr('data-fv-notempty-message')
	            },
	
	            stringLength: {
	              min: 6,
	
	              message: $(this.el).find('[name=RegPassword]').attr('data-fv-stringlength-message')
	            },
	
	            different: {
	              field: 'RegUsername',
	
	              message: $(this.el).find('[name=RegPassword]').attr('data-fv-different-message')
	            }
	          }
	        },
	
	        RegEmail: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=RegEmail]').attr('data-fv-notempty-message')
	            },
	
	            callback: {
	              message: $(this.el).find('[name=RegEmail]').attr('data-fv-callback-message'),
	
	              callback: _validators2.default.checkEmail
	            }
	          }
	        },
	
	        birthday: {
	          row: '.col-xs-6',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=birthday]').attr('data-fv-notempty-message')
	            },
	
	            callback: {
	              message: $(this.el).find('[name=birthday]').attr('data-fv-date-message'),
	
	              callback: _validators2.default.checkDate
	            }
	          }
	        },
	
	        bday: {
	          row: '.col-xs-4',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=bday]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        bmonth: {
	          row: '.col-xs-4',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=bmonth]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        byear: {
	          row: '.col-xs-4',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=byear]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        Ich_suche: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Ich_suche]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        Geschlecht: {
	          row: '.col-xs-6',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Geschlecht]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        Partner: {
	          row: '.col-xs-6',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Partner]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        place_id: {
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Geosearch]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        Geosearch: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=Geosearch]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        agb_ok: {
	          row: '.col-xs-12',
	
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.el).find('[name=agb_ok]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	    /* eslint-enable */
	
	  }]);
	
	  return Formvalidation;
	}();
	
	exports.default = Formvalidation;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(4);
	
	__webpack_require__(3);
	
	var _external_links = __webpack_require__(12);
	
	var _external_links2 = _interopRequireDefault(_external_links);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ready() {
	  var externalLinks = new _external_links2.default();
	  externalLinks.init();
	
	  /**
	   * Activate Bootstrap popover
	   */
	  if (window.innerWidth > 1024) {
	    $('[data-toggle="popover"]').popover();
	  }
	
	  /**
	   * Automatically instantiates modules based on data-attributes specifying
	   * module file-names.
	   */
	  var moduleElements = document.querySelectorAll('[data-module]');
	
	  for (var i = 0; i < moduleElements.length; i += 1) {
	    var el = moduleElements[i];
	    var name = el.getAttribute('data-module');
	    var Module = __webpack_require__(74)("./" + name).default; // eslint-disable-line global-require, import/no-dynamic-require
	
	    new Module(el); // eslint-disable-line no-new
	  }
	}
	
	// in case the document is already rendered
	if (document.readyState !== 'loading') {
	  ready();
	} else {
	  document.addEventListener('DOMContentLoaded', ready);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TreffToolTip = function TreffToolTip() {
	  _classCallCheck(this, TreffToolTip);
	
	  $('body').tooltip({
	    selector: '.treff-tooltip',
	    template: '<div data-test="test" class="tt tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
	  });
	};
	
	exports.default = TreffToolTip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modernizr = __webpack_require__(3);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(6);
	
	__webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidateMessageForm = function () {
	  function ValidateMessageForm(elem) {
	    _classCallCheck(this, ValidateMessageForm);
	
	    this.form = elem;
	
	    this.framework = 'bootstrap';
	    this.trigger = 'blur';
	    this.breakpoint = this._getBreakpoint();
	    this.fields = this._getFieldsToValidate();
	    this.icons = this._getIcons();
	
	    this.init();
	  }
	
	  _createClass(ValidateMessageForm, [{
	    key: 'init',
	    value: function init() {
	      if (this.breakpoint === 'screen-sm') {
	        this._validateForm(this._getValidationObject());
	      } else {
	        this._validateFormWithTooltip(this._getValidationObject({
	          err: {
	            container: 'tooltip'
	          }
	        }));
	      }
	    }
	  }, {
	    key: '_validateForm',
	    value: function _validateForm(obj) {
	      var _this = this;
	
	      $(this.form).formValidation(obj).on('success.form.fv', function (e) {
	        // Prevent form submission
	        e.preventDefault();
	        _this._processForm(e);
	      });
	    }
	  }, {
	    key: '_validateFormWithTooltip',
	    value: function _validateFormWithTooltip(obj) {
	      var _this2 = this;
	
	      $(this.form).formValidation(obj).on('err.field.fv', function (e, data) {
	        var $input = data.element[0];
	        var placement = $input.getAttribute('data-fv-tooltip-placement');
	        var $icon = data.element.data('fv.icon');
	        var title = $icon.data('bs.tooltip').getTitle();
	
	        $icon.tooltip('destroy');
	
	        data.element.tooltip({
	          html: true,
	
	          placement: placement,
	
	          template: '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',
	
	          title: title,
	
	          container: 'body'
	        });
	      }).on('success.field.fv', function (e, data) {
	        data.element.tooltip('destroy');
	      }).on('success.form.fv', function (e) {
	        // Prevent form submission
	        e.preventDefault();
	
	        _this2._processForm(e);
	      });
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_processForm',
	    value: function _processForm(e) {
	      var _this3 = this;
	
	      var $form = $(e.target);
	      var formData = new FormData();
	      var params = $form.serializeArray();
	      // const { files } = $form.find('[name="uploadedFiles"]')[0].files;
	      // const { files } = $('input[name="uploadedFiles"]')[0].files;
	      // console.log('input[name="uploadedFiles"');
	      // console.log($('input[name="uploadedFiles"]')[0].files);
	      // console.log('files');
	      // console.log(files);
	
	      var $alert = $('#message-box-pn');
	      //  const $alertSuccessTitle = $alert.attr('data-info-title');
	      var $alertSuccessTitle = $alert.attr('');
	      //  const $alertDangerTitle = $alert.attr('data-info-title');
	      var $alertDangerTitle = $alert.attr('');
	
	      // $.each($('input[name="uploadedFiles"]')[0].files, (i, file) => {
	      // Prefix the name of uploaded files with "uploadedFiles-"
	      // formData.append(`uploadedFiles-${i}`, file);
	      // });
	
	      $.each(params, function (i, val) {
	        formData.append(val.name, val.value);
	        if (val.name === 'recipient_id') {
	          _this3.recipient_id = val.value;
	        }
	      });
	
	      var request = $.ajax({
	        beforeSend: function beforeSend() {
	          $('#js-loader').show();
	        },
	        cache: false,
	
	        contentType: false,
	
	        processData: false,
	
	        url: $form.attr('action'),
	
	        type: 'POST',
	
	        data: formData
	      });
	      // console.log(request);
	      request.done(function (response) {
	        // console.log(response);
	        var $formGroup = $form.find('.form-group');
	        var $formGroupIcon = $formGroup.find('i');
	        var $submitBtn = $form.find('[type=submit]');
	        if (response.type === 'info') {
	          // Remove the has-success class
	          $formGroup.removeClass('has-success');
	          // Hide the success icon
	          $formGroupIcon.hide();
	          // Activate Button
	          $submitBtn.removeClass('disabled');
	          $submitBtn.attr('disabled', false);
	          // Reset form
	          $form[0].reset();
	          // Show success message
	          $alert.find('p:first-child').text($alertSuccessTitle);
	          $alert.find('p:last-child').text(response.MESSAGE);
	          $alert.removeClass('alert-danger');
	          $alert.addClass('alert-success');
	          $alert.slideDown();
	          setTimeout(function () {
	            $alert.slideUp();
	            $alert.removeClass('alert-success');
	            $alert.find('p:first-child').html('');
	            $alert.find('p:last-child').html('');
	          }, 6000);
	          document.querySelector('#queue').innerHTML = '';
	          document.querySelector('#uploadifive-uploadifive').style.display = '';
	          // window.location.href = `/profile.php?id=${this.recipient_id}&n=1`;
	        } else {
	          // Remove the has-success class
	          $formGroup.removeClass('has-success');
	          // Hide the success icon
	          $formGroupIcon.hide();
	          // Activate Button
	          $submitBtn.removeClass('disabled');
	          $submitBtn.attr('disabled', false);
	          // Reset form
	          // $form[0].reset();
	          // Show danger message
	          $alert.find('p:first-child').text($alertDangerTitle);
	          $alert.find('p:last-child').html(response.MESSAGE);
	          $alert.removeClass('alert-success');
	          $alert.addClass('alert-danger');
	          $alert.slideDown();
	          setTimeout(function () {
	            $alert.slideUp();
	            $alert.removeClass('alert-danger');
	            $alert.find('p:first-child').html('');
	            $alert.find('p:last-child').html('');
	          }, 6000);
	        }
	      });
	
	      request.fail(function (jqXHR, textStatus) {
	        // Show error message
	        $alert.show(textStatus);
	      });
	
	      request.always(function () {
	        $('#js-loader').hide();
	      });
	    }
	  }, {
	    key: '_getIcons',
	    value: function _getIcons() {
	      var icons = {
	        valid: 'fa fa-check',
	
	        invalid: 'fa fa-times',
	
	        validating: 'fa fa-refresh'
	      };
	
	      return icons;
	    }
	  }, {
	    key: '_getBreakpoint',
	    value: function _getBreakpoint() {
	      var breakpoint = void 0;
	
	      if (_modernizr2.default.mq('(min-width: 992px)')) {
	        breakpoint = 'screen-lg';
	      } else if (_modernizr2.default.mq('(min-width: 768px)')) {
	        breakpoint = 'screen-md';
	      } else {
	        breakpoint = 'screen-sm';
	      }
	
	      return breakpoint;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }, {
	    key: '_getFieldsToValidate',
	    value: function _getFieldsToValidate() {
	      var fields = {
	        subject: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.form).find('[name=subject]').attr('data-fv-notempty-message')
	            }
	          }
	        },
	
	        message: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.form).find('[name=message]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_getValidationObject',
	    value: function _getValidationObject() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$framework = _ref.framework,
	          framework = _ref$framework === undefined ? this.framework : _ref$framework,
	          _ref$icon = _ref.icon,
	          icon = _ref$icon === undefined ? this.icons : _ref$icon,
	          _ref$fields = _ref.fields,
	          fields = _ref$fields === undefined ? this.fields : _ref$fields,
	          _ref$trigger = _ref.trigger,
	          trigger = _ref$trigger === undefined ? this.trigger : _ref$trigger,
	          err = _ref.err;
	
	      var object = {
	        framework: framework,
	        icon: icon,
	        fields: fields,
	        trigger: trigger,
	        err: err
	      };
	
	      return object;
	    }
	  }]);
	
	  return ValidateMessageForm;
	}();
	
	exports.default = ValidateMessageForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modernizr = __webpack_require__(3);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(6);
	
	__webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidateMessageboxFolderForm = function () {
	  function ValidateMessageboxFolderForm(elem) {
	    _classCallCheck(this, ValidateMessageboxFolderForm);
	
	    this.form = elem;
	
	    this.framework = 'bootstrap';
	    this.trigger = 'blur';
	    this.breakpoint = this._getBreakpoint();
	    this.fields = this._getFieldsToValidate();
	    this.icons = this._getIcons();
	
	    this.init();
	  }
	
	  _createClass(ValidateMessageboxFolderForm, [{
	    key: 'init',
	    value: function init() {
	      if (this.breakpoint === 'screen-sm') {
	        this._validateForm(this._getValidationObject());
	      } else {
	        var validationObject = this._getValidationObject({
	          err: { container: 'tooltip' }
	        });
	
	        this._validateFormWithTooltip(validationObject);
	      }
	    }
	  }, {
	    key: '_validateForm',
	    value: function _validateForm(obj) {
	      var _this = this;
	
	      $(this.form).formValidation(obj).on('success.form.fv', function (e) {
	        if (e.target.classList.contains('js-inplace-edit')) {
	          e.preventDefault();
	          _this._processForm(e);
	        }
	      });
	    }
	  }, {
	    key: '_validateFormWithTooltip',
	    value: function _validateFormWithTooltip(obj) {
	      var _this2 = this;
	
	      $(this.form).formValidation(obj).on('err.field.fv', function (e, data) {
	        var $input = data.element[0];
	        var placement = $input.getAttribute('data-fv-tooltip-placement');
	        var $icon = data.element.data('fv.icon');
	        var title = $icon.data('bs.tooltip').getTitle();
	
	        $icon.tooltip('destroy');
	
	        data.element.tooltip({
	          html: true,
	
	          placement: placement,
	
	          template: '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',
	
	          title: title,
	
	          container: 'body'
	        });
	      }).on('success.field.fv', function (e, data) {
	        data.element.tooltip('destroy');
	      }).on('success.form.fv', function (e) {
	        if (e.target.classList.contains('js-inplace-edit')) {
	          e.preventDefault();
	
	          _this2._processForm(e);
	        }
	      });
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_processForm',
	    value: function _processForm(e) {
	      var $form = $(e.target);
	
	      // Generate data object
	      var data = {};
	
	      // Collect form data
	      $form.serialize().split('&').forEach(function (set) {
	        var arr = set.split('=');
	        var key = arr[0];
	        var val = arr[1];
	
	        data[key] = val;
	      });
	
	      // Clean-up form data for renaming
	      data.album_name = data.foldername;
	      delete data.foldername;
	
	      // Send form data to server
	      var request = $.ajax({
	        url: $form.attr('action'),
	
	        type: 'POST',
	
	        data: data
	      });
	
	      var $folder = $form.parents('tr[data-folder]');
	      var $folderLink = $folder.find('.js-folder-link');
	      // console.log('$folderLink from validate');
	      // console.log($folderLink);
	      var $folderRename = $folder.find('[data-folder-action="rename"]');
	      var $folderCancel = $folder.find('[data-folder-action="cancel"]');
	
	      var $formGroup = $form.find('.form-group');
	      var $formGroupIcon = $formGroup.find('i.form-control-feedback');
	      var $formGroupInput = $form.find('input[name="foldername"]');
	      var $formGroupButton = $form.find('[type=submit]');
	
	      request.done(function () {
	        // Reset form
	        $form[0].reset();
	        // Remove the has-success class
	        $formGroup.removeClass('has-success');
	        // Hide the success icon
	        $formGroupIcon.hide();
	        // Change input value to new foldername
	        $formGroupInput.val(data.album_name);
	        // Activate Button
	        $formGroupButton.removeClass('disabled');
	        $formGroupButton.attr('disabled', false);
	        // Hide form
	        $form.css('display', 'none');
	        // Change folder link to new foldername
	        $folderLink.find('a span').text(data.album_name);
	        // Show folder link
	        $folderLink.css('display', '');
	        // Hide cancel link
	        $folderCancel.css('display', 'none');
	        // Show rename link
	        // console.log('SHOW FOLDERRENAME BUTTON');
	        $folderRename.css('display', '');
	      });
	
	      request.fail(function (jqXHR) {
	        var $domAnchor = $folder.find('td');
	        var $errorContainer = document.createElement('div');
	        var errorMessage = document.createTextNode(jqXHR.status + ': ' + jqXHR.statusText);
	
	        // Append error message to error container
	        $errorContainer.appendChild(errorMessage);
	        // Add bootstarp alert styles to error container
	        $errorContainer.classList.add('alert', 'alert-danger');
	
	        // Remove the has-success class
	        $formGroup.removeClass('has-success');
	        // Add the has-error class
	        $formGroup.addClass('has-error');
	        // Change the success icon with the error icon
	        $formGroupIcon.removeClass('fa-check');
	        $formGroupIcon.addClass('fa-times');
	        // Add the error container to the DOM
	        $domAnchor.prepend($errorContainer);
	      });
	    }
	  }, {
	    key: '_getIcons',
	    value: function _getIcons() {
	      var icons = {
	        valid: 'fa fa-check',
	
	        invalid: 'fa fa-times',
	
	        validating: 'fa fa-refresh'
	      };
	
	      return icons;
	    }
	  }, {
	    key: '_getBreakpoint',
	    value: function _getBreakpoint() {
	      var breakpoint = void 0;
	
	      if (_modernizr2.default.mq('(min-width: 992px)')) {
	        breakpoint = 'screen-lg';
	      } else if (_modernizr2.default.mq('(min-width: 768px)')) {
	        breakpoint = 'screen-md';
	      } else {
	        breakpoint = 'screen-sm';
	      }
	
	      return breakpoint;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }, {
	    key: '_getFieldsToValidate',
	    value: function _getFieldsToValidate() {
	      var fields = {
	        foldername: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.form).find('[name=foldername]').attr('data-fv-notempty-message')
	            },
	
	            stringLength: {
	              max: 18,
	
	              message: $(this.form).find('[name=foldername]').attr('data-fv-stringlength-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_getValidationObject',
	    value: function _getValidationObject() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$framework = _ref.framework,
	          framework = _ref$framework === undefined ? this.framework : _ref$framework,
	          _ref$icon = _ref.icon,
	          icon = _ref$icon === undefined ? this.icons : _ref$icon,
	          _ref$fields = _ref.fields,
	          fields = _ref$fields === undefined ? this.fields : _ref$fields,
	          _ref$trigger = _ref.trigger,
	          trigger = _ref$trigger === undefined ? this.trigger : _ref$trigger,
	          err = _ref.err;
	
	      var object = {
	        framework: framework,
	        icon: icon,
	        fields: fields,
	        trigger: trigger,
	        err: err
	      };
	
	      return object;
	    }
	  }]);
	
	  return ValidateMessageboxFolderForm;
	}();
	
	exports.default = ValidateMessageboxFolderForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modernizr = __webpack_require__(3);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(6);
	
	__webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ValidateMiscMessageForm = function () {
	  function ValidateMiscMessageForm(elem) {
	    _classCallCheck(this, ValidateMiscMessageForm);
	
	    this.form = elem;
	    // console.log(this.form);
	
	    this.framework = 'bootstrap';
	    this.trigger = 'blur';
	    this.breakpoint = this._getBreakpoint();
	    this.fields = this._getFieldsToValidate();
	    this.icons = this._getIcons();
	    console.log(this.fields);
	
	    this.init();
	  }
	
	  _createClass(ValidateMiscMessageForm, [{
	    key: 'init',
	    value: function init() {
	      if (this.breakpoint === 'screen-sm') {
	        this._validateForm(this._getValidationObject());
	      } else {
	        this._validateFormWithTooltip(this._getValidationObject({
	          err: {
	            container: 'tooltip'
	          }
	        }));
	      }
	    }
	  }, {
	    key: '_validateForm',
	    value: function _validateForm(obj) {
	      var _this = this;
	
	      $(this.form).formValidation(obj).on('success.form.fv', function (e) {
	        // Prevent form submission
	        e.preventDefault();
	        _this._processForm(e);
	      });
	    }
	  }, {
	    key: '_validateFormWithTooltip',
	    value: function _validateFormWithTooltip(obj) {
	      var _this2 = this;
	
	      $(this.form).formValidation(obj).on('err.field.fv', function (e, data) {
	        var $input = data.element[0];
	        var placement = $input.getAttribute('data-fv-tooltip-placement');
	        var $icon = data.element.data('fv.icon');
	        var title = $icon.data('bs.tooltip').getTitle();
	
	        $icon.tooltip('destroy');
	
	        data.element.tooltip({
	          html: true,
	
	          placement: placement,
	
	          template: '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',
	
	          title: title,
	
	          container: 'body'
	        });
	      }).on('success.field.fv', function (e, data) {
	        data.element.tooltip('destroy');
	      }).on('success.form.fv', function (e) {
	        // Prevent form submission
	        e.preventDefault();
	
	        _this2._processForm(e);
	      });
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_processForm',
	    value: function _processForm(e) {
	      var _this3 = this;
	
	      var $form = $(e.target);
	      var formData = new FormData();
	      var params = $form.serializeArray();
	      var $alert = $('#message-box');
	      // const $alertSuccessTitle = $alert.attr('');
	      // const $alertDangerTitle = $alert.attr('');
	      $.each(params, function (i, val) {
	        formData.append(val.name, val.value);
	        if (val.name === 'recipient_id') {
	          _this3.recipient_id = val.value;
	        }
	      });
	      var request = $.ajax({
	        beforeSend: function beforeSend() {
	          $('#js-loader').show();
	        },
	        cache: false,
	        contentType: false,
	        processData: false,
	        url: $form.attr('action'),
	        type: 'POST',
	        data: formData
	      });
	      // console.log(request);
	      request.done(function (response) {
	        console.log(response);
	      });
	
	      request.fail(function (jqXHR, textStatus) {
	        // Show error message
	        $alert.show(textStatus);
	      });
	
	      request.always(function () {
	        $('#js-loader').hide();
	      });
	    }
	  }, {
	    key: '_getIcons',
	    value: function _getIcons() {
	      var icons = {
	        valid: 'fa fa-check',
	
	        invalid: 'fa fa-times',
	
	        validating: 'fa fa-refresh'
	      };
	
	      return icons;
	    }
	  }, {
	    key: '_getBreakpoint',
	    value: function _getBreakpoint() {
	      var breakpoint = void 0;
	
	      if (_modernizr2.default.mq('(min-width: 992px)')) {
	        breakpoint = 'screen-lg';
	      } else if (_modernizr2.default.mq('(min-width: 768px)')) {
	        breakpoint = 'screen-md';
	      } else {
	        breakpoint = 'screen-sm';
	      }
	
	      return breakpoint;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }, {
	    key: '_getFieldsToValidate',
	    value: function _getFieldsToValidate() {
	      var fields = {
	        message: {
	          verbose: false,
	
	          validators: {
	            notEmpty: {
	              message: $(this.form).find('[name="misc"]').attr('data-fv-notempty-message')
	            }
	          }
	        }
	      };
	
	      return fields;
	    }
	  }, {
	    key: '_getValidationObject',
	    value: function _getValidationObject() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$framework = _ref.framework,
	          framework = _ref$framework === undefined ? this.framework : _ref$framework,
	          _ref$icon = _ref.icon,
	          icon = _ref$icon === undefined ? this.icons : _ref$icon,
	          _ref$fields = _ref.fields,
	          fields = _ref$fields === undefined ? this.fields : _ref$fields,
	          _ref$trigger = _ref.trigger,
	          trigger = _ref$trigger === undefined ? this.trigger : _ref$trigger,
	          err = _ref.err;
	
	      var object = {
	        framework: framework,
	        icon: icon,
	        fields: fields,
	        trigger: trigger,
	        err: err
	      };
	
	      return object;
	    }
	  }]);
	
	  return ValidateMiscMessageForm;
	}();
	
	exports.default = ValidateMiscMessageForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = {"languages":[{"default":{"format":"L","locale":"en","today":"Go to today","clear":"Clear selection","close":"Close","selectMonth":"Select Month","prevMonth":"Previous Month","nextMonth":"Next Month","selectYear":"Select Year","prevYear":"Previous Year","nextYear":"Next Year","selectDecade":"Select Decade","prevDecade":"Previous Decade","nextDecade":"Next Decade","prevCentury":"Previous Century","nextCentury":"Next Century"},"de":{"format":"L","locale":"de","today":"Zu heute wechseln","clear":"Auswahl löschen","close":"Schließen","selectMonth":"Monat auswählen","prevMonth":"Vorheriger Monat","nextMonth":"Nächster Monat","selectYear":"Jahr auswählen","prevYear":"Vorheriges Jahr","nextYear":"Nächstes Jahr","selectDecade":"Dekade auswählen","prevDecade":"Vorherige Dekade","nextDecade":"Nächste Dekade","prevCentury":"Vorheriges Jahrhundert","nextCentury":"Nächstes Jahrhundert"},"en":{"format":"L","locale":"en","today":"Go to today","clear":"Clear selection","close":"Close","selectMonth":"Select Month","prevMonth":"Previous Month","nextMonth":"Next Month","selectYear":"Select Year","prevYear":"Previous Year","nextYear":"Next Year","selectDecade":"Select Decade","prevDecade":"Previous Decade","nextDecade":"Next Decade","prevCentury":"Previous Century","nextCentury":"Next Century"},"fr":{"format":"L","locale":"fr","today":"Aller à aujourd'hui","clear":"Effacer la sélection","close":"Fermer","selectMonth":"Sélectionner le mois","prevMonth":"Mois précédent","nextMonth":"Mois suivant","selectYear":"Sélectionner l'année","prevYear":"Année précédente","nextYear":"Année suivante","selectDecade":"Sélectionner la décennie","prevDecade":"Décennie précédente","nextDecade":"Décennie suivante","prevCentury":"Siècle précédent","nextCentury":"Siècle suivant"},"it":{"format":"L","locale":"it","today":"Vai a oggi","clear":"Pulisci la sezione","close":"Chiudi","selectMonth":"Seleziona il mese","prevMonth":"Mese precedente","nextMonth":"Mese successivo","selectYear":"Seleziona l'anno","prevYear":"Anno precedente","nextYear":"Anno successivo","selectDecade":"Seleziona decennio","prevDecade":"Decennio precedente","nextDecade":"Prossimo decennio","prevCentury":"Secolo precedente","nextCentury":"Secolo successivo"},"hu":{"format":"L","locale":"hu","today":"Menj a mára","clear":"Kiválasztás törlése","close":"Bezár","selectMonth":"Válassza ki a hónapot","prevMonth":"Előző hónap","nextMonth":"Következő hónap","selectYear":"Válassza ki az évet","prevYear":"Előző év","nextYear":"Következő év","selectDecade":"Válassza az évtizedet","prevDecade":"Előző évtized","nextDecade":"Következő évtized","prevCentury":"Múlt század","nextCentury":"Következő század"}}]}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _treffcook = __webpack_require__(9);
	
	var _treffcook2 = _interopRequireDefault(_treffcook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Updates the chatbox toggle button.
	exports.updateSliderToggle = function (item) {
	  if ($(item).hasClass('chatbox-closed')) {
	    $(item).removeClass('chatbox-closed').addClass('chatbox-open').find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
	    _treffcook2.default.Set('dcbxmin', 0, 3600, '/');
	  } else {
	    $(item).removeClass('chatbox-open').addClass('chatbox-closed').find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
	    _treffcook2.default.Set('dcbxmin', 1, 3600, '/');
	  }
	};
	exports.try2play = function () {
	  var dcsound = document.getElementById('dcaudio');
	  dcsound.play();
	};
	// Global call to obtain all chat posts.
	// It is executed by an interval.
	exports.checkChatState = function () {
	  $.ajax({
	    url: '/directchat/ajax_chat.php',
	    method: 'POST',
	    type: 'json',
	    data: {
	      mode: 'checkStates'
	    },
	    success: function success(data) {
	      var response = $.parseJSON(data);
	      var total = parseInt(response.total, 10);
	      if (total > 0) {
	        $('body').find('#navbar-chat-info-bubble, #unread-chat-info-bubble, #dc-chat-info-bubble').html(response.total).show();
	        if (parseInt(_treffcook2.default.Get('numofnew'), 10) < parseInt(total, 10)) {
	          if (parseInt(_treffcook2.default.Get('private_sound'), 10) === 1) {
	            var dcsound = document.getElementById('dcaudio');
	            dcsound.play();
	            // console.log('lib private_sound', cookie.Get('private_sound'));
	          }
	          _treffcook2.default.Set('numofnew', total, 3600, '/');
	        }
	        if (Object.keys(response.new_messages).length > 0) {
	          $.each(response.new_messages, function (cid, num) {
	            var itenID = '#' + cid + '_message_info';
	            if (num > 0) {
	              $('body').find(itenID).html(num).show();
	            } else {
	              $('body').find(itenID).html('').hide();
	            }
	          });
	        }
	      } else {
	        $('body').find('#navbar-chat-info-bubble, #unread-chat-info-bubble, #dc-chat-info-bubble').hide();
	      }
	    }
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	exports.getCacheBustedLink = function () {
	  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ajax';
	  var fileprefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'php';
	
	  var cacheBuster = new Date().getTime();
	  var returnString = '' + root + filename + cacheBuster + '.' + fileprefix;
	  return returnString;
	};
	
	exports.hideMessage = function (id, classSuffix, reload, sttoClear, toAction) {
	  var msgContainer = $(id);
	  msgContainer.slideUp('slow');
	  msgContainer.removeClass('alert-danger alert-success');
	  msgContainer.find('p:first-child').html('');
	  msgContainer.find('p:last-child').html('');
	  // clear
	  if (sttoClear) {
	    clearTimeout(toAction);
	  }
	  if (reload === 1) {
	    window.location = window.location.href;
	  }
	};
	
	exports.showMessage = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
	  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#message-box';
	  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	  var tout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10000;
	  var callBack = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	
	  var reload = 0;
	  if (callBack === 'reloadpage') {
	    reload = 1;
	  }
	  var classSuffix = type === 'error' ? 'danger' : 'success';
	  var msgContainer = $(id);
	  var duration = tout === 'wait' ? 2000000 : tout;
	  msgContainer.removeClass('alert-danger alert-success');
	  msgContainer.find('p:first-child').html(title);
	  msgContainer.find('p:last-child').html(text);
	  msgContainer.addClass('alert-' + classSuffix);
	  msgContainer.slideDown();
	  setTimeout(function (mySo) {
	    var sttoClear = tout === 'wait';
	    if (tout === 'wait') {
	      var confirmButton = document.createElement('button');
	      $(confirmButton).addClass('btn');
	      $(confirmButton).addClass('btn-success');
	      $(confirmButton).attr('id', 'confirm-me');
	      $(confirmButton).text('Ok');
	      msgContainer.append(confirmButton);
	      $('body').on('click', '#confirm-me', function () {
	        callBack();
	      });
	    }
	    module.exports.hideMessage(id, classSuffix, reload, sttoClear, mySo);
	  }, duration);
	};
	
	exports.standardMessage = function (target, action, partnerId, success) {
	  checkSendPermissionsSimple(partnerId, "SMILE").then(function (permissions) {
	    if (permissions.checkFailed === true) {
	      exports.showMessage("error", "#message-box", "", permissions.errorMessage, 99999999);
	      if (permissions.showPremium === true) {
	        $('#message-box p:last-child').append($('<br>')).append($('<br>')).append($('<div>').addClass('text-center').html(i8n.error.Become_premium_button));
	      }
	      return false;
	    }
	
	    var data = new FormData();
	
	    data.append("message", new Blob([JSON.stringify({
	      message: "",
	      type: action
	    })], {
	      type: "application/json"
	    }));
	
	    fetch('/api/v1/public/message-threads/' + partnerId, {
	      method: "POST", // *GET, POST, PUT, DELETE, etc.
	      body: data // body data type must match "Content-Type" header
	    }).then(function (r) {
	      success(r);
	    });
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _croppie = __webpack_require__(58);
	
	var _croppie2 = _interopRequireDefault(_croppie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CroppieTest = function () {
	  function CroppieTest(el) {
	    _classCallCheck(this, CroppieTest);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(CroppieTest, [{
	    key: 'init',
	    value: function init() {
	      this.vanillaResult = document.querySelector('.vanilla-result');
	      this.vanillaSave = document.querySelector('.vanilla-save');
	      this.vanillaRotate = document.querySelector('.vanilla-rotate');
	      this.image = this.el.getAttribute('data-file');
	      this.demoVanilla();
	    }
	  }, {
	    key: 'demoVanilla',
	    value: function demoVanilla() {
	      var _this = this;
	
	      var vanilla = new _croppie2.default(document.getElementById('vanilla-demo'), {
	        viewport: {
	          width: 81,
	          height: 108
	        },
	        boundary: {
	          width: 450,
	          height: 600
	        },
	        enableOrientation: true
	      });
	      vanilla.bind({
	        url: this.image
	      });
	      this.vanillaResult.addEventListener('click', function () {
	        vanilla.result({
	          type: 'canvas',
	          format: 'jpeg',
	          quality: 1
	        }).then(_this.resultVanilla(vanilla.result));
	      });
	      this.vanillaSave.addEventListener('click', function () {
	        vanilla.result({
	          type: 'canvas',
	          format: 'jpeg',
	          quality: 1
	        }).then(_this.saveVanilla(vanilla.result));
	      });
	      this.vanillaRotate.addEventListener('click', function (e) {
	        vanilla.rotate(parseInt(e.target.getAttribute('data-deg'), 10));
	      });
	    }
	  }, {
	    key: 'resultVanilla',
	    value: function resultVanilla(result) {
	      // console.log(result);
	      // console.log('result von resultVanilla', result);
	      var resultWrapper = document.getElementById('vanilla-cropped');
	      var img = new Image();
	      img.src = result;
	      resultWrapper.innerHTML = '';
	      resultWrapper.appendChild(img);
	      var data = {
	        file: result,
	        otra: 'otra c'
	      };
	      $.ajax({
	        url: 'operations.php',
	        method: 'POST',
	        type: 'json',
	        data: data,
	        success: function success() {
	          // console.log(response);
	        }
	      });
	    }
	  }, {
	    key: 'saveVanilla',
	    value: function saveVanilla(result) {
	      return result;
	      // console.log(result);
	      // console.log('result von saveVanilla', result);
	      // let textStr = `<a id="save" href="${result}" download="result">`;
	      // textStr = `${textStr}<img src="${result}" /><br>`;
	      // textStr = `${textStr}<button>Download</button></a>`;
	      // console.log(textStr);
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return CroppieTest;
	}();
	
	exports.default = CroppieTest;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _corejsTypeahead = __webpack_require__(90);
	
	var _corejsTypeahead2 = _interopRequireDefault(_corejsTypeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// eslint-disable-line
	
	var Typeahead = function () {
	  function Typeahead(el) {
	    _classCallCheck(this, Typeahead);
	
	    this.el = el;
	    this.init();
	  }
	
	  _createClass(Typeahead, [{
	    key: 'init',
	    value: function init() {
	      $('#the-basics .typeahead').typeahead({
	        hint: true,
	        highlight: true,
	        minLength: 1
	      }, {
	        source: this._substringMatcher2()
	      });
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_substringMatcher2',
	    value: function _substringMatcher2() {
	      return function findMatches(q, cb) {
	        // an array that will be populated with substring matches
	        var matches = [];
	        // const strs = [];
	        $.ajax({
	          url: '/autocomplete_ajax.php',
	          type: 'POST',
	          dataType: 'JSON',
	          async: false,
	          data: {
	            mode: 'test',
	            qry: q
	          },
	          success: function success(data) {
	            // console.log(data);
	            data.forEach(function (str) {
	              matches.push(str);
	            });
	          }
	        });
	        // console.log(matches);
	        cb(matches);
	      };
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_substringMatcher',
	    value: function _substringMatcher(strs) {
	      return function findMatches(q, cb) {
	        // an array that will be populated with substring matches
	        var matches = [];
	
	        // regex used to determine if a string contains the substring `q`
	        var substrRegex = new RegExp(q, 'i');
	
	        // iterate through the pool of strings and for any string that
	        // contains the substring `q`, add it to the `matches` array
	        $.each(strs, function (i, str) {
	          if (substrRegex.test(str)) {
	            matches.push(str);
	          }
	        });
	
	        cb(matches);
	      };
	    }
	  }, {
	    key: '_getStates',
	    value: function _getStates() {
	      return ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return Typeahead;
	}();
	
	exports.default = Typeahead;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AutoSave = function () {
	  function AutoSave(el) {
	    var _this = this;
	
	    _classCallCheck(this, AutoSave);
	
	    this.el = el;
	    this.saveButton = this.el.querySelector('.do-button');
	    // Methods are l (local - simple-data-storage) or r (remote - ajax callbak)
	    // for the first disabled
	    if (this.storageAvailable('localStorage')) {
	      this.storeMethod = 'r';
	    } else {
	      this.storeMethod = 'r';
	    }
	    this.fields = this.el.getAttribute('data-as-fields').replace(/\s/g, '').split(',');
	    this.urlHash = window.md5(window.location.href.substr(0, window.location.href.length - window.location.hash.length));
	    this.saveButton.addEventListener('click', function () {
	      if (_this.storeMethod === 'r') {
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          type: 'json',
	          data: {
	            mode: 'as_del',
	            urlhash: _this.urlHash
	          }
	        });
	      } else {
	        localStorage.removeItem(_this.urlHash);
	      }
	    });
	    // localStorage.removeItem(this.urlHash);
	
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(AutoSave, [{
	    key: 'init',
	    value: function init() {
	      this.compareData();
	      this.startAutoSave(20000);
	    }
	  }, {
	    key: 'compareData',
	    value: function compareData() {
	      // console.log('compareData');
	      // console.log(Date.now());
	      if (this.storeMethod === 'r') {
	        this.dbData = this.readDataRemote();
	      } else {
	        this.dbData = this.readDataLocal();
	      }
	      if (this.dbData === null || this.dbData === undefined || Object.entries(this.dbData).toString().length === 0) {
	        this.dbData = { counter: 0 };
	      } else {
	        this.dbData = JSON.parse(this.dbData);
	      }
	      this.currentData = this.readCurrent();
	      // console.log('this.dbData', this.dbData);
	      // console.log('this.currentData', this.currentData);
	      if (this.currentData.counter === 0 && this.dbData.counter !== 0) {
	        // console.log('this.currentData.counter is: ');
	        // console.log(this.currentData.counter);
	        this.readCurrent(1);
	      } else {
	        this.saveData(JSON.stringify(this.currentData));
	      }
	      //  Object.entries(this.currentData).toString() !==
	      //  Object.entries(this.dbData).toString()
	    }
	  }, {
	    key: 'readCurrent',
	    value: function readCurrent(n) {
	      var _this2 = this;
	
	      n = n || 0; // eslint-disable-line no-param-reassign
	      var result = { astime: Date.now(), counter: 0 };
	      this.fields.forEach(function (field) {
	        var vari = field.split('=');
	        var type = vari[0];
	        var name = vari[1];
	        var inputField = '';
	        var selector = '';
	        switch (type) {
	          case 'i':
	            selector = 'input[name="' + name + '"]';
	            inputField = _this2.el.querySelector(selector);
	            if (n) {
	              inputField.value = _this2.dbData[name];
	            }
	            result[name] = inputField.value;
	            result.counter += result[name].length;
	            break;
	          case 'tc':
	            if (n) {
	              window.CKEDITOR.instances.text.setData(_this2.dbData[name]);
	            }
	            result[name] = window.CKEDITOR.instances.text.getData();
	            result.counter += result[name].length;
	            break;
	          case 't':
	            selector = 'textarea[name="' + name + '"]';
	            // console.log(selector);
	            inputField = _this2.el.querySelector(selector);
	            if (n) {
	              inputField.value = _this2.dbData[name];
	            }
	            result[name] = inputField.value;
	            result.counter += result[name].length;
	            break;
	          case 's':
	            selector = 'select[name="' + name + '"]';
	            inputField = _this2.el.querySelector(selector);
	            if (n) {
	              inputField.value = _this2.dbData[name];
	            }
	            result[name] = inputField.value;
	            // result.counter += result[name].length;
	            break;
	          default: // Do nothing
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(content) {
	      // console.log('asegura local');
	      // console.log(content);
	      if (this.storeMethod === 'r') {
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          type: 'json',
	          data: {
	            mode: 'as_set',
	            urlhash: this.urlHash,
	            content: content
	          }
	        });
	      } else {
	        localStorage.setItem(this.urlHash, content);
	      }
	    }
	  }, {
	    key: 'readDataLocal',
	    value: function readDataLocal() {
	      return localStorage.getItem(this.urlHash);
	    }
	  }, {
	    key: 'readDataRemote',
	    value: function readDataRemote() {
	      var output = void 0;
	      $.ajax({
	        url: '/ajax.php',
	        method: 'POST',
	        type: 'json',
	        async: false,
	        data: {
	          mode: 'as_get',
	          urlhash: this.urlHash
	        },
	        success: function success(respons) {
	          output = respons.savedAS;
	        }
	      });
	      return output;
	    }
	  }, {
	    key: 'storageAvailable',
	    value: function storageAvailable(type) {
	      var storage = void 0;
	      var response = void 0;
	      try {
	        storage = window[type];
	        var x = '__storage_test__';
	        storage.setItem(x, x);
	        storage.removeItem(x);
	        response = true;
	      } catch (e) {
	        storage = e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
	      }
	      return response;
	    }
	
	    // Start interval action - look for changes and save them.
	
	  }, {
	    key: 'startAutoSave',
	    value: function startAutoSave(duration) {
	      var _this3 = this;
	
	      setInterval(function () {
	        _this3.compareData();
	      }, duration);
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return AutoSave;
	}();
	
	exports.default = AutoSave;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bootstrap3Dialog = __webpack_require__(89);
	
	var _bootstrap3Dialog2 = _interopRequireDefault(_bootstrap3Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// eslint-disable-line
	
	var Bootstrap3Dialog = function () {
	  function Bootstrap3Dialog(el) {
	    _classCallCheck(this, Bootstrap3Dialog);
	
	    this.el = el;
	
	    this.init();
	  }
	
	  _createClass(Bootstrap3Dialog, [{
	    key: 'init',
	    value: function init() {
	      this.el.querySelector('button').addEventListener('click', this.showDialog, false);
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: 'showDialog',
	    value: function showDialog() {
	      _bootstrap3Dialog2.default.alert('I want banana!');
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return Bootstrap3Dialog;
	}();
	
	exports.default = Bootstrap3Dialog;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContactSubject = function () {
	  function ContactSubject(el) {
	    _classCallCheck(this, ContactSubject);
	
	    this.el = el;
	
	    this.init();
	  }
	
	  _createClass(ContactSubject, [{
	    key: 'init',
	    value: function init() {
	      this.premiumMessage = this.el.getAttribute('data-cancel-premium-membership-message');
	      this.membershipMessage = this.el.getAttribute('data-cancel-membership-message');
	      this.inputFields = this.el.closest('form').querySelectorAll('input');
	      this.questionField = this.el.closest('form').querySelector('[name=question]');
	      this.submitButtons = this.el.closest('form').querySelectorAll('button[type=submit]');
	      this.alert = document.querySelector('.js-contact-alert');
	
	      this.el.addEventListener('change', this._onChange.bind(this), false);
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(event) {
	      event.preventDefault();
	
	      var selectedIndex = event.target.selectedIndex.selectedIndex;
	
	
	      if (selectedIndex === 2 || selectedIndex === 4) {
	        this._disableFormFields(true);
	
	        if (selectedIndex === 2) {
	          this._showMessage(true, this.premiumMessage);
	        } else {
	          this._showMessage(true, this.membershipMessage);
	        }
	      } else {
	        this._disableFormFields(false);
	        this._showMessage(false);
	      }
	    }
	  }, {
	    key: '_disableFormFields',
	    value: function _disableFormFields(disable) {
	      if (disable) {
	        [].concat(_toConsumableArray(this.inputFields)).forEach(function (input) {
	          input.classList.add('disabled');
	          input.setAttribute('disabled', 'disabled');
	        });
	        this.questionField.classList.add('disabled');
	        this.questionField.setAttribute('disabled', 'disabled');
	        [].concat(_toConsumableArray(this.submitButtons)).forEach(function (btn) {
	          btn.classList.add('disabled');
	          btn.setAttribute('disabled', 'disabled');
	        });
	      } else {
	        [].concat(_toConsumableArray(this.inputFields)).forEach(function (input) {
	          input.classList.remove('disabled');
	          input.removeAttribute('disabled');
	        });
	        this.questionField.classList.remove('disabled');
	        this.questionField.removeAttribute('disabled');
	        [].concat(_toConsumableArray(this.submitButtons)).forEach(function (btn) {
	          btn.classList.remove('disabled');
	          btn.removeAttribute('disabled');
	        });
	      }
	    }
	  }, {
	    key: '_showMessage',
	    value: function _showMessage(show, message) {
	      var _this = this;
	
	      if (show) {
	        this.alert.innerHTML = message.trim();
	        $(this.alert).fadeIn('slow');
	      } else {
	        $(this.alert).fadeOut('slow', function () {
	          _this.alert.innerHTML = '';
	        });
	      }
	    }
	  }]);
	
	  return ContactSubject;
	}();
	
	exports.default = ContactSubject;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @TODO - Crear un switch para asegurar notas en contactos.
	// El ajax callback nececita otros parametros.
	
	
	var _str_tool = __webpack_require__(75);
	
	var _str_tool2 = _interopRequireDefault(_str_tool);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContactsFavoritesNotices = function () {
	  function ContactsFavoritesNotices(el) {
	    _classCallCheck(this, ContactsFavoritesNotices);
	
	    this.el = el;
	    this.module = this.el.getAttribute('data-module-name');
	    this.currentId = this.el.getAttribute('data-current-id');
	    this.modalId = this.el.getAttribute('data-modal-id');
	    this.modalContainer = this.el.querySelector(this.modalId);
	    this.noNoticeStr = this.modalContainer.getAttribute('data-no-notices');
	    this.noticeView = this.modalContainer.querySelector('#notice-view');
	    this.noticeViewContent = this.noticeView.querySelector('p');
	    this.noticeEdit = this.modalContainer.querySelector('#notice-edit');
	    this.modalTextarea = this.modalContainer.querySelector('textarea');
	    this.editNoteButton = this.modalContainer.querySelector('.edit-note');
	    this.deleteNoteButton = this.modalContainer.querySelector('.delete-note');
	    this.saveNoteButton = this.modalContainer.querySelector('.save-note');
	    this.abortNoteButton = this.modalContainer.querySelector('.abort-note');
	    this.items = this.el.querySelectorAll('a.notice-button');
	    this.lang = _str_tool2.default.getLang();
	    this.testDate = _str_tool2.default.formatDate(this.lang);
	    this.saveMode = this.module === 'favorites' ? 'savenote' : 'SaveContactNote';
	    this.deleteMode = this.module === 'favorites' ? 'delnote' : 'SaveContactNote';
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(ContactsFavoritesNotices, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.items.forEach(function (item) {
	        item.addEventListener('click', function (e) {
	          var button = e.target;
	          if (e.target.nodeName === 'I') {
	            button = e.target.parentNode;
	          }
	          // const testDate = st.formatDate(this.lang);
	          var noteId = parseInt(button.getAttribute('data-notice-id'), 10);
	          var textDivId = button.getAttribute('data-notice-selector').trim();
	          var textDiv = document.querySelector(textDivId);
	          _this.noticeViewContent.innerHTML = textDiv.innerHTML.replace(/\n/gi, '<br>');
	          var myText = textDiv.innerHTML.replace(/(<\/?font.*?>)/gi, '').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').trim();
	          var hasContent = myText.length;
	          myText = hasContent ? myText + '\n[' + _this.testDate + '] ' : '[' + _this.testDate + '] ';
	
	          if (hasContent) {
	            _this.setStates('view-full');
	          } else {
	            _this.setStates('view-empty');
	          }
	          _this.noticeView.scrollIntoView();
	          _this.modalTextarea.value = _str_tool2.default.br2nl(myText, 1);
	          _this.modalTextarea.setAttribute('data-note-id', noteId);
	          _this.modalTextarea.setAttribute('data-note-raw', textDivId);
	        });
	      });
	      this.abortNoteButton.addEventListener('click', function () {
	        _this.clear(_this.modalTextarea.getAttribute('data-note-id'));
	      });
	      this.editNoteButton.addEventListener('click', function () {
	        _this.editTheNote(_this.modalTextarea.getAttribute('data-note-id'));
	      });
	      this.deleteNoteButton.addEventListener('click', function () {
	        _this.deleteTheNote();
	      });
	      this.saveNoteButton.addEventListener('click', function () {
	        _this.saveTheNote(_this.modalTextarea.value);
	      });
	    }
	  }, {
	    key: 'saveTheNote',
	    value: function saveTheNote(notetext) {
	      var _this2 = this;
	
	      this.noticeViewContent.innerHTML = this.modalTextarea.value.replace(/\n/gi, '<br>');
	      document.querySelector(this.modalTextarea.getAttribute('data-note-raw')).innerHTML = this.modalTextarea.value.trim();
	      var nId = this.modalTextarea.getAttribute('data-note-id');
	      document.getElementById('edit-link-notice-' + nId).classList.remove('grey');
	      var data = {
	        json: true,
	        note: notetext.trim(),
	        id: this.modalTextarea.getAttribute('data-note-id'),
	        mode: this.saveMode
	      };
	      if (this.module === 'contacts') {
	        data.profileId = this.currentId;
	      }
	      // Send data to server
	      $.post('/ajax.php', data, function () {
	        // if (response) console.log('response');
	        _this2.setStates('save');
	      }, 'json');
	    }
	  }, {
	    key: 'setStates',
	    value: function setStates(mod) {
	      switch (mod) {
	        case 'save':
	          this.noticeEdit.style.display = 'none';
	          this.saveNoteButton.style.display = 'none';
	          this.abortNoteButton.style.display = 'none';
	          this.deleteNoteButton.style.display = '';
	          this.noticeView.style.display = '';
	          this.editNoteButton.style.display = '';
	          break;
	        case 'delete':
	          this.noticeEdit.style.display = 'none';
	          this.saveNoteButton.style.display = 'none';
	          this.deleteNoteButton.style.display = 'none';
	          this.abortNoteButton.style.display = 'none';
	          this.noticeView.style.display = '';
	          this.editNoteButton.style.display = '';
	          this.noticeViewContent.innerHTML = this.noNoticeStr;
	          break;
	        case 'view-full':
	          this.noticeEdit.style.display = 'none';
	          this.saveNoteButton.style.display = 'none';
	          this.abortNoteButton.style.display = 'none';
	          this.deleteNoteButton.style.display = '';
	          this.noticeView.style.display = '';
	          this.editNoteButton.style.display = '';
	          break;
	        case 'view-empty':
	          this.noticeView.style.display = 'none';
	          this.editNoteButton.style.display = 'none';
	          this.deleteNoteButton.style.display = 'none';
	          this.noticeEdit.style.display = '';
	          this.saveNoteButton.style.display = '';
	          break;
	        case 'edit':
	          this.editNoteButton.style.display = 'none';
	          this.noticeView.style.display = 'none';
	          this.abortNoteButton.style.display = '';
	          this.saveNoteButton.style.display = '';
	          this.deleteNoteButton.style.display = '';
	          this.noticeEdit.style.display = '';
	          break;
	        default: // Do nothing
	      }
	    }
	  }, {
	    key: 'editTheNote',
	    value: function editTheNote() {
	      this.setStates('edit');
	    }
	  }, {
	    key: 'deleteTheNote',
	    value: function deleteTheNote() {
	      var _this3 = this;
	
	      var data = {
	        json: true,
	        id: this.modalTextarea.getAttribute('data-note-id'),
	        mode: this.deleteMode
	      };
	      if (this.module === 'contacts') {
	        data.profileId = this.currentId;
	      }
	      // Send data to server
	      $.post('/ajax.php', data, function () {
	        // if (response) console.log('response');
	        _this3.setStates('delete');
	        document.querySelector(_this3.modalTextarea.getAttribute('data-note-raw')).innerHTML = '';
	        _this3.modalTextarea.value = '[' + _this3.testDate + '] ';
	        var nId = _this3.modalTextarea.getAttribute('data-note-id');
	        document.getElementById('edit-link-notice-' + nId).classList.add('grey');
	      }, 'json');
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.modalTextarea.value = '';
	      this.noticeViewContent.innerHTML = '';
	      this.modalTextarea.setAttribute('data-note-id', '');
	      this.modalTextarea.setAttribute('data-note-raw', '');
	    }
	  }, {
	    key: 'tres',
	    value: function tres() {}
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ContactsFavoritesNotices;
	}();
	
	exports.default = ContactsFavoritesNotices;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// @format
	/**
	 * Function copied from includes/scripts_general.tpl
	 * NOTE 2016-07-20: What is this for and/or where is it used?
	 */
	// mock show Message, um fehler zu vermeiden
	// function showMessage(message, caption, obsolete1, obsolete2, callback) {
	//   console.log(message);
	//
	//   $('#messagePopup .message').html(message);
	//   $('#messagePopup .caption').html(caption);
	//   $('#messagePopup').show();
	//
	//   var onclick = "$('#messagePopup').hide()";
	//
	//   if(typeof callback === 'function'){
	//     onclick = callback.toString();
	//     onclick += "$('#messagePopup').hide()";
	//   }
	//
	//   $('#messagePopup .footer button').attr('onclick', onclick);
	// }
	
	/**
	 * Function copied from includes/scripts_layout.tpl
	 * NOTE 2016-08-16: I guess Chat but what is it doing?
	 */
	// var path;
	// var enable1to1chatsound;
	//
	// {if $USER_IS_LOGGED_IN && $footer2_valid1to1}
	//   {* TODO: im eingeloggten Zustand wieder aktivieren *}
	//   #<{(|*
	//     * Chatpoll
	//     |)}>#
	//   //enable1to1chatsound = {$1to1sound};
	//   //window.setTimeout('cwin_poll_1to1chat("")', 10000);
	// {/if}
	//
	// {* Die Links zu den Profilen derjenigen die mich bannen verändern *}
	// {if $USER_IS_LOGGED_IN}
	// var bannedBy = [{$bannedBy}];
	// $(bannedBy).each(function(index, value) {
	//     $('a[href*="/profile.php?id='+value+'"]')
	//       .add('a[href*="/blog.php?id='+value+'"]')
	//       .add('a[href*="/gallery.php?pic_id='+value+'"]')
	//       .removeAttr('onclick').unbind('click').click(function(event) {
	//         event.preventDefault();
	//         showMessage(SELFBANNED, ERROR, 'small', 'notify');
	//     });
	// });
	// {/if}
	
	/* eslint-disable max-len */
	/**
	 * Function copied from includes/scripts_regcheck.tpl
	 * NOTE 2016-08-16: Sign-up Form
	 */
	// Alle bekannten Länder
	// var knownCountries = new Array({$statesJs});
	// var knownCountriesShires = new Array({$statesJsShires});
	//
	// Meldungen für den RegCheck
	// var regMessages = {
	//   nicktooshort: '{$lang.Storeexpress_6signs_or_more|escape:'quotes'}',
	//   nickchars: '{$lang.Storeexpress_signs_in_nickname|escape:'quotes'}<ul><li>{$lang.Storeexpress_signs_in_nickname1|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname2|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname3|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname4|escape:'quotes'}</li><li>{$lang.Storeexpress_no_spaces|escape:'quotes'}</li></ul>',
	//   nickused: '{$lang.Storeexpress_nickname|escape:'quotes'} {$lang.Storeexpress_alredy_registered|escape:'quotes'}',
	//   nicknotallowed: '{$lang.Storeexpress_nickname|escape:'quotes'} {$lang.Storeexpress_not_allowed|escape:'quotes'}',
	//   emailincorrect: '{$lang.Storeexpress_please_valid_email|escape:'quotes'}',
	//   emailused: '{$lang.Storeexpress_mail_adress|escape:'quotes'} {$lang.Storeexpress_not_more_entry|escape:'quotes'}',
	//   passtooshort: '{$lang.Storeexpress_6signs_or_more_pass|escape:'quotes'}',
	//   passchars: '{$lang.Storeexpress_pass_only_signs|escape:'quotes'}<ul><li>{$lang.Storeexpress_signs_in_nickname1|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname2|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname3|escape:'quotes'}</li><li>{$lang.Storeexpress_signs_in_nickname4|escape:'quotes'}</li><li>{$lang.Storeexpress_no_space_pass|escape:'quotes'}</li></ul>',
	//   Storeexpress_passes_username: '{$lang.Storeexpress_passes_username|escape:'quotes'}',
	//   error: '<img src="./images/icon_error_22.png" alt="Error" />',
	//   ok: '<img src="./images/icon_ok_22.png" alt="Ok" />',
	//   unknown: '<img src="./images/icon_error_22.png" alt="Error" />',
	//   tooshort: '<img src="./images/icon_error_22.png" alt="Error" />'
	// };
	// var doOnLoadCheck = {if count($smarty.post)}true{else}false{/if};
	/* eslint-enable max-len */
	"use strict";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(4);
	
	__webpack_require__(59);
	
	var _datetimepicker_i18n = __webpack_require__(19);
	
	var _datetimepicker_i18n2 = _interopRequireDefault(_datetimepicker_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Datetimepicker = function () {
	  function Datetimepicker(el) {
	    _classCallCheck(this, Datetimepicker);
	
	    this.el = el;
	    this.init();
	  }
	
	  _createClass(Datetimepicker, [{
	    key: 'init',
	    value: function init() {
	      // Get language of page
	      this.lang = this._getLang();
	      // console.log(this.lang);
	
	      // Assign Font Awesome icons
	      this.faIcons = {
	        time: 'fa fa-clock-o',
	        date: 'fa fa-calendar',
	        up: 'fa fa-chevron-up',
	        down: 'fa fa-chevron-down',
	        previous: 'fa fa-chevron-left',
	        next: 'fa fa-chevron-right',
	        today: 'fa fa-bullseye',
	        clear: 'fa fa-trash',
	        close: 'fa fa-times'
	      };
	
	      // Set min and max date
	      if (window.location.href.match('refaid')) {
	        this.minDate = (0, _moment2.default)().subtract(12, 'years');
	        this.maxDate = (0, _moment2.default)().subtract(1, 'years');
	      } else {
	        this.minDate = (0, _moment2.default)().subtract(96, 'years');
	        this.maxDate = (0, _moment2.default)().subtract(45, 'years');
	      }
	
	      // Get language settings
	      this.i18n = _datetimepicker_i18n2.default.languages[0][this.lang];
	
	      this._datetimepicker();
	      this._clear();
	    }
	  }, {
	    key: '_datetimepicker',
	    value: function _datetimepicker() {
	      var _this = this;
	
	      $(this.el).datetimepicker({
	        icons: this.faIcons,
	        format: this.i18n.format,
	        locale: this.i18n.locale,
	        minDate: this.minDate,
	        maxDate: this.maxDate,
	        viewMode: 'years',
	        tooltips: {
	          today: this.i18n.today,
	          clear: this.i18n.clear,
	          close: this.i18n.close,
	          selectMonth: this.i18n.selectMonth,
	          prevMonth: this.i18n.prevMonth,
	          nextMonth: this.i18n.nextMonth,
	          selectYear: this.i18n.selectYear,
	          prevYear: this.i18n.prevYear,
	          nextYear: this.i18n.nextYear,
	          selectDecade: this.i18n.selectDecade,
	          prevDecade: this.i18n.prevDecade,
	          nextDecade: this.i18n.nextDecade,
	          prevCentury: this.i18n.prevCentury,
	          nextCentury: this.i18n.nextCentury
	        },
	        widgetPositioning: {
	          vertical: 'bottom'
	        }
	      }).on('dp.change', function (e) {
	        if (e.date !== false) {
	          _this._change();
	        }
	      });
	    }
	  }, {
	    key: '_clear',
	    value: function _clear() {
	      $(this.el).data('DateTimePicker').clear();
	    }
	  }, {
	    key: '_change',
	    value: function _change() {
	      if (!window.location.href.match('refaid')) {
	        var $form = $(this.el).parents('form');
	        $form.formValidation('revalidateField', $(this.el).attr('name'));
	      }
	    }
	  }, {
	    key: '_getLang',
	    value: function _getLang() {
	      var $html = $(this.el).parents('html');
	      var langAttr = $html[0].getAttribute('lang');
	      var lang = langAttr.split('-', 1);
	
	      return lang[0];
	    }
	  }]);
	
	  return Datetimepicker;
	}();
	
	exports.default = Datetimepicker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _directchat_lib = __webpack_require__(20);
	
	var _directchat_lib2 = _interopRequireDefault(_directchat_lib);
	
	var _treffcook = __webpack_require__(9);
	
	var _treffcook2 = _interopRequireDefault(_treffcook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DirectChat = function () {
	  function DirectChat(el) {
	    _classCallCheck(this, DirectChat);
	
	    this.el = el;
	    // const dcsound2 = document.getElementById('dcaudio');
	    _treffcook2.default.Set('dc', parseInt($('body').attr('data-dc-en'), 10));
	    this.lastid = 0;
	    this.dcSoundPlayer = document.getElementById('dcaudio');
	    if (parseInt(_treffcook2.default.Get('dccrrvw'), 10) === 1) {
	      this.showList();
	    }
	    if (parseInt(_treffcook2.default.Get('dccrrvw'), 10) === 2) {
	      this.showConversation();
	    }
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(DirectChat, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      // Toggle the sound by dc
	      $('body').on('click', '#dc-sound-toggle-234', function () {
	        // cookie.Set('private_sound', newVal, 3600, '/');
	        $.ajax({
	          url: '/directchat/ajax_chat.php',
	          method: 'POST',
	          type: 'json',
	          data: {
	            mode: 'toggle1to1_sound'
	          },
	          success: function success() {}
	        });
	        if (parseInt(_treffcook2.default.Get('private_sound'), 10) === 1) {
	          $('#dc-sound-toggle i').removeClass('fa-volume-off');
	          $('#dc-sound-toggle i').addClass('fa-volume-up');
	        } else {
	          $('#dc-sound-toggle i').removeClass('fa-volume-up');
	          $('#dc-sound-toggle i').addClass('fa-volume-off');
	        }
	      });
	      // Minimize/maximize or close the chatbox.
	      $('body').on('click', '#chatbox-close-button', function () {
	        _treffcook2.default.Set('dcbxmin', 0, 3600, '/');
	        _treffcook2.default.Set('dclsopn', 0, 3600, '/');
	        _treffcook2.default.Set('dccrrvw', 0, 3600, '/');
	        _treffcook2.default.Set('dccrrto', 0, 3600, '/');
	        _treffcook2.default.Set('dccrr', 0, 3600, '/');
	        _treffcook2.default.Set('dccrrname', '', 3600, '/');
	        _this.stopNewLinesWatchDog();
	        $(_this.el).hide();
	      });
	
	      $('body').on('click', '#chatbox-toggle-button', function () {
	        _directchat_lib2.default.updateSliderToggle($('#chatbox-toggle-button'));
	      });
	
	      // Binds clicks.
	      // Load a chat-conversation from the chat-conversations list.
	      $('body').on('click', '#conversations-list > a', function (elm) {
	        elm.preventDefault();
	        var rm = false;
	        var ammount = 0;
	        var isLast = false;
	        var id = '';
	        var to = '';
	        var name = '';
	        if (elm.target && elm.target.parentElement.nodeName === 'A') {
	          id = elm.target.parentElement.getAttribute('data-cid');
	          to = elm.target.parentElement.getAttribute('data-to');
	          name = elm.target.parentElement.getAttribute('data-name');
	        } else if (elm.target && elm.target.parentElement.nodeName === 'SPAN') {
	          id = elm.target.parentElement.parentElement.getAttribute('data-cid');
	          to = elm.target.parentElement.parentElement.getAttribute('data-to');
	          name = elm.target.parentElement.parentElement.getAttribute('data-name');
	          if (elm.target.parentElement.classList.contains('dcl-delete')) {
	            rm = id;
	            ammount = elm.target.parentElement.parentElement.parentElement.querySelectorAll('a').length;
	            if (parseInt(ammount, 10) === 1) {
	              isLast = true;
	            }
	          }
	        } else if (elm.target && elm.target.parentElement.nodeName === 'I') {
	          id = elm.target.parentElement.parentElement.parentElement.getAttribute('data-cid');
	          to = elm.target.parentElement.parentElement.parentElement.getAttribute('data-to');
	          name = elm.target.parentElement.parentElement.parentElement.getAttribute('data-name');
	          if (elm.target.parentElement.parentElement.classList.contains('dcl-delete')) {
	            rm = id;
	            ammount = elm.target.parentElement.parentElement.parentElement.parentElement.querySelectorAll('a').length;
	            if (parseInt(ammount, 10) === 1) {
	              isLast = true;
	            }
	          }
	        } else {
	          id = elm.target.getAttribute('data-cid');
	          to = elm.target.getAttribute('data-to');
	          name = elm.target.getAttribute('data-name');
	        }
	        if (rm) {
	          _this.removeListItem(id, isLast);
	        } else {
	          _treffcook2.default.Set('dclsopn', 0, 3600, '/');
	          _treffcook2.default.Set('dccrr', id, 3600, '/');
	          _treffcook2.default.Set('dccrrvw', 2, 3600, '/');
	          _treffcook2.default.Set('dccrrname', name, 3600, '/');
	          _treffcook2.default.Set('dccrrto', to, 3600, '/');
	          _this.openConversation(id, to, name);
	        }
	      });
	
	      // Binds clicks of the send message button
	      $('body').on('click', '#send-chat-message', function () {
	        // const reciver = $('body')
	        // .find('#chat-message-field')
	        // .parents('.dchat');
	        _this.sendChatMessage();
	        // this.loadConversation(reciver.attr('id'));
	      });
	
	      // Binds clicks.
	      // Executes necessary actions to the invitation process.
	      $('body').on('click', '#directchat-invite-btn', function (elm) {
	        elm.preventDefault();
	        var id = elm.target.getAttribute('data-uid');
	        var name = elm.target.getAttribute('data-uname');
	        $.ajax({
	          url: '/directchat/ajax_chat.php',
	          method: 'POST',
	          type: 'html',
	          data: {
	            mode: 'invite',
	            uid: id,
	            uname: name
	          },
	          success: function success(data) {
	            if (data) {
	              var response = $.parseJSON(data);
	              _treffcook2.default.Set('dccrr', response.dcid, 3600, '/');
	              _treffcook2.default.Set('dccrrvw', 2, 3600, '/');
	              // $('#directchat-content').html(response.render);
	              // // dc.checkChatState();
	              // $(this.el).show();
	              // $('#chatbox-toggle-button').click();
	              // $(elm.target).hide();
	              _this.openConversation(id, id, name, 1);
	            }
	          }
	        });
	      });
	
	      // Binds clicks.
	      // Load the chat-conversations list.
	      $('body').on('click', '#directchat-menu-link, #directchat-list-button', function () {
	        _this.stopNewLinesWatchDog();
	        _treffcook2.default.Set('dccrr', 0, 3600, '/');
	        _treffcook2.default.Set('dculatm', 0, 3600, '/');
	        _treffcook2.default.Set('dccrrvw', 1, 3600, '/');
	        _treffcook2.default.Set('dclsopn', 1, 3600, '/');
	        $.ajax({
	          url: '/directchat/ajax_chat.php',
	          method: 'POST',
	          type: 'html',
	          data: {
	            mode: 'list'
	          },
	          success: function success(data) {
	            if (data) {
	              var response = $.parseJSON(data);
	              $('#directchat-content').html(response.render);
	              $(_this.el).show();
	              $('#chatbox-toggle-button').click();
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'showConversation',
	    value: function showConversation() {
	      var id = _treffcook2.default.Get('dccrr');
	      var to = _treffcook2.default.Get('dccrrto');
	      var name = _treffcook2.default.Get('dccrrname');
	      this.openConversation(id, to, name);
	    }
	  }, {
	    key: 'showList',
	    value: function showList() {
	      var _this2 = this;
	
	      this.stopNewLinesWatchDog();
	      _treffcook2.default.Set('dccrr', 0, 3600, '/');
	      _treffcook2.default.Set('dculatm', 0, 3600, '/');
	      _treffcook2.default.Set('dccrrvw', 1, 3600, '/');
	      _treffcook2.default.Set('dclsopn', 1, 3600, '/');
	      $.ajax({
	        url: '/directchat/ajax_chat.php',
	        method: 'POST',
	        type: 'html',
	        data: {
	          mode: 'list'
	        },
	        success: function success(data) {
	          if (data) {
	            var response = $.parseJSON(data);
	            $('#directchat-content').html(response.render);
	            $(_this2.el).show();
	            // $('#chatbox-toggle-button').click();
	            if (parseInt(_treffcook2.default.Get('dcbxmin'), 10) === 0) {
	              $('#chatbox-toggle-button').click();
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'removeListItem',
	    value: function removeListItem(id, isLast) {
	      var _this3 = this;
	
	      $.post('/directchat/ajax_chat.php', {
	        dcid: id,
	        mode: 'listRM',
	        last: isLast
	      }, function () {
	        $('a[data-cid="' + id + '"]').remove();
	        if (isLast) {
	          _this3.showList();
	        }
	      });
	    }
	
	    // Send a message.
	
	  }, {
	    key: 'sendChatMessage',
	    value: function sendChatMessage() {
	      var message = $('#chat-message-field');
	      var reciver = $('#chat-message-field').parents('.dchat');
	      var to = parseInt(reciver.attr('data-reciver'), 10);
	      var from = parseInt(reciver.attr('data-from'), 10);
	      var min = Math.min(to, from);
	      var max = Math.max(to, from);
	      var dcid = min + '-' + max;
	      // Fix dcid if wrong (in invite case)
	      var splArr = reciver.attr('id').split('-');
	      if (splArr.length < 2) {
	        reciver.attr('id', dcid);
	      }
	      if (message.val().length > 0) {
	        var messageVal = message.val();
	        // $.post('ajaxAdd.php', $('directchat-form').serialize());
	        $.ajax({
	          url: '/directchat/ajax_chat.php',
	          method: 'POST',
	          data: {
	            mode: 'addMessage',
	            text: messageVal,
	            cid: dcid,
	            reciver: parseInt(reciver.attr('data-reciver'), 10)
	          },
	          success: function success() {
	            // this.loadConversation2(reciver.attr('id'));
	          }
	        });
	        message.val('');
	        messageVal = '';
	      }
	      message.focus();
	    }
	
	    // Load conversation-wrapper into the chatbox.
	
	  }, {
	    key: 'openConversation',
	    value: function openConversation(id, to, name, invitation) {
	      var _this4 = this;
	
	      if (invitation) {
	        _treffcook2.default.Set('dcbxmin', 0, 3600, '/');
	      }
	      this.lastid = 0;
	      $.ajax({
	        url: '/directchat/ajax_chat.php',
	        method: 'POST',
	        type: 'html',
	        data: {
	          mode: 'open',
	          cid: id,
	          uid: to,
	          uname: name,
	          invited: invitation * 1
	        },
	        success: function success(data) {
	          if (data) {
	            var response = $.parseJSON(data);
	            $('#directchat-content').html(response.render);
	            if (parseInt(_treffcook2.default.Get('dcbxmin'), 10) === 0) {
	              $('#chatbox-toggle-button').click();
	            }
	            $(_this4.el).show();
	          }
	        }
	      });
	      this.startNewLinesWatchDog(id, 1000);
	    }
	  }, {
	    key: 'loadConversation2',
	    value: function loadConversation2(dcid) {
	      var _this5 = this;
	
	      var conversation = $('body').find('#conversation');
	      var dchat = conversation.parents('.dchat');
	      var to = parseInt(dchat.attr('data-reciver'), 10);
	      var from = parseInt(dchat.attr('data-from'), 10);
	      var min = Math.min(to, from);
	      var max = Math.max(to, from);
	      var cid = min + '-' + max;
	      var splt = dcid.split('-');
	      var myDCid = splt.length < 2 ? cid : dcid;
	      if (conversation.length > 0) {
	        $.post('/directchat/ajax_chat.php', {
	          mode: 'refresh',
	          id: myDCid,
	          last: this.lastid
	        }, function (data) {
	          var response = $.parseJSON(data);
	          if (response.render) {
	            conversation.find('dl').append(response.render);
	            var sender = parseInt(response.sender, 10);
	            // const reciver = parseInt(response.reciver, 10);
	            var validId = parseInt(response.valid_id, 10);
	            // console.log('sender => ', response.sender);
	            // console.log('reciver => ', response.reciver);
	            // console.log('valid_id => ', response.valid_id);
	            // const soundOn = this.el.getAttribute('data-dc-snd');
	            // console.log('cd private_sound', cookie.Get('private_sound'));
	            if (validId !== sender && parseInt(_treffcook2.default.Get('private_sound'), 10) === 1) {
	              // console.log('RECIVER');
	              _directchat_lib2.default.try2play();
	            }
	            conversation.animate({ scrollTop: conversation[0].scrollHeight }, 'slow');
	            if (response.last) {
	              _this5.lastid = response.last;
	            }
	          }
	        });
	      } else {
	        this.stopNewLinesWatchDog();
	      }
	    }
	
	    // Load conversation-wrapper into the conversation-wrapper.
	
	  }, {
	    key: 'loadConversation',
	    value: function loadConversation(id, open) {
	      var submode = open ? 1 : 0;
	      var currentid = id ? _treffcook2.default.Get('dccrr') : id;
	      var dclast = $('body').find('#directchat-wrapper').attr('data-eval-id');
	      $.ajax({
	        url: '/directchat/ajax_chat.php',
	        method: 'POST',
	        type: 'html',
	        data: {
	          mode: 'getNewLines',
	          cid: currentid,
	          last: open === 1 ? 0 : dclast,
	          opn: submode
	        },
	        success: function success(data) {
	          var response = $.parseJSON(data);
	          var newText = response.new_text;
	          if (newText !== undefined && newText.length) {
	            var conversation = $('body').find('#conversation');
	            if (conversation !== null) {
	              if (conversation.length === 0) {
	                conversation = document.getElementById('conversation');
	              } else {
	                $('body').find('#directchat-wrapper').attr('data-eval-id', response.last);
	                $('body').find('#dc-check-test').html(response.last);
	                conversation.find('dl').append(newText);
	                conversation.animate({ scrollTop: conversation[0].scrollHeight }, 'slow');
	              }
	            }
	          }
	        }
	      });
	    }
	
	    // Stop the watchdog by inactivity
	
	  }, {
	    key: 'stopByInactivity',
	    value: function stopByInactivity() {
	      this.stopNewLinesWatchDog();
	    }
	
	    // Start interval action - Load new message(s).
	
	  }, {
	    key: 'startNewLinesWatchDog',
	    value: function startNewLinesWatchDog(id, duration) {
	      var _this6 = this;
	
	      var i = 0;
	      var cid = id;
	      this.newLines = setInterval(function () {
	        if (!cid) {
	          cid = _treffcook2.default.Get('dccrr');
	        }
	        // Watch for chat updates or invitations.
	        _this6.loadConversation2(cid);
	        i += i;
	      }, duration);
	    }
	
	    // Stops the interval action - Load new message(s).
	
	  }, {
	    key: 'stopNewLinesWatchDog',
	    value: function stopNewLinesWatchDog() {
	      clearInterval(this.newLines);
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return DirectChat;
	}();
	
	exports.default = DirectChat;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditMessageboxFolder = function () {
	  function EditMessageboxFolder(elem) {
	    _classCallCheck(this, EditMessageboxFolder);
	
	    this.elem = elem;
	    this.folders = [].concat(_toConsumableArray(this.elem.querySelectorAll('[data-folder]')));
	
	    this.init();
	  }
	
	  _createClass(EditMessageboxFolder, [{
	    key: 'init',
	    value: function init() {
	      if (this.folders.length) {
	        // this._renameFolder();
	        this._renameFolder2();
	        // this._deleteFolder();
	        this._deleteFolder2();
	      }
	    }
	  }, {
	    key: '_renameFolder',
	    value: function _renameFolder() {
	      this.folders.forEach(function (folder) {
	        var $folderRename = folder.querySelector('[data-folder-action="rename"]');
	        var $folderCancel = folder.querySelector('[data-folder-action="cancel"]');
	        var $folderLink = folder.querySelector('.js-folder-link');
	        var $form = folder.querySelector('.js-inplace-edit');
	
	        $folderRename.addEventListener('click', function (e) {
	          e.preventDefault();
	
	          $folderLink.style.display = 'none';
	          $form.style.display = '';
	
	          e.target.style.display = 'none';
	          $folderCancel.style.display = '';
	        }, false);
	
	        $folderCancel.addEventListener('click', function (e) {
	          e.preventDefault();
	
	          $form.style.display = 'none';
	          $folderLink.style.display = '';
	
	          e.target.style.display = 'none';
	          $folderRename.style.display = '';
	        }, false);
	      });
	    }
	  }, {
	    key: '_deleteFolder',
	    value: function _deleteFolder() {
	      this.folders.forEach(function (folder) {
	        var $folderPopover = folder.querySelector('[data-folder-action="popover"]');
	
	        var $folderId = $folderPopover.getAttribute('data-folder-id');
	        // const $folderName = $folderPopover.getAttribute('data-folder-name');
	        var $buttonLabel = $folderPopover.getAttribute('data-button-label');
	        var $folderMessage = $folderPopover.getAttribute('data-folder-message');
	        var $folderMessageClean = $folderMessage.replace(/\\/gi, '');
	
	        // Create temp container element for the delete button
	        var $deleteCtn = document.createElement('div');
	        // Create the delete button
	        var $deleteBtn = document.createElement('button');
	        var deleteBtnLabel = document.createTextNode($buttonLabel);
	        $deleteBtn.setAttribute('type', 'button');
	        $deleteBtn.setAttribute('data-folder-action', 'delete');
	        $deleteBtn.classList.add('btn', 'btn-danger');
	        // Put everything into its box
	        $deleteBtn.appendChild(deleteBtnLabel);
	        $deleteCtn.appendChild($deleteBtn);
	
	        $($folderPopover).popover({
	          content: $folderMessageClean,
	
	          html: true,
	
	          placement: 'left',
	
	          template: '<div class="popover" role="tooltip">\n                     <div class="arrow"></div>\n                     <div class="popover-content"></div>\n                     <div class="popover-action">\n                       ' + $($deleteCtn).html() + '\n                     </div>\n                   </div>'
	        });
	
	        $folderPopover.addEventListener('click', function (e) {
	          e.preventDefault();
	        }, false);
	
	        folder.addEventListener('click', function (e) {
	          if (e.target.getAttribute('data-folder-action') === 'delete') {
	            var data = {
	              ordner: $folderId,
	
	              del: 'true',
	
	              really_del: 'true',
	
	              ajaxed: 'true'
	            };
	
	            // Send data to server
	            var request = $.ajax({
	              url: 'messagebox_ordner.php?t=' + Date.now(),
	
	              type: 'POST',
	
	              data: data
	            });
	
	            request.done(function () {
	              window.location.href = '/messagebox_ordner.php';
	            });
	
	            request.fail(function (jqXHR) {
	              var $domAnchor = $(folder).find('td');
	              var $errorContainer = document.createElement('div');
	              var errorMessage = document.createTextNode(jqXHR.status + ': ' + jqXHR.statusText);
	
	              // Append error message to error container
	              $errorContainer.appendChild(errorMessage);
	              // Add bootstarp alert styles to error container
	              $errorContainer.classList.add('alert', 'alert-danger');
	              // Add the error container to the DOM
	              $domAnchor.prepend($errorContainer);
	            });
	          }
	        }, false);
	      });
	    }
	  }, {
	    key: '_renameFolder2',
	    value: function _renameFolder2() {
	      this.folders.forEach(function (folder) {
	        var $folderRename = folder.querySelector('[data-folder-action="rename"]');
	        var $folderDel = folder.querySelector('.js-inplace-remove');
	        var $folderCancel = folder.querySelector('[data-folder-action="cancel"]');
	
	        // console.log($folderRename);
	        // console.log($folderCancel);
	
	        var $folderLink = folder.querySelector('.js-folder-link');
	        var $form = folder.querySelector('.js-inplace-edit');
	        var $oldRenameInput = folder.querySelector('input[name="foldername"]');
	        var $oldRenameValue = $oldRenameInput.value;
	        // console.log('$oldRenameValue');
	        // console.log($oldRenameValue);
	
	        $folderRename.addEventListener('click', function (e) {
	          // console.log('UNO');
	          // console.log(e.target.tagName);
	          // console.log(e.currentTarget.tagName);
	          e.preventDefault();
	
	          $folderLink.style.display = 'none';
	          $form.style.display = '';
	
	          // e.target.style.display = 'none';
	          e.currentTarget.style.display = 'none';
	          $folderCancel.style.display = '';
	          $folderDel.style.display = 'none';
	        }, false);
	
	        $folderCancel.addEventListener('click', function (e) {
	          e.preventDefault();
	
	          $form.style.display = 'none';
	          $folderLink.style.display = '';
	
	          e.currentTarget.style.display = 'none';
	          $folderRename.style.display = '';
	          $oldRenameInput.value = $oldRenameValue;
	        }, false);
	      });
	    }
	  }, {
	    key: '_deleteFolder2',
	    value: function _deleteFolder2() {
	      this.folders.forEach(function (folder) {
	        var $folderPopover = folder.querySelector('[data-folder-action="popover"]');
	
	        // console.log(folder);
	
	        var $folderId = $folderPopover.getAttribute('data-folder-id');
	        // const $folderName = $folderPopover.getAttribute('data-folder-name');
	        // const $buttonLabel = $folderPopover.getAttribute('data-button-label');
	        // const $folderMessage = $folderPopover.getAttribute('data-folder-message');
	        // const $folderMessageClean = $folderMessage.replace(/\\/gi, '');
	
	        // console.log($folderMessageClean);
	
	        // Create temp container element for the delete button
	        // const $deleteCtn = document.createElement('div');
	        // Create the delete button
	        // const $deleteBtn = document.createElement('button');
	        // const deleteBtnLabel = document.createTextNode($buttonLabel);
	        // $deleteBtn.setAttribute('type', 'button');
	        // $deleteBtn.setAttribute('data-folder-action', 'delete');
	        // $deleteBtn.classList.add('btn', 'btn-danger');
	        // Put everything into its box
	        // $deleteBtn.appendChild(deleteBtnLabel);
	        // $deleteCtn.appendChild($deleteBtn);
	
	        $folderPopover.addEventListener('click', function (e) {
	          e.preventDefault();
	          // console.log(e);
	        }, false);
	
	        folder.addEventListener('click', function (e) {
	          var action = '';
	          if (e.target.tagName === 'I') {
	            // console.log('estoy en I also get parent a');
	            action = e.target.parentElement.getAttribute('data-folder-action');
	          } else if (e.target.tagName === 'A') {
	            // console.log('estoy en A also get this');
	            action = e.target.getAttribute('data-folder-action');
	          } else if (e.target.tagName === 'BUTTON') {
	            // console.log('estoy en BUTTON also get this');
	            action = !e.target.getAttribute('data-folder-action') ? 'cancel' : e.target.getAttribute('data-folder-action');
	          }
	          var $folderRen = folder.querySelector('[data-folder-action="rename"]');
	          var $folderCancel = folder.querySelector('[data-folder-action="cancel"]');
	          // console.log('clicked:');
	          // console.log(e.target.tagName);
	          // console.log(e.currentTarget.tagName);
	          // console.log('action es:');
	          // console.log(action);
	          if (action === 'cancel') {
	            // console.log('ensena el formulario');
	            var $delForm = folder.querySelector('.js-inplace-remove');
	            $delForm.style.display = 'none';
	            $folderCancel.style.display = 'none';
	            $folderRen.style.display = '';
	          }
	          if (action === 'popover') {
	            // console.log('ensena el formulario');
	            var _$delForm = folder.querySelector('.js-inplace-remove');
	            var $renForm = folder.querySelector('.js-inplace-edit');
	            var $renLink = folder.querySelector('.js-folder-link');
	            _$delForm.style.display = '';
	            $renLink.style.display = '';
	            $renForm.style.display = 'none';
	            $folderCancel.style.display = 'none';
	            $folderRen.style.display = '';
	          }
	          // if (e.target.getAttribute('data-folder-action') === 'delete') {
	          if (action === 'delete') {
	            // console.log('llegue a delete');
	            var data = {
	              ordner: $folderId,
	
	              del: 'true',
	
	              really_del: 'true',
	
	              ajaxed: 'true'
	            };
	
	            var $pause = 3;
	            if ($pause === 3) {
	              // Send data to server
	              var request = $.ajax({
	                url: 'messagebox_ordner.php?t=' + Date.now(),
	
	                type: 'POST',
	
	                data: data
	              });
	
	              request.done(function () {
	                window.location.href = '/messagebox_ordner.php';
	              });
	
	              request.fail(function (jqXHR) {
	                var $domAnchor = $(folder).find('td');
	                var $errorContainer = document.createElement('div');
	                var errorMessage = document.createTextNode(jqXHR.status + ': ' + jqXHR.statusText);
	
	                // Append error message to error container
	                $errorContainer.appendChild(errorMessage);
	                // Add bootstarp alert styles to error container
	                $errorContainer.classList.add('alert', 'alert-danger');
	                // Add the error container to the DOM
	                $domAnchor.prepend($errorContainer);
	              });
	            }
	          }
	        }, false);
	      });
	    }
	  }]);
	
	  return EditMessageboxFolder;
	}();
	
	exports.default = EditMessageboxFolder;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FavoritesExecutes = function () {
	  function FavoritesExecutes(el) {
	    _classCallCheck(this, FavoritesExecutes);
	
	    this.el = el;
	    this.favAction = this.el.getAttribute('data-action');
	    this.favExecType = this.el.getAttribute('data-exec-type');
	    this.messageContainer = $('.js-message-form-alert');
	    this.favcounter = $('#favcounter');
	
	    this.init();
	  }
	
	  _createClass(FavoritesExecutes, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.favExecType === 'button' && this.favAction === 'delfav') {
	        this.el.addEventListener('click', function () {
	          var elements = document.querySelectorAll('input[id^="checkFav_"]:checked');
	          var checkedIDs = [];
	          // Reset array if not empty.
	          if (checkedIDs.length > 0) {
	            checkedIDs = [];
	          }
	          Array.prototype.map.call(elements, function (element) {
	            checkedIDs.push(element.value);
	          });
	          var data = {
	            del: 'true',
	            really_del: 'true',
	            ajaxed: 'true',
	            id: checkedIDs
	          };
	          // Send data to server
	          $.post('/ajax.php', {
	            json: true,
	            id: checkedIDs,
	            mode: 'delfav',
	            data: data
	          }, function (respond) {
	            _this.messageContainer.fadeIn().delay(500).fadeOut('slow');
	            // Wurden Favoriten gelöscht?
	            if (typeof respond.deleted !== 'undefined') {
	              $.each(respond.deleted, function (idx, val) {
	                $('input[id^="checkFav_' + val + '"]').parents('ul').slideUp().remove();
	                $('input[id^="checkFav_' + val + '"]').parents('.profile-one').slideUp().remove();
	              });
	              // Anzahl der restlichen Favoriten berechnen und Counter updaten.
	              var fCount = $('input[id^="checkFav_"]').length;
	              $('#favcounter').text(fCount);
	              // Keine mehr Übrig?
	              if (!fCount || fCount < 0) {
	                $('#favsFound, #buttons').fadeOut(function () {
	                  $('#noFavs').fadeIn();
	                });
	              }
	              _this.messageContainer.find('p').html(respond.message);
	            }
	          }, 'json');
	        });
	      }
	    }
	  }]);
	
	  return FavoritesExecutes;
	}();
	
	exports.default = FavoritesExecutes;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import gl from '../lib/gallery_lib';
	var FolderManager = function () {
	  function FolderManager(el) {
	    _classCallCheck(this, FolderManager);
	  }
	  // this.el = el;
	  // this.moduleName = this.el.getAttribute('data-module-name');
	  // this.itemsSelector = this.el.getAttribute('data-items-selector');
	  // this.maxCharsWrapper = this.el.querySelector('#msg-max-chars-wrapper');
	  // this.errorMaxChars = this.maxCharsWrapper.innerHTML;
	  // this.allovedCharsWrapper = this.el.querySelector(
	  //   '#msg-alloved-chars-wrapper'
	  // );
	  // this.errorAllovedChars = this.allovedCharsWrapper.innerHTML;
	  // this.deleteMessageWrapper = this.el.querySelector(
	  //   '#msg-delete-message-wrapper'
	  // );
	  // this.deleteMessage = this.deleteMessageWrapper.innerHTML;
	  // this.items = this.el.querySelectorAll(this.itemsSelector);
	  // this.submitSelector = this.el.getAttribute('data-submit-selector');
	  // this.createFolderButton = this.el.querySelectorAll(this.submitSelector);
	  // this.init();
	
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(FolderManager, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.createFolderButton.forEach(function (createBtn) {
	        createBtn.addEventListener('click', function () {
	          var inField = _this.el.querySelector('input[name="foldername"]');
	          _this.createFolder(0, inField.value);
	        });
	      });
	
	      this.items.forEach(function (item) {
	        var id = item.getAttribute('data-item-id');
	        // const name = item.getAttribute('data-item-name');
	        var nameWrapper = item.querySelector('.name-wrapper');
	        var nameWrapperText = nameWrapper.querySelector('span');
	        var editBtn = item.querySelector('.edit-btn');
	        var saveBtn = item.querySelector('.save-btn');
	        var deleteBtn = item.querySelector('.delete-btn');
	        // const deleteConfirmBtn = item.querySelector('.delete-confirm-btn');
	        var cancelBtn = item.querySelector('.cancel-btn');
	        var msgBox = item.querySelector('#message-' + id);
	        var actionsWrapper = item.querySelector('.action-element-wrapper');
	        var inputName = actionsWrapper.querySelector('input[name="item_name[' + id + ']"]');
	        var inputNameCurrent = actionsWrapper.querySelector('input[name="item_name_current[' + id + ']"]');
	
	        editBtn.addEventListener('click', function () {
	          _this.implaceEdit('show', editBtn, nameWrapper, actionsWrapper);
	        });
	
	        saveBtn.addEventListener('click', function () {
	          var newValue = inputName.value.trim();
	          var result = _this.save(id, newValue);
	          if (result.error === 0) {
	            _this.implaceEdit('hide', editBtn, nameWrapper, actionsWrapper);
	            item.setAttribute('data-item-name', newValue);
	            nameWrapperText.innerText = newValue;
	            inputNameCurrent.value = newValue;
	            msgBox.classList.add('hidden');
	            msgBox.innerHTML = '';
	            deleteBtn.removeAttribute('disabled');
	            if (_this.moduleName === 'messagebox_ordner') {
	              var navBox = document.getElementById('leftnav-message-folders');
	              var navItem = navBox.querySelector('#message-folder-name-' + id);
	              navItem.innerHTML = newValue;
	            }
	          } else {
	            msgBox.classList.remove('hidden');
	            msgBox.innerHTML = result.message;
	          }
	        });
	
	        deleteBtn.addEventListener('click', function (event) {
	          event.preventDefault();
	          event.stopPropagation();
	          deleteBtn.setAttribute('disabled', 'disabled');
	          msgBox.innerHTML = _this.deleteMessage.replace(/(%s|%d)/g, function ($0) {
	            var index = {
	              '%s': nameWrapperText.innerText,
	              '%d': id
	            };
	            return index[$0] !== undefined ? index[$0] : $0;
	          });
	          msgBox.classList.remove('hidden');
	        });
	
	        $('body').on('click', '.confirm-delete', function (e) {
	          var elm = e.target || e.srcElement;
	          var elID = elm.id;
	          if (elm.nodeName === 'I') {
	            elID = elm.parentElement.id;
	          }
	          if (elID === id) {
	            item.style.display = 'none'; // eslint-disable-line no-param-reassign
	            if (_this.moduleName === 'messagebox_ordner') {
	              _this.deleteMessageFolder(id);
	            } else {
	              _this.deleteAlbum(id);
	            }
	          }
	        });
	
	        cancelBtn.addEventListener('click', function () {
	          var newCurrentValue = inputNameCurrent.value.trim();
	          item.setAttribute('data-item-name', newCurrentValue);
	          nameWrapperText.innerText = newCurrentValue;
	          inputName.value = newCurrentValue;
	          deleteBtn.removeAttribute('disabled');
	          msgBox.classList.add('hidden');
	          msgBox.innerHTML = '';
	          _this.implaceEdit('hide', editBtn, nameWrapper, actionsWrapper);
	        });
	      });
	    }
	  }, {
	    key: 'createFolder',
	    value: function createFolder(id, name) {
	      var result = {
	        error: 0
	      };
	      if (name.length < 3) {
	        result.error = 1;
	        result.title = 'errorTitle';
	        result.message = this.errorMaxChars;
	      } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄßàÀèÈìÌòÒùÙáÁéÉíÍóÓúÚ' _-]+)$/)) {
	        result.error = 2;
	        result.title = 'errorTitle';
	        result.message = this.errorAllovedChars;
	      } else {
	        var formular = document.getElementById('create-folder');
	        formular.submit();
	      }
	      return result;
	    }
	  }, {
	    key: 'deleteAlbum',
	    value: function deleteAlbum(id) {
	      var data = {
	        mode: 'deleteGalleryAlbum',
	        album_id: parseInt(id, 10)
	      };
	      $.ajax({
	        url: '/ajax.php',
	        method: 'GET',
	        data: data,
	        success: function success(response) {
	          if (response.error !== undefined) {
	            // eslint-disable-next-line no-alert
	            alert('An error is ocurred. Please try again.');
	          }
	        }
	      });
	    }
	  }, {
	    key: 'deleteMessageFolder',
	    value: function deleteMessageFolder(id) {
	      var date = new Date();
	      var time = date.getTime();
	      $.post('messagebox_ordner.php?t=' + time, {
	        ordner: id,
	        del: true,
	        really_del: true,
	        ajaxed: true
	      }).always(function () {
	        window.location.href = '/messagebox_ordner.php';
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save(id, name) {
	      var result = {
	        error: 0
	      };
	      if (name.length < 3) {
	        result.error = 1;
	        result.title = 'errorTitle';
	        result.message = this.errorMaxChars;
	      } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄßàÀèÈìÌòÒùÙáÁéÉíÍóÓúÚ' _-]+)$/)) {
	        result.error = 2;
	        result.title = 'errorTitle';
	        result.message = this.errorAllovedChars;
	      } else {
	        var scriptUrl = '/ajax.php';
	        var data = {};
	        data.album_id = id;
	        data.album_name = name.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        if (this.moduleName === 'messagebox_ordner') {
	          data.mode = 'renameMessageboxFolder';
	        } else {
	          data.mode = 'renameGalleryAlbum';
	        }
	        $.ajax({
	          url: scriptUrl,
	          method: 'POST',
	          data: data,
	          success: function success(response) {
	            if (response.error !== undefined) {
	              // eslint-disable-next-line no-alert
	              alert('An error is ocurred. Please try again.');
	            }
	          }
	        });
	      }
	      return result;
	    }
	
	    /* eslint-disable no-param-reassign */
	
	  }, {
	    key: 'implaceEdit',
	    value: function implaceEdit(action, editBtn, nameWrapper, actionsWrapper) {
	      var tmp = actionsWrapper.querySelector('input[type="text"]');
	      switch (action) {
	        case 'show':
	          // hide text
	          nameWrapper.style.display = 'none';
	          editBtn.style.display = 'none';
	          // show input
	          tmp.value = tmp.value.trim();
	          actionsWrapper.style.display = '';
	          actionsWrapper.querySelector('.action-elements').style.display = '';
	          break;
	        case 'hide':
	        default:
	          // show text
	          tmp.value.trim();
	          nameWrapper.style.display = '';
	          editBtn.style.display = '';
	          // hide input
	          actionsWrapper.style.display = 'none';
	          actionsWrapper.querySelector('.action-elements').style.display = 'none';
	          break;
	      }
	    }
	    /* eslint-enable no-param-reassign */
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return FolderManager;
	}();
	
	exports.default = FolderManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _photoswipe = __webpack_require__(92);
	
	var _photoswipe2 = _interopRequireDefault(_photoswipe);
	
	var _photoswipeUiDefault = __webpack_require__(93);
	
	var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Gallery = function () {
	  function Gallery(elem) {
	    _classCallCheck(this, Gallery);
	
	    this.gallerySelector = elem;
	
	    this.galleryPrefix = 'gallery-';
	    this.elements = this.galleryPrefix + 'elements';
	    this.uid = this.galleryPrefix + 'uid';
	    this.storage = sessionStorage;
	
	    this.init();
	  }
	
	  _createClass(Gallery, [{
	    key: 'init',
	    value: function init() {
	      this._initSessionStorage();
	
	      // select all galleries
	      var galleries = document.querySelectorAll('[data-pswp-uid]');
	      var uid = galleries.length ? this._getUID(galleries.length) : (this._setUID(), this._getUID());
	
	      this._setUID(uid);
	      this._setUIDAttr(uid);
	
	      this.gallerySelector.addEventListener('click', this._onThumbnailsClick.bind(this), false);
	
	      // Parse URL and open gallery if it contains #&pid=3&gid=1
	      var hashData = this._photoswipeParseHash();
	      if (hashData.pid && hashData.gid) {
	        var gallery = document.querySelector('[data-pswp-uid="' + hashData.gid + '"]');
	        this._openPhotoSwipe(hashData.pid, gallery, true, true);
	      }
	    }
	
	    // Creates the gallery keys in the session storage
	
	  }, {
	    key: '_initSessionStorage',
	    value: function _initSessionStorage() {
	      if (this.storage.getItem(this.uid) == null) {
	        this.storage.setItem(this.uid, '0');
	      }
	    }
	  }, {
	    key: '_getUID',
	    value: function _getUID() {
	      var inc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      return Number(this.storage.getItem(this.uid)) + inc;
	    }
	  }, {
	    key: '_setUID',
	    value: function _setUID() {
	      var uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.storage.setItem(this.uid, uid.toString());
	    }
	  }, {
	    key: '_setUIDAttr',
	    value: function _setUIDAttr(uid) {
	      this.gallerySelector.setAttribute('data-pswp-uid', uid.toString());
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_openPhotoSwipe',
	    value: function _openPhotoSwipe(index, clickedGallery, disableAnimation, fromURL) {
	      var pswpElement = document.querySelector('.pswp');
	
	      var items = this._parseThumbnailElements(clickedGallery);
	
	      // define options (if needed)
	      var options = {
	        galleryUID: clickedGallery.getAttribute('data-pswp-uid'),
	
	        getThumbBoundsFn: function getThumbBoundsFn(idx) {
	          var thumbnail = items[idx].el.children[0];
	          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
	          var rect = thumbnail.getBoundingClientRect();
	
	          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
	        },
	
	
	        /* eslint-disable no-param-reassign */
	        addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl) {
	          if (!item.title) {
	            captionEl.children[0].innerText = '';
	
	            return false;
	          }
	
	          captionEl.children[0].innerHTML = item.title + '<br/><small>Photo: ' + item.author + '</small>';
	
	          return true;
	        }
	        /* eslint-enable no-param-reassign */
	
	      };
	
	      if (fromURL) {
	        if (options.galleryPIDs) {
	          // parse real index when custom PIDs are used
	          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
	          for (var j = 0; j < items.length; j += 1) {
	            if (items[j].pid === index) {
	              options.index = j;
	              break;
	            }
	          }
	        } else {
	          options.index = parseInt(index, 10) - 1;
	        }
	      } else {
	        options.index = parseInt(index, 10);
	      }
	
	      // exit if index not found
	      if (Number.isNaN(options.index)) {
	        return;
	      }
	
	      if (disableAnimation) {
	        options.showAnimationDuration = 0;
	      }
	
	      // Pass data to PhotoSwipe and initialize it
	      var gallery = new _photoswipe2.default(pswpElement, _photoswipeUiDefault2.default, items, options);
	
	      // see: http://photoswipe.com/documentation/responsive-images.html
	      var firstResize = true;
	      var useLargeImages = false;
	      var realViewportWidth = void 0;
	      var imageSrcWillChange = void 0;
	
	      gallery.listen('beforeResize', function () {
	        var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
	        dpiRatio = Math.min(dpiRatio, 2.5);
	        realViewportWidth = gallery.viewportSize.x * dpiRatio;
	
	        if (realViewportWidth >= 1200 || !gallery.likelyTouchDevice && realViewportWidth > 800 || window.screen.width > 1200) {
	          if (!useLargeImages) {
	            useLargeImages = true;
	            imageSrcWillChange = true;
	          }
	        } else if (useLargeImages) {
	          useLargeImages = false;
	          imageSrcWillChange = true;
	        }
	
	        if (imageSrcWillChange && !firstResize) {
	          gallery.invalidateCurrItems();
	        }
	
	        if (firstResize) {
	          firstResize = false;
	        }
	
	        imageSrcWillChange = false;
	      });
	
	      gallery.listen('gettingData', function (idx, item) {
	        /* eslint-disable no-param-reassign */
	        if (useLargeImages) {
	          item.src = item.o.src;
	          item.w = item.o.w;
	          item.h = item.o.h;
	        } else {
	          item.src = item.m.src;
	          item.w = item.m.w;
	          item.h = item.m.h;
	        }
	        /* eslint-enable no-param-reassign */
	      });
	
	      gallery.init();
	    }
	  }, {
	    key: '_onThumbnailsClick',
	    value: function _onThumbnailsClick(e) {
	      e.preventDefault();
	
	      var eTarget = e.target;
	      var clickedListItem = eTarget.closest('a');
	
	      if (clickedListItem) {
	        var clickedGallery = clickedListItem.parentNode;
	
	        var _clickedGallery$child = _toArray(clickedGallery.childNodes),
	            childNodes = _clickedGallery$child.slice(0);
	
	        var nodeIndex = 0;
	        var index = void 0;
	
	        childNodes.filter(function (item) {
	          return item.nodeType === 1;
	        }).forEach(function (item) {
	          if (item === clickedListItem) {
	            index = nodeIndex;
	          } else {
	            nodeIndex += 1;
	          }
	        });
	
	        if (index >= 0) {
	          this._openPhotoSwipe(index, clickedGallery);
	        }
	      }
	    }
	  }, {
	    key: '_photoswipeParseHash',
	    value: function _photoswipeParseHash() {
	      var hash = window.location.hash.substring(1);
	      var fragment = hash.charAt(0) === '&' ? hash.substr(1) : hash;
	      var params = {};
	
	      if (fragment.length >= 5) {
	        // pid=1
	        var items = fragment.split('&');
	
	        items.forEach(function (item) {
	          var _item$split = item.split('='),
	              _item$split2 = _slicedToArray(_item$split, 2),
	              key = _item$split2[0],
	              val = _item$split2[1];
	
	          params[key] = key === 'gid' ? parseInt(val, 10) : val;
	        });
	      }
	
	      return params;
	    }
	  }, {
	    key: '_parseThumbnailElements',
	    value: function _parseThumbnailElements(elem) {
	      var thumbElements = elem.childNodes;
	      var numNodes = thumbElements.length;
	      var items = [];
	
	      for (var i = 0; i < numNodes; i += 1) {
	        var el = thumbElements[i];
	
	        // include only element nodes
	        if (el.nodeType === 1) {
	          var childElements = el.children;
	          var size = el.getAttribute('data-size').split('x');
	
	          // create slide object
	          var item = {
	            src: el.getAttribute('href'),
	
	            w: parseInt(size[0], 10),
	
	            h: parseInt(size[1], 10),
	
	            author: el.getAttribute('data-author'),
	
	            el: el // save link to element for getThumbBoundsFn
	          };
	
	          if (childElements.length > 0) {
	            // thumbnail url
	            item.msrc = childElements[0].getAttribute('src');
	            if (childElements.length > 1) {
	              // caption (contents of figure)
	              item.title = childElements[1].innerHTML;
	            }
	          }
	
	          var mediumSrc = el.getAttribute('data-med');
	          if (mediumSrc) {
	            size = el.getAttribute('data-med-size').split('x');
	
	            // "medium-sized" image
	            item.m = {
	              src: mediumSrc,
	
	              w: parseInt(size[0], 10),
	
	              h: parseInt(size[1], 10)
	            };
	          }
	
	          // original image
	          item.o = {
	            src: item.src,
	
	            w: item.w,
	
	            h: item.h
	          };
	
	          items.push(item);
	        }
	      }
	
	      return items;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return Gallery;
	}();
	
	exports.default = Gallery;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import gl from '../lib/gallery_lib';
	var GalleryAlbum = function () {
	  function GalleryAlbum(el) {
	    _classCallCheck(this, GalleryAlbum);
	
	    this.el = el;
	    this.openEdit = this.el.querySelectorAll('.open-edit');
	    this.errorTitle = this.el.getAttribute('data-error-title');
	    this.errorMaxChars = this.el.getAttribute('data-error-max-chars');
	    this.errorAllovedChars = this.el.getAttribute('data-error-alloved-chars');
	    this.deleteTitle = this.el.getAttribute('data-delete-title');
	    this.deleteMessage = this.el.getAttribute('data-delete-message');
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(GalleryAlbum, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.openEdit.forEach(function (item) {
	        item.addEventListener('click', function () {
	          // Init
	          var actionsWrapper = item.previousElementSibling;
	          var itemName = item.previousElementSibling.previousElementSibling;
	          var itemWrapper = item.parentElement.parentElement;
	          var albumID = itemWrapper.getAttribute('data-album-id');
	          var albumName = itemWrapper.getAttribute('data-album-name');
	          var btnCancel = actionsWrapper.querySelector('.album-cancel');
	          var btnSave = actionsWrapper.querySelector('.album-save');
	          var btnDelete = actionsWrapper.querySelector('.album-delete');
	          var inField = actionsWrapper.querySelector('input[name="album_name[' + albumID + ']"]');
	          var inFieldCurrent = actionsWrapper.querySelector('input[name="album_name_current[' + albumID + ']"]');
	          var inFieldMessage = itemWrapper.querySelector('#message-' + albumID);
	          // Actions
	          btnCancel.addEventListener('click', function () {
	            inField.value = inFieldCurrent.value;
	            btnDelete.removeAttribute('disabled');
	            inFieldMessage.classList.add('hidden');
	            _this.implaceEdit('hide', item, itemName, actionsWrapper, itemWrapper);
	          });
	          // Save changes
	          btnSave.addEventListener('click', function () {
	            btnDelete.removeAttribute('disabled');
	            var newNm = inField.value;
	            var nameSpan = actionsWrapper.previousElementSibling.querySelector('span');
	            var result = _this.saveName(albumID, newNm);
	            if (result.error === 0) {
	              _this.implaceEdit('hide', item, itemName, actionsWrapper, itemWrapper);
	              inField.value = newNm;
	              inFieldCurrent.value = newNm;
	              nameSpan.innerText = newNm;
	              inFieldMessage.classList.add('hidden');
	            } else {
	              inFieldMessage.classList.remove('hidden');
	              inFieldMessage.innerHTML = result.message;
	            }
	          });
	          // Display delete confirm message
	          btnDelete.addEventListener('click', function (event) {
	            event.preventDefault();
	            event.stopPropagation();
	            btnDelete.setAttribute('disabled', 'disabled');
	            inFieldMessage.innerHTML = _this.deleteMessage.replace(/(%s|%d)/g, function ($0) {
	              var index = {
	                '%s': albumName,
	                '%d': albumID
	              };
	              return index[$0] !== undefined ? index[$0] : $0;
	            });
	            inFieldMessage.classList.remove('hidden');
	          });
	          // Confirm deletion
	          $('body').on('click', '.confirm-delete', function (e) {
	            var elm = e.target || e.srcElement;
	            if (elm.id === albumID) {
	              itemWrapper.style.display = 'none';
	              _this.deleteAlbum(albumID);
	            }
	          });
	          // Execute
	          _this.implaceEdit('show', item, itemName, actionsWrapper, itemWrapper);
	        });
	      });
	    }
	  }, {
	    key: 'saveName',
	    value: function saveName(id, name) {
	      var result = {
	        error: 0
	      };
	      if (name.length < 3) {
	        result.error = 1;
	        result.title = this.errorTitle;
	        result.message = this.errorMaxChars;
	      } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄß _-]+)$/)) {
	        result.error = 2;
	        result.title = this.errorTitle;
	        result.message = this.errorAllovedChars;
	      } else {
	        var data = {
	          mode: 'renameGalleryAlbum',
	          album_id: id,
	          album_name: name
	        };
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          data: data,
	          success: function success(response) {
	            if (response.error !== undefined) {
	              // eslint-disable-next-line no-alert
	              alert('An error is ocurred. Please try again.');
	            }
	          }
	        });
	      }
	      return result;
	    }
	  }, {
	    key: 'deleteAlbum',
	    value: function deleteAlbum(id) {
	      var data = {
	        mode: 'deleteGalleryAlbum',
	        album_id: parseInt(id, 10)
	      };
	      $.ajax({
	        url: '/ajax.php',
	        method: 'GET',
	        data: data,
	        success: function success(response) {
	          if (response.error !== undefined) {
	            // eslint-disable-next-line no-alert
	            alert('An error is ocurred. Please try again.');
	          }
	        }
	      });
	    }
	
	    /* eslint-disable no-param-reassign */
	
	  }, {
	    key: 'implaceEdit',
	    value: function implaceEdit(action, item, itemName, actionsWrapper) {
	      switch (action) {
	        case 'show':
	          // hidde
	          item.style.display = 'none';
	          itemName.style.display = 'none';
	          // show
	          actionsWrapper.style.display = '';
	          actionsWrapper.querySelector('.edit-name').style.display = '';
	          break;
	        default:
	          // show
	          item.style.display = '';
	          itemName.style.display = '';
	          // hidde
	          actionsWrapper.style.display = 'none';
	          actionsWrapper.querySelector('.edit-name').style.display = 'none';
	          break;
	      }
	    }
	    /* eslint-enable no-param-reassign */
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return GalleryAlbum;
	}();
	
	exports.default = GalleryAlbum;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var groupNavigation = function () {
	  function groupNavigation(el) {
	    _classCallCheck(this, groupNavigation);
	
	    this.el = el;
	    this.init();
	  }
	
	  _createClass(groupNavigation, [{
	    key: 'init',
	    value: function init() {
	      // Get active group id
	      this.gid = this._getCurrentGroupID();
	      this.gnd = this._getCurrentGroupNode();
	
	      this._collapseGroupNodes();
	    }
	  }, {
	    key: '_getCurrentGroupID',
	    value: function _getCurrentGroupID() {
	      return $(this.el).data('current-group-id');
	    }
	  }, {
	    key: '_getCurrentGroupNode',
	    value: function _getCurrentGroupNode() {
	      var citiesParentNode = document.querySelector('#js--lg--cities');
	      var citiesNode = document.querySelector('#js--lg--cities__options--' + this.gid);
	      var themesParentNode = document.querySelector('#js--lg--themes');
	      var themesNode = document.querySelector('#js--lg--themes__options--' + this.gid);
	
	      return citiesNode !== null ? [citiesParentNode, citiesNode] : [themesParentNode, themesNode];
	    }
	  }, {
	    key: '_collapseGroupNodes',
	    value: function _collapseGroupNodes() {
	      if (groupNavigation._isInNode(this.gnd[0], this.gnd[1])) {
	        $(this.gnd[0]).collapse();
	        $(this.gnd[1]).collapse();
	
	        groupNavigation._highlightCurrentLink(this.gnd[1]);
	        // groupNavigation._highlightCurrentGroup(this.gnd[0], this.gnd[1]);
	      }
	    }
	  }], [{
	    key: '_highlightCurrentLink',
	    value: function _highlightCurrentLink(node) {
	      var uno = window.location.search.substr(1).split('&');
	      var cgid = uno[0].split('=')[1];
	      var urlPath = groupNavigation._getURLPath();
	      var link = $(node).find('a[href=\'' + urlPath + '\']');
	      if (link.length === 0) {
	        link = $(node).find('a[href=\'' + urlPath + '?f=' + cgid + '\']');
	      }
	      link.addClass('lgi--current');
	    }
	  }, {
	    key: '_highlightCurrentGroup',
	    value: function _highlightCurrentGroup(parentNode, node) {
	      $(parentNode).scrollTop($(node).prev().position().top - $(parentNode).position().top);
	    }
	  }, {
	    key: '_getURLPath',
	    value: function _getURLPath() {
	      return window.location.pathname;
	    }
	  }, {
	    key: '_isInNode',
	    value: function _isInNode(node, subnode) {
	      return node === subnode ? false : node.contains(subnode);
	    }
	  }]);
	
	  return groupNavigation;
	}();
	
	exports.default = groupNavigation;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _croppie = __webpack_require__(58);
	
	var _croppie2 = _interopRequireDefault(_croppie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageEditor = function () {
	  function ImageEditor(el) {
	    _classCallCheck(this, ImageEditor);
	
	    this.el = el;
	    this.refererURL = this.el.getAttribute('data-referer').trim();
	    this.rotateBtn = this.el.querySelector('.rotate-button');
	    this.removeBtn = this.el.querySelector('.remove-button');
	    this.saveBtn = this.el.querySelector('.save-button');
	    this.workContainerRot = this.el.querySelector('.work-container-rot');
	    this.workContainerCrop = this.el.querySelector('.work-container-crop');
	    this.modulemode = this.el.getAttribute('data-module-mode');
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(ImageEditor, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.modulemode === 'crop') {
	        this.cropResult = document.querySelector('.crop-result');
	        this.cropSave = document.querySelector('.crop-save');
	        this.cropRotate = document.querySelector('.crop-rotate');
	        this.image = this.el.getAttribute('data-crop-file');
	        this.cropWork();
	      }
	      if (this.modulemode === 'rot') {
	        this.saveBtn.addEventListener('click', function () {
	          $.ajax({
	            url: '/support/img_editor/operations.php',
	            method: 'POST',
	            type: 'json',
	            data: {
	              mode: 'save',
	              uid: _this.el.getAttribute('data-uid'),
	              file: _this.el.getAttribute('data-file'),
	              type: _this.el.getAttribute('data-type'),
	              o: _this.el.getAttribute('data-o')
	            },
	            success: function success(data) {
	              var response = $.parseJSON(data);
	              if (response.success === 'ok') {
	                window.location = _this.refererURL;
	              }
	            }
	          });
	        });
	        this.rotateBtn.addEventListener('click', function () {
	          $.ajax({
	            url: '/support/img_editor/operations.php',
	            method: 'POST',
	            type: 'json',
	            data: {
	              mode: 'rotate',
	              type: _this.el.getAttribute('data-type'),
	              uid: _this.el.getAttribute('data-uid'),
	              file: _this.el.getAttribute('data-file')
	            },
	            success: function success(data) {
	              var response = $.parseJSON(data);
	              var otra = response.new_url;
	              var newIMG = new Image();
	              var now = Date.now();
	              newIMG.src = otra + '?' + now;
	              newIMG.classList.add('img-responsive');
	              _this.workContainerRot.innerHTML = '';
	              _this.workContainerRot.appendChild(newIMG);
	            }
	          });
	        });
	        this.removeBtn.addEventListener('click', function () {
	          // eslint-disable-next-line
	          var res = confirm('Sicher löschen?');
	          if (res) {
	            $.ajax({
	              url: '/hier eine adresse',
	              method: 'POST',
	              type: 'json',
	              data: {
	                mode: 'remove'
	              },
	              success: function success() {
	                _this.workContainer.innerHTML = '';
	              }
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cropWork',
	    value: function cropWork() {
	      var _this2 = this;
	
	      var c = new _croppie2.default(document.getElementById('crop-work'), {
	        viewport: {
	          width: 199,
	          height: 265
	        },
	        boundary: {
	          width: 450,
	          height: 600
	        },
	        enableOrientation: true,
	        enableResize: false,
	        mouseWheelZoom: 'ctrl'
	      });
	      c.bind({
	        url: this.image
	      });
	      this.cropResult.addEventListener('click', function () {
	        c.result({
	          type: 'canvas',
	          format: 'jpeg',
	          quality: 1
	        }).then(_this2.resultCrop);
	      });
	      this.cropSave.addEventListener('click', function () {
	        c.result({
	          type: 'canvas',
	          format: 'jpeg',
	          quality: 1
	        }).then(_this2.saveCrop);
	      });
	      this.cropRotate.addEventListener('click', function (e) {
	        c.rotate(parseInt(e.target.getAttribute('data-deg'), 10));
	      });
	    }
	  }, {
	    key: 'resultCrop',
	    value: function resultCrop(result) {
	      var resultWrapper = document.getElementById('image-cropped');
	      var img = new Image();
	      img.src = result;
	      resultWrapper.innerHTML = '';
	      resultWrapper.appendChild(img);
	    }
	  }, {
	    key: 'saveCrop',
	    value: function saveCrop(result) {
	      var el = document.getElementById('imageeditor-wrapper');
	      var refererURL = el.getAttribute('data-referer');
	      var mytype = el.getAttribute('data-type');
	      var userid = el.getAttribute('data-uid');
	      var original = el.getAttribute('data-0');
	      var data = {
	        mode: 'save_min',
	        uid: userid,
	        file: result,
	        type: mytype,
	        o: original
	      };
	      $.ajax({
	        url: '/support/img_editor/operations.php',
	        method: 'POST',
	        type: 'json',
	        data: data,
	        success: function success(res) {
	          var response = $.parseJSON(res);
	          if (response.success === 'ok') {
	            window.location = refererURL;
	          }
	        }
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ImageEditor;
	}();
	
	exports.default = ImageEditor;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InboxOperation = function () {
	  function InboxOperation(el) {
	    var _this = this;
	
	    _classCallCheck(this, InboxOperation);
	
	    this.el = el;
	    this.selectBox = document.querySelector('select[name="action"]');
	    this.ListContainer = this.el.getAttribute('data-messages-list-items');
	    this.currentFolder = document.querySelector('input[name="ordner"]').value;
	    this.listItems = document.querySelectorAll(this.ListContainer);
	    this.checkboxesItems = $(this.listItems).find('input[type="checkbox"]');
	    $(this.selectBox).on('change', function (sel) {
	      // Get checked.
	      _this.msgIds = [];
	      $('input[type="checkbox"]:checked').each(function (i, elm) {
	        _this.ii = i;
	        _this.msgIds.push(elm.value);
	      });
	      // Determine action for ajax.
	      _this.actionValue = sel.currentTarget.value;
	      // console.log('actionValue');
	      // console.log(this.actionValue);
	      var action = '';
	      switch (_this.actionValue) {
	        case 'r':
	        case 'ur':
	          action = 'set_flag';
	          break;
	        case 'new':
	          action = 'new_folder';
	          break;
	        case '3':
	        case '4':
	          action = 'remove';
	          break;
	        default:
	          action = 'move';
	      }
	      if (_this.msgIds.length > 0) {
	        _this._doOperation(_this.currentFolder, action, _this.actionValue, _this.msgIds);
	      } else {
	        // console.log('0 message(s) selected.');
	      }
	      _this._resetAll();
	    });
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(InboxOperation, [{
	    key: '_doOperation',
	    value: function _doOperation(current, action, value, ids) {
	      switch (action) {
	        case 'move':
	        case 'remove':
	          // console.log('remove items from view');
	          this._removeItems();
	          this._execute(current, action, value, ids);
	          break;
	        case 'set_flag':
	          // console.log('change flags');
	          this._execute(current, action, value, ids);
	          break;
	        default:
	          this._freeMe();
	      }
	    }
	  }, {
	    key: '_resetAll',
	    value: function _resetAll() {
	      $(this.selectBox).val('');
	    }
	  }, {
	    key: '_removeItems',
	    value: function _removeItems() {
	      // console.log(this.checkboxesItems);
	    }
	  }, {
	    key: '_freeMe',
	    value: function _freeMe() {
	      this.ii = 0;
	    }
	  }, {
	    key: '_execute',
	    value: function _execute(current, action, value, ids) {
	      var data = {};
	      data.mode = 'send';
	      data.current = current;
	      data.action = action;
	      data.value = value;
	      data.ids = ids;
	      $.ajax({
	        url: '/inbox_operations.php',
	        type: 'POST',
	        data: data,
	        success: function success(response) {
	          // console.log('response');
	          // console.log(response);
	          window.location = window.location.href;
	          if (response.action === 'OK') {
	            window.location = window.location.href;
	          }
	        }
	      });
	    }
	  }]);
	
	  return InboxOperation;
	}();
	
	exports.default = InboxOperation;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Likes = function () {
	  function Likes(el) {
	    _classCallCheck(this, Likes);
	
	    this.el = el;
	    this.handSelector = this.el.getAttribute('data-hand-selector');
	    this.hand = this.el.querySelector(this.handSelector);
	    this.handValue = this.el.querySelector('.likes-like');
	    this.userid = this.el.getAttribute('data-uid');
	    this.galid = this.el.getAttribute('data-gallid');
	    // green
	    this.activeColor = '#4A9501';
	    // gray
	    this.pasiveColor = 'rgb(128, 128, 128)';
	
	    this.init();
	  }
	
	  _createClass(Likes, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.hand.addEventListener('click', function () {
	        if (_this.hand.classList.contains('y-like')) {
	          _this.hand.style.color = _this.pasiveColor;
	          _this.handValue.innerHTML = parseInt(_this.handValue.innerHTML, 10) + 1;
	          _this.hand.classList.remove('y-like');
	        } else {
	          _this.hand.style.color = _this.activeColor;
	          _this.hand.classList.add('y-like');
	          _this.handValue.innerHTML = parseInt(_this.handValue.innerHTML, 10) - 1;
	        }
	      });
	    }
	  }]);
	
	  return Likes;
	}();
	
	exports.default = Likes;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Messages = function () {
	  function Messages(el) {
	    _classCallCheck(this, Messages);
	
	    // console.log('messages > constructor');
	    this.el = el;
	    // Get selectors
	    this.selectorItems = this.el.getAttribute('data-messages-list-items');
	    this.selectorView = this.el.getAttribute('data-message-view');
	    this.selectorItemCaret = this.el.getAttribute('data-message-caret');
	    this.selectorItemCount = this.el.getAttribute('data-messages-count');
	    this.msgsBubble = document.getElementById('navbar-info-bubble');
	    // Get first message of the list onload.
	    // console.log('this.selectorItems.length');
	    // console.log(this.selectorItems.length);
	    if (this.selectorItemCount > 0) {
	      this.msgID = document.querySelectorAll(this.selectorItems)[0].id;
	      this.dest = document.querySelector(this.selectorView);
	      this.items = $(this.selectorItemCaret).parents('li');
	      this.body = $('body');
	      // this.selectLeft = $('select#move-left');
	      this.selectLeft = document.querySelector('#move-to-parent');
	      // this.selectRight = $('select#move-right');
	      this.init();
	      document.getElementById(this.msgID).click();
	    }
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(Messages, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      // console.log('messages > init');
	      if (this.items.length) {
	        // this._getMsg(this.msgID);
	        this.body.on('click', '' + this.selectorItems, function (item) {
	          if (_this.msgsBubble !== null) {
	            _this.msgsBubbleState = parseInt(_this.msgsBubble.innerHTML, 10);
	          } else {
	            _this.msgsBubbleState = 0;
	          }
	          if (item.target.type !== 'checkbox') {
	            _this._getMsg(item.currentTarget.id);
	            if (_this.msgsBubbleState > 0) {
	              _this.msgsBubble.innerHTML = _this.msgsBubbleState - 1;
	            }
	          }
	        });
	      }
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_getMsg',
	    value: function _getMsg(mid) {
	      var _this2 = this;
	
	      var msgLi = $('li#' + mid);
	      var msgLiI = msgLi.find('i');
	      // Set background color.
	      $(this.selectorItems).removeClass('is-active');
	      // Change status symbol.
	      msgLi.addClass('is-active');
	      msgLiI.removeClass('fa-envelope').addClass('fa-envelope-o');
	      $.post('/message_ajax.php', {
	        id: mid
	      }, function (html) {
	        _this2.dest.innerHTML = html;
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return Messages;
	}();
	
	exports.default = Messages;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MsgTree = function () {
	  function MsgTree(el) {
	    _classCallCheck(this, MsgTree);
	
	    this.el = el;
	    this.formContainer = this.el.querySelector('#form-container');
	    this.showTreeButton = this.el.querySelector('#show-tree-button');
	    this.confirmContainer = this.el.querySelector('#confirm-container');
	    this.confirmButton = this.el.querySelector('#confirm-button');
	    this.cancelButton = this.el.querySelector('#cancel-button');
	    this.confirmID = this.el.querySelector('#confirm-id');
	    this.outputContainer = this.el.querySelector('#tree-output');
	    this.outputContainer = this.el.querySelector('#tree-output');
	    this.resultContainer = this.el.querySelector('#result-container');
	    this.outputAmount = this.el.querySelector('#amount');
	    this.userid = this.el.querySelector('input[name="uid"]');
	
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(MsgTree, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.cancelButton.addEventListener('click', function () {
	        _this.confirmID.innerHTML = _this.userid.value;
	        _this.formContainer.classList.remove('hidden');
	        _this.confirmContainer.classList.add('hidden');
	        _this.resultContainer.classList.add('hidden');
	        _this.confirmID.innerHTML = '';
	        _this.outputContainer.innerHTML = '';
	        _this.outputAmount.innerHTML = '0 ';
	        _this.userid.value = '';
	        window.scrollTo(0, 0);
	      });
	      this.showTreeButton.addEventListener('click', function () {
	        if (!_this.userid.value) {
	          return;
	        }
	
	        var userId = _this.userid.value;
	
	        $('#result-container').addClass('hidden');
	        $('#confirm-container').addClass('hidden');
	        $('#tree-output').text('');
	
	        fetch('/api/v1/public/all-message-threads/' + userId).then(function (response) {
	          return response.json();
	        }).then(function (jsMessage) {
	          if (typeof jsMessage.messages == 'undefined' || jsMessage.messages.length == 0) {
	
	            $('#result-container').removeClass('hidden');
	            $('#removeMessagePanelTitle').html(i8n.removeMessagePanelTitle);
	
	            return false;
	          }
	
	          // eslint-disable-next-line no-restricted-syntax
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = jsMessage.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var message = _step.value;
	
	              var messageItemWrap = $('<div>').addClass('message-thread-item row');
	
	              var msgTimeObj = new Date(message.timestamp);
	
	              var senderName = message.senderUserName;
	              var receiverName = message.receiverUserName;
	
	              var messageItemContentWrap = $('<div>').addClass('row');
	
	              var messageItemTime = $('<div>').addClass('message-thread-item-time ').text(msgTimeObj.toLocaleString(mailloc.iso4, mailloc.DateOptions));
	
	              var messageItemPartners = $('<div>').addClass('message-thread-item-partners').text(senderName + ' -> ' + receiverName);
	
	              var textStr = void 0;
	
	              textStr = message.type == 'CUSTOM' ? message.message : i8n.message_text['SENDER'][message.type];
	
	              textStr = textStr.replace('{RECEIVER}', receiverName);
	              textStr = textStr.replace('{SENDER}', senderName);
	
	              var messageItemText = $('<div>').addClass('message-thread-item-text row').append($('<div>').addClass('col-sm-12').html(textStr));
	
	              messageItemContentWrap.append(messageItemTime);
	
	              messageItemContentWrap.append(messageItemPartners);
	
	              messageItemWrap.append(messageItemContentWrap);
	
	              messageItemWrap.append(messageItemText);
	
	              $('#tree-output').append(messageItemWrap);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          $('#removeMessagePanelTitle').text(i8n.removeMessagePanelTitle.replace("<span id=\"amount\">0 </span>", jsMessage.messages.length + ' '));
	
	          $('#result-container').removeClass('hidden');
	          $('#confirm-container').removeClass('hidden');
	        });
	      });
	      this.confirmButton.addEventListener('click', function () {
	
	        var userId = _this.userid.value;
	
	        fetch('/api/v1/public/all-message-threads/' + userId, { method: "DELETE" }).then(function (response) {
	          if (response.ok) {
	            return response.json();
	          }
	          return Promise.reject(response);
	        }).then(function (jsMessage) {
	          _this.outputContainer.innerHTML = '';
	          _this.confirmContainer.classList.add('hidden');
	          _this.outputAmount.innerHTML = '0 ';
	          _this.userid.value = '';
	          window.scrollTo(0, 0);
	        }).catch(function (response) {
	          response.json().then(function (json) {
	            console.log(json);
	          });
	        });
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return MsgTree;
	}();
	
	exports.default = MsgTree;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MultipleCheckboxToggle = function MultipleCheckboxToggle(el) {
	  var _this = this;
	
	  _classCallCheck(this, MultipleCheckboxToggle);
	
	  this.el = el;
	  this.boxesParent = this.el.getAttribute('data-boxes-wrapper');
	  this.el.addEventListener('click', function (e) {
	    if (e.target.checked) {
	      $(_this.boxesParent).find('input[type=checkbox]').prop('checked', true);
	    } else {
	      $(_this.boxesParent).find('input[type=checkbox]').prop('checked', false);
	    }
	  }, false);
	};
	
	exports.default = MultipleCheckboxToggle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _helper_lib = __webpack_require__(21);
	
	var _helper_lib2 = _interopRequireDefault(_helper_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProfileActions = function () {
	  function ProfileActions(el) {
	    _classCallCheck(this, ProfileActions);
	
	    this.el = el;
	    this.favToggle = this.el.querySelectorAll(".favorite-toggle");
	    this.addContactButton = this.el.querySelectorAll("#addContact");
	
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(ProfileActions, [{
	    key: "init",
	    value: function init() {
	      this.favoriteToggle();
	      this.sendSmile();
	      this.addContact();
	      this.ConfirmContact();
	    }
	  }, {
	    key: "sendSmile",
	    value: function sendSmile() {
	      $("body").on("click", "#sendSmile", function (usr) {
	        var myObj = usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;
	
	        var partnerId = encodeURIComponent(myObj.getAttribute("data-uid"));
	        var success = function success(r) {
	          var disableButton = true;
	          if (disableButton) {
	            myObj.setAttribute("disabled", "disabled");
	            setTimeout(function () {
	              target.removeAttribute("disabled");
	              disableButton = false;
	            }, 30000);
	          }
	          if (r.status !== "undefined" && r.status == 200) {
	            _helper_lib2.default.showMessage("info", "#message-box", "", i8n.Send_send_ok, 10000);
	          } else if (typeof r.status !== "undefined" && r.status == 429) {
	            _helper_lib2.default.showMessage("error", "#message-box", "", i8n.error.Visitor_tofast, 20000);
	          } else {
	            _helper_lib2.default.showMessage("error", "#message-box", "", i8n.error.Bulkpost_error, 10000);
	          }
	        };
	
	        _helper_lib2.default.standardMessage(myObj, "SMILE", partnerId, success);
	      });
	    }
	  }, {
	    key: "addContact",
	    value: function addContact() {
	      $("body").on("click", "#addContact", function (usr) {
	        var myObj = usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;
	        var partnerId = myObj.getAttribute("data-uid");
	
	        var action = "contactRequest";
	
	        var success = function success(r) {
	          if (r.status !== "undefined" && r.status == 200) {
	
	            $("#addContact").removeClass("fa-user-plus fa-user").addClass("fa-user-o");
	            $("#addContact").attr("data-content", $("#addContact").attr("data-title-requested"));
	
	            _helper_lib2.default.showMessage(response.type, "#message-box", "", response.message, 10000);
	          } else {
	            _helper_lib2.default.showMessage("error", "#message-box", "", i8n.error.Bulkpost_error, 10000);
	          }
	        };
	
	        _helper_lib2.default.standardMessage(myObj, action, partnerId, success);
	      });
	    }
	  }, {
	    key: "ConfirmContact",
	    value: function ConfirmContact() {
	      $("body").on("click", "#ConfirmContactProfil", function (usr) {
	        var myObj = usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;
	        var userid = myObj.getAttribute("data-uid");
	        var data = {};
	        data.id = userid;
	
	        data.adduser = userid;
	        data.mode = "ConfirmContactProfil";
	        data.ras = "g";
	
	        $.ajax({
	          url: _helper_lib2.default.getCacheBustedLink("/", "ajax", "php"),
	          method: "POST",
	          data: data,
	          success: function success(response) {
	            $("#addContact").removeClass("fa-user-plus fa-user-o").addClass("fa-user");
	            $("#addContact").attr("data-content", $("#addContact").attr("data-title-accepted"));
	            _helper_lib2.default.showMessage(response.type, "#message-box", "", response.message, 10000);
	          }
	        });
	      });
	    }
	  }, {
	    key: "favoriteToggle",
	    value: function favoriteToggle() {
	      this.favToggle.forEach(function (toggle) {
	        var userid = toggle.dataset.id;
	        toggle.addEventListener("click", function () {
	          var data = {
	            id: userid,
	            act: 1,
	            mode: "favsave"
	          };
	          $.ajax({
	            url: _helper_lib2.default.getCacheBustedLink("/", "ajax", "php"),
	            method: "POST",
	            type: "html",
	            data: data,
	            success: function success(response) {
	              _helper_lib2.default.showMessage(response.type, "#message-box", "", response.message, 10000);
	              var iObj = $("#fav-i-" + userid);
	              switch (response.action) {
	                case "i":
	                  iObj.find("i").removeClass("fa-bookmark-o").addClass("fa-bookmark");
	                  iObj.attr("data-content", iObj.data("title-remove"));
	                  break;
	                case "r":
	                  iObj.find("i").removeClass("fa-bookmark").addClass("fa-bookmark-o");
	                  iObj.attr("data-content", iObj.data("title-add"));
	                  break;
	                // no default
	              }
	              return true;
	            }
	          });
	        });
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ProfileActions;
	}();
	
	exports.default = ProfileActions;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RandomIMG = function () {
	  function RandomIMG(el) {
	    _classCallCheck(this, RandomIMG);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(RandomIMG, [{
	    key: 'init',
	    value: function init() {
	      var numImg = Number.parseInt(this.el.getAttribute('data-numImg'), 10);
	
	      var _mapPath = this.mapPath(this.el.getAttribute('src')),
	          path = _mapPath.path,
	          fileNameInit = _mapPath.fileNameInit;
	
	      var fileName = this.randomizeImg(fileNameInit, numImg);
	
	      this.setImg(path, fileName);
	    }
	  }, {
	    key: 'setImg',
	    value: function setImg(path, fileName) {
	      this.el.setAttribute('src', path + '/' + fileName);
	    }
	  }, {
	    key: 'randomizeImg',
	    value: function randomizeImg(fileNameInit, numImg) {
	      var _fileNameInit$split = fileNameInit.split('.'),
	          _fileNameInit$split2 = _slicedToArray(_fileNameInit$split, 2),
	          fileName = _fileNameInit$split2[0],
	          fileExtension = _fileNameInit$split2[1];
	
	      var fileNameBase = fileName.slice(0, -1);
	      var num = this.randomIntFromInterval(1, numImg);
	
	      return '' + fileNameBase + num + '.' + fileExtension;
	    }
	  }, {
	    key: 'mapPath',
	    value: function mapPath(fullPath) {
	      var pathParts = fullPath.split('/');
	      var fileNameInit = pathParts.pop();
	      var pathClean = pathParts.filter(Boolean);
	      var path = '/' + pathClean.join('/');
	
	      return {
	        path: path,
	        fileNameInit: fileNameInit
	      };
	    }
	  }, {
	    key: 'randomIntFromInterval',
	    value: function randomIntFromInterval(min, max) {
	      return Math.floor(Math.random() * (max - min + 1) + min);
	    }
	  }]);
	
	  return RandomIMG;
	}();
	
	exports.default = RandomIMG;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _helper_lib = __webpack_require__(21);
	
	var _helper_lib2 = _interopRequireDefault(_helper_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RequestPicture = function () {
	  function RequestPicture(el) {
	    _classCallCheck(this, RequestPicture);
	
	    this.el = el;
	    this.senderId = this.el.dataset.senderId;
	    this.senderName = this.el.dataset.senderName;
	    this.reciverID = this.el.dataset.reciverId;
	    this.reciverEmi = this.el.dataset.reciverEmi;
	    this.reciverName = this.el.dataset.reciverName;
	    this.requestDate = this.el.dataset.date;
	    this.langRequested = this.el.dataset.langRequested;
	    this.slg = this.el.dataset.slg;
	    this.spg = this.el.dataset.spg;
	
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(RequestPicture, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      checkSendPermissionsSimple(this.reciverID, 'PICTURE_REQUEST').then(function (permissions) {
	        if (permissions.disableOption) {
	          _this.el.remove();
	        }
	        if (permissions.checkFailed) {
	          _this.el.addEventListener('click', function () {
	            _helper_lib2.default.showMessage('error', '#message-box', '', permissions.errorMessage, 10000);
	          });
	        } else {
	          _this.el.addEventListener('click', function () {
	            var data = {
	              mode: 'send_picture_request',
	              senderId: _this.senderId,
	              senderName: _this.senderName,
	              reciverEmi: _this.reciverEmi,
	              reciverID: _this.reciverID,
	              reciverName: _this.reciverName,
	              date: _this.requestDate,
	              slg: _this.slg,
	              spg: _this.spg
	            };
	
	            var post = new FormData();
	
	            post.append('message', new Blob([JSON.stringify({
	              message: '',
	              type: 'PICTURE_REQUEST'
	            })], {
	              type: 'application/json'
	            }));
	
	            fetch('/api/v1/public/message-threads/' + data.reciverID, {
	              method: 'POST', // *GET, POST, PUT, DELETE, etc.
	              body: post // body data type must match "Content-Type" header
	            }).then(function (r) {
	              var disableButton = true;
	              if (disableButton) {
	                _this.el.setAttribute('disabled', 'disabled');
	                // console.log('disable the button', myObj);
	                setTimeout(function () {
	                  _this.el.removeAttribute('disabled');
	                  disableButton = false;
	                }, 30000);
	              }
	              if (r.status !== 'undefined' && r.status == 200) {
	                _this.el.setAttribute('disabled', 'disabled');
	                _this.el.classList.remove('btn-success');
	                _this.el.classList.add('picture_requested');
	                _this.el.innerHTML = _this.langRequested;
	                _this.el.setAttribute('disabled', 'disabled');
	              } else {
	                _helper_lib2.default.showMessage('error', '#message-box', '', i8n.error.Bulkpost_error, 10000);
	              }
	            });
	          });
	        }
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return RequestPicture;
	}();
	
	exports.default = RequestPicture;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchHelper = function () {
	  function SearchHelper(el) {
	    _classCallCheck(this, SearchHelper);
	
	    this.el = el;
	    this.formSelector = this.el.getAttribute('data-form-selector');
	    this.qsForm = document.getElementById(this.formSelector);
	    this.genderField = this.qsForm.querySelector('select[name="Geschlecht"]');
	    this.userGender = this.qsForm.querySelector('select[name="Partner"]');
	    this.genderOptionF = this.genderField.querySelector('option[value="f"]');
	    this.genderOptionM = this.genderField.querySelector('option[value="m"]');
	    this.genderOptionE = this.genderField.querySelector('option[value="e"]');
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(SearchHelper, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.el.addEventListener('change', function () {
	        if (_this.el.value === 'Partnerschaft') {
	          _this.genderOptionE.removeAttribute('selected');
	          if (_this.userGender.value === 'm') {
	            _this.genderOptionF.setAttribute('selected', 'selected');
	            _this.genderField.value = 'f';
	          } else {
	            _this.genderOptionM.setAttribute('selected', 'selected');
	            _this.genderField.value = 'm';
	          }
	          _this.genderOptionE.setAttribute('disabled', 'disabled');
	        } else {
	          _this.genderOptionE.removeAttribute('disabled');
	        }
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return SearchHelper;
	}();
	
	exports.default = SearchHelper;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShortMessage = function () {
	  function ShortMessage() {
	    _classCallCheck(this, ShortMessage);
	  }
	
	  _createClass(ShortMessage, [{
	    key: '_show',
	
	    /* eslint-disable class-methods-use-this */
	    value: function _show(mtype, mtitle, mtext, maction, mcall) {
	      var _this = this;
	
	      this._parseInput(mtype, mtitle, mtext, maction, mcall);
	      // console.log('shortMessage.showMsg()');
	      var $msgContainer = $('#message-box');
	      $msgContainer.find('p:first-child').html(this.msgTitle);
	      $msgContainer.find('p:last-child').html(this.msgText);
	      $msgContainer.addClass('alert-' + this.msgClass);
	      $msgContainer.slideDown();
	      setTimeout(function () {
	        $msgContainer.slideUp();
	        $msgContainer.removeClass('alert-' + _this.msgClass);
	        $msgContainer.find('p:first-child').html('');
	        $msgContainer.find('p:last-child').html('');
	      }, 4000);
	    }
	  }, {
	    key: '_parseInput',
	    value: function _parseInput(mtype, mtitle, mtext, maction, mcall) {
	      // console.log(mtype);
	      // console.log(mtitle);
	      // console.log(mtext);
	      // console.log(maction);
	      // console.log(mcall);
	      switch (mtype) {
	        case 'e':
	        case 'error':
	          this.msgClass = 'danger';
	          break;
	        case 'i':
	        case 'info':
	          this.msgClass = 'success';
	          break;
	        default:
	          this.msgClass = 'default';
	      }
	      // console.log('----------------------');
	      // console.log(this.msgClass);
	      // console.log('----------------------');
	      if (mtitle !== undefined || mtitle !== '') {
	        this.msgTitle = mtitle;
	      } else {
	        this.msgTitle = 'Info';
	      }
	      if (mtext !== undefined || mtext !== '') {
	        this.msgText = mtext;
	      } else {
	        this.msgText = '';
	      }
	      if (maction !== undefined || maction !== '') {
	        this.msgAction = maction;
	      } else {
	        this.msgAction = '';
	      }
	      if (mcall !== undefined || mcall !== '') {
	        this.msgCallback = maction;
	      } else {
	        this.msgCallback = '';
	      }
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ShortMessage;
	}();
	
	exports.default = ShortMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShowMessage = function () {
	  function ShowMessage(el) {
	    _classCallCheck(this, ShowMessage);
	
	    this.el = el;
	    // Messages teasers container
	    this.selectorItems = this.el.getAttribute('data-messages-list-items');
	    this.msgID = document.querySelectorAll(this.selectorItems)[0].id;
	    this.selectorView = this.el.getAttribute('data-message-view');
	    this.dest = document.querySelector(this.selectorView);
	    this.items = $('.c-postbox__message__caret').parents('li');
	
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(ShowMessage, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.items.length) {
	        this._getMsg(this.msgID);
	        this.items.on('click', function (item) {
	          _this._getMsg(item.currentTarget.id);
	        });
	      }
	    }
	
	    /* eslint-disable class-methods-use-this */
	
	  }, {
	    key: '_getMsg',
	    value: function _getMsg(mid) {
	      var _this2 = this;
	
	      $.post('/message_ajax.php', {
	        id: mid
	      }, function (html) {
	        _this2.dest.innerHTML = html;
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return ShowMessage;
	}();
	
	exports.default = ShowMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SupportCheckField = function () {
	  function SupportCheckField(el) {
	    _classCallCheck(this, SupportCheckField);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(SupportCheckField, [{
	    key: 'init',
	    value: function init() {
	      this.modalBox = document.getElementById('support_checkprofiles-modal-container');
	      this.blogFields = ['Blogtitel', 'Blogheadline', 'Blogkommentar'];
	      this.gallFields = ['Gal. Titel', 'Gal. Beschreibung', 'Gal. Kommentar'];
	      this.gbFields = ['Gästebuch'];
	      this.autoreplayFields = ['Autoreply'];
	      this.hits = this.el.querySelectorAll('.modal-link');
	      this.saveFieldOperations();
	    }
	  }, {
	    key: 'getModalData',
	    value: function getModalData() {
	      this.modalId = this.el.getAttribute('data-modal-id');
	      this.modal = document.querySelector(this.modalId);
	      this.modalField = {
	        fieldName: this.modal.querySelector('#fieldname'),
	        userid: this.modal.querySelector('#userid'),
	        profileId: this.modal.querySelector('#profileId'),
	        profileUserid: this.modal.querySelector('#profileUserid'),
	        warnings: this.modal.querySelector('#warnings'),
	        gid: this.modal.querySelector('#gid'),
	        warn: this.modal.querySelector('#warn')
	      };
	      /* eslint-disable no-unused-vars */
	      this.greenWarning = this.el.getAttribute('data-greenWarning');
	      this.yellowWarning = this.el.getAttribute('data-yellowWarning');
	      this.orangeWarning = this.el.getAttribute('data-orangeWarning');
	      this.redWarning = this.el.getAttribute('data-redWarning');
	      this.redWarning2 = this.el.getAttribute('data-redWarning2');
	      this.deleteWarning = this.el.getAttribute('data-deleteWarning');
	      /* eslint-enable no-unused-vars */
	      this.closeButton = this.modal.querySelector('.close');
	    }
	  }, {
	    key: 'saveNoSingleField',
	    value: function saveNoSingleField(tLink) {
	      var _this = this;
	
	      var gid = tLink.getAttribute('data-gid');
	      var payflag = tLink.getAttribute('data-premium');
	      // Fill hidden field s
	      this.modalField.userid.value = tLink.getAttribute('data-userid');
	      this.modalField.profileId.value = tLink.getAttribute('data-profileId');
	      this.modalField.profileUserid.value = tLink.getAttribute('data-profileUserid');
	      this.modalField.warnings.value = parseInt(tLink.getAttribute('data-warnings'), 10);
	      this.modalField.warn.value = parseInt(tLink.getAttribute('data-warn'), 10);
	      // Info fields
	      if (payflag) {
	        document.getElementById('isPremium').style.display = 'block';
	      }
	      // Content field
	      var rawTxtId = '#clearText_' + gid;
	      var rawTxt = this.el.querySelector(rawTxtId);
	      var contentField = this.modal.querySelector('#contentField');
	      contentField.value = rawTxt.innerHTML;
	      // Warnings etc
	      var warnText = '';
	      var warningsValue = parseInt(this.modalField.warnings.value, 10);
	      if (warningsValue === 0) {
	        warnText = this.yellowWarning;
	      } else if (warningsValue === 1) {
	        warnText = this.orangeWarning;
	      } else if (warningsValue === 2) {
	        warnText = this.redWarning2;
	      } else if (warningsValue === 3) {
	        warnText = this.deleteWarning;
	      }
	      var textWarn = document.getElementById('textWarn');
	      if (warnText !== '') {
	        textWarn.style.display = 'block';
	        var warnBox = textWarn.querySelectorAll('P');
	        warnBox[1].innerHTML = warnText;
	      }
	      // Submit data
	      var data = {};
	      data.json = true;
	      var mode = '';
	      var modul = '';
	      var method = '';
	      switch (this.fieldToCheck) {
	        case 'Autoreply':
	          mode = 'saveAutoreply';
	          modul = 'a';
	          method = 'POST';
	          data.str = 'ar';
	          break;
	        case 'Blogtitel':
	          mode = 'saveBlogTitle';
	          modul = 'a';
	          method = 'POST';
	          data.id = gid;
	          data.profileId = tLink.getAttribute('data-userid');
	          data.adduser = contentField.value;
	          data.str = 0;
	          break;
	        case 'Blogheadline':
	          mode = 'editBlogText';
	          modul = 'a';
	          method = 'POST';
	          data.id = gid;
	          data.profileId = tLink.getAttribute('data-userid');
	          data.adduser = contentField.value;
	          data.str = 0;
	          break;
	        case 'Blogkommentar':
	          mode = 'editBlogEntry';
	          modul = 'a';
	          method = 'POST';
	          data.id = gid;
	          data.str = 'ar';
	          break;
	        case 'Gästebuch':
	          mode = 'editGB';
	          modul = 'sae';
	          method = 'POST';
	          data.adduser = contentField.value;
	          data.id = gid;
	          data.str = 0;
	          break;
	        case 'Gal. Titel':
	          mode = 'editGalTitle';
	          modul = 'sae';
	          method = 'POST';
	          data.id = gid;
	          data._ = 1543361619970;
	          data.str = 0;
	          break;
	        case 'Gal. Beschreibung':
	          mode = 'editGalDesc';
	          modul = 'sae';
	          method = 'POST';
	          data.id = gid;
	          data._ = 1543361619970;
	          data.str = 0;
	          break;
	        case 'Gal. Kommentar':
	          mode = 'editGalComm';
	          modul = 'sae';
	          method = 'POST';
	          data.id = gid;
	          data.str = 0;
	          break;
	        // no default
	      }
	      data.mode = mode;
	      var URL = window.location.protocol + '//' + window.location.hostname;
	      var ajaxURL = modul === 'sae' ? URL + '/support/ajax_edit.php' : URL + '/ajax.php';
	      $('body').on('click', '#savebutton', function (e) {
	        e.preventDefault();
	        data.text = contentField.value;
	        if (data.str === 'ar') {
	          data.profileId = tLink.getAttribute('data-userid');
	          data.adduser = 'profileId=' + data.profileId + '&';
	          data.adduser = data.adduser + 'flag=1&';
	          data.adduser = data.adduser + 'force=1&';
	          data.adduser = data.adduser + 'warnings=' + _this.modalField.warnings.value + '&';
	          data.adduser = data.adduser + 'warn=' + _this.modalField.warn.value + '&';
	          data.adduser = data.adduser + 'autoreply_text=' + contentField.value;
	        } else {
	          data.adduser = contentField.value;
	        }
	        $.ajax({
	          url: ajaxURL,
	          method: method === 'POST' ? 'POST' : 'GET',
	          type: 'json',
	          data: data,
	          success: function success() {
	            _this.closeButton.click();
	            window.location.reload(true);
	            // window.location = window.location.href;
	          }
	        });
	      });
	      $('body').on('click', '#savewarnbutton', function (e) {
	        e.preventDefault();
	        data.text = contentField.value;
	        if (data.str === 'ar') {
	          data.profileId = tLink.getAttribute('data-userid');
	          // data.warnings = this.modalField.warnings.value;
	          // data.warn = this.modalField.warn.value;
	          data.adduser = 'profileId=' + data.profileId + '&';
	          data.adduser = data.adduser + 'flag=1&';
	          data.adduser = data.adduser + 'force=1&';
	          data.adduser = data.adduser + 'warnings=' + _this.modalField.warnings.value + '&';
	          data.adduser = data.adduser + 'warn=' + _this.modalField.warn.value + '&';
	          data.adduser = data.adduser + 'autoreply_text=' + contentField.value;
	        } else {
	          data.adduser = contentField.value;
	        }
	        $.ajax({
	          url: ajaxURL,
	          method: 'POST',
	          type: 'json',
	          data: data,
	          success: function success() {
	            _this._sendWarn(_this.closeButton, _this.modalField);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'saveSingleField',
	    value: function saveSingleField(tLink) {
	      var _this2 = this;
	
	      // Data
	      var mLink = tLink;
	      var gid = mLink.getAttribute('data-gid');
	      var payflag = mLink.getAttribute('data-premium');
	
	      // Fill hidden field s
	      this.modalField.userid.value = mLink.getAttribute('data-userid');
	      this.modalField.profileId.value = mLink.getAttribute('data-profileId');
	      this.modalField.profileUserid.value = mLink.getAttribute('data-profileUserid');
	      this.modalField.warnings.value = parseInt(mLink.getAttribute('data-warnings'), 10);
	      this.modalField.warn.value = parseInt(mLink.getAttribute('data-warn'), 10);
	      // Info fields
	      if (payflag) {
	        document.getElementById('isPremium').style.display = 'block';
	      }
	      // Content field
	      var rawTxtId = '#clearText_' + gid;
	      var rawTxt = this.el.querySelector(rawTxtId);
	      var contentField = this.modal.querySelector('#contentField');
	      contentField.value = rawTxt.innerHTML;
	      // Warnings etc
	      var warnText = '';
	      var warningsValue = parseInt(this.modalField.warnings.value, 10);
	      if (warningsValue === 0) {
	        warnText = this.yellowWarning;
	      } else if (warningsValue === 1) {
	        warnText = this.orangeWarning;
	      } else if (warningsValue === 2) {
	        warnText = this.redWarning2;
	      } else if (warningsValue === 3) {
	        warnText = this.deleteWarning;
	      }
	      var textWarn = document.getElementById('textWarn');
	      if (warnText !== '') {
	        textWarn.style.display = 'block';
	        var warnBox = textWarn.querySelectorAll('P');
	        warnBox[1].innerHTML = warnText;
	      }
	      // Submit data
	      var URL = window.location.protocol + '//' + window.location.hostname;
	      var ajaxURL = URL + '/ajax.php';
	      var data = {};
	      $('body').on('click', '#savebutton', function (e) {
	        e.preventDefault();
	        data.adduser = contentField.value;
	        data.text = contentField.value;
	        data.field = _this2.modalField.fieldName.value;
	        data.mode = 'saveSinglePfield';
	        data.profileId = _this2.modalField.userid.value;
	        $.ajax({
	          url: ajaxURL,
	          method: 'POST',
	          type: 'json',
	          data: data,
	          success: function success() {
	            _this2.closeButton.click();
	            window.location = window.location.href;
	          }
	        });
	      });
	      $('body').on('click', '#savewarnbutton', function (e) {
	        e.preventDefault();
	        data.adduser = contentField.value;
	        data.field = _this2.modalField.fieldName.value;
	        data.mode = 'saveSinglePfield';
	        data.profileId = _this2.modalField.userid.value;
	        data.id = _this2.modalField.userid.value;
	        data.json = true;
	        data.warn = _this2.modalField.warn.value;
	        data.warnings = _this2.modalField.warnings.value;
	        data.info = ajaxURL;
	        $.ajax({
	          url: ajaxURL,
	          method: 'POST',
	          type: 'json',
	          data: data,
	          success: function success() {
	            _this2._sendWarn(_this2.closeButton, _this2.modalField);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'saveFieldOperations',
	    value: function saveFieldOperations() {
	      var _this3 = this;
	
	      this.getModalData();
	      $('body').on('click', '#close-modal-dialog', function () {
	        _this3._resetButtons();
	      });
	      this.hits.forEach(function (link) {
	        link.addEventListener('click', function (currLink) {
	          // Modal
	          var tLink = currLink.target.localName === 'div' ? currLink.target : currLink.target.parentNode;
	          _this3.fieldToCheck = _this3.el.getAttribute('data-check');
	          if (_this3.blogFields.includes(_this3.fieldToCheck) || _this3.gallFields.includes(_this3.fieldToCheck) || _this3.gbFields.includes(_this3.fieldToCheck) || _this3.autoreplayFields.includes(_this3.fieldToCheck)) {
	            _this3.saveNoSingleField(tLink);
	          } else {
	            _this3.saveSingleField(tLink);
	          }
	        });
	      });
	    }
	  }, {
	    key: '_resetButtons',
	    value: function _resetButtons() {
	      $('body').off('click', '#savebutton');
	      $('body').off('click', '#savewarnbutton');
	    }
	  }, {
	    key: '_sendWarn',
	    value: function _sendWarn(closeButton, modalField) {
	      // eslint-disable no-unused-vars
	      var data2 = {};
	      data2.profileId = modalField.userid.value;
	      data2.id = modalField.userid.value;
	      data2.json = true;
	      data2.mode = 'sendWarning';
	      data2.warn = modalField.warn.value;
	      data2.warnings = modalField.warnings.value;
	      $.ajax({
	        url: '/support/ajax_edit.php',
	        method: 'GET',
	        type: 'json',
	        data: data2,
	        success: function success() {
	          closeButton.click();
	          window.location = window.location.href;
	        }
	      });
	      // eslint-enable no-unused-vars
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return SupportCheckField;
	}();
	
	exports.default = SupportCheckField;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SupportMailCheck = function () {
	  function SupportMailCheck(el) {
	    _classCallCheck(this, SupportMailCheck);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(SupportMailCheck, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this._inputSelector = document.getElementById('mailToCheck');
	      this._inputSelector.addEventListener('keyup', function () {
	        _this.checkMailAddress();
	      });
	    }
	  }, {
	    key: 'checkMailAddress',
	    value: function checkMailAddress() {
	      var _respondSelector = $('#checkRespond');
	      var mailAdress = this._inputSelector.value;
	      // if (mailAdress.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
	      if (mailAdress.match(/[a-z0-9._-]+@[a-z0-9-.]+\.[a-z]{2,}/)) {
	        $.post('ajax_edit.php', {
	          mode: 'mailCheck',
	          val: mailAdress,
	          json: true
	        }, function (respond) {
	          _respondSelector.html(respond.message).fadeIn('slow');
	        }, 'json');
	      } else {
	        _respondSelector.fadeOut('slow');
	      }
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return SupportMailCheck;
	}();
	
	exports.default = SupportMailCheck;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextCountdown = function () {
	  function TextCountdown(el) {
	    _classCallCheck(this, TextCountdown);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(TextCountdown, [{
	    key: 'init',
	    value: function init() {
	      var fieldsSelector = this.el.getAttribute('data-fields-selector');
	      var fields2count = this.el.querySelectorAll(fieldsSelector);
	      fields2count.forEach(function (f2c) {
	        var maxL = f2c.getAttribute('maxlength');
	        var cBox = f2c.parentElement.nextElementSibling;
	        var cBoxOutput = cBox.querySelector('span');
	        cBoxOutput.innerHTML = maxL - f2c.value.length;
	        f2c.addEventListener('keyup', function () {
	          cBoxOutput.innerHTML = maxL - f2c.value.length;
	        });
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return TextCountdown;
	}();
	
	exports.default = TextCountdown;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextZaehlen = function () {
	  function TextZaehlen(el) {
	    _classCallCheck(this, TextZaehlen);
	
	    this.el = el;
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(TextZaehlen, [{
	    key: 'init',
	    value: function init() {
	      // Update length output if needed.
	      this.myGBtextLength = document.querySelector('#gbtext').value.length;
	      // console.log(this.myGBtextLength);
	      this.maxLng = 1000 - this.myGBtextLength;
	      this.charsAmmount = document.querySelector('#gbanzeige');
	      this.charsAmmount.innerHTML = this.maxLng;
	      // console.log(this.el.id);
	      this.el.onkeyup = function onkeyup() {
	        this.myGBtextLength = document.querySelector('#gbtext').value.length;
	        this.charsAmmount = document.querySelector('#gbanzeige');
	        this.charsAmmount.innerHTML = 1000 - this.myGBtextLength;
	      };
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return TextZaehlen;
	}();
	
	exports.default = TextZaehlen;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TreffHelper = function () {
	  function TreffHelper(el) {
	    _classCallCheck(this, TreffHelper);
	
	    this.el = el;
	    this.pagename = this.el.getAttribute('data-pagename');
	    if (this.pagename === 'friends') {
	      this.items2 = this.el.querySelectorAll('.friends-picture');
	    } else {
	      this.toggleLink = document.querySelector('.new-teasers-toggle-link');
	      this.items = this.el.querySelectorAll('.profile-picture');
	      this.banner = this.el.querySelectorAll('.profile-teasers-banner');
	    }
	    this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(TreffHelper, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.resizeItems();
	      $(this.toggleLink).on('click', function () {
	        _this.resizeItems();
	      });
	      $(window).on('resize', function () {
	        _this.resizeItems();
	      });
	    }
	  }, {
	    key: 'resizeItems',
	    value: function resizeItems() {
	      var _this2 = this;
	
	      if (this.pagename === 'friends' && this.items2.length > 0) {
	        this.items2.forEach(function (item) {
	          $(item).height(_this2.calculateHeight(item, 1.4));
	        });
	      } else if (typeof this.items !== 'undefined' && this.items.length > 0) {
	        this.items.forEach(function (item) {
	          $(item).height(_this2.calculateHeight(item, 1.33333333));
	        });
	        console.log('items = ', this.items.length);
	        this.banner.forEach(function (banner) {
	          $(banner).css('background-color', '#ffcc33');
	          $(banner).height($(_this2.items[0]).parents('.panel-default').height());
	        });
	      }
	    }
	  }, {
	    key: 'calculateHeight',
	    value: function calculateHeight(item, factor) {
	      var newHight = $(item).width() * factor;
	      var newHightValue = newHight === 0 ? 'auto' : newHight;
	      return newHightValue;
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return TreffHelper;
	}();
	
	exports.default = TreffHelper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _directchat_lib = __webpack_require__(20);
	
	var _directchat_lib2 = _interopRequireDefault(_directchat_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WatchDog = function () {
	  function WatchDog(el) {
	    _classCallCheck(this, WatchDog);
	  }
	
	  /* eslint-disable class-methods-use-this */
	  // Watch for new chat entries.
	
	
	  _createClass(WatchDog, [{
	    key: 'startWatchChatDog',
	    value: function startWatchChatDog(duration) {
	      var i = 0;
	      this.chat = setInterval(function () {
	        // Watch for chat updates or invitations.
	        _directchat_lib2.default.checkChatState();
	        i += i;
	      }, duration !== undefined ? duration : this.watchChatDuration);
	    }
	
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return WatchDog;
	}();
	
	exports.default = WatchDog;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserPictureBig = function UserPictureBig(el) {
	  _classCallCheck(this, UserPictureBig);
	
	  this.el = el;
	  // this.images = this.el.getAttribute('data-big');
	  this.images = document.querySelectorAll('.c-member-photo img');
	  // console.log(this.images.length);
	  // console.log(this.images);
	};
	
	exports.default = UserPictureBig;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserAgentParser = function () {
	  function UserAgentParser() {
	    _classCallCheck(this, UserAgentParser);
	
	    this.el = document.querySelector('#ua-parse');
	    // this.init();
	  }
	
	  /* eslint-disable class-methods-use-this */
	
	
	  _createClass(UserAgentParser, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.el.addEventListener('click', function () {
	        _this.uaStr = _this.el.getAtribute('data-uastr');
	        $.ajax({
	          url: '/ajax.php',
	          method: 'POST',
	          type: 'html',
	          data: {
	            mode: 'uaInfo'
	          },
	          success: function success() {}
	        });
	      });
	    }
	    /* eslint-enable class-methods-use-this */
	
	  }]);
	
	  return UserAgentParser;
	}();
	
	exports.default = UserAgentParser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
	__webpack_require__(88)
	__webpack_require__(78)
	__webpack_require__(79)
	__webpack_require__(80)
	__webpack_require__(81)
	__webpack_require__(82)
	__webpack_require__(83)
	__webpack_require__(87)
	__webpack_require__(84)
	__webpack_require__(85)
	__webpack_require__(86)
	__webpack_require__(77)

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*************************
	 * Croppie
	 * Copyright 2019
	 * Foliotek
	 * Version: 2.6.5
	 *************************/
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	        // CommonJS
	        module.exports = factory();
	    } else {
	        // Browser globals
	        root.Croppie = factory();
	    }
	}(typeof self !== 'undefined' ? self : this, function () {
	
	    /* Polyfills */
	    if (typeof Promise !== 'function') {
	        /*! promise-polyfill 3.1.0 */
	        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"===typeof a||"function"===typeof a)){var c=a.then;if("function"===typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"===typeof a?a:null,this.onRejected="function"===typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"===typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"===typeof g||"function"===typeof g)){var h=g.then;if("function"===typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"===typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!==typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
	    }
	
	    if (typeof window !== 'undefined' && typeof window.CustomEvent !== "function") {
	        (function(){
	            function CustomEvent ( event, params ) {
	                params = params || { bubbles: false, cancelable: false, detail: undefined };
	                var evt = document.createEvent( 'CustomEvent' );
	                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	                return evt;
	            }
	            CustomEvent.prototype = window.Event.prototype;
	            window.CustomEvent = CustomEvent;
	        }());
	    }
	
	    if (typeof HTMLCanvasElement !== 'undefined' && !HTMLCanvasElement.prototype.toBlob) {
	        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	            value: function (callback, type, quality) {
	                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
	                len = binStr.length,
	                arr = new Uint8Array(len);
	
	                for (var i=0; i<len; i++ ) {
	                    arr[i] = binStr.charCodeAt(i);
	                }
	
	                callback( new Blob( [arr], {type: type || 'image/png'} ) );
	            }
	        });
	    }
	    /* End Polyfills */
	
	    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
	        emptyStyles = typeof document !== 'undefined' ? document.createElement('div').style : {},
	        EXIF_NORM = [1,8,3,6],
	        EXIF_FLIP = [2,7,4,5],
	        CSS_TRANS_ORG,
	        CSS_TRANSFORM,
	        CSS_USERSELECT;
	
	    function vendorPrefix(prop) {
	        if (prop in emptyStyles) {
	            return prop;
	        }
	
	        var capProp = prop[0].toUpperCase() + prop.slice(1),
	            i = cssPrefixes.length;
	
	        while (i--) {
	            prop = cssPrefixes[i] + capProp;
	            if (prop in emptyStyles) {
	                return prop;
	            }
	        }
	    }
	
	    CSS_TRANSFORM = vendorPrefix('transform');
	    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
	    CSS_USERSELECT = vendorPrefix('userSelect');
	
	    function getExifOffset(ornt, rotate) {
	        var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP,
	            index = arr.indexOf(ornt),
	            offset = (rotate / 90) % arr.length;// 180 = 2%4 = 2 shift exif by 2 indexes
	
	        return arr[(arr.length + index + (offset % arr.length)) % arr.length];
	    }
	
	    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
	    function deepExtend(destination, source) {
	        destination = destination || {};
	        for (var property in source) {
	            if (source[property] && source[property].constructor && source[property].constructor === Object) {
	                destination[property] = destination[property] || {};
	                deepExtend(destination[property], source[property]);
	            } else {
	                destination[property] = source[property];
	            }
	        }
	        return destination;
	    }
	
	    function clone(object) {
	        return deepExtend({}, object);
	    }
	
	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            var later = function () {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    }
	
	    function dispatchChange(element) {
	        if ("createEvent" in document) {
	            var evt = document.createEvent("HTMLEvents");
	            evt.initEvent("change", false, true);
	            element.dispatchEvent(evt);
	        }
	        else {
	            element.fireEvent("onchange");
	        }
	    }
	
	    //http://jsperf.com/vanilla-css
	    function css(el, styles, val) {
	        if (typeof (styles) === 'string') {
	            var tmp = styles;
	            styles = {};
	            styles[tmp] = val;
	        }
	
	        for (var prop in styles) {
	            el.style[prop] = styles[prop];
	        }
	    }
	
	    function addClass(el, c) {
	        if (el.classList) {
	            el.classList.add(c);
	        }
	        else {
	            el.className += ' ' + c;
	        }
	    }
	
	    function removeClass(el, c) {
	        if (el.classList) {
	            el.classList.remove(c);
	        }
	        else {
	            el.className = el.className.replace(c, '');
	        }
	    }
	
	    function setAttributes(el, attrs) {
	        for (var key in attrs) {
	            el.setAttribute(key, attrs[key]);
	        }
	    }
	
	    function num(v) {
	        return parseInt(v, 10);
	    }
	
	    /* Utilities */
	    function loadImage(src, doExif) {
	        if (!src) { throw 'Source image missing'; }
	        
	        var img = new Image();
	        img.style.opacity = '0';
	        return new Promise(function (resolve, reject) {
	            function _resolve() {
	                img.style.opacity = '1';
	                setTimeout(function () {
	                    resolve(img);
	                }, 1);
	            }
	
	            img.removeAttribute('crossOrigin');
	            if (src.match(/^https?:\/\/|^\/\//)) {
	                img.setAttribute('crossOrigin', 'anonymous');
	            }
	
	            img.onload = function () {
	                if (doExif) {
	                    EXIF.getData(img, function () {
	                        _resolve();
	                    });
	                }
	                else {
	                    _resolve();
	                }
	            };
	            img.onerror = function (ev) {
	                img.style.opacity = 1;
	                setTimeout(function () {
	                    reject(ev);
	                }, 1);
	            };
	            img.src = src;
	        });
	    }
	
	    function naturalImageDimensions(img, ornt) {
	        var w = img.naturalWidth;
	        var h = img.naturalHeight;
	        var orient = ornt || getExifOrientation(img);
	        if (orient && orient >= 5) {
	            var x= w;
	            w = h;
	            h = x;
	        }
	        return { width: w, height: h };
	    }
	
	    /* CSS Transform Prototype */
	    var TRANSLATE_OPTS = {
	        'translate3d': {
	            suffix: ', 0px'
	        },
	        'translate': {
	            suffix: ''
	        }
	    };
	    var Transform = function (x, y, scale) {
	        this.x = parseFloat(x);
	        this.y = parseFloat(y);
	        this.scale = parseFloat(scale);
	    };
	
	    Transform.parse = function (v) {
	        if (v.style) {
	            return Transform.parse(v.style[CSS_TRANSFORM]);
	        }
	        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
	            return Transform.fromMatrix(v);
	        }
	        else {
	            return Transform.fromString(v);
	        }
	    };
	
	    Transform.fromMatrix = function (v) {
	        var vals = v.substring(7).split(',');
	        if (!vals.length || v === 'none') {
	            vals = [1, 0, 0, 1, 0, 0];
	        }
	
	        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
	    };
	
	    Transform.fromString = function (v) {
	        var values = v.split(') '),
	            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
	            scale = values.length > 1 ? values[1].substring(6) : 1,
	            x = translate.length > 1 ? translate[0] : 0,
	            y = translate.length > 1 ? translate[1] : 0;
	
	        return new Transform(x, y, scale);
	    };
	
	    Transform.prototype.toString = function () {
	        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
	        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
	    };
	
	    var TransformOrigin = function (el) {
	        if (!el || !el.style[CSS_TRANS_ORG]) {
	            this.x = 0;
	            this.y = 0;
	            return;
	        }
	        var css = el.style[CSS_TRANS_ORG].split(' ');
	        this.x = parseFloat(css[0]);
	        this.y = parseFloat(css[1]);
	    };
	
	    TransformOrigin.prototype.toString = function () {
	        return this.x + 'px ' + this.y + 'px';
	    };
	
	    function getExifOrientation (img) {
	        return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
	    }
	
	    function drawCanvas(canvas, img, orientation) {
	        var width = img.width,
	            height = img.height,
	            ctx = canvas.getContext('2d');
	
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        ctx.save();
	        switch (orientation) {
	          case 2:
	             ctx.translate(width, 0);
	             ctx.scale(-1, 1);
	             break;
	
	          case 3:
	              ctx.translate(width, height);
	              ctx.rotate(180*Math.PI/180);
	              break;
	
	          case 4:
	              ctx.translate(0, height);
	              ctx.scale(1, -1);
	              break;
	
	          case 5:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.scale(1, -1);
	              break;
	
	          case 6:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.translate(0, -height);
	              break;
	
	          case 7:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(-90*Math.PI/180);
	              ctx.translate(-width, height);
	              ctx.scale(1, -1);
	              break;
	
	          case 8:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.translate(0, width);
	              ctx.rotate(-90*Math.PI/180);
	              break;
	        }
	        ctx.drawImage(img, 0,0, width, height);
	        ctx.restore();
	    }
	
	    /* Private Methods */
	    function _create() {
	        var self = this,
	            contClass = 'croppie-container',
	            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
	            boundary, img, viewport, overlay, bw, bh;
	
	        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
	        // Properties on class
	        self.data = {};
	        self.elements = {};
	
	        boundary = self.elements.boundary = document.createElement('div');
	        viewport = self.elements.viewport = document.createElement('div');
	        img = self.elements.img = document.createElement('img');
	        overlay = self.elements.overlay = document.createElement('div');
	
	        if (self.options.useCanvas) {
	            self.elements.canvas = document.createElement('canvas');
	            self.elements.preview = self.elements.canvas;
	        }
	        else {
	            self.elements.preview = img;
	        }
	
	        addClass(boundary, 'cr-boundary');
	        boundary.setAttribute('aria-dropeffect', 'none');
	        bw = self.options.boundary.width;
	        bh = self.options.boundary.height;
	        css(boundary, {
	            width: (bw + (isNaN(bw) ? '' : 'px')),
	            height: (bh + (isNaN(bh) ? '' : 'px'))
	        });
	
	        addClass(viewport, 'cr-viewport');
	        if (customViewportClass) {
	            addClass(viewport, customViewportClass);
	        }
	        css(viewport, {
	            width: self.options.viewport.width + 'px',
	            height: self.options.viewport.height + 'px'
	        });
	        viewport.setAttribute('tabindex', 0);
	
	        addClass(self.elements.preview, 'cr-image');
	        setAttributes(self.elements.preview, { 'alt': 'preview', 'aria-grabbed': 'false' });
	        addClass(overlay, 'cr-overlay');
	
	        self.element.appendChild(boundary);
	        boundary.appendChild(self.elements.preview);
	        boundary.appendChild(viewport);
	        boundary.appendChild(overlay);
	
	        addClass(self.element, contClass);
	        if (self.options.customClass) {
	            addClass(self.element, self.options.customClass);
	        }
	
	        _initDraggable.call(this);
	
	        if (self.options.enableZoom) {
	            _initializeZoom.call(self);
	        }
	
	        // if (self.options.enableOrientation) {
	        //     _initRotationControls.call(self);
	        // }
	
	        if (self.options.enableResize) {
	            _initializeResize.call(self);
	        }
	    }
	
	    // function _initRotationControls () {
	    //     var self = this,
	    //         wrap, btnLeft, btnRight, iLeft, iRight;
	
	    //     wrap = document.createElement('div');
	    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
	    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');
	
	    //     wrap.appendChild(btnLeft);
	    //     wrap.appendChild(btnRight);
	
	    //     iLeft = document.createElement('i');
	    //     iRight = document.createElement('i');
	    //     btnLeft.appendChild(iLeft);
	    //     btnRight.appendChild(iRight);
	
	    //     addClass(wrap, 'cr-rotate-controls');
	    //     addClass(btnLeft, 'cr-rotate-l');
	    //     addClass(btnRight, 'cr-rotate-r');
	
	    //     self.elements.boundary.appendChild(wrap);
	
	    //     btnLeft.addEventListener('click', function () {
	    //         self.rotate(-90);
	    //     });
	    //     btnRight.addEventListener('click', function () {
	    //         self.rotate(90);
	    //     });
	    // }
	
	    function _hasExif() {
	        return this.options.enableExif && window.EXIF;
	    }
	
	    function _initializeResize () {
	        var self = this;
	        var wrap = document.createElement('div');
	        var isDragging = false;
	        var direction;
	        var originalX;
	        var originalY;
	        var minSize = 50;
	        var maxWidth;
	        var maxHeight;
	        var vr;
	        var hr;
	
	        addClass(wrap, 'cr-resizer');
	        css(wrap, {
	            width: this.options.viewport.width + 'px',
	            height: this.options.viewport.height + 'px'
	        });
	
	        if (this.options.resizeControls.height) {
	            vr = document.createElement('div');
	            addClass(vr, 'cr-resizer-vertical');
	            wrap.appendChild(vr);
	        }
	
	        if (this.options.resizeControls.width) {
	            hr = document.createElement('div');
	            addClass(hr, 'cr-resizer-horisontal');
	            wrap.appendChild(hr);
	        }
	
	        function mouseDown(ev) {
	            if (ev.button !== undefined && ev.button !== 0) return;
	
	            ev.preventDefault();
	            if (isDragging) {
	                return;
	            }
	
	            var overlayRect = self.elements.overlay.getBoundingClientRect();
	
	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;
	            direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
	            maxWidth = overlayRect.width;
	            maxHeight = overlayRect.height;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }
	
	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	        }
	
	        function mouseMove(ev) {
	            var pageX = ev.pageX;
	            var pageY = ev.pageY;
	
	            ev.preventDefault();
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }
	
	            var deltaX = pageX - originalX;
	            var deltaY = pageY - originalY;
	            var newHeight = self.options.viewport.height + deltaY;
	            var newWidth = self.options.viewport.width + deltaX;
	
	            if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
	                css(wrap, {
	                    height: newHeight + 'px'
	                });
	
	                self.options.boundary.height += deltaY;
	                css(self.elements.boundary, {
	                    height: self.options.boundary.height + 'px'
	                });
	
	                self.options.viewport.height += deltaY;
	                css(self.elements.viewport, {
	                    height: self.options.viewport.height + 'px'
	                });
	            }
	            else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
	                css(wrap, {
	                    width: newWidth + 'px'
	                });
	
	                self.options.boundary.width += deltaX;
	                css(self.elements.boundary, {
	                    width: self.options.boundary.width + 'px'
	                });
	
	                self.options.viewport.width += deltaX;
	                css(self.elements.viewport, {
	                    width: self.options.viewport.width + 'px'
	                });
	            }
	
	            _updateOverlay.call(self);
	            _updateZoomLimits.call(self);
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }
	
	        function mouseUp() {
	            isDragging = false;
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	        }
	
	        if (vr) {
	            vr.addEventListener('mousedown', mouseDown);
	            vr.addEventListener('touchstart', mouseDown);
	        }
	
	        if (hr) {
	            hr.addEventListener('mousedown', mouseDown);
	            hr.addEventListener('touchstart', mouseDown);
	        }
	
	        this.elements.boundary.appendChild(wrap);
	    }
	
	    function _setZoomerVal(v) {
	        if (this.options.enableZoom) {
	            var z = this.elements.zoomer,
	                val = fix(v, 4);
	
	            z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
	        }
	    }
	
	    function _initializeZoom() {
	        var self = this,
	            wrap = self.elements.zoomerWrap = document.createElement('div'),
	            zoomer = self.elements.zoomer = document.createElement('input');
	
	        addClass(wrap, 'cr-slider-wrap');
	        addClass(zoomer, 'cr-slider');
	        zoomer.type = 'range';
	        zoomer.step = '0.0001';
	        zoomer.value = '1';
	        zoomer.style.display = self.options.showZoomer ? '' : 'none';
	        zoomer.setAttribute('aria-label', 'zoom');
	
	        self.element.appendChild(wrap);
	        wrap.appendChild(zoomer);
	
	        self._currentZoom = 1;
	
	        function change() {
	            _onZoom.call(self, {
	                value: parseFloat(zoomer.value),
	                origin: new TransformOrigin(self.elements.preview),
	                viewportRect: self.elements.viewport.getBoundingClientRect(),
	                transform: Transform.parse(self.elements.preview)
	            });
	        }
	
	        function scroll(ev) {
	            var delta, targetZoom;
	
	            if(self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true){
	              return 0;
	            } else if (ev.wheelDelta) {
	                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
	            } else if (ev.deltaY) {
	                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
	            } else if (ev.detail) {
	                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
	            } else {
	                delta = 0;
	            }
	
	            targetZoom = self._currentZoom + (delta * self._currentZoom);
	
	            ev.preventDefault();
	            _setZoomerVal.call(self, targetZoom);
	            change.call(self);
	        }
	
	        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
	        self.elements.zoomer.addEventListener('change', change);
	
	        if (self.options.mouseWheelZoom) {
	            self.elements.boundary.addEventListener('mousewheel', scroll);
	            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
	        }
	    }
	
	    function _onZoom(ui) {
	        var self = this,
	            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
	            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
	            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview);
	
	        function applyCss() {
	            var transCss = {};
	            transCss[CSS_TRANSFORM] = transform.toString();
	            transCss[CSS_TRANS_ORG] = origin.toString();
	            css(self.elements.preview, transCss);
	        }
	
	        self._currentZoom = ui ? ui.value : self._currentZoom;
	        transform.scale = self._currentZoom;
	        self.elements.zoomer.setAttribute('aria-valuenow', self._currentZoom);
	        applyCss();
	
	        if (self.options.enforceBoundary) {
	            var boundaries = _getVirtualBoundaries.call(self, vpRect),
	                transBoundaries = boundaries.translate,
	                oBoundaries = boundaries.origin;
	
	            if (transform.x >= transBoundaries.maxX) {
	                origin.x = oBoundaries.minX;
	                transform.x = transBoundaries.maxX;
	            }
	
	            if (transform.x <= transBoundaries.minX) {
	                origin.x = oBoundaries.maxX;
	                transform.x = transBoundaries.minX;
	            }
	
	            if (transform.y >= transBoundaries.maxY) {
	                origin.y = oBoundaries.minY;
	                transform.y = transBoundaries.maxY;
	            }
	
	            if (transform.y <= transBoundaries.minY) {
	                origin.y = oBoundaries.maxY;
	                transform.y = transBoundaries.minY;
	            }
	        }
	        applyCss();
	        _debouncedOverlay.call(self);
	        _triggerUpdate.call(self);
	    }
	
	    function _getVirtualBoundaries(viewport) {
	        var self = this,
	            scale = self._currentZoom,
	            vpWidth = viewport.width,
	            vpHeight = viewport.height,
	            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
	            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
	            imgRect = self.elements.preview.getBoundingClientRect(),
	            curImgWidth = imgRect.width,
	            curImgHeight = imgRect.height,
	            halfWidth = vpWidth / 2,
	            halfHeight = vpHeight / 2;
	
	        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
	        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));
	
	        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
	        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));
	
	        var originMinX = (1 / scale) * halfWidth;
	        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;
	
	        var originMinY = (1 / scale) * halfHeight;
	        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;
	
	        return {
	            translate: {
	                maxX: maxX,
	                minX: minX,
	                maxY: maxY,
	                minY: minY
	            },
	            origin: {
	                maxX: originMaxX,
	                minX: originMinX,
	                maxY: originMaxY,
	                minY: originMinY
	            }
	        };
	    }
	
	    function _updateCenterPoint(rotate) {
	        var self = this,
	            scale = self._currentZoom,
	            data = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
	            pc = new TransformOrigin(self.elements.preview),
	            top = (vpData.top - data.top) + (vpData.height / 2),
	            left = (vpData.left - data.left) + (vpData.width / 2),
	            center = {},
	            adj = {};
	
	        if (rotate) {
	            var cx = pc.x;
	            var cy = pc.y;
	            var tx = transform.x;
	            var ty = transform.y;
	
	            center.y = cx;
	            center.x = cy;
	            transform.y = tx;
	            transform.x = ty;
	        }
	        else {
	            center.y = top / scale;
	            center.x = left / scale;
	
	            adj.y = (center.y - pc.y) * (1 - scale);
	            adj.x = (center.x - pc.x) * (1 - scale);
	
	            transform.x -= adj.x;
	            transform.y -= adj.y;
	        }
	
	        var newCss = {};
	        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
	        newCss[CSS_TRANSFORM] = transform.toString();
	        css(self.elements.preview, newCss);
	    }
	
	    function _initDraggable() {
	        var self = this,
	            isDragging = false,
	            originalX,
	            originalY,
	            originalDistance,
	            vpRect,
	            transform;
	
	        function assignTransformCoordinates(deltaX, deltaY) {
	            var imgRect = self.elements.preview.getBoundingClientRect(),
	                top = transform.y + deltaY,
	                left = transform.x + deltaX;
	
	            if (self.options.enforceBoundary) {
	                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
	                    transform.y = top;
	                }
	
	                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
	                    transform.x = left;
	                }
	            }
	            else {
	                transform.y = top;
	                transform.x = left;
	            }
	        }
	
	        function toggleGrabState(isDragging) {
	          self.elements.preview.setAttribute('aria-grabbed', isDragging);
	          self.elements.boundary.setAttribute('aria-dropeffect', isDragging? 'move': 'none');
	        }
	
	        function keyDown(ev) {
	            var LEFT_ARROW  = 37,
	                UP_ARROW    = 38,
	                RIGHT_ARROW = 39,
	                DOWN_ARROW  = 40;
	
	            if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
	                var zoom;
	                if (ev.keyCode === UP_ARROW) {
	                    zoom = parseFloat(self.elements.zoomer.value) + parseFloat(self.elements.zoomer.step)
	                }
	                else {
	                    zoom = parseFloat(self.elements.zoomer.value) - parseFloat(self.elements.zoomer.step)
	                }
	                self.setZoom(zoom);
	            }
	            else if (self.options.enableKeyMovement && (ev.keyCode >= 37 && ev.keyCode <= 40)) {
	                ev.preventDefault();
	                var movement = parseKeyDown(ev.keyCode);
	
	                transform = Transform.parse(self.elements.preview);
	                document.body.style[CSS_USERSELECT] = 'none';
	                vpRect = self.elements.viewport.getBoundingClientRect();
	                keyMove(movement);
	            }
	
	            function parseKeyDown(key) {
	                switch (key) {
	                    case LEFT_ARROW:
	                        return [1, 0];
	                    case UP_ARROW:
	                        return [0, 1];
	                    case RIGHT_ARROW:
	                        return [-1, 0];
	                    case DOWN_ARROW:
	                        return [0, -1];
	                }
	            }
	        }
	
	        function keyMove(movement) {
	            var deltaX = movement[0],
	                deltaY = movement[1],
	                newCss = {};
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        function mouseDown(ev) {
	            if (ev.button !== undefined && ev.button !== 0) return;
	
	            ev.preventDefault();
	            if (isDragging) return;
	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }
	            toggleGrabState(isDragging);
	            transform = Transform.parse(self.elements.preview);
	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	            vpRect = self.elements.viewport.getBoundingClientRect();
	        }
	
	        function mouseMove(ev) {
	            ev.preventDefault();
	            var pageX = ev.pageX,
	                pageY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }
	
	            var deltaX = pageX - originalX,
	                deltaY = pageY - originalY,
	                newCss = {};
	
	            if (ev.type === 'touchmove') {
	                if (ev.touches.length > 1) {
	                    var touch1 = ev.touches[0];
	                    var touch2 = ev.touches[1];
	                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));
	
	                    if (!originalDistance) {
	                        originalDistance = dist / self._currentZoom;
	                    }
	
	                    var scale = dist / originalDistance;
	
	                    _setZoomerVal.call(self, scale);
	                    dispatchChange(self.elements.zoomer);
	                    return;
	                }
	            }
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }
	
	        function mouseUp() {
	            isDragging = false;
	            toggleGrabState(isDragging);
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        self.elements.overlay.addEventListener('mousedown', mouseDown);
	        self.elements.viewport.addEventListener('keydown', keyDown);
	        self.elements.overlay.addEventListener('touchstart', mouseDown);
	    }
	
	    function _updateOverlay() {
	        if (!this.elements) return; // since this is debounced, it can be fired after destroy
	        var self = this,
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            imgData = self.elements.preview.getBoundingClientRect();
	
	        css(self.elements.overlay, {
	            width: imgData.width + 'px',
	            height: imgData.height + 'px',
	            top: (imgData.top - boundRect.top) + 'px',
	            left: (imgData.left - boundRect.left) + 'px'
	        });
	    }
	    var _debouncedOverlay = debounce(_updateOverlay, 500);
	
	    function _triggerUpdate() {
	        var self = this,
	            data = self.get();
	
	        if (!_isVisible.call(self)) {
	            return;
	        }
	
	        self.options.update.call(self, data);
	        if (self.$ && typeof Prototype === 'undefined') {
	            self.$(self.element).trigger('update.croppie', data);
	        }
	        else {
	            var ev;
	            if (window.CustomEvent) {
	                ev = new CustomEvent('update', { detail: data });
	            } else {
	                ev = document.createEvent('CustomEvent');
	                ev.initCustomEvent('update', true, true, data);
	            }
	
	            self.element.dispatchEvent(ev);
	        }
	    }
	
	    function _isVisible() {
	        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
	    }
	
	    function _updatePropertiesFromImage() {
	        var self = this,
	            initialZoom = 1,
	            cssReset = {},
	            img = self.elements.preview,
	            imgData,
	            transformReset = new Transform(0, 0, initialZoom),
	            originReset = new TransformOrigin(),
	            isVisible = _isVisible.call(self);
	
	        if (!isVisible || self.data.bound) {// if the croppie isn't visible or it doesn't need binding
	            return;
	        }
	
	        self.data.bound = true;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        cssReset[CSS_TRANS_ORG] = originReset.toString();
	        cssReset['opacity'] = 1;
	        css(img, cssReset);
	
	        imgData = self.elements.preview.getBoundingClientRect();
	
	        self._originalImageWidth = imgData.width;
	        self._originalImageHeight = imgData.height;
	        self.data.orientation = _hasExif.call(self) ? getExifOrientation(self.elements.img) : self.data.orientation;
	
	        if (self.options.enableZoom) {
	            _updateZoomLimits.call(self, true);
	        }
	        else {
	            self._currentZoom = initialZoom;
	        }
	
	        transformReset.scale = self._currentZoom;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        css(img, cssReset);
	
	        if (self.data.points.length) {
	            _bindPoints.call(self, self.data.points);
	        }
	        else {
	            _centerImage.call(self);
	        }
	
	        _updateCenterPoint.call(self);
	        _updateOverlay.call(self);
	    }
	
	    function _updateZoomLimits (initial) {
	        var self = this,
	            minZoom = Math.max(self.options.minZoom, 0) || 0,
	            maxZoom = self.options.maxZoom || 1.5,
	            initialZoom,
	            defaultInitialZoom,
	            zoomer = self.elements.zoomer,
	            scale = parseFloat(zoomer.value),
	            boundaryData = self.elements.boundary.getBoundingClientRect(),
	            imgData = naturalImageDimensions(self.elements.img, self.data.orientation),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            minW,
	            minH;
	        if (self.options.enforceBoundary) {
	            minW = vpData.width / imgData.width;
	            minH = vpData.height / imgData.height;
	            minZoom = Math.max(minW, minH);
	        }
	
	        if (minZoom >= maxZoom) {
	            maxZoom = minZoom + 1;
	        }
	
	        zoomer.min = fix(minZoom, 4);
	        zoomer.max = fix(maxZoom, 4);
	
	        if (!initial && (scale < zoomer.min || scale > zoomer.max)) {
	            _setZoomerVal.call(self, scale < zoomer.min ? zoomer.min : zoomer.max);
	        }
	        else if (initial) {
	            defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
	            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
	            _setZoomerVal.call(self, initialZoom);
	        }
	
	        dispatchChange(zoomer);
	    }
	
	    function _bindPoints(points) {
	        if (points.length !== 4) {
	            throw "Croppie - Invalid number of points supplied: " + points;
	        }
	        var self = this,
	            pointsWidth = points[2] - points[0],
	            // pointsHeight = points[3] - points[1],
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            vpOffset = {
	                left: vpData.left - boundRect.left,
	                top: vpData.top - boundRect.top
	            },
	            scale = vpData.width / pointsWidth,
	            originTop = points[1],
	            originLeft = points[0],
	            transformTop = (-1 * points[1]) + vpOffset.top,
	            transformLeft = (-1 * points[0]) + vpOffset.left,
	            newCss = {};
	
	        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
	        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
	        css(self.elements.preview, newCss);
	
	        _setZoomerVal.call(self, scale);
	        self._currentZoom = scale;
	    }
	
	    function _centerImage() {
	        var self = this,
	            imgDim = self.elements.preview.getBoundingClientRect(),
	            vpDim = self.elements.viewport.getBoundingClientRect(),
	            boundDim = self.elements.boundary.getBoundingClientRect(),
	            vpLeft = vpDim.left - boundDim.left,
	            vpTop = vpDim.top - boundDim.top,
	            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
	            h = vpTop - ((imgDim.height - vpDim.height) / 2),
	            transform = new Transform(w, h, self._currentZoom);
	
	        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
	    }
	
	    function _transferImageToCanvas(customOrientation) {
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            ctx = canvas.getContext('2d');
	
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        var orientation = self.options.enableOrientation && customOrientation || getExifOrientation(img);
	        drawCanvas(canvas, img, orientation);
	    }
	
	    function _getCanvas(data) {
	        var self = this,
	            points = data.points,
	            left = num(points[0]),
	            top = num(points[1]),
	            right = num(points[2]),
	            bottom = num(points[3]),
	            width = right-left,
	            height = bottom-top,
	            circle = data.circle,
	            canvas = document.createElement('canvas'),
	            ctx = canvas.getContext('2d'),
	            startX = 0,
	            startY = 0,
	            canvasWidth = data.outputWidth || width,
	            canvasHeight = data.outputHeight || height;
	
	        canvas.width = canvasWidth;
	        canvas.height = canvasHeight;
	
	        if (data.backgroundColor) {
	            ctx.fillStyle = data.backgroundColor;
	            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
	        }
	
	        // By default assume we're going to draw the entire
	        // source image onto the destination canvas.
	        var sx = left,
	            sy = top,
	            sWidth = width,
	            sHeight = height,
	            dx = 0,
	            dy = 0,
	            dWidth = canvasWidth,
	            dHeight = canvasHeight;
	
	        //
	        // Do not go outside of the original image's bounds along the x-axis.
	        // Handle translations when projecting onto the destination canvas.
	        //
	
	        // The smallest possible source x-position is 0.
	        if (left < 0) {
	            sx = 0;
	            dx = (Math.abs(left) / width) * canvasWidth;
	        }
	
	        // The largest possible source width is the original image's width.
	        if (sWidth + sx > self._originalImageWidth) {
	            sWidth = self._originalImageWidth - sx;
	            dWidth =  (sWidth / width) * canvasWidth;
	        }
	
	        //
	        // Do not go outside of the original image's bounds along the y-axis.
	        //
	
	        // The smallest possible source y-position is 0.
	        if (top < 0) {
	            sy = 0;
	            dy = (Math.abs(top) / height) * canvasHeight;
	        }
	
	        // The largest possible source height is the original image's height.
	        if (sHeight + sy > self._originalImageHeight) {
	            sHeight = self._originalImageHeight - sy;
	            dHeight = (sHeight / height) * canvasHeight;
	        }
	
	        // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });
	
	        ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
	        if (circle) {
	            ctx.fillStyle = '#fff';
	            ctx.globalCompositeOperation = 'destination-in';
	            ctx.beginPath();
	            ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
	            ctx.closePath();
	            ctx.fill();
	        }
	        return canvas;
	    }
	
	    function _getHtmlResult(data) {
	        var points = data.points,
	            div = document.createElement('div'),
	            img = document.createElement('img'),
	            width = points[2] - points[0],
	            height = points[3] - points[1];
	
	        addClass(div, 'croppie-result');
	        div.appendChild(img);
	        css(img, {
	            left: (-1 * points[0]) + 'px',
	            top: (-1 * points[1]) + 'px'
	        });
	        img.src = data.url;
	        css(div, {
	            width: width + 'px',
	            height: height + 'px'
	        });
	
	        return div;
	    }
	
	    function _getBase64Result(data) {
	        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
	    }
	
	    function _getBlobResult(data) {
	        var self = this;
	        return new Promise(function (resolve) {
	            _getCanvas.call(self, data).toBlob(function (blob) {
	                resolve(blob);
	            }, data.format, data.quality);
	        });
	    }
	
	    function _replaceImage(img) {
	        if (this.elements.img.parentNode) {
	            Array.prototype.forEach.call(this.elements.img.classList, function(c) { img.classList.add(c); });
	            this.elements.img.parentNode.replaceChild(img, this.elements.img);
	            this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
	        }
	        this.elements.img = img;
	    }
	
	    function _bind(options, cb) {
	        var self = this,
	            url,
	            points = [],
	            zoom = null,
	            hasExif = _hasExif.call(self);
	
	        if (typeof (options) === 'string') {
	            url = options;
	            options = {};
	        }
	        else if (Array.isArray(options)) {
	            points = options.slice();
	        }
	        else if (typeof (options) === 'undefined' && self.data.url) { //refreshing
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            return null;
	        }
	        else {
	            url = options.url;
	            points = options.points || [];
	            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
	        }
	
	        self.data.bound = false;
	        self.data.url = url || self.data.url;
	        self.data.boundZoom = zoom;
	
	        return loadImage(url, hasExif).then(function (img) {
	            _replaceImage.call(self, img);
	            if (!points.length) {
	                var natDim = naturalImageDimensions(img);
	                var rect = self.elements.viewport.getBoundingClientRect();
	                var aspectRatio = rect.width / rect.height;
	                var imgAspectRatio = natDim.width / natDim.height;
	                var width, height;
	
	                if (imgAspectRatio > aspectRatio) {
	                    height = natDim.height;
	                    width = height * aspectRatio;
	                }
	                else {
	                    width = natDim.width;
	                    height = natDim.height / aspectRatio;
	                }
	
	                var x0 = (natDim.width - width) / 2;
	                var y0 = (natDim.height - height) / 2;
	                var x1 = x0 + width;
	                var y1 = y0 + height;
	                self.data.points = [x0, y0, x1, y1];
	            }
	            else if (self.options.relative) {
	                points = [
	                    points[0] * img.naturalWidth / 100,
	                    points[1] * img.naturalHeight / 100,
	                    points[2] * img.naturalWidth / 100,
	                    points[3] * img.naturalHeight / 100
	                ];
	            }
	
	            self.data.orientation = options.orientation || 1;
	            self.data.points = points.map(function (p) {
	                return parseFloat(p);
	            });
	            if (self.options.useCanvas) {
	                _transferImageToCanvas.call(self, self.data.orientation);
	            }
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            cb && cb();
	        });
	    }
	
	    function fix(v, decimalPoints) {
	        return parseFloat(v).toFixed(decimalPoints || 0);
	    }
	
	    function _get() {
	        var self = this,
	            imgData = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            x1 = vpData.left - imgData.left,
	            y1 = vpData.top - imgData.top,
	            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2, //border
	            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
	            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
	            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
	            scale = self._currentZoom;
	
	        if (scale === Infinity || isNaN(scale)) {
	            scale = 1;
	        }
	
	        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
	        x1 = Math.max(max, x1 / scale);
	        y1 = Math.max(max, y1 / scale);
	        x2 = Math.max(max, x2 / scale);
	        y2 = Math.max(max, y2 / scale);
	
	        return {
	            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
	            zoom: scale,
	            orientation: self.data.orientation
	        };
	    }
	
	    var RESULT_DEFAULTS = {
	            type: 'canvas',
	            format: 'png',
	            quality: 1
	        },
	        RESULT_FORMATS = ['jpeg', 'webp', 'png'];
	
	    function _result(options) {
	        var self = this,
	            data = _get.call(self),
	            opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)),
	            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
	            size = opts.size || 'viewport',
	            format = opts.format,
	            quality = opts.quality,
	            backgroundColor = opts.backgroundColor,
	            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
	            vpRect = self.elements.viewport.getBoundingClientRect(),
	            ratio = vpRect.width / vpRect.height,
	            prom;
	
	        if (size === 'viewport') {
	            data.outputWidth = vpRect.width;
	            data.outputHeight = vpRect.height;
	        } else if (typeof size === 'object') {
	            if (size.width && size.height) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.height;
	            } else if (size.width) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.width / ratio;
	            } else if (size.height) {
	                data.outputWidth = size.height * ratio;
	                data.outputHeight = size.height;
	            }
	        }
	
	        if (RESULT_FORMATS.indexOf(format) > -1) {
	            data.format = 'image/' + format;
	            data.quality = quality;
	        }
	
	        data.circle = circle;
	        data.url = self.data.url;
	        data.backgroundColor = backgroundColor;
	
	        prom = new Promise(function (resolve) {
	            switch(resultType.toLowerCase())
	            {
	                case 'rawcanvas':
	                    resolve(_getCanvas.call(self, data));
	                    break;
	                case 'canvas':
	                case 'base64':
	                    resolve(_getBase64Result.call(self, data));
	                    break;
	                case 'blob':
	                    _getBlobResult.call(self, data).then(resolve);
	                    break;
	                default:
	                    resolve(_getHtmlResult.call(self, data));
	                    break;
	            }
	        });
	        return prom;
	    }
	
	    function _refresh() {
	        _updatePropertiesFromImage.call(this);
	    }
	
	    function _rotate(deg) {
	        if (!this.options.useCanvas || !this.options.enableOrientation) {
	            throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
	        }
	
	        var self = this,
	            canvas = self.elements.canvas;
	
	        self.data.orientation = getExifOffset(self.data.orientation, deg);
	        drawCanvas(canvas, self.elements.img, self.data.orientation);
	        _updateCenterPoint.call(self, true);
	        _updateZoomLimits.call(self);
	
	        // Reverses image dimensions if the degrees of rotation is not divisible by 180.
	        if ((Math.abs(deg) / 90) % 2 === 1) {
	            var oldHeight = self._originalImageHeight;
	            var oldWidth = self._originalImageWidth;
	            self._originalImageWidth = oldHeight;
	            self._originalImageHeight = oldWidth;
	        }
	    }
	
	    function _destroy() {
	        var self = this;
	        self.element.removeChild(self.elements.boundary);
	        removeClass(self.element, 'croppie-container');
	        if (self.options.enableZoom) {
	            self.element.removeChild(self.elements.zoomerWrap);
	        }
	        delete self.elements;
	    }
	
	    if (typeof window !== 'undefined' && window.jQuery) {
	        var $ = window.jQuery;
	        $.fn.croppie = function (opts) {
	            var ot = typeof opts;
	
	            if (ot === 'string') {
	                var args = Array.prototype.slice.call(arguments, 1);
	                var singleInst = $(this).data('croppie');
	
	                if (opts === 'get') {
	                    return singleInst.get();
	                }
	                else if (opts === 'result') {
	                    return singleInst.result.apply(singleInst, args);
	                }
	                else if (opts === 'bind') {
	                    return singleInst.bind.apply(singleInst, args);
	                }
	
	                return this.each(function () {
	                    var i = $(this).data('croppie');
	                    if (!i) return;
	
	                    var method = i[opts];
	                    if ($.isFunction(method)) {
	                        method.apply(i, args);
	                        if (opts === 'destroy') {
	                            $(this).removeData('croppie');
	                        }
	                    }
	                    else {
	                        throw 'Croppie ' + opts + ' method not found';
	                    }
	                });
	            }
	            else {
	                return this.each(function () {
	                    var i = new Croppie(this, opts);
	                    i.$ = $;
	                    $(this).data('croppie', i);
	                });
	            }
	        };
	    }
	
	    function Croppie(element, opts) {
	        if (element.className.indexOf('croppie-container') > -1) {
	            throw new Error("Croppie: Can't initialize croppie more than once");
	        }
	        this.element = element;
	        this.options = deepExtend(clone(Croppie.defaults), opts);
	
	        if (this.element.tagName.toLowerCase() === 'img') {
	            var origImage = this.element;
	            addClass(origImage, 'cr-original-image');
	            setAttributes(origImage, {'aria-hidden' : 'true', 'alt' : '' });
	            var replacementDiv = document.createElement('div');
	            this.element.parentNode.appendChild(replacementDiv);
	            replacementDiv.appendChild(origImage);
	            this.element = replacementDiv;
	            this.options.url = this.options.url || origImage.src;
	        }
	
	        _create.call(this);
	        if (this.options.url) {
	            var bindOpts = {
	                url: this.options.url,
	                points: this.options.points
	            };
	            delete this.options['url'];
	            delete this.options['points'];
	            _bind.call(this, bindOpts);
	        }
	    }
	
	    Croppie.defaults = {
	        viewport: {
	            width: 100,
	            height: 100,
	            type: 'square'
	        },
	        boundary: { },
	        orientationControls: {
	            enabled: true,
	            leftClass: '',
	            rightClass: ''
	        },
	        resizeControls: {
	            width: true,
	            height: true
	        },
	        customClass: '',
	        showZoomer: true,
	        enableZoom: true,
	        enableResize: false,
	        mouseWheelZoom: true,
	        enableExif: false,
	        enforceBoundary: true,
	        enableOrientation: false,
	        enableKeyMovement: true,
	        update: function () { }
	    };
	
	    Croppie.globals = {
	        translate: 'translate3d'
	    };
	
	    deepExtend(Croppie.prototype, {
	        bind: function (options, cb) {
	            return _bind.call(this, options, cb);
	        },
	        get: function () {
	            var data = _get.call(this);
	            var points = data.points;
	            if (this.options.relative) {
	                points[0] /= this.elements.img.naturalWidth / 100;
	                points[1] /= this.elements.img.naturalHeight / 100;
	                points[2] /= this.elements.img.naturalWidth / 100;
	                points[3] /= this.elements.img.naturalHeight / 100;
	            }
	            return data;
	        },
	        result: function (type) {
	            return _result.call(this, type);
	        },
	        refresh: function () {
	            return _refresh.call(this);
	        },
	        setZoom: function (v) {
	            _setZoomerVal.call(this, v);
	            dispatchChange(this.elements.zoomer);
	        },
	        rotate: function (deg) {
	            _rotate.call(this, deg);
	        },
	        destroy: function () {
	            return _destroy.call(this);
	        }
	    });
	    return Croppie;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73).setImmediate))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Bootstrap Datetime Picker v4.17.49
	  * Copyright 2015-2020 Jonathan Peterson
	  * Licensed under MIT (https://github.com/Eonasdan/bootstrap-datetimepicker/blob/master/LICENSE)
	  */
	/*global define:false */
	/*global exports:false */
	/*global require:false */
	/*global jQuery:false */
	/*global moment:false */
	(function (factory) {
	    'use strict';
	    if (true) {
	        // AMD is used - Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('jquery'), require('moment'));
	    } else {
	        // Neither AMD nor CommonJS used. Use global variables.
	        if (typeof jQuery === 'undefined') {
	            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
	        }
	        if (typeof moment === 'undefined') {
	            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
	        }
	        factory(jQuery, moment);
	    }
	}(function ($, moment) {
	    'use strict';
	    if (!moment) {
	        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
	    }
	
	    var dateTimePicker = function (element, options) {
	        var picker = {},
	            date,
	            viewDate,
	            unset = true,
	            input,
	            component = false,
	            widget = false,
	            use24Hours,
	            minViewModeNumber = 0,
	            actualFormat,
	            parseFormats,
	            currentViewMode,
	            datePickerModes = [
	                {
	                    clsName: 'days',
	                    navFnc: 'M',
	                    navStep: 1
	                },
	                {
	                    clsName: 'months',
	                    navFnc: 'y',
	                    navStep: 1
	                },
	                {
	                    clsName: 'years',
	                    navFnc: 'y',
	                    navStep: 10
	                },
	                {
	                    clsName: 'decades',
	                    navFnc: 'y',
	                    navStep: 100
	                }
	            ],
	            viewModes = ['days', 'months', 'years', 'decades'],
	            verticalModes = ['top', 'bottom', 'auto'],
	            horizontalModes = ['left', 'right', 'auto'],
	            toolbarPlacements = ['default', 'top', 'bottom'],
	            keyMap = {
	                'up': 38,
	                38: 'up',
	                'down': 40,
	                40: 'down',
	                'left': 37,
	                37: 'left',
	                'right': 39,
	                39: 'right',
	                'tab': 9,
	                9: 'tab',
	                'escape': 27,
	                27: 'escape',
	                'enter': 13,
	                13: 'enter',
	                'pageUp': 33,
	                33: 'pageUp',
	                'pageDown': 34,
	                34: 'pageDown',
	                'shift': 16,
	                16: 'shift',
	                'control': 17,
	                17: 'control',
	                'space': 32,
	                32: 'space',
	                't': 84,
	                84: 't',
	                'delete': 46,
	                46: 'delete'
	            },
	            keyState = {},
	
	            /********************************************************************************
	             *
	             * Private functions
	             *
	             ********************************************************************************/
	
	            hasTimeZone = function () {
	                return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
	            },
	
	            getMoment = function (d) {
	                var returnMoment;
	
	                if (d === undefined || d === null) {
	                    returnMoment = moment(); //TODO should this use format? and locale?
	                } else if (moment.isDate(d) || moment.isMoment(d)) {
	                    // If the date that is passed in is already a Date() or moment() object,
	                    // pass it directly to moment.
	                    returnMoment = moment(d);
	                } else if (hasTimeZone()) { // There is a string to parse and a default time zone
	                    // parse with the tz function which takes a default time zone if it is not in the format string
	                    returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
	                } else {
	                    returnMoment = moment(d, parseFormats, options.useStrict);
	                }
	
	                if (hasTimeZone()) {
	                    returnMoment.tz(options.timeZone);
	                }
	
	                return returnMoment;
	            },
	
	            isEnabled = function (granularity) {
	                if (typeof granularity !== 'string' || granularity.length > 1) {
	                    throw new TypeError('isEnabled expects a single character string parameter');
	                }
	                switch (granularity) {
	                    case 'y':
	                        return actualFormat.indexOf('Y') !== -1;
	                    case 'M':
	                        return actualFormat.indexOf('M') !== -1;
	                    case 'd':
	                        return actualFormat.toLowerCase().indexOf('d') !== -1;
	                    case 'h':
	                    case 'H':
	                        return actualFormat.toLowerCase().indexOf('h') !== -1;
	                    case 'm':
	                        return actualFormat.indexOf('m') !== -1;
	                    case 's':
	                        return actualFormat.indexOf('s') !== -1;
	                    default:
	                        return false;
	                }
	            },
	
	            hasTime = function () {
	                return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
	            },
	
	            hasDate = function () {
	                return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
	            },
	
	            getDatePickerTemplate = function () {
	                var headTemplate = $('<thead>')
	                        .append($('<tr>')
	                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
	                                .append($('<span>').addClass(options.icons.previous))
	                                )
	                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
	                            .append($('<th>').addClass('next').attr('data-action', 'next')
	                                .append($('<span>').addClass(options.icons.next))
	                                )
	                            ),
	                    contTemplate = $('<tbody>')
	                        .append($('<tr>')
	                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
	                            );
	
	                return [
	                    $('<div>').addClass('datepicker-days')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate)
	                            .append($('<tbody>'))
	                            ),
	                    $('<div>').addClass('datepicker-months')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            ),
	                    $('<div>').addClass('datepicker-years')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            ),
	                    $('<div>').addClass('datepicker-decades')
	                        .append($('<table>').addClass('table-condensed')
	                            .append(headTemplate.clone())
	                            .append(contTemplate.clone())
	                            )
	                ];
	            },
	
	            getTimePickerMainTemplate = function () {
	                var topRow = $('<tr>'),
	                    middleRow = $('<tr>'),
	                    bottomRow = $('<tr>');
	
	                if (isEnabled('h')) {
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<span>').addClass(options.icons.down))));
	                }
	                if (isEnabled('m')) {
	                    if (isEnabled('h')) {
	                        topRow.append($('<td>').addClass('separator'));
	                        middleRow.append($('<td>').addClass('separator').html(':'));
	                        bottomRow.append($('<td>').addClass('separator'));
	                    }
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
	                            .append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
	                            .append($('<span>').addClass(options.icons.down))));
	                }
	                if (isEnabled('s')) {
	                    if (isEnabled('m')) {
	                        topRow.append($('<td>').addClass('separator'));
	                        middleRow.append($('<td>').addClass('separator').html(':'));
	                        bottomRow.append($('<td>').addClass('separator'));
	                    }
	                    topRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
	                            .append($('<span>').addClass(options.icons.up))));
	                    middleRow.append($('<td>')
	                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
	                    bottomRow.append($('<td>')
	                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
	                            .append($('<span>').addClass(options.icons.down))));
	                }
	
	                if (!use24Hours) {
	                    topRow.append($('<td>').addClass('separator'));
	                    middleRow.append($('<td>')
	                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
	                    bottomRow.append($('<td>').addClass('separator'));
	                }
	
	                return $('<div>').addClass('timepicker-picker')
	                    .append($('<table>').addClass('table-condensed')
	                        .append([topRow, middleRow, bottomRow]));
	            },
	
	            getTimePickerTemplate = function () {
	                var hoursView = $('<div>').addClass('timepicker-hours')
	                        .append($('<table>').addClass('table-condensed')),
	                    minutesView = $('<div>').addClass('timepicker-minutes')
	                        .append($('<table>').addClass('table-condensed')),
	                    secondsView = $('<div>').addClass('timepicker-seconds')
	                        .append($('<table>').addClass('table-condensed')),
	                    ret = [getTimePickerMainTemplate()];
	
	                if (isEnabled('h')) {
	                    ret.push(hoursView);
	                }
	                if (isEnabled('m')) {
	                    ret.push(minutesView);
	                }
	                if (isEnabled('s')) {
	                    ret.push(secondsView);
	                }
	
	                return ret;
	            },
	
	            getToolbar = function () {
	                var row = [];
	                if (options.showTodayButton) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
	                }
	                if (!options.sideBySide && hasDate() && hasTime()) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
	                }
	                if (options.showClear) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
	                }
	                if (options.showClose) {
	                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
	                }
	                return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
	            },
	
	            getTemplate = function () {
	                var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
	                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
	                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
	                    content = $('<ul>').addClass('list-unstyled'),
	                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());
	
	                if (options.inline) {
	                    template.removeClass('dropdown-menu');
	                }
	
	                if (use24Hours) {
	                    template.addClass('usetwentyfour');
	                }
	
	                if (isEnabled('s') && !use24Hours) {
	                    template.addClass('wider');
	                }
	
	                if (options.sideBySide && hasDate() && hasTime()) {
	                    template.addClass('timepicker-sbs');
	                    if (options.toolbarPlacement === 'top') {
	                        template.append(toolbar);
	                    }
	                    template.append(
	                        $('<div>').addClass('row')
	                            .append(dateView.addClass('col-md-6'))
	                            .append(timeView.addClass('col-md-6'))
	                    );
	                    if (options.toolbarPlacement === 'bottom') {
	                        template.append(toolbar);
	                    }
	                    return template;
	                }
	
	                if (options.toolbarPlacement === 'top') {
	                    content.append(toolbar);
	                }
	                if (hasDate()) {
	                    content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
	                }
	                if (options.toolbarPlacement === 'default') {
	                    content.append(toolbar);
	                }
	                if (hasTime()) {
	                    content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
	                }
	                if (options.toolbarPlacement === 'bottom') {
	                    content.append(toolbar);
	                }
	                return template.append(content);
	            },
	
	            dataToOptions = function () {
	                var eData,
	                    dataOptions = {};
	
	                if (element.is('input') || options.inline) {
	                    eData = element.data();
	                } else {
	                    eData = element.find('input').data();
	                }
	
	                if (eData.dateOptions && eData.dateOptions instanceof Object) {
	                    dataOptions = $.extend(true, dataOptions, eData.dateOptions);
	                }
	
	                $.each(options, function (key) {
	                    var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
	                    if (eData[attributeName] !== undefined) {
	                        dataOptions[key] = eData[attributeName];
	                    }
	                });
	                return dataOptions;
	            },
	
	            place = function () {
	                var position = (component || element).position(),
	                    offset = (component || element).offset(),
	                    vertical = options.widgetPositioning.vertical,
	                    horizontal = options.widgetPositioning.horizontal,
	                    parent;
	
	                if (options.widgetParent) {
	                    parent = options.widgetParent.append(widget);
	                } else if (element.is('input')) {
	                    parent = element.after(widget).parent();
	                } else if (options.inline) {
	                    parent = element.append(widget);
	                    return;
	                } else {
	                    parent = element;
	                    element.children().first().after(widget);
	                }
	
	                // Top and bottom logic
	                if (vertical === 'auto') {
	                    if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
	                        widget.height() + element.outerHeight() < offset.top) {
	                        vertical = 'top';
	                    } else {
	                        vertical = 'bottom';
	                    }
	                }
	
	                // Left and right logic
	                if (horizontal === 'auto') {
	                    if (parent.width() < offset.left + widget.outerWidth() / 2 &&
	                        offset.left + widget.outerWidth() > $(window).width()) {
	                        horizontal = 'right';
	                    } else {
	                        horizontal = 'left';
	                    }
	                }
	
	                if (vertical === 'top') {
	                    widget.addClass('top').removeClass('bottom');
	                } else {
	                    widget.addClass('bottom').removeClass('top');
	                }
	
	                if (horizontal === 'right') {
	                    widget.addClass('pull-right');
	                } else {
	                    widget.removeClass('pull-right');
	                }
	
	                // find the first parent element that has a non-static css positioning
	                if (parent.css('position') === 'static') {
	                    parent = parent.parents().filter(function () {
	                        return $(this).css('position') !== 'static';
	                    }).first();
	                }
	
	                if (parent.length === 0) {
	                    throw new Error('datetimepicker component should be placed within a non-static positioned container');
	                }
	
	                widget.css({
	                    top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
	                    bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
	                    left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
	                    right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
	                });
	            },
	
	            notifyEvent = function (e) {
	                if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
	                    return;
	                }
	                element.trigger(e);
	            },
	
	            viewUpdate = function (e) {
	                if (e === 'y') {
	                    e = 'YYYY';
	                }
	                notifyEvent({
	                    type: 'dp.update',
	                    change: e,
	                    viewDate: viewDate.clone()
	                });
	            },
	
	            showMode = function (dir) {
	                if (!widget) {
	                    return;
	                }
	                if (dir) {
	                    currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
	                }
	                widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
	            },
	
	            fillDow = function () {
	                var row = $('<tr>'),
	                    currentDate = viewDate.clone().startOf('w').startOf('d');
	
	                if (options.calendarWeeks === true) {
	                    row.append($('<th>').addClass('cw').text('#'));
	                }
	
	                while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
	                    row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
	                    currentDate.add(1, 'd');
	                }
	                widget.find('.datepicker-days thead').append(row);
	            },
	
	            isInDisabledDates = function (testDate) {
	                return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
	            },
	
	            isInEnabledDates = function (testDate) {
	                return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
	            },
	
	            isInDisabledHours = function (testDate) {
	                return options.disabledHours[testDate.format('H')] === true;
	            },
	
	            isInEnabledHours = function (testDate) {
	                return options.enabledHours[testDate.format('H')] === true;
	            },
	
	            isValid = function (targetMoment, granularity) {
	                if (!targetMoment.isValid()) {
	                    return false;
	                }
	                if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
	                    return false;
	                }
	                if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
	                    return false;
	                }
	                if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
	                    return false;
	                }
	                if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
	                    return false;
	                }
	                if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
	                    return false;
	                }
	                if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
	                    return false;
	                }
	                if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
	                    return false;
	                }
	                if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
	                    var found = false;
	                    $.each(options.disabledTimeIntervals, function () {
	                        if (targetMoment.isBetween(this[0], this[1])) {
	                            found = true;
	                            return false;
	                        }
	                    });
	                    if (found) {
	                        return false;
	                    }
	                }
	                return true;
	            },
	
	            fillMonths = function () {
	                var spans = [],
	                    monthsShort = viewDate.clone().startOf('y').startOf('d');
	                while (monthsShort.isSame(viewDate, 'y')) {
	                    spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
	                    monthsShort.add(1, 'M');
	                }
	                widget.find('.datepicker-months td').empty().append(spans);
	            },
	
	            updateMonths = function () {
	                var monthsView = widget.find('.datepicker-months'),
	                    monthsViewHeader = monthsView.find('th'),
	                    months = monthsView.find('tbody').find('span');
	
	                monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
	                monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
	                monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);
	
	                monthsView.find('.disabled').removeClass('disabled');
	
	                if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
	                    monthsViewHeader.eq(0).addClass('disabled');
	                }
	
	                monthsViewHeader.eq(1).text(viewDate.year());
	
	                if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
	                    monthsViewHeader.eq(2).addClass('disabled');
	                }
	
	                months.removeClass('active');
	                if (date.isSame(viewDate, 'y') && !unset) {
	                    months.eq(date.month()).addClass('active');
	                }
	
	                months.each(function (index) {
	                    if (!isValid(viewDate.clone().month(index), 'M')) {
	                        $(this).addClass('disabled');
	                    }
	                });
	            },
	
	            updateYears = function () {
	                var yearsView = widget.find('.datepicker-years'),
	                    yearsViewHeader = yearsView.find('th'),
	                    startYear = viewDate.clone().subtract(5, 'y'),
	                    endYear = viewDate.clone().add(6, 'y'),
	                    html = '';
	
	                yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
	                yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
	                yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);
	
	                yearsView.find('.disabled').removeClass('disabled');
	
	                if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
	                    yearsViewHeader.eq(0).addClass('disabled');
	                }
	
	                yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());
	
	                if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
	                    yearsViewHeader.eq(2).addClass('disabled');
	                }
	
	                while (!startYear.isAfter(endYear, 'y')) {
	                    html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
	                    startYear.add(1, 'y');
	                }
	
	                yearsView.find('td').html(html);
	            },
	
	            updateDecades = function () {
	                var decadesView = widget.find('.datepicker-decades'),
	                    decadesViewHeader = decadesView.find('th'),
	                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
	                    endDecade = startDecade.clone().add(100, 'y'),
	                    startedAt = startDecade.clone(),
	                    minDateDecade = false,
	                    maxDateDecade = false,
	                    endDecadeYear,
	                    html = '';
	
	                decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
	                decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);
	
	                decadesView.find('.disabled').removeClass('disabled');
	
	                if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
	                    decadesViewHeader.eq(0).addClass('disabled');
	                }
	
	                decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());
	
	                if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
	                    decadesViewHeader.eq(2).addClass('disabled');
	                }
	
	                while (!startDecade.isAfter(endDecade, 'y')) {
	                    endDecadeYear = startDecade.year() + 12;
	                    minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
	                    maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
	                    html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
	                        (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
	                    startDecade.add(12, 'y');
	                }
	                html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even
	
	                decadesView.find('td').html(html);
	                decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
	            },
	
	            fillDate = function () {
	                var daysView = widget.find('.datepicker-days'),
	                    daysViewHeader = daysView.find('th'),
	                    currentDate,
	                    html = [],
	                    row,
	                    clsNames = [],
	                    i;
	
	                if (!hasDate()) {
	                    return;
	                }
	
	                daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
	                daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
	                daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);
	
	                daysView.find('.disabled').removeClass('disabled');
	                daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));
	
	                if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
	                    daysViewHeader.eq(0).addClass('disabled');
	                }
	                if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
	                    daysViewHeader.eq(2).addClass('disabled');
	                }
	
	                currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');
	
	                for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
	                    if (currentDate.weekday() === 0) {
	                        row = $('<tr>');
	                        if (options.calendarWeeks) {
	                            row.append('<td class="cw">' + currentDate.week() + '</td>');
	                        }
	                        html.push(row);
	                    }
	                    clsNames = ['day'];
	                    if (currentDate.isBefore(viewDate, 'M')) {
	                        clsNames.push('old');
	                    }
	                    if (currentDate.isAfter(viewDate, 'M')) {
	                        clsNames.push('new');
	                    }
	                    if (currentDate.isSame(date, 'd') && !unset) {
	                        clsNames.push('active');
	                    }
	                    if (!isValid(currentDate, 'd')) {
	                        clsNames.push('disabled');
	                    }
	                    if (currentDate.isSame(getMoment(), 'd')) {
	                        clsNames.push('today');
	                    }
	                    if (currentDate.day() === 0 || currentDate.day() === 6) {
	                        clsNames.push('weekend');
	                    }
	                    notifyEvent({
	                        type: 'dp.classify',
	                        date: currentDate,
	                        classNames: clsNames
	                    });
	                    row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
	                    currentDate.add(1, 'd');
	                }
	
	                daysView.find('tbody').empty().append(html);
	
	                updateMonths();
	
	                updateYears();
	
	                updateDecades();
	            },
	
	            fillHours = function () {
	                var table = widget.find('.timepicker-hours table'),
	                    currentHour = viewDate.clone().startOf('d'),
	                    html = [],
	                    row = $('<tr>');
	
	                if (viewDate.hour() > 11 && !use24Hours) {
	                    currentHour.hour(12);
	                }
	                while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
	                    if (currentHour.hour() % 4 === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
	                    currentHour.add(1, 'h');
	                }
	                table.empty().append(html);
	            },
	
	            fillMinutes = function () {
	                var table = widget.find('.timepicker-minutes table'),
	                    currentMinute = viewDate.clone().startOf('h'),
	                    html = [],
	                    row = $('<tr>'),
	                    step = options.stepping === 1 ? 5 : options.stepping;
	
	                while (viewDate.isSame(currentMinute, 'h')) {
	                    if (currentMinute.minute() % (step * 4) === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
	                    currentMinute.add(step, 'm');
	                }
	                table.empty().append(html);
	            },
	
	            fillSeconds = function () {
	                var table = widget.find('.timepicker-seconds table'),
	                    currentSecond = viewDate.clone().startOf('m'),
	                    html = [],
	                    row = $('<tr>');
	
	                while (viewDate.isSame(currentSecond, 'm')) {
	                    if (currentSecond.second() % 20 === 0) {
	                        row = $('<tr>');
	                        html.push(row);
	                    }
	                    row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
	                    currentSecond.add(5, 's');
	                }
	
	                table.empty().append(html);
	            },
	
	            fillTime = function () {
	                var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');
	
	                if (!use24Hours) {
	                    toggle = widget.find('.timepicker [data-action=togglePeriod]');
	                    newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');
	
	                    toggle.text(date.format('A'));
	
	                    if (isValid(newDate, 'h')) {
	                        toggle.removeClass('disabled');
	                    } else {
	                        toggle.addClass('disabled');
	                    }
	                }
	                timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
	                timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
	                timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));
	
	                fillHours();
	                fillMinutes();
	                fillSeconds();
	            },
	
	            update = function () {
	                if (!widget) {
	                    return;
	                }
	                fillDate();
	                fillTime();
	            },
	
	            setValue = function (targetMoment) {
	                var oldDate = unset ? null : date;
	
	                // case of calling setValue(null or false)
	                if (!targetMoment) {
	                    unset = true;
	                    input.val('');
	                    element.data('date', '');
	                    notifyEvent({
	                        type: 'dp.change',
	                        date: false,
	                        oldDate: oldDate
	                    });
	                    update();
	                    return;
	                }
	
	                targetMoment = targetMoment.clone().locale(options.locale);
	
	                if (hasTimeZone()) {
	                    targetMoment.tz(options.timeZone);
	                }
	
	                if (options.stepping !== 1) {
	                    targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);
	
	                    while (options.minDate && targetMoment.isBefore(options.minDate)) {
	                        targetMoment.add(options.stepping, 'minutes');
	                    }
	                }
	
	                if (isValid(targetMoment)) {
	                    date = targetMoment;
	                    viewDate = date.clone();
	                    input.val(date.format(actualFormat));
	                    element.data('date', date.format(actualFormat));
	                    unset = false;
	                    update();
	                    notifyEvent({
	                        type: 'dp.change',
	                        date: date.clone(),
	                        oldDate: oldDate
	                    });
	                } else {
	                    if (!options.keepInvalid) {
	                        input.val(unset ? '' : date.format(actualFormat));
	                    } else {
	                        notifyEvent({
	                            type: 'dp.change',
	                            date: targetMoment,
	                            oldDate: oldDate
	                        });
	                    }
	                    notifyEvent({
	                        type: 'dp.error',
	                        date: targetMoment,
	                        oldDate: oldDate
	                    });
	                }
	            },
	
	            /**
	             * Hides the widget. Possibly will emit dp.hide
	             */
	            hide = function () {
	                var transitioning = false;
	                if (!widget) {
	                    return picker;
	                }
	                // Ignore event if in the middle of a picker transition
	                widget.find('.collapse').each(function () {
	                    var collapseData = $(this).data('collapse');
	                    if (collapseData && collapseData.transitioning) {
	                        transitioning = true;
	                        return false;
	                    }
	                    return true;
	                });
	                if (transitioning) {
	                    return picker;
	                }
	                if (component && component.hasClass('btn')) {
	                    component.toggleClass('active');
	                }
	                widget.hide();
	
	                $(window).off('resize', place);
	                widget.off('click', '[data-action]');
	                widget.off('mousedown', false);
	
	                widget.remove();
	                widget = false;
	
	                notifyEvent({
	                    type: 'dp.hide',
	                    date: date.clone()
	                });
	
	                input.blur();
	
	                viewDate = date.clone();
	
	                return picker;
	            },
	
	            clear = function () {
	                setValue(null);
	            },
	
	            parseInputDate = function (inputDate) {
	                if (options.parseInputDate === undefined) {
	                    if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
	                        inputDate = getMoment(inputDate);
	                    }
	                } else {
	                    inputDate = options.parseInputDate(inputDate);
	                }
	                //inputDate.locale(options.locale);
	                return inputDate;
	            },
	
	            /********************************************************************************
	             *
	             * Widget UI interaction functions
	             *
	             ********************************************************************************/
	            actions = {
	                next: function () {
	                    var navFnc = datePickerModes[currentViewMode].navFnc;
	                    viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
	                    fillDate();
	                    viewUpdate(navFnc);
	                },
	
	                previous: function () {
	                    var navFnc = datePickerModes[currentViewMode].navFnc;
	                    viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
	                    fillDate();
	                    viewUpdate(navFnc);
	                },
	
	                pickerSwitch: function () {
	                    showMode(1);
	                },
	
	                selectMonth: function (e) {
	                    var month = $(e.target).closest('tbody').find('span').index($(e.target));
	                    viewDate.month(month);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('M');
	                },
	
	                selectYear: function (e) {
	                    var year = parseInt($(e.target).text(), 10) || 0;
	                    viewDate.year(year);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('YYYY');
	                },
	
	                selectDecade: function (e) {
	                    var year = parseInt($(e.target).data('selection'), 10) || 0;
	                    viewDate.year(year);
	                    if (currentViewMode === minViewModeNumber) {
	                        setValue(date.clone().year(viewDate.year()));
	                        if (!options.inline) {
	                            hide();
	                        }
	                    } else {
	                        showMode(-1);
	                        fillDate();
	                    }
	                    viewUpdate('YYYY');
	                },
	
	                selectDay: function (e) {
	                    var day = viewDate.clone();
	                    if ($(e.target).is('.old')) {
	                        day.subtract(1, 'M');
	                    }
	                    if ($(e.target).is('.new')) {
	                        day.add(1, 'M');
	                    }
	                    setValue(day.date(parseInt($(e.target).text(), 10)));
	                    if (!hasTime() && !options.keepOpen && !options.inline) {
	                        hide();
	                    }
	                },
	
	                incrementHours: function () {
	                    var newDate = date.clone().add(1, 'h');
	                    if (isValid(newDate, 'h')) {
	                        setValue(newDate);
	                    }
	                },
	
	                incrementMinutes: function () {
	                    var newDate = date.clone().add(options.stepping, 'm');
	                    if (isValid(newDate, 'm')) {
	                        setValue(newDate);
	                    }
	                },
	
	                incrementSeconds: function () {
	                    var newDate = date.clone().add(1, 's');
	                    if (isValid(newDate, 's')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementHours: function () {
	                    var newDate = date.clone().subtract(1, 'h');
	                    if (isValid(newDate, 'h')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementMinutes: function () {
	                    var newDate = date.clone().subtract(options.stepping, 'm');
	                    if (isValid(newDate, 'm')) {
	                        setValue(newDate);
	                    }
	                },
	
	                decrementSeconds: function () {
	                    var newDate = date.clone().subtract(1, 's');
	                    if (isValid(newDate, 's')) {
	                        setValue(newDate);
	                    }
	                },
	
	                togglePeriod: function () {
	                    setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
	                },
	
	                togglePicker: function (e) {
	                    var $this = $(e.target),
	                        $parent = $this.closest('ul'),
	                        expanded = $parent.find('.in'),
	                        closed = $parent.find('.collapse:not(.in)'),
	                        collapseData;
	
	                    if (expanded && expanded.length) {
	                        collapseData = expanded.data('collapse');
	                        if (collapseData && collapseData.transitioning) {
	                            return;
	                        }
	                        if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
	                            expanded.collapse('hide');
	                            closed.collapse('show');
	                        } else { // otherwise just toggle in class on the two views
	                            expanded.removeClass('in');
	                            closed.addClass('in');
	                        }
	                        if ($this.is('span')) {
	                            $this.toggleClass(options.icons.time + ' ' + options.icons.date);
	                        } else {
	                            $this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
	                        }
	
	                        // NOTE: uncomment if toggled state will be restored in show()
	                        //if (component) {
	                        //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
	                        //}
	                    }
	                },
	
	                showPicker: function () {
	                    widget.find('.timepicker > div:not(.timepicker-picker)').hide();
	                    widget.find('.timepicker .timepicker-picker').show();
	                },
	
	                showHours: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-hours').show();
	                },
	
	                showMinutes: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-minutes').show();
	                },
	
	                showSeconds: function () {
	                    widget.find('.timepicker .timepicker-picker').hide();
	                    widget.find('.timepicker .timepicker-seconds').show();
	                },
	
	                selectHour: function (e) {
	                    var hour = parseInt($(e.target).text(), 10);
	
	                    if (!use24Hours) {
	                        if (date.hours() >= 12) {
	                            if (hour !== 12) {
	                                hour += 12;
	                            }
	                        } else {
	                            if (hour === 12) {
	                                hour = 0;
	                            }
	                        }
	                    }
	                    setValue(date.clone().hours(hour));
	                    actions.showPicker.call(picker);
	                },
	
	                selectMinute: function (e) {
	                    setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
	                    actions.showPicker.call(picker);
	                },
	
	                selectSecond: function (e) {
	                    setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
	                    actions.showPicker.call(picker);
	                },
	
	                clear: clear,
	
	                today: function () {
	                    var todaysDate = getMoment();
	                    if (isValid(todaysDate, 'd')) {
	                        setValue(todaysDate);
	                    }
	                },
	
	                close: hide
	            },
	
	            doAction = function (e) {
	                if ($(e.currentTarget).is('.disabled')) {
	                    return false;
	                }
	                actions[$(e.currentTarget).data('action')].apply(picker, arguments);
	                return false;
	            },
	
	            /**
	             * Shows the widget. Possibly will emit dp.show and dp.change
	             */
	            show = function () {
	                var currentMoment,
	                    useCurrentGranularity = {
	                        'year': function (m) {
	                            return m.month(0).date(1).hours(0).seconds(0).minutes(0);
	                        },
	                        'month': function (m) {
	                            return m.date(1).hours(0).seconds(0).minutes(0);
	                        },
	                        'day': function (m) {
	                            return m.hours(0).seconds(0).minutes(0);
	                        },
	                        'hour': function (m) {
	                            return m.seconds(0).minutes(0);
	                        },
	                        'minute': function (m) {
	                            return m.seconds(0);
	                        }
	                    };
	
	                if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
	                    return picker;
	                }
	                if (input.val() !== undefined && input.val().trim().length !== 0) {
	                    setValue(parseInputDate(input.val().trim()));
	                } else if (unset && options.useCurrent && (options.inline || (input.is('input') && input.val().trim().length === 0))) {
	                    currentMoment = getMoment();
	                    if (typeof options.useCurrent === 'string') {
	                        currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
	                    }
	                    setValue(currentMoment);
	                }
	                widget = getTemplate();
	
	                fillDow();
	                fillMonths();
	
	                widget.find('.timepicker-hours').hide();
	                widget.find('.timepicker-minutes').hide();
	                widget.find('.timepicker-seconds').hide();
	
	                update();
	                showMode();
	
	                $(window).on('resize', place);
	                widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
	                widget.on('mousedown', false);
	
	                if (component && component.hasClass('btn')) {
	                    component.toggleClass('active');
	                }
	                place();
	                widget.show();
	                if (options.focusOnShow && !input.is(':focus')) {
	                    input.focus();
	                }
	
	                notifyEvent({
	                    type: 'dp.show'
	                });
	                return picker;
	            },
	
	            /**
	             * Shows or hides the widget
	             */
	            toggle = function () {
	                return (widget ? hide() : show());
	            },
	
	            keydown = function (e) {
	                var handler = null,
	                    index,
	                    index2,
	                    pressedKeys = [],
	                    pressedModifiers = {},
	                    currentKey = e.which,
	                    keyBindKeys,
	                    allModifiersPressed,
	                    pressed = 'p';
	
	                keyState[currentKey] = pressed;
	
	                for (index in keyState) {
	                    if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
	                        pressedKeys.push(index);
	                        if (parseInt(index, 10) !== currentKey) {
	                            pressedModifiers[index] = true;
	                        }
	                    }
	                }
	
	                for (index in options.keyBinds) {
	                    if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
	                        keyBindKeys = index.split(' ');
	                        if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
	                            allModifiersPressed = true;
	                            for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
	                                if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
	                                    allModifiersPressed = false;
	                                    break;
	                                }
	                            }
	                            if (allModifiersPressed) {
	                                handler = options.keyBinds[index];
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (handler) {
	                    handler.call(picker, widget);
	                    e.stopPropagation();
	                    e.preventDefault();
	                }
	            },
	
	            keyup = function (e) {
	                keyState[e.which] = 'r';
	                e.stopPropagation();
	                e.preventDefault();
	            },
	
	            change = function (e) {
	                var val = $(e.target).val().trim(),
	                    parsedDate = val ? parseInputDate(val) : null;
	                setValue(parsedDate);
	                e.stopImmediatePropagation();
	                return false;
	            },
	
	            attachDatePickerElementEvents = function () {
	                input.on({
	                    'change': change,
	                    'blur': options.debug ? '' : hide,
	                    'keydown': keydown,
	                    'keyup': keyup,
	                    'focus': options.allowInputToggle ? show : ''
	                });
	
	                if (element.is('input')) {
	                    input.on({
	                        'focus': show
	                    });
	                } else if (component) {
	                    component.on('click', toggle);
	                    component.on('mousedown', false);
	                }
	            },
	
	            detachDatePickerElementEvents = function () {
	                input.off({
	                    'change': change,
	                    'blur': blur,
	                    'keydown': keydown,
	                    'keyup': keyup,
	                    'focus': options.allowInputToggle ? hide : ''
	                });
	
	                if (element.is('input')) {
	                    input.off({
	                        'focus': show
	                    });
	                } else if (component) {
	                    component.off('click', toggle);
	                    component.off('mousedown', false);
	                }
	            },
	
	            indexGivenDates = function (givenDatesArray) {
	                // Store given enabledDates and disabledDates as keys.
	                // This way we can check their existence in O(1) time instead of looping through whole array.
	                // (for example: options.enabledDates['2014-02-27'] === true)
	                var givenDatesIndexed = {};
	                $.each(givenDatesArray, function () {
	                    var dDate = parseInputDate(this);
	                    if (dDate.isValid()) {
	                        givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
	                    }
	                });
	                return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
	            },
	
	            indexGivenHours = function (givenHoursArray) {
	                // Store given enabledHours and disabledHours as keys.
	                // This way we can check their existence in O(1) time instead of looping through whole array.
	                // (for example: options.enabledHours['2014-02-27'] === true)
	                var givenHoursIndexed = {};
	                $.each(givenHoursArray, function () {
	                    givenHoursIndexed[this] = true;
	                });
	                return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
	            },
	
	            initFormatting = function () {
	                var format = options.format || 'L LT';
	
	                actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
	                    var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
	                    return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
	                        return date.localeData().longDateFormat(formatInput2) || formatInput2;
	                    });
	                });
	
	
	                parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
	                if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
	                    parseFormats.push(actualFormat);
	                }
	
	                use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);
	
	                if (isEnabled('y')) {
	                    minViewModeNumber = 2;
	                }
	                if (isEnabled('M')) {
	                    minViewModeNumber = 1;
	                }
	                if (isEnabled('d')) {
	                    minViewModeNumber = 0;
	                }
	
	                currentViewMode = Math.max(minViewModeNumber, currentViewMode);
	
	                if (!unset) {
	                    setValue(date);
	                }
	            };
	
	        /********************************************************************************
	         *
	         * Public API functions
	         * =====================
	         *
	         * Important: Do not expose direct references to private objects or the options
	         * object to the outer world. Always return a clone when returning values or make
	         * a clone when setting a private variable.
	         *
	         ********************************************************************************/
	        picker.destroy = function () {
	            ///<summary>Destroys the widget and removes all attached event listeners</summary>
	            hide();
	            detachDatePickerElementEvents();
	            element.removeData('DateTimePicker');
	            element.removeData('date');
	        };
	
	        picker.toggle = toggle;
	
	        picker.show = show;
	
	        picker.hide = hide;
	
	        picker.disable = function () {
	            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
	            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
	            hide();
	            if (component && component.hasClass('btn')) {
	                component.addClass('disabled');
	            }
	            input.prop('disabled', true);
	            return picker;
	        };
	
	        picker.enable = function () {
	            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
	            if (component && component.hasClass('btn')) {
	                component.removeClass('disabled');
	            }
	            input.prop('disabled', false);
	            return picker;
	        };
	
	        picker.ignoreReadonly = function (ignoreReadonly) {
	            if (arguments.length === 0) {
	                return options.ignoreReadonly;
	            }
	            if (typeof ignoreReadonly !== 'boolean') {
	                throw new TypeError('ignoreReadonly () expects a boolean parameter');
	            }
	            options.ignoreReadonly = ignoreReadonly;
	            return picker;
	        };
	
	        picker.options = function (newOptions) {
	            if (arguments.length === 0) {
	                return $.extend(true, {}, options);
	            }
	
	            if (!(newOptions instanceof Object)) {
	                throw new TypeError('options() options parameter should be an object');
	            }
	            $.extend(true, options, newOptions);
	            $.each(options, function (key, value) {
	                if (picker[key] !== undefined) {
	                    picker[key](value);
	                } else {
	                    throw new TypeError('option ' + key + ' is not recognized!');
	                }
	            });
	            return picker;
	        };
	
	        picker.date = function (newDate) {
	            ///<signature helpKeyword="$.fn.datetimepicker.date">
	            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
	            ///<returns type="Moment">date.clone()</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
	            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                if (unset) {
	                    return null;
	                }
	                return date.clone();
	            }
	
	            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
	                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
	            }
	
	            setValue(newDate === null ? null : parseInputDate(newDate));
	            return picker;
	        };
	
	        picker.format = function (newFormat) {
	            ///<summary>test su</summary>
	            ///<param name="newFormat">info about para</param>
	            ///<returns type="string|boolean">returns foo</returns>
	            if (arguments.length === 0) {
	                return options.format;
	            }
	
	            if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
	                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
	            }
	
	            options.format = newFormat;
	            if (actualFormat) {
	                initFormatting(); // reinit formatting
	            }
	            return picker;
	        };
	
	        picker.timeZone = function (newZone) {
	            if (arguments.length === 0) {
	                return options.timeZone;
	            }
	
	            if (typeof newZone !== 'string') {
	                throw new TypeError('newZone() expects a string parameter');
	            }
	
	            options.timeZone = newZone;
	
	            return picker;
	        };
	
	        picker.dayViewHeaderFormat = function (newFormat) {
	            if (arguments.length === 0) {
	                return options.dayViewHeaderFormat;
	            }
	
	            if (typeof newFormat !== 'string') {
	                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
	            }
	
	            options.dayViewHeaderFormat = newFormat;
	            return picker;
	        };
	
	        picker.extraFormats = function (formats) {
	            if (arguments.length === 0) {
	                return options.extraFormats;
	            }
	
	            if (formats !== false && !(formats instanceof Array)) {
	                throw new TypeError('extraFormats() expects an array or false parameter');
	            }
	
	            options.extraFormats = formats;
	            if (parseFormats) {
	                initFormatting(); // reinit formatting
	            }
	            return picker;
	        };
	
	        picker.disabledDates = function (dates) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
	            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
	            ///<returns type="array">options.disabledDates</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
	            }
	
	            if (!dates) {
	                options.disabledDates = false;
	                update();
	                return picker;
	            }
	            if (!(dates instanceof Array)) {
	                throw new TypeError('disabledDates() expects an array parameter');
	            }
	            options.disabledDates = indexGivenDates(dates);
	            options.enabledDates = false;
	            update();
	            return picker;
	        };
	
	        picker.enabledDates = function (dates) {
	            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
	            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
	            ///<returns type="array">options.enabledDates</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
	            }
	
	            if (!dates) {
	                options.enabledDates = false;
	                update();
	                return picker;
	            }
	            if (!(dates instanceof Array)) {
	                throw new TypeError('enabledDates() expects an array parameter');
	            }
	            options.enabledDates = indexGivenDates(dates);
	            options.disabledDates = false;
	            update();
	            return picker;
	        };
	
	        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
	            if (arguments.length === 0) {
	                return options.daysOfWeekDisabled.splice(0);
	            }
	
	            if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
	                options.daysOfWeekDisabled = false;
	                update();
	                return picker;
	            }
	
	            if (!(daysOfWeekDisabled instanceof Array)) {
	                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
	            }
	            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
	                currentValue = parseInt(currentValue, 10);
	                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
	                    return previousValue;
	                }
	                if (previousValue.indexOf(currentValue) === -1) {
	                    previousValue.push(currentValue);
	                }
	                return previousValue;
	            }, []).sort();
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'd')) {
	                    date.add(1, 'd');
	                    if (tries === 31) {
	                        throw 'Tried 31 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	
	        picker.maxDate = function (maxDate) {
	            if (arguments.length === 0) {
	                return options.maxDate ? options.maxDate.clone() : options.maxDate;
	            }
	
	            if ((typeof maxDate === 'boolean') && maxDate === false) {
	                options.maxDate = false;
	                update();
	                return picker;
	            }
	
	            if (typeof maxDate === 'string') {
	                if (maxDate === 'now' || maxDate === 'moment') {
	                    maxDate = getMoment();
	                }
	            }
	
	            var parsedDate = parseInputDate(maxDate);
	
	            if (!parsedDate.isValid()) {
	                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
	            }
	            if (options.minDate && parsedDate.isBefore(options.minDate)) {
	                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
	            }
	            options.maxDate = parsedDate;
	            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
	                setValue(options.maxDate);
	            }
	            if (viewDate.isAfter(parsedDate)) {
	                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
	            }
	            update();
	            return picker;
	        };
	
	        picker.minDate = function (minDate) {
	            if (arguments.length === 0) {
	                return options.minDate ? options.minDate.clone() : options.minDate;
	            }
	
	            if ((typeof minDate === 'boolean') && minDate === false) {
	                options.minDate = false;
	                update();
	                return picker;
	            }
	
	            if (typeof minDate === 'string') {
	                if (minDate === 'now' || minDate === 'moment') {
	                    minDate = getMoment();
	                }
	            }
	
	            var parsedDate = parseInputDate(minDate);
	
	            if (!parsedDate.isValid()) {
	                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
	            }
	            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
	                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
	            }
	            options.minDate = parsedDate;
	            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
	                setValue(options.minDate);
	            }
	            if (viewDate.isBefore(parsedDate)) {
	                viewDate = parsedDate.clone().add(options.stepping, 'm');
	            }
	            update();
	            return picker;
	        };
	
	        picker.defaultDate = function (defaultDate) {
	            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
	            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
	            ///<returns type="Moment">date.clone()</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
	            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
	            }
	            if (!defaultDate) {
	                options.defaultDate = false;
	                return picker;
	            }
	
	            if (typeof defaultDate === 'string') {
	                if (defaultDate === 'now' || defaultDate === 'moment') {
	                    defaultDate = getMoment();
	                } else {
	                    defaultDate = getMoment(defaultDate);
	                }
	            }
	
	            var parsedDate = parseInputDate(defaultDate);
	            if (!parsedDate.isValid()) {
	                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
	            }
	            if (!isValid(parsedDate)) {
	                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
	            }
	
	            options.defaultDate = parsedDate;
	
	            if ((options.defaultDate && options.inline) || input.val().trim() === '') {
	                setValue(options.defaultDate);
	            }
	            return picker;
	        };
	
	        picker.locale = function (locale) {
	            if (arguments.length === 0) {
	                return options.locale;
	            }
	
	            if (!moment.localeData(locale)) {
	                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
	            }
	
	            options.locale = locale;
	            date.locale(options.locale);
	            viewDate.locale(options.locale);
	
	            if (actualFormat) {
	                initFormatting(); // reinit formatting
	            }
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.stepping = function (stepping) {
	            if (arguments.length === 0) {
	                return options.stepping;
	            }
	
	            stepping = parseInt(stepping, 10);
	            if (isNaN(stepping) || stepping < 1) {
	                stepping = 1;
	            }
	            options.stepping = stepping;
	            return picker;
	        };
	
	        picker.useCurrent = function (useCurrent) {
	            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
	            if (arguments.length === 0) {
	                return options.useCurrent;
	            }
	
	            if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
	                throw new TypeError('useCurrent() expects a boolean or string parameter');
	            }
	            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
	                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
	            }
	            options.useCurrent = useCurrent;
	            return picker;
	        };
	
	        picker.collapse = function (collapse) {
	            if (arguments.length === 0) {
	                return options.collapse;
	            }
	
	            if (typeof collapse !== 'boolean') {
	                throw new TypeError('collapse() expects a boolean parameter');
	            }
	            if (options.collapse === collapse) {
	                return picker;
	            }
	            options.collapse = collapse;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.icons = function (icons) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.icons);
	            }
	
	            if (!(icons instanceof Object)) {
	                throw new TypeError('icons() expects parameter to be an Object');
	            }
	            $.extend(options.icons, icons);
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.tooltips = function (tooltips) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.tooltips);
	            }
	
	            if (!(tooltips instanceof Object)) {
	                throw new TypeError('tooltips() expects parameter to be an Object');
	            }
	            $.extend(options.tooltips, tooltips);
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.useStrict = function (useStrict) {
	            if (arguments.length === 0) {
	                return options.useStrict;
	            }
	
	            if (typeof useStrict !== 'boolean') {
	                throw new TypeError('useStrict() expects a boolean parameter');
	            }
	            options.useStrict = useStrict;
	            return picker;
	        };
	
	        picker.sideBySide = function (sideBySide) {
	            if (arguments.length === 0) {
	                return options.sideBySide;
	            }
	
	            if (typeof sideBySide !== 'boolean') {
	                throw new TypeError('sideBySide() expects a boolean parameter');
	            }
	            options.sideBySide = sideBySide;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.viewMode = function (viewMode) {
	            if (arguments.length === 0) {
	                return options.viewMode;
	            }
	
	            if (typeof viewMode !== 'string') {
	                throw new TypeError('viewMode() expects a string parameter');
	            }
	
	            if (viewModes.indexOf(viewMode) === -1) {
	                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
	            }
	
	            options.viewMode = viewMode;
	            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);
	
	            showMode();
	            return picker;
	        };
	
	        picker.toolbarPlacement = function (toolbarPlacement) {
	            if (arguments.length === 0) {
	                return options.toolbarPlacement;
	            }
	
	            if (typeof toolbarPlacement !== 'string') {
	                throw new TypeError('toolbarPlacement() expects a string parameter');
	            }
	            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
	                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
	            }
	            options.toolbarPlacement = toolbarPlacement;
	
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.widgetPositioning = function (widgetPositioning) {
	            if (arguments.length === 0) {
	                return $.extend({}, options.widgetPositioning);
	            }
	
	            if (({}).toString.call(widgetPositioning) !== '[object Object]') {
	                throw new TypeError('widgetPositioning() expects an object variable');
	            }
	            if (widgetPositioning.horizontal) {
	                if (typeof widgetPositioning.horizontal !== 'string') {
	                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
	                }
	                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
	                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
	                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
	                }
	                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
	            }
	            if (widgetPositioning.vertical) {
	                if (typeof widgetPositioning.vertical !== 'string') {
	                    throw new TypeError('widgetPositioning() vertical variable must be a string');
	                }
	                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
	                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
	                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
	                }
	                options.widgetPositioning.vertical = widgetPositioning.vertical;
	            }
	            update();
	            return picker;
	        };
	
	        picker.calendarWeeks = function (calendarWeeks) {
	            if (arguments.length === 0) {
	                return options.calendarWeeks;
	            }
	
	            if (typeof calendarWeeks !== 'boolean') {
	                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
	            }
	
	            options.calendarWeeks = calendarWeeks;
	            update();
	            return picker;
	        };
	
	        picker.showTodayButton = function (showTodayButton) {
	            if (arguments.length === 0) {
	                return options.showTodayButton;
	            }
	
	            if (typeof showTodayButton !== 'boolean') {
	                throw new TypeError('showTodayButton() expects a boolean parameter');
	            }
	
	            options.showTodayButton = showTodayButton;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.showClear = function (showClear) {
	            if (arguments.length === 0) {
	                return options.showClear;
	            }
	
	            if (typeof showClear !== 'boolean') {
	                throw new TypeError('showClear() expects a boolean parameter');
	            }
	
	            options.showClear = showClear;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.widgetParent = function (widgetParent) {
	            if (arguments.length === 0) {
	                return options.widgetParent;
	            }
	
	            if (typeof widgetParent === 'string') {
	                widgetParent = $(widgetParent);
	            }
	
	            if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
	                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
	            }
	
	            options.widgetParent = widgetParent;
	            if (widget) {
	                hide();
	                show();
	            }
	            return picker;
	        };
	
	        picker.keepOpen = function (keepOpen) {
	            if (arguments.length === 0) {
	                return options.keepOpen;
	            }
	
	            if (typeof keepOpen !== 'boolean') {
	                throw new TypeError('keepOpen() expects a boolean parameter');
	            }
	
	            options.keepOpen = keepOpen;
	            return picker;
	        };
	
	        picker.focusOnShow = function (focusOnShow) {
	            if (arguments.length === 0) {
	                return options.focusOnShow;
	            }
	
	            if (typeof focusOnShow !== 'boolean') {
	                throw new TypeError('focusOnShow() expects a boolean parameter');
	            }
	
	            options.focusOnShow = focusOnShow;
	            return picker;
	        };
	
	        picker.inline = function (inline) {
	            if (arguments.length === 0) {
	                return options.inline;
	            }
	
	            if (typeof inline !== 'boolean') {
	                throw new TypeError('inline() expects a boolean parameter');
	            }
	
	            options.inline = inline;
	            return picker;
	        };
	
	        picker.clear = function () {
	            clear();
	            return picker;
	        };
	
	        picker.keyBinds = function (keyBinds) {
	            if (arguments.length === 0) {
	                return options.keyBinds;
	            }
	
	            options.keyBinds = keyBinds;
	            return picker;
	        };
	
	        picker.getMoment = function (d) {
	            return getMoment(d);
	        };
	
	        picker.debug = function (debug) {
	            if (typeof debug !== 'boolean') {
	                throw new TypeError('debug() expects a boolean parameter');
	            }
	
	            options.debug = debug;
	            return picker;
	        };
	
	        picker.allowInputToggle = function (allowInputToggle) {
	            if (arguments.length === 0) {
	                return options.allowInputToggle;
	            }
	
	            if (typeof allowInputToggle !== 'boolean') {
	                throw new TypeError('allowInputToggle() expects a boolean parameter');
	            }
	
	            options.allowInputToggle = allowInputToggle;
	            return picker;
	        };
	
	        picker.showClose = function (showClose) {
	            if (arguments.length === 0) {
	                return options.showClose;
	            }
	
	            if (typeof showClose !== 'boolean') {
	                throw new TypeError('showClose() expects a boolean parameter');
	            }
	
	            options.showClose = showClose;
	            return picker;
	        };
	
	        picker.keepInvalid = function (keepInvalid) {
	            if (arguments.length === 0) {
	                return options.keepInvalid;
	            }
	
	            if (typeof keepInvalid !== 'boolean') {
	                throw new TypeError('keepInvalid() expects a boolean parameter');
	            }
	            options.keepInvalid = keepInvalid;
	            return picker;
	        };
	
	        picker.datepickerInput = function (datepickerInput) {
	            if (arguments.length === 0) {
	                return options.datepickerInput;
	            }
	
	            if (typeof datepickerInput !== 'string') {
	                throw new TypeError('datepickerInput() expects a string parameter');
	            }
	
	            options.datepickerInput = datepickerInput;
	            return picker;
	        };
	
	        picker.parseInputDate = function (parseInputDate) {
	            if (arguments.length === 0) {
	                return options.parseInputDate;
	            }
	
	            if (typeof parseInputDate !== 'function') {
	                throw new TypeError('parseInputDate() sholud be as function');
	            }
	
	            options.parseInputDate = parseInputDate;
	
	            return picker;
	        };
	
	        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
	            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
	            ///<returns type="array">options.disabledTimeIntervals</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledDates if such exist.</summary>
	            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
	            }
	
	            if (!disabledTimeIntervals) {
	                options.disabledTimeIntervals = false;
	                update();
	                return picker;
	            }
	            if (!(disabledTimeIntervals instanceof Array)) {
	                throw new TypeError('disabledTimeIntervals() expects an array parameter');
	            }
	            options.disabledTimeIntervals = disabledTimeIntervals;
	            update();
	            return picker;
	        };
	
	        picker.disabledHours = function (hours) {
	            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
	            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
	            ///<returns type="array">options.disabledHours</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
	            ///options.enabledHours if such exist.</summary>
	            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
	            }
	
	            if (!hours) {
	                options.disabledHours = false;
	                update();
	                return picker;
	            }
	            if (!(hours instanceof Array)) {
	                throw new TypeError('disabledHours() expects an array parameter');
	            }
	            options.disabledHours = indexGivenHours(hours);
	            options.enabledHours = false;
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'h')) {
	                    date.add(1, 'h');
	                    if (tries === 24) {
	                        throw 'Tried 24 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	
	        picker.enabledHours = function (hours) {
	            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
	            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
	            ///<returns type="array">options.enabledHours</returns>
	            ///</signature>
	            ///<signature>
	            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
	            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
	            ///</signature>
	            if (arguments.length === 0) {
	                return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
	            }
	
	            if (!hours) {
	                options.enabledHours = false;
	                update();
	                return picker;
	            }
	            if (!(hours instanceof Array)) {
	                throw new TypeError('enabledHours() expects an array parameter');
	            }
	            options.enabledHours = indexGivenHours(hours);
	            options.disabledHours = false;
	            if (options.useCurrent && !options.keepInvalid) {
	                var tries = 0;
	                while (!isValid(date, 'h')) {
	                    date.add(1, 'h');
	                    if (tries === 24) {
	                        throw 'Tried 24 times to find a valid date';
	                    }
	                    tries++;
	                }
	                setValue(date);
	            }
	            update();
	            return picker;
	        };
	        /**
	         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
	         * @param {Takes string, viewDate, moment, null parameter.} newDate
	         * @returns {viewDate.clone()}
	         */
	        picker.viewDate = function (newDate) {
	            if (arguments.length === 0) {
	                return viewDate.clone();
	            }
	
	            if (!newDate) {
	                viewDate = date.clone();
	                return picker;
	            }
	
	            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
	                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
	            }
	
	            viewDate = parseInputDate(newDate);
	            viewUpdate();
	            return picker;
	        };
	
	        // initializing element and component attributes
	        if (element.is('input')) {
	            input = element;
	        } else {
	            input = element.find(options.datepickerInput);
	            if (input.length === 0) {
	                input = element.find('input');
	            } else if (!input.is('input')) {
	                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
	            }
	        }
	
	        if (element.hasClass('input-group')) {
	            // in case there is more then one 'input-group-addon' Issue #48
	            if (element.find('.datepickerbutton').length === 0) {
	                component = element.find('.input-group-addon');
	            } else {
	                component = element.find('.datepickerbutton');
	            }
	        }
	
	        if (!options.inline && !input.is('input')) {
	            throw new Error('Could not initialize DateTimePicker without an input element');
	        }
	
	        // Set defaults for date here now instead of in var declaration
	        date = getMoment();
	        viewDate = date.clone();
	
	        $.extend(true, options, dataToOptions());
	
	        picker.options(options);
	
	        initFormatting();
	
	        attachDatePickerElementEvents();
	
	        if (input.prop('disabled')) {
	            picker.disable();
	        }
	        if (input.is('input') && input.val().trim().length !== 0) {
	            setValue(parseInputDate(input.val().trim()));
	        }
	        else if (options.defaultDate && input.attr('placeholder') === undefined) {
	            setValue(options.defaultDate);
	        }
	        if (options.inline) {
	            show();
	        }
	        return picker;
	    };
	
	    /********************************************************************************
	     *
	     * jQuery plugin constructor and defaults object
	     *
	     ********************************************************************************/
	
	    /**
	    * See (http://jquery.com/).
	    * @name jQuery
	    * @class
	    * See the jQuery Library  (http://jquery.com/) for full details.  This just
	    * documents the function and classes that are added to jQuery by this plug-in.
	    */
	    /**
	     * See (http://jquery.com/)
	     * @name fn
	     * @class
	     * See the jQuery Library  (http://jquery.com/) for full details.  This just
	     * documents the function and classes that are added to jQuery by this plug-in.
	     * @memberOf jQuery
	     */
	    /**
	     * Show comments
	     * @class datetimepicker
	     * @memberOf jQuery.fn
	     */
	    $.fn.datetimepicker = function (options) {
	        options = options || {};
	
	        var args = Array.prototype.slice.call(arguments, 1),
	            isInstance = true,
	            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
	            returnValue;
	
	        if (typeof options === 'object') {
	            return this.each(function () {
	                var $this = $(this),
	                    _options;
	                if (!$this.data('DateTimePicker')) {
	                    // create a private copy of the defaults object
	                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
	                    $this.data('DateTimePicker', dateTimePicker($this, _options));
	                }
	            });
	        } else if (typeof options === 'string') {
	            this.each(function () {
	                var $this = $(this),
	                    instance = $this.data('DateTimePicker');
	                if (!instance) {
	                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
	                }
	
	                returnValue = instance[options].apply(instance, args);
	                isInstance = returnValue === instance;
	            });
	
	            if (isInstance || $.inArray(options, thisMethods) > -1) {
	                return this;
	            }
	
	            return returnValue;
	        }
	
	        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
	    };
	
	    $.fn.datetimepicker.defaults = {
	        timeZone: '',
	        format: false,
	        dayViewHeaderFormat: 'MMMM YYYY',
	        extraFormats: false,
	        stepping: 1,
	        minDate: false,
	        maxDate: false,
	        useCurrent: true,
	        collapse: true,
	        locale: moment.locale(),
	        defaultDate: false,
	        disabledDates: false,
	        enabledDates: false,
	        icons: {
	            time: 'glyphicon glyphicon-time',
	            date: 'glyphicon glyphicon-calendar',
	            up: 'glyphicon glyphicon-chevron-up',
	            down: 'glyphicon glyphicon-chevron-down',
	            previous: 'glyphicon glyphicon-chevron-left',
	            next: 'glyphicon glyphicon-chevron-right',
	            today: 'glyphicon glyphicon-screenshot',
	            clear: 'glyphicon glyphicon-trash',
	            close: 'glyphicon glyphicon-remove'
	        },
	        tooltips: {
	            today: 'Go to today',
	            clear: 'Clear selection',
	            close: 'Close the picker',
	            selectMonth: 'Select Month',
	            prevMonth: 'Previous Month',
	            nextMonth: 'Next Month',
	            selectYear: 'Select Year',
	            prevYear: 'Previous Year',
	            nextYear: 'Next Year',
	            selectDecade: 'Select Decade',
	            prevDecade: 'Previous Decade',
	            nextDecade: 'Next Decade',
	            prevCentury: 'Previous Century',
	            nextCentury: 'Next Century',
	            pickHour: 'Pick Hour',
	            incrementHour: 'Increment Hour',
	            decrementHour: 'Decrement Hour',
	            pickMinute: 'Pick Minute',
	            incrementMinute: 'Increment Minute',
	            decrementMinute: 'Decrement Minute',
	            pickSecond: 'Pick Second',
	            incrementSecond: 'Increment Second',
	            decrementSecond: 'Decrement Second',
	            togglePeriod: 'Toggle Period',
	            selectTime: 'Select Time'
	        },
	        useStrict: false,
	        sideBySide: false,
	        daysOfWeekDisabled: false,
	        calendarWeeks: false,
	        viewMode: 'days',
	        toolbarPlacement: 'default',
	        showTodayButton: false,
	        showClear: false,
	        showClose: false,
	        widgetPositioning: {
	            horizontal: 'auto',
	            vertical: 'auto'
	        },
	        widgetParent: null,
	        ignoreReadonly: false,
	        keepOpen: false,
	        focusOnShow: true,
	        inline: false,
	        keepInvalid: false,
	        datepickerInput: '.datepickerinput',
	        keyBinds: {
	            up: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(7, 'd'));
	                } else {
	                    this.date(d.clone().add(this.stepping(), 'm'));
	                }
	            },
	            down: function (widget) {
	                if (!widget) {
	                    this.show();
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(7, 'd'));
	                } else {
	                    this.date(d.clone().subtract(this.stepping(), 'm'));
	                }
	            },
	            'control up': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'y'));
	                } else {
	                    this.date(d.clone().add(1, 'h'));
	                }
	            },
	            'control down': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'y'));
	                } else {
	                    this.date(d.clone().subtract(1, 'h'));
	                }
	            },
	            left: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'd'));
	                }
	            },
	            right: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'd'));
	                }
	            },
	            pageUp: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().subtract(1, 'M'));
	                }
	            },
	            pageDown: function (widget) {
	                if (!widget) {
	                    return;
	                }
	                var d = this.date() || this.getMoment();
	                if (widget.find('.datepicker').is(':visible')) {
	                    this.date(d.clone().add(1, 'M'));
	                }
	            },
	            enter: function () {
	                this.hide();
	            },
	            escape: function () {
	                this.hide();
	            },
	            //tab: function (widget) { //this break the flow of the form. disabling for now
	            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
	            //    if(toggle.length > 0) toggle.click();
	            //},
	            'control space': function (widget) {
	                if (!widget) {
	                    return;
	                }
	                if (widget.find('.timepicker').is(':visible')) {
	                    widget.find('.btn[data-action="togglePeriod"]').click();
	                }
	            },
	            t: function () {
	                this.date(this.getMoment());
	            },
	            'delete': function () {
	                this.clear();
	            }
	        },
	        debug: false,
	        allowInputToggle: false,
	        disabledTimeIntervals: false,
	        disabledHours: false,
	        enabledHours: false,
	        viewDate: false
	    };
	
	    return $.fn.datetimepicker;
	}));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(95);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./_croppietest": 22,
		"./_croppietest.js": 22,
		"./autocomplete": 23,
		"./autocomplete.js": 23,
		"./autosave": 24,
		"./autosave.js": 24,
		"./befine": 10,
		"./befine.js": 10,
		"./bootstrap_dialog": 25,
		"./bootstrap_dialog.js": 25,
		"./contact_subject": 26,
		"./contact_subject.js": 26,
		"./contacts_favorites_notices": 27,
		"./contacts_favorites_notices.js": 27,
		"./cookies_rules": 11,
		"./cookies_rules.js": 11,
		"./cruft": 28,
		"./cruft.js": 28,
		"./datetimepicker": 29,
		"./datetimepicker.js": 29,
		"./datetimepicker_i18n": 19,
		"./datetimepicker_i18n.json": 19,
		"./directchat": 30,
		"./directchat.js": 30,
		"./edit_messagebox_folder": 31,
		"./edit_messagebox_folder.js": 31,
		"./external_links": 12,
		"./external_links.js": 12,
		"./favorites": 32,
		"./favorites.js": 32,
		"./folder_manager": 33,
		"./folder_manager.js": 33,
		"./formvalidation": 13,
		"./formvalidation.js": 13,
		"./gallery": 34,
		"./gallery.js": 34,
		"./gallery_album": 35,
		"./gallery_album.js": 35,
		"./group_navigation": 36,
		"./group_navigation.js": 36,
		"./imageeditor": 37,
		"./imageeditor.js": 37,
		"./inbox_operations": 38,
		"./inbox_operations.js": 38,
		"./index": 14,
		"./index.js": 14,
		"./likes": 39,
		"./likes.js": 39,
		"./messages": 40,
		"./messages.js": 40,
		"./msgtree": 41,
		"./msgtree.js": 41,
		"./multiple_checkbox_toggle": 42,
		"./multiple_checkbox_toggle.js": 42,
		"./profile_actions": 43,
		"./profile_actions.js": 43,
		"./random_img": 44,
		"./random_img.js": 44,
		"./request_picture": 45,
		"./request_picture.js": 45,
		"./search_helper": 46,
		"./search_helper.js": 46,
		"./short_message": 47,
		"./short_message.js": 47,
		"./show_message": 48,
		"./show_message.js": 48,
		"./support_check_field": 49,
		"./support_check_field.js": 49,
		"./support_mail_check": 50,
		"./support_mail_check.js": 50,
		"./text_countdown": 51,
		"./text_countdown.js": 51,
		"./text_zaehlen": 52,
		"./text_zaehlen.js": 52,
		"./treff_helper": 53,
		"./treff_helper.js": 53,
		"./treff_watchdog": 54,
		"./treff_watchdog.js": 54,
		"./trefftooltip": 15,
		"./trefftooltip.js": 15,
		"./user_picture_big": 55,
		"./user_picture_big.js": 55,
		"./useragentparser": 56,
		"./useragentparser.js": 56,
		"./validate_message_form": 16,
		"./validate_message_form.js": 16,
		"./validate_messagebox_folder_form": 17,
		"./validate_messagebox_folder_form.js": 17,
		"./validate_misc_message_form": 18,
		"./validate_misc_message_form.js": 18
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 74;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import i18n from '../modules/datetimepicker_i18n.json';
	
	exports.br2nl = function (str, replaceMode) {
	  var replaceStr = replaceMode ? '\n' : '';
	  // Includes <br>, <BR>, <br />, </br>
	  // return str.replace('/<\s*\/?br\s*[\/]?>/gi', replaceStr);
	  return str.replace('/<s*/?brs*[/]?>/gi', replaceStr);
	};
	
	exports.nl2br = function (str, replaceMode, isXhtml) {
	  var breakTag = isXhtml ? '<br />' : '<br>';
	  // const replaceStr = replaceMode ? '$1'+ breakTag : '$1'+ breakTag +'$2';
	  var replaceStr = replaceMode ? '$1' + breakTag : '$1' + breakTag + '$2';
	  return 'str'.trim().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
	};
	
	exports.getLang = function () {
	  var $html = document.querySelector('html');
	  var langAttr = $html.getAttribute('lang');
	  var lang = langAttr.split('-', 1);
	
	  return lang[0];
	};
	
	exports.formatDate = function (lang) {
	  switch (lang) {
	    case 'en':
	      return (0, _moment2.default)().format('MM/DD/YYYY');
	    // return moment('DD/MM/YYYY');
	    case 'fr':
	    case 'it':
	      return (0, _moment2.default)().format('DD/MM/YYYY');
	    // return moment('YYYY.MM.DD.');
	    case 'hu':
	      return (0, _moment2.default)().format('YYYY.MM.DD.');
	    // return moment('MM/DD/YYYY');
	    case 'de':
	    default:
	      return (0, _moment2.default)().format('DD.MM.YYYY');
	  }
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.checkUsername = function (value, validator, $field) {
	  var check = true;
	
	  if (value === '') {
	    return true;
	  }
	
	  // Check string length
	  if (value.length < 6 || value.length > 30) {
	    return {
	      valid: false,
	
	      message: $field.attr('data-fv-stringlength-message')
	    };
	  }
	
	  // Check chars
	  var pattern = /^[a-zA-Z0-9_.]+$/i;
	
	  if (!pattern.test(value)) {
	    return {
	      valid: false,
	
	      message: $field.attr('data-fv-regexp-message')
	    };
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', '/ajax.php', false);
	  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	  xhr.send('id=300&mode=nickCheck&adduser=' + value);
	
	  check = JSON.parse(xhr.responseText).free;
	
	  if (!check) {
	    return {
	      valid: false,
	      message: $field.attr('data-fv-callback-message')
	    };
	  }
	
	  return check;
	};
	
	exports.checkEmail = function (value, validator, $field) {
	  var check = false;
	
	  if (value === '') {
	    return {
	      valid: false,
	
	      message: 'das ist eine probe'
	    };
	  }
	
	  // Check email
	  var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; //eslint-disable-line
	
	  if (!pattern.test(value)) {
	    return {
	      valid: false,
	
	      message: $field.attr('data-fv-emailaddress-message')
	    };
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', '/ajax.php', false);
	  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	  xhr.send('id=300&mode=mailCheck&adduser=' + value);
	
	  check = JSON.parse(xhr.responseText).free || JSON.parse(xhr.responseText).mxcheck;
	
	  return check;
	};
	
	exports.checkDate = function (value, validator, $field) {
	  var $html = $field.parents('html');
	  var langAttr = $html[0].getAttribute('lang');
	  var lang = langAttr.split('-', 1);
	
	  if (value === '') {
	    return true;
	  }
	
	  switch (lang[0]) {
	    case 'de':
	      return (0, _moment2.default)(value, 'DD.MM.YYYY', true).isValid();
	    case 'fr':
	      return (0, _moment2.default)(value, 'DD/MM/YYYY', true).isValid();
	    case 'it':
	      return (0, _moment2.default)(value, 'DD/MM/YYYY', true).isValid();
	    case 'hu':
	      return (0, _moment2.default)(value, 'YYYY.MM.DD.', true).isValid();
	    default:
	      return (0, _moment2.default)(value, 'MM/DD/YYYY', true).isValid();
	  }
	};
	
	exports.checkZipCode = function (value, validator, $field) {
	  var dfd = new $.Deferred();
	
	  var countrySelected = $field.parents('form').find('[name=Country]').val();
	
	  // Check string length
	  if (value.length < 2) {
	    dfd.resolve({
	      valid: false,
	      message: $field.attr('data-fv-stringlength-message')
	    });
	
	    return dfd.promise();
	  }
	
	  return $.ajax({
	    contentType: 'application/x-www-form-urlencoded',
	    data: {
	      id: 305,
	      mode: 'plzCheck',
	      adduser: '' + value,
	      userstatus: '' + countrySelected
	    },
	    dataType: 'json',
	    method: 'POST',
	    url: '/ajax.php'
	  }).then(function (data) {
	    return {
	      valid: data.known,
	      message: $field.attr('data-fv-callback-message')
	    };
	  });
	};
	
	exports.subject = function (value, validator, $field) {
	  var premium = $field.attr('data-fv-premium-message');
	  var membership = $field.attr('data-fv-membership-message');
	  var selectedSubject = $field.parents('html').find('[name=subject]').selectedIndex;
	
	  var message = void 0;
	
	  if (value === '') {
	    return true;
	  }
	
	  if (selectedSubject === 2 || selectedSubject === 4) {
	    if (selectedSubject === 2) {
	      message = premium;
	    } else {
	      message = membership;
	    }
	  }
	
	  return {
	    valid: false,
	
	    message: message
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define */
	
	/* ================================================
	 * Make use of Bootstrap's modal more monkey-friendly.
	 *
	 * For Bootstrap 3.
	 *
	 * javanoob@hotmail.com
	 *
	 * https://github.com/nakupanda/bootstrap3-dialog
	 *
	 * Licensed under The MIT License.
	 * ================================================ */
	(function (root, factory) {
	
	    "use strict";
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory(__webpack_require__(1), __webpack_require__(57));
	    }
	    // AMD module is defined
	    else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	            return factory($);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // planted over the root!
	        root.BootstrapDialog = factory(root.jQuery);
	    }
	
	}(this, function ($) {
	
	    "use strict";
	
	    /* ================================================
	     * Definition of BootstrapDialogModal.
	     * Extend Bootstrap Modal and override some functions.
	     * BootstrapDialogModal === Modified Modal.
	     * ================================================ */
	    var Modal = $.fn.modal.Constructor;
	    var BootstrapDialogModal = function (element, options) {
	        Modal.call(this, element, options);
	    };
	    BootstrapDialogModal.getModalVersion = function () {
	        var version = null;
	        if (typeof $.fn.modal.Constructor.VERSION === 'undefined') {
	            version = 'v3.1';
	        } else if (/3\.2\.\d+/.test($.fn.modal.Constructor.VERSION)) {
	            version = 'v3.2';
	        } else if (/3\.3\.[1,2]/.test($.fn.modal.Constructor.VERSION)) {
	            version = 'v3.3';  // v3.3.1, v3.3.2
	        } else {
	            version = 'v3.3.4';
	        }
	
	        return version;
	    };
	    BootstrapDialogModal.ORIGINAL_BODY_PADDING = parseInt(($('body').css('padding-right') || 0), 10);
	    BootstrapDialogModal.METHODS_TO_OVERRIDE = {};
	    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.1'] = {};
	    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.2'] = {
	        hide: function (e) {
	            if (e) {
	                e.preventDefault();
	            }
	            e = $.Event('hide.bs.modal');
	
	            this.$element.trigger(e);
	
	            if (!this.isShown || e.isDefaultPrevented()) {
	                return;
	            }
	
	            this.isShown = false;
	
	            // Remove css class 'modal-open' when the last opened dialog is closing.
	            var openedDialogs = this.getGlobalOpenedDialogs();
	            if (openedDialogs.length === 0) {
	                this.$body.removeClass('modal-open');
	            }
	
	            this.resetScrollbar();
	            this.escape();
	
	            $(document).off('focusin.bs.modal');
	
	            this.$element
	            .removeClass('in')
	            .attr('aria-hidden', true)
	            .off('click.dismiss.bs.modal');
	
	            $.support.transition && this.$element.hasClass('fade') ?
	            this.$element
	            .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	            .emulateTransitionEnd(300) :
	            this.hideModal();
	        }
	    };
	    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3'] = {
	        /**
	         * Overrided.
	         * 
	         * @returns {undefined}
	         */
	        setScrollbar: function () {
	            var bodyPad = BootstrapDialogModal.ORIGINAL_BODY_PADDING;
	            if (this.bodyIsOverflowing) {
	                this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	            }
	        },
	        /**
	         * Overrided.
	         * 
	         * @returns {undefined}
	         */
	        resetScrollbar: function () {
	            var openedDialogs = this.getGlobalOpenedDialogs();
	            if (openedDialogs.length === 0) {
	                this.$body.css('padding-right', BootstrapDialogModal.ORIGINAL_BODY_PADDING);
	            }
	        },
	        /**
	         * Overrided.
	         * 
	         * @returns {undefined}
	         */
	        hideModal: function () {
	            this.$element.hide();
	            this.backdrop($.proxy(function () {
	                var openedDialogs = this.getGlobalOpenedDialogs();
	                if (openedDialogs.length === 0) {
	                    this.$body.removeClass('modal-open');
	                }
	                this.resetAdjustments();
	                this.resetScrollbar();
	                this.$element.trigger('hidden.bs.modal');
	            }, this));
	        }
	    };
	    BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3.4'] = $.extend({}, BootstrapDialogModal.METHODS_TO_OVERRIDE['v3.3']);
	    BootstrapDialogModal.prototype = {
	        constructor: BootstrapDialogModal,
	        /**
	         * New function, to get the dialogs that opened by BootstrapDialog.
	         * 
	         * @returns {undefined}
	         */
	        getGlobalOpenedDialogs: function () {
	            var openedDialogs = [];
	            $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
	                if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
	                    openedDialogs.push(dialogInstance);
	                }
	            });
	
	            return openedDialogs;
	        }
	    };
	
	    // Add compatible methods.
	    BootstrapDialogModal.prototype = $.extend(BootstrapDialogModal.prototype, Modal.prototype, BootstrapDialogModal.METHODS_TO_OVERRIDE[BootstrapDialogModal.getModalVersion()]);
	
	    /* ================================================
	     * Definition of BootstrapDialog.
	     * ================================================ */
	    var BootstrapDialog = function (options) {
	        this.defaultOptions = $.extend(true, {
	            id: BootstrapDialog.newGuid(),
	            buttons: [],
	            data: {},
	            onshow: null,
	            onshown: null,
	            onhide: null,
	            onhidden: null
	        }, BootstrapDialog.defaultOptions);
	        this.indexedButtons = {};
	        this.registeredButtonHotkeys = {};
	        this.draggableData = {
	            isMouseDown: false,
	            mouseOffset: {}
	        };
	        this.realized = false;
	        this.opened = false;
	        this.initOptions(options);
	        this.holdThisInstance();
	    };
	
	    BootstrapDialog.BootstrapDialogModal = BootstrapDialogModal;
	
	    /**
	     *  Some constants.
	     */
	    BootstrapDialog.NAMESPACE = 'bootstrap-dialog';
	    BootstrapDialog.TYPE_DEFAULT = 'type-default';
	    BootstrapDialog.TYPE_INFO = 'type-info';
	    BootstrapDialog.TYPE_PRIMARY = 'type-primary';
	    BootstrapDialog.TYPE_SUCCESS = 'type-success';
	    BootstrapDialog.TYPE_WARNING = 'type-warning';
	    BootstrapDialog.TYPE_DANGER = 'type-danger';
	    BootstrapDialog.DEFAULT_TEXTS = {};
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DEFAULT] = 'Information';
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_INFO] = 'Information';
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_PRIMARY] = 'Information';
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_SUCCESS] = 'Success';
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_WARNING] = 'Warning';
	    BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DANGER] = 'Danger';
	    BootstrapDialog.DEFAULT_TEXTS['OK'] = 'OK';
	    BootstrapDialog.DEFAULT_TEXTS['CANCEL'] = 'Cancel';
	    BootstrapDialog.DEFAULT_TEXTS['CONFIRM'] = 'Confirmation';
	    BootstrapDialog.SIZE_NORMAL = 'size-normal';
	    BootstrapDialog.SIZE_SMALL = 'size-small';
	    BootstrapDialog.SIZE_WIDE = 'size-wide';    // size-wide is equal to modal-lg
	    BootstrapDialog.SIZE_LARGE = 'size-large';
	    BootstrapDialog.BUTTON_SIZES = {};
	    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_NORMAL] = '';
	    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_SMALL] = '';
	    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_WIDE] = '';
	    BootstrapDialog.BUTTON_SIZES[BootstrapDialog.SIZE_LARGE] = 'btn-lg';
	    BootstrapDialog.ICON_SPINNER = 'glyphicon glyphicon-asterisk';
	    BootstrapDialog.BUTTONS_ORDER_CANCEL_OK = 'btns-order-cancel-ok';
	    BootstrapDialog.BUTTONS_ORDER_OK_CANCEL = 'btns-order-ok-cancel';
	
	    /**
	     * Default options.
	     */
	    BootstrapDialog.defaultOptions = {
	        type: BootstrapDialog.TYPE_PRIMARY,
	        size: BootstrapDialog.SIZE_NORMAL,
	        cssClass: '',
	        title: null,
	        message: null,
	        nl2br: true,
	        closable: true,
	        closeByBackdrop: true,
	        closeByKeyboard: true,
	        closeIcon: '&#215;',
	        spinicon: BootstrapDialog.ICON_SPINNER,
	        autodestroy: true,
	        draggable: false,
	        animate: true,
	        description: '',
	        tabindex: -1,
	        btnsOrder: BootstrapDialog.BUTTONS_ORDER_CANCEL_OK
	    };
	
	    /**
	     * Config default options.
	     */
	    BootstrapDialog.configDefaultOptions = function (options) {
	        BootstrapDialog.defaultOptions = $.extend(true, BootstrapDialog.defaultOptions, options);
	    };
	
	    /**
	     * Open / Close all created dialogs all at once.
	     */
	    BootstrapDialog.dialogs = {};
	    BootstrapDialog.openAll = function () {
	        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
	            dialogInstance.open();
	        });
	    };
	    BootstrapDialog.closeAll = function () {
	        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
	            dialogInstance.close();
	        });
	    };
	
	    /**
	     * Get dialog instance by given id.
	     * 
	     * @returns dialog instance
	     */
	    BootstrapDialog.getDialog = function (id) {
	        var dialog = null;
	        if (typeof BootstrapDialog.dialogs[id] !== 'undefined') {
	            dialog = BootstrapDialog.dialogs[id];
	        }
	
	        return dialog;
	    };
	
	    /**
	     * Set a dialog.
	     * 
	     * @returns the dialog that has just been set.
	     */
	    BootstrapDialog.setDialog = function (dialog) {
	        BootstrapDialog.dialogs[dialog.getId()] = dialog;
	
	        return dialog;
	    };
	
	    /**
	     * Alias of BootstrapDialog.setDialog(dialog)
	     * 
	     * @param {type} dialog
	     * @returns {unresolved}
	     */
	    BootstrapDialog.addDialog = function (dialog) {
	        return BootstrapDialog.setDialog(dialog);
	    };
	
	    /**
	     * Move focus to next visible dialog.
	     */
	    BootstrapDialog.moveFocus = function () {
	        var lastDialogInstance = null;
	        $.each(BootstrapDialog.dialogs, function (id, dialogInstance) {
	            if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
	                lastDialogInstance = dialogInstance;
	            }
	        });
	        if (lastDialogInstance !== null) {
	            lastDialogInstance.getModal().focus();
	        }
	    };
	
	    BootstrapDialog.METHODS_TO_OVERRIDE = {};
	    BootstrapDialog.METHODS_TO_OVERRIDE['v3.1'] = {
	        handleModalBackdropEvent: function () {
	            this.getModal().on('click', {dialog: this}, function (event) {
	                event.target === this && event.data.dialog.isClosable() && event.data.dialog.canCloseByBackdrop() && event.data.dialog.close();
	            });
	
	            return this;
	        },
	        /**
	         * To make multiple opened dialogs look better.
	         * 
	         * Will be removed in later version, after Bootstrap Modal >= 3.3.0, updating z-index is unnecessary.
	         */
	        updateZIndex: function () {
	            if (this.isOpened()) {
	                var zIndexBackdrop = 1040;
	                var zIndexModal = 1050;
	                var dialogCount = 0;
	                $.each(BootstrapDialog.dialogs, function (dialogId, dialogInstance) {
	                    if (dialogInstance.isRealized() && dialogInstance.isOpened()) {
	                        dialogCount++;
	                    }
	                });
	                var $modal = this.getModal();
	                var $backdrop = $modal.data('bs.modal').$backdrop;
	                $modal.css('z-index', zIndexModal + (dialogCount - 1) * 20);
	                $backdrop.css('z-index', zIndexBackdrop + (dialogCount - 1) * 20);
	            }
	
	            return this;
	        },
	        open: function () {
	            !this.isRealized() && this.realize();
	            this.getModal().modal('show');
	            this.updateZIndex();
	
	            return this;
	        }
	    };
	    BootstrapDialog.METHODS_TO_OVERRIDE['v3.2'] = {
	        handleModalBackdropEvent: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['handleModalBackdropEvent'],
	        updateZIndex: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['updateZIndex'],
	        open: BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']['open']
	    };
	    BootstrapDialog.METHODS_TO_OVERRIDE['v3.3'] = {};
	    BootstrapDialog.METHODS_TO_OVERRIDE['v3.3.4'] = $.extend({}, BootstrapDialog.METHODS_TO_OVERRIDE['v3.1']);
	    BootstrapDialog.prototype = {
	        constructor: BootstrapDialog,
	        initOptions: function (options) {
	            this.options = $.extend(true, this.defaultOptions, options);
	
	            return this;
	        },
	        holdThisInstance: function () {
	            BootstrapDialog.addDialog(this);
	
	            return this;
	        },
	        initModalStuff: function () {
	            this.setModal(this.createModal())
	            .setModalDialog(this.createModalDialog())
	            .setModalContent(this.createModalContent())
	            .setModalHeader(this.createModalHeader())
	            .setModalBody(this.createModalBody())
	            .setModalFooter(this.createModalFooter());
	
	            this.getModal().append(this.getModalDialog());
	            this.getModalDialog().append(this.getModalContent());
	            this.getModalContent()
	            .append(this.getModalHeader())
	            .append(this.getModalBody())
	            .append(this.getModalFooter());
	
	            return this;
	        },
	        createModal: function () {
	            var $modal = $('<div class="modal" role="dialog" aria-hidden="true"></div>');
	            $modal.prop('id', this.getId());
	            $modal.attr('aria-labelledby', this.getId() + '_title');
	
	            return $modal;
	        },
	        getModal: function () {
	            return this.$modal;
	        },
	        setModal: function ($modal) {
	            this.$modal = $modal;
	
	            return this;
	        },
	        createModalDialog: function () {
	            return $('<div class="modal-dialog"></div>');
	        },
	        getModalDialog: function () {
	            return this.$modalDialog;
	        },
	        setModalDialog: function ($modalDialog) {
	            this.$modalDialog = $modalDialog;
	
	            return this;
	        },
	        createModalContent: function () {
	            return $('<div class="modal-content"></div>');
	        },
	        getModalContent: function () {
	            return this.$modalContent;
	        },
	        setModalContent: function ($modalContent) {
	            this.$modalContent = $modalContent;
	
	            return this;
	        },
	        createModalHeader: function () {
	            return $('<div class="modal-header"></div>');
	        },
	        getModalHeader: function () {
	            return this.$modalHeader;
	        },
	        setModalHeader: function ($modalHeader) {
	            this.$modalHeader = $modalHeader;
	
	            return this;
	        },
	        createModalBody: function () {
	            return $('<div class="modal-body"></div>');
	        },
	        getModalBody: function () {
	            return this.$modalBody;
	        },
	        setModalBody: function ($modalBody) {
	            this.$modalBody = $modalBody;
	
	            return this;
	        },
	        createModalFooter: function () {
	            return $('<div class="modal-footer"></div>');
	        },
	        getModalFooter: function () {
	            return this.$modalFooter;
	        },
	        setModalFooter: function ($modalFooter) {
	            this.$modalFooter = $modalFooter;
	
	            return this;
	        },
	        createDynamicContent: function (rawContent) {
	            var content = null;
	            if (typeof rawContent === 'function') {
	                content = rawContent.call(rawContent, this);
	            } else {
	                content = rawContent;
	            }
	            if (typeof content === 'string') {
	                content = this.formatStringContent(content);
	            }
	
	            return content;
	        },
	        formatStringContent: function (content) {
	            if (this.options.nl2br) {
	                return content.replace(/\r\n/g, '<br />').replace(/[\r\n]/g, '<br />');
	            }
	
	            return content;
	        },
	        setData: function (key, value) {
	            this.options.data[key] = value;
	
	            return this;
	        },
	        getData: function (key) {
	            return this.options.data[key];
	        },
	        setId: function (id) {
	            this.options.id = id;
	
	            return this;
	        },
	        getId: function () {
	            return this.options.id;
	        },
	        getType: function () {
	            return this.options.type;
	        },
	        setType: function (type) {
	            this.options.type = type;
	            this.updateType();
	
	            return this;
	        },
	        updateType: function () {
	            if (this.isRealized()) {
	                var types = [BootstrapDialog.TYPE_DEFAULT,
	                    BootstrapDialog.TYPE_INFO,
	                    BootstrapDialog.TYPE_PRIMARY,
	                    BootstrapDialog.TYPE_SUCCESS,
	                    BootstrapDialog.TYPE_WARNING,
	                    BootstrapDialog.TYPE_DANGER];
	
	                this.getModal().removeClass(types.join(' ')).addClass(this.getType());
	            }
	
	            return this;
	        },
	        getSize: function () {
	            return this.options.size;
	        },
	        setSize: function (size) {
	            this.options.size = size;
	            this.updateSize();
	
	            return this;
	        },
	        updateSize: function () {
	            if (this.isRealized()) {
	                var dialog = this;
	
	                // Dialog size
	                this.getModal().removeClass(BootstrapDialog.SIZE_NORMAL)
	                .removeClass(BootstrapDialog.SIZE_SMALL)
	                .removeClass(BootstrapDialog.SIZE_WIDE)
	                .removeClass(BootstrapDialog.SIZE_LARGE);
	                this.getModal().addClass(this.getSize());
	
	                // Smaller dialog.
	                this.getModalDialog().removeClass('modal-sm');
	                if (this.getSize() === BootstrapDialog.SIZE_SMALL) {
	                    this.getModalDialog().addClass('modal-sm');
	                }
	
	                // Wider dialog.
	                this.getModalDialog().removeClass('modal-lg');
	                if (this.getSize() === BootstrapDialog.SIZE_WIDE) {
	                    this.getModalDialog().addClass('modal-lg');
	                }
	
	                // Button size
	                $.each(this.options.buttons, function (index, button) {
	                    var $button = dialog.getButton(button.id);
	                    var buttonSizes = ['btn-lg', 'btn-sm', 'btn-xs'];
	                    var sizeClassSpecified = false;
	                    if (typeof button['cssClass'] === 'string') {
	                        var btnClasses = button['cssClass'].split(' ');
	                        $.each(btnClasses, function (index, btnClass) {
	                            if ($.inArray(btnClass, buttonSizes) !== -1) {
	                                sizeClassSpecified = true;
	                            }
	                        });
	                    }
	                    if (!sizeClassSpecified) {
	                        $button.removeClass(buttonSizes.join(' '));
	                        $button.addClass(dialog.getButtonSize());
	                    }
	                });
	            }
	
	            return this;
	        },
	        getCssClass: function () {
	            return this.options.cssClass;
	        },
	        setCssClass: function (cssClass) {
	            this.options.cssClass = cssClass;
	
	            return this;
	        },
	        getTitle: function () {
	            return this.options.title;
	        },
	        setTitle: function (title) {
	            this.options.title = title;
	            this.updateTitle();
	
	            return this;
	        },
	        updateTitle: function () {
	            if (this.isRealized()) {
	                var title = this.getTitle() !== null ? this.createDynamicContent(this.getTitle()) : this.getDefaultText();
	                this.getModalHeader().find('.' + this.getNamespace('title')).html('').append(title).prop('id', this.getId() + '_title');
	            }
	
	            return this;
	        },
	        getMessage: function () {
	            return this.options.message;
	        },
	        setMessage: function (message) {
	            this.options.message = message;
	            this.updateMessage();
	
	            return this;
	        },
	        updateMessage: function () {
	            if (this.isRealized()) {
	                var message = this.createDynamicContent(this.getMessage());
	                this.getModalBody().find('.' + this.getNamespace('message')).html('').append(message);
	            }
	
	            return this;
	        },
	        isClosable: function () {
	            return this.options.closable;
	        },
	        setClosable: function (closable) {
	            this.options.closable = closable;
	            this.updateClosable();
	
	            return this;
	        },
	        setCloseByBackdrop: function (closeByBackdrop) {
	            this.options.closeByBackdrop = closeByBackdrop;
	
	            return this;
	        },
	        canCloseByBackdrop: function () {
	            return this.options.closeByBackdrop;
	        },
	        setCloseByKeyboard: function (closeByKeyboard) {
	            this.options.closeByKeyboard = closeByKeyboard;
	
	            return this;
	        },
	        canCloseByKeyboard: function () {
	            return this.options.closeByKeyboard;
	        },
	        isAnimate: function () {
	            return this.options.animate;
	        },
	        setAnimate: function (animate) {
	            this.options.animate = animate;
	
	            return this;
	        },
	        updateAnimate: function () {
	            if (this.isRealized()) {
	                this.getModal().toggleClass('fade', this.isAnimate());
	            }
	
	            return this;
	        },
	        getSpinicon: function () {
	            return this.options.spinicon;
	        },
	        setSpinicon: function (spinicon) {
	            this.options.spinicon = spinicon;
	
	            return this;
	        },
	        addButton: function (button) {
	            this.options.buttons.push(button);
	
	            return this;
	        },
	        addButtons: function (buttons) {
	            var that = this;
	            $.each(buttons, function (index, button) {
	                that.addButton(button);
	            });
	
	            return this;
	        },
	        getButtons: function () {
	            return this.options.buttons;
	        },
	        setButtons: function (buttons) {
	            this.options.buttons = buttons;
	            this.updateButtons();
	
	            return this;
	        },
	        /**
	         * If there is id provided for a button option, it will be in dialog.indexedButtons list.
	         *
	         * In that case you can use dialog.getButton(id) to find the button.
	         *
	         * @param {type} id
	         * @returns {undefined}
	         */
	        getButton: function (id) {
	            if (typeof this.indexedButtons[id] !== 'undefined') {
	                return this.indexedButtons[id];
	            }
	
	            return null;
	        },
	        getButtonSize: function () {
	            if (typeof BootstrapDialog.BUTTON_SIZES[this.getSize()] !== 'undefined') {
	                return BootstrapDialog.BUTTON_SIZES[this.getSize()];
	            }
	
	            return '';
	        },
	        updateButtons: function () {
	            if (this.isRealized()) {
	                if (this.getButtons().length === 0) {
	                    this.getModalFooter().hide();
	                } else {
	                    this.getModalFooter().show().find('.' + this.getNamespace('footer')).html('').append(this.createFooterButtons());
	                }
	            }
	
	            return this;
	        },
	        isAutodestroy: function () {
	            return this.options.autodestroy;
	        },
	        setAutodestroy: function (autodestroy) {
	            this.options.autodestroy = autodestroy;
	        },
	        getDescription: function () {
	            return this.options.description;
	        },
	        setDescription: function (description) {
	            this.options.description = description;
	
	            return this;
	        },
	        setTabindex: function (tabindex) {
	            this.options.tabindex = tabindex;
	
	            return this;
	        },
	        getTabindex: function () {
	            return this.options.tabindex;
	        },
	        updateTabindex: function () {
	            if (this.isRealized()) {
	                this.getModal().attr('tabindex', this.getTabindex());
	            }
	
	            return this;
	        },
	        getDefaultText: function () {
	            return BootstrapDialog.DEFAULT_TEXTS[this.getType()];
	        },
	        getNamespace: function (name) {
	            return BootstrapDialog.NAMESPACE + '-' + name;
	        },
	        createHeaderContent: function () {
	            var $container = $('<div></div>');
	            $container.addClass(this.getNamespace('header'));
	
	            // title
	            $container.append(this.createTitleContent());
	
	            // Close button
	            $container.prepend(this.createCloseButton());
	
	            return $container;
	        },
	        createTitleContent: function () {
	            var $title = $('<div></div>');
	            $title.addClass(this.getNamespace('title'));
	
	            return $title;
	        },
	        createCloseButton: function () {
	            var $container = $('<div></div>');
	            $container.addClass(this.getNamespace('close-button'));
	            var $icon = $('<button class="close" aria-label="close"></button>');
	            $icon.append(this.options.closeIcon);
	            $container.append($icon);
	            $container.on('click', {dialog: this}, function (event) {
	                event.data.dialog.close();
	            });
	
	            return $container;
	        },
	        createBodyContent: function () {
	            var $container = $('<div></div>');
	            $container.addClass(this.getNamespace('body'));
	
	            // Message
	            $container.append(this.createMessageContent());
	
	            return $container;
	        },
	        createMessageContent: function () {
	            var $message = $('<div></div>');
	            $message.addClass(this.getNamespace('message'));
	
	            return $message;
	        },
	        createFooterContent: function () {
	            var $container = $('<div></div>');
	            $container.addClass(this.getNamespace('footer'));
	
	            return $container;
	        },
	        createFooterButtons: function () {
	            var that = this;
	            var $container = $('<div></div>');
	            $container.addClass(this.getNamespace('footer-buttons'));
	            this.indexedButtons = {};
	            $.each(this.options.buttons, function (index, button) {
	                if (!button.id) {
	                    button.id = BootstrapDialog.newGuid();
	                }
	                var $button = that.createButton(button);
	                that.indexedButtons[button.id] = $button;
	                $container.append($button);
	            });
	
	            return $container;
	        },
	        createButton: function (button) {
	            var $button = $('<button class="btn"></button>');
	            $button.prop('id', button.id);
	            $button.data('button', button);
	
	            // Icon
	            if (typeof button.icon !== 'undefined' && $.trim(button.icon) !== '') {
	                $button.append(this.createButtonIcon(button.icon));
	            }
	
	            // Label
	            if (typeof button.label !== 'undefined') {
	                $button.append(button.label);
	            }
	
	            // title
	            if (typeof button.title !== 'undefined') {
	                $button.attr('title',  button.title);
	            }
	
	            // Css class
	            if (typeof button.cssClass !== 'undefined' && $.trim(button.cssClass) !== '') {
	                $button.addClass(button.cssClass);
	            } else {
	                $button.addClass('btn-default');
	            }
	
	            // Data attributes
	            if (typeof button.data === 'object' && button.data.constructor === {}.constructor) {
	                $.each(button.data, function (key, value) {
	                    $button.attr('data-' + key, value);
	                });
	            }
	
	            // Hotkey
	            if (typeof button.hotkey !== 'undefined') {
	                this.registeredButtonHotkeys[button.hotkey] = $button;
	            }
	
	            // Button on click
	            $button.on('click', {dialog: this, $button: $button, button: button}, function (event) {
	                var dialog = event.data.dialog;
	                var $button = event.data.$button;
	                var button = $button.data('button');
	                if (button.autospin) {
	                    $button.toggleSpin(true);
	                }
	                if (typeof button.action === 'function') {
	                    return button.action.call($button, dialog, event);
	                }
	            });
	
	            // Dynamically add extra functions to $button
	            this.enhanceButton($button);
	
	            //Initialize enabled or not
	            if (typeof button.enabled !== 'undefined') {
	                $button.toggleEnable(button.enabled);
	            }
	
	            return $button;
	        },
	        /**
	         * Dynamically add extra functions to $button
	         *
	         * Using '$this' to reference 'this' is just for better readability.
	         *
	         * @param {type} $button
	         * @returns {_L13.BootstrapDialog.prototype}
	         */
	        enhanceButton: function ($button) {
	            $button.dialog = this;
	
	            // Enable / Disable
	            $button.toggleEnable = function (enable) {
	                var $this = this;
	                if (typeof enable !== 'undefined') {
	                    $this.prop("disabled", !enable).toggleClass('disabled', !enable);
	                } else {
	                    $this.prop("disabled", !$this.prop("disabled"));
	                }
	
	                return $this;
	            };
	            $button.enable = function () {
	                var $this = this;
	                $this.toggleEnable(true);
	
	                return $this;
	            };
	            $button.disable = function () {
	                var $this = this;
	                $this.toggleEnable(false);
	
	                return $this;
	            };
	
	            // Icon spinning, helpful for indicating ajax loading status.
	            $button.toggleSpin = function (spin) {
	                var $this = this;
	                var dialog = $this.dialog;
	                var $icon = $this.find('.' + dialog.getNamespace('button-icon'));
	                if (typeof spin === 'undefined') {
	                    spin = !($button.find('.icon-spin').length > 0);
	                }
	                if (spin) {
	                    $icon.hide();
	                    $button.prepend(dialog.createButtonIcon(dialog.getSpinicon()).addClass('icon-spin'));
	                } else {
	                    $icon.show();
	                    $button.find('.icon-spin').remove();
	                }
	
	                return $this;
	            };
	            $button.spin = function () {
	                var $this = this;
	                $this.toggleSpin(true);
	
	                return $this;
	            };
	            $button.stopSpin = function () {
	                var $this = this;
	                $this.toggleSpin(false);
	
	                return $this;
	            };
	
	            return this;
	        },
	        createButtonIcon: function (icon) {
	            var $icon = $('<span></span>');
	            $icon.addClass(this.getNamespace('button-icon')).addClass(icon);
	
	            return $icon;
	        },
	        /**
	         * Invoke this only after the dialog is realized.
	         *
	         * @param {type} enable
	         * @returns {undefined}
	         */
	        enableButtons: function (enable) {
	            $.each(this.indexedButtons, function (id, $button) {
	                $button.toggleEnable(enable);
	            });
	
	            return this;
	        },
	        /**
	         * Invoke this only after the dialog is realized.
	         *
	         * @returns {undefined}
	         */
	        updateClosable: function () {
	            if (this.isRealized()) {
	                // Close button
	                this.getModalHeader().find('.' + this.getNamespace('close-button')).toggle(this.isClosable());
	            }
	
	            return this;
	        },
	        /**
	         * Set handler for modal event 'show.bs.modal'.
	         * This is a setter!
	         */
	        onShow: function (onshow) {
	            this.options.onshow = onshow;
	
	            return this;
	        },
	        /**
	         * Set handler for modal event 'shown.bs.modal'.
	         * This is a setter!
	         */
	        onShown: function (onshown) {
	            this.options.onshown = onshown;
	
	            return this;
	        },
	        /**
	         * Set handler for modal event 'hide.bs.modal'.
	         * This is a setter!
	         */
	        onHide: function (onhide) {
	            this.options.onhide = onhide;
	
	            return this;
	        },
	        /**
	         * Set handler for modal event 'hidden.bs.modal'.
	         * This is a setter!
	         */
	        onHidden: function (onhidden) {
	            this.options.onhidden = onhidden;
	
	            return this;
	        },
	        isRealized: function () {
	            return this.realized;
	        },
	        setRealized: function (realized) {
	            this.realized = realized;
	
	            return this;
	        },
	        isOpened: function () {
	            return this.opened;
	        },
	        setOpened: function (opened) {
	            this.opened = opened;
	
	            return this;
	        },
	        handleModalEvents: function () {
	            this.getModal().on('show.bs.modal', {dialog: this}, function (event) {
	                var dialog = event.data.dialog;
	                dialog.setOpened(true);
	                if (dialog.isModalEvent(event) && typeof dialog.options.onshow === 'function') {
	                    var openIt = dialog.options.onshow(dialog);
	                    if (openIt === false) {
	                        dialog.setOpened(false);
	                    }
	
	                    return openIt;
	                }
	            });
	            this.getModal().on('shown.bs.modal', {dialog: this}, function (event) {
	                var dialog = event.data.dialog;
	                dialog.isModalEvent(event) && typeof dialog.options.onshown === 'function' && dialog.options.onshown(dialog);
	            });
	            this.getModal().on('hide.bs.modal', {dialog: this}, function (event) {
	                var dialog = event.data.dialog;
	                dialog.setOpened(false);
	                if (dialog.isModalEvent(event) && typeof dialog.options.onhide === 'function') {
	                    var hideIt = dialog.options.onhide(dialog);
	                    if (hideIt === false) {
	                        dialog.setOpened(true);
	                    }
	
	                    return hideIt;
	                }
	            });
	            this.getModal().on('hidden.bs.modal', {dialog: this}, function (event) {
	                var dialog = event.data.dialog;
	                dialog.isModalEvent(event) && typeof dialog.options.onhidden === 'function' && dialog.options.onhidden(dialog);
	                if (dialog.isAutodestroy()) {
	                    dialog.setRealized(false);
	                    delete BootstrapDialog.dialogs[dialog.getId()];
	                    $(this).remove();
	                }
	                BootstrapDialog.moveFocus();
	                if ($('.modal').hasClass('in')) {
	                  $('body').addClass('modal-open');
	                }
	            });
	
	            // Backdrop, I did't find a way to change bs3 backdrop option after the dialog is popped up, so here's a new wheel.
	            this.handleModalBackdropEvent();
	
	            // ESC key support
	            this.getModal().on('keyup', {dialog: this}, function (event) {
	                event.which === 27 && event.data.dialog.isClosable() && event.data.dialog.canCloseByKeyboard() && event.data.dialog.close();
	            });
	
	            // Button hotkey
	            this.getModal().on('keyup', {dialog: this}, function (event) {
	                var dialog = event.data.dialog;
	                if (typeof dialog.registeredButtonHotkeys[event.which] !== 'undefined') {
	                    var $button = $(dialog.registeredButtonHotkeys[event.which]);
	                    !$button.prop('disabled') && $button.focus().trigger('click');
	                }
	            });
	
	            return this;
	        },
	        handleModalBackdropEvent: function () {
	            this.getModal().on('click', {dialog: this}, function (event) {
	                $(event.target).hasClass('modal-backdrop') && event.data.dialog.isClosable() && event.data.dialog.canCloseByBackdrop() && event.data.dialog.close();
	            });
	
	            return this;
	        },
	        isModalEvent: function (event) {
	            return typeof event.namespace !== 'undefined' && event.namespace === 'bs.modal';
	        },
	        makeModalDraggable: function () {
	            if (this.options.draggable) {
	                this.getModalHeader().addClass(this.getNamespace('draggable')).on('mousedown', {dialog: this}, function (event) {
	                    var dialog = event.data.dialog;
	                    dialog.draggableData.isMouseDown = true;
	                    var dialogOffset = dialog.getModalDialog().offset();
	                    dialog.draggableData.mouseOffset = {
	                        top: event.clientY - dialogOffset.top,
	                        left: event.clientX - dialogOffset.left
	                    };
	                });
	                this.getModal().on('mouseup mouseleave', {dialog: this}, function (event) {
	                    event.data.dialog.draggableData.isMouseDown = false;
	                });
	                $('body').on('mousemove', {dialog: this}, function (event) {
	                    var dialog = event.data.dialog;
	                    if (!dialog.draggableData.isMouseDown) {
	                        return;
	                    }
	                    dialog.getModalDialog().offset({
	                        top: event.clientY - dialog.draggableData.mouseOffset.top,
	                        left: event.clientX - dialog.draggableData.mouseOffset.left
	                    });
	                });
	            }
	
	            return this;
	        },
	        realize: function () {
	            this.initModalStuff();
	            this.getModal().addClass(BootstrapDialog.NAMESPACE)
	            .addClass(this.getCssClass());
	            this.updateSize();
	            if (this.getDescription()) {
	                this.getModal().attr('aria-describedby', this.getDescription());
	            }
	            this.getModalFooter().append(this.createFooterContent());
	            this.getModalHeader().append(this.createHeaderContent());
	            this.getModalBody().append(this.createBodyContent());
	            this.getModal().data('bs.modal', new BootstrapDialogModal(this.getModal(), {
	                backdrop: 'static',
	                keyboard: false,
	                show: false
	            }));
	            this.makeModalDraggable();
	            this.handleModalEvents();
	            this.setRealized(true);
	            this.updateButtons();
	            this.updateType();
	            this.updateTitle();
	            this.updateMessage();
	            this.updateClosable();
	            this.updateAnimate();
	            this.updateSize();
	            this.updateTabindex();
	
	            return this;
	        },
	        open: function () {
	            !this.isRealized() && this.realize();
	            this.getModal().modal('show');
	
	            return this;
	        },
	        close: function () {
	            !this.isRealized() && this.realize();
	            this.getModal().modal('hide');
	
	            return this;
	        }
	    };
	
	    // Add compatible methods.
	    BootstrapDialog.prototype = $.extend(BootstrapDialog.prototype, BootstrapDialog.METHODS_TO_OVERRIDE[BootstrapDialogModal.getModalVersion()]);
	
	    /**
	     * RFC4122 version 4 compliant unique id creator.
	     *
	     * Added by https://github.com/tufanbarisyildirim/
	     *
	     *  @returns {String}
	     */
	    BootstrapDialog.newGuid = function () {
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    };
	
	    /* ================================================
	     * For lazy people
	     * ================================================ */
	
	    /**
	     * Shortcut function: show
	     *
	     * @param {type} options
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.show = function (options) {
	        return new BootstrapDialog(options).open();
	    };
	
	    /**
	     * Alert window
	     *
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.alert = function () {
	        var alertOptions = {};
	        var defaultAlertOptions = {
	            type: BootstrapDialog.TYPE_PRIMARY,
	            title: null,
	            message: null,
	            closable: false,
	            draggable: false,
	            buttonLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
	            buttonHotkey: null,
	            callback: null
	        };
	
	        if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
	            alertOptions = $.extend(true, defaultAlertOptions, arguments[0]);
	        } else {
	            alertOptions = $.extend(true, defaultAlertOptions, {
	                message: arguments[0],
	                callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
	            });
	        }
	
	        var dialog = new BootstrapDialog(alertOptions);
	        dialog.setData('callback', alertOptions.callback);
	        dialog.addButton({
	            label: alertOptions.buttonLabel,
	            hotkey: alertOptions.buttonHotkey,
	            action: function (dialog) {
	                if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, true) === false) {
	                    return false;
	                }
	                dialog.setData('btnClicked', true);
	
	                return dialog.close();
	            }
	        });
	        if (typeof dialog.options.onhide === 'function') {
	            dialog.onHide(function (dialog) {
	                var hideIt = true;
	                if (!dialog.getData('btnClicked') && dialog.isClosable() && typeof dialog.getData('callback') === 'function') {
	                    hideIt = dialog.getData('callback')(false);
	                }
	                if (hideIt === false) {
	                    return false;
	                }
	                hideIt = this.onhide(dialog);
	
	                return hideIt;
	            }.bind({
	                onhide: dialog.options.onhide
	            }));
	        } else {
	            dialog.onHide(function (dialog) {
	                var hideIt = true;
	                if (!dialog.getData('btnClicked') && dialog.isClosable() && typeof dialog.getData('callback') === 'function') {
	                    hideIt = dialog.getData('callback')(false);
	                }
	
	                return hideIt;
	            });
	        }
	
	        return dialog.open();
	    };
	
	    /**
	     * Confirm window
	     *
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.confirm = function () {
	        var confirmOptions = {};
	        var defaultConfirmOptions = {
	            type: BootstrapDialog.TYPE_PRIMARY,
	            title: null,
	            message: null,
	            closable: false,
	            draggable: false,
	            btnCancelLabel: BootstrapDialog.DEFAULT_TEXTS.CANCEL,
	            btnCancelClass: null,
	            btnCancelHotkey: null,
	            btnOKLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
	            btnOKClass: null,
	            btnOKHotkey: null,
	            btnsOrder: BootstrapDialog.defaultOptions.btnsOrder,
	            callback: null
	        };
	        if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
	            confirmOptions = $.extend(true, defaultConfirmOptions, arguments[0]);
	        } else {
	            confirmOptions = $.extend(true, defaultConfirmOptions, {
	                message: arguments[0],
	                callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
	            });
	        }
	        if (confirmOptions.btnOKClass === null) {
	            confirmOptions.btnOKClass = ['btn', confirmOptions.type.split('-')[1]].join('-');
	        }
	
	        var dialog = new BootstrapDialog(confirmOptions);
	        dialog.setData('callback', confirmOptions.callback);
	
	        var buttons = [{
	                label: confirmOptions.btnCancelLabel,
	                cssClass: confirmOptions.btnCancelClass,
	                hotkey: confirmOptions.btnCancelHotkey,
	                action: function (dialog) {
	                    if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, false) === false) {
	                        return false;
	                    }
	
	                    return dialog.close();
	                }
	            }, {
	                label: confirmOptions.btnOKLabel,
	                cssClass: confirmOptions.btnOKClass,
	                hotkey: confirmOptions.btnOKHotkey,
	                action: function (dialog) {
	                    if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback').call(this, true) === false) {
	                        return false;
	                    }
	
	                    return dialog.close();
	                }
	            }];
	        if (confirmOptions.btnsOrder === BootstrapDialog.BUTTONS_ORDER_OK_CANCEL) {
	            buttons.reverse();
	        }
	        dialog.addButtons(buttons);
	
	        return dialog.open();
	
	    };
	
	    /**
	     * Warning window
	     *
	     * @param {type} message
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.warning = function (message, callback) {
	        return new BootstrapDialog({
	            type: BootstrapDialog.TYPE_WARNING,
	            message: message
	        }).open();
	    };
	
	    /**
	     * Danger window
	     *
	     * @param {type} message
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.danger = function (message, callback) {
	        return new BootstrapDialog({
	            type: BootstrapDialog.TYPE_DANGER,
	            message: message
	        }).open();
	    };
	
	    /**
	     * Success window
	     *
	     * @param {type} message
	     * @returns the created dialog instance
	     */
	    BootstrapDialog.success = function (message, callback) {
	        return new BootstrapDialog({
	            type: BootstrapDialog.TYPE_SUCCESS,
	            message: message
	        }).open();
	    };
	
	    return BootstrapDialog;
	
	}));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
	 * typeahead.js 1.3.1
	 * https://github.com/corejavascript/typeahead.js
	 * Copyright 2013-2020 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return root["Bloodhound"] = factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(require("jquery"));
	    } else {
	        root["Bloodhound"] = factory(root["jQuery"]);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            guid: function() {
	                function _p8(s) {
	                    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
	                    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
	                }
	                return "tt-" + _p8() + _p8(true) + _p8(true) + _p8();
	            },
	            noop: function() {}
	        };
	    }();
	    var VERSION = "1.3.1";
	    var tokenizers = function() {
	        "use strict";
	        return {
	            nonword: nonword,
	            whitespace: whitespace,
	            ngram: ngram,
	            obj: {
	                nonword: getObjTokenizer(nonword),
	                whitespace: getObjTokenizer(whitespace),
	                ngram: getObjTokenizer(ngram)
	            }
	        };
	        function whitespace(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\s+/) : [];
	        }
	        function nonword(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\W+/) : [];
	        }
	        function ngram(str) {
	            str = _.toStr(str);
	            var tokens = [], word = "";
	            _.each(str.split(""), function(char) {
	                if (char.match(/\s+/)) {
	                    word = "";
	                } else {
	                    tokens.push(word + char);
	                    word += char;
	                }
	            });
	            return tokens;
	        }
	        function getObjTokenizer(tokenizer) {
	            return function setKey(keys) {
	                keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
	                return function tokenize(o) {
	                    var tokens = [];
	                    _.each(keys, function(k) {
	                        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
	                    });
	                    return tokens;
	                };
	            };
	        }
	    }();
	    var LruCache = function() {
	        "use strict";
	        function LruCache(maxSize) {
	            this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
	            this.reset();
	            if (this.maxSize <= 0) {
	                this.set = this.get = $.noop;
	            }
	        }
	        _.mixin(LruCache.prototype, {
	            set: function set(key, val) {
	                var tailItem = this.list.tail, node;
	                if (this.size >= this.maxSize) {
	                    this.list.remove(tailItem);
	                    delete this.hash[tailItem.key];
	                    this.size--;
	                }
	                if (node = this.hash[key]) {
	                    node.val = val;
	                    this.list.moveToFront(node);
	                } else {
	                    node = new Node(key, val);
	                    this.list.add(node);
	                    this.hash[key] = node;
	                    this.size++;
	                }
	            },
	            get: function get(key) {
	                var node = this.hash[key];
	                if (node) {
	                    this.list.moveToFront(node);
	                    return node.val;
	                }
	            },
	            reset: function reset() {
	                this.size = 0;
	                this.hash = {};
	                this.list = new List();
	            }
	        });
	        function List() {
	            this.head = this.tail = null;
	        }
	        _.mixin(List.prototype, {
	            add: function add(node) {
	                if (this.head) {
	                    node.next = this.head;
	                    this.head.prev = node;
	                }
	                this.head = node;
	                this.tail = this.tail || node;
	            },
	            remove: function remove(node) {
	                node.prev ? node.prev.next = node.next : this.head = node.next;
	                node.next ? node.next.prev = node.prev : this.tail = node.prev;
	            },
	            moveToFront: function(node) {
	                this.remove(node);
	                this.add(node);
	            }
	        });
	        function Node(key, val) {
	            this.key = key;
	            this.val = val;
	            this.prev = this.next = null;
	        }
	        return LruCache;
	    }();
	    var PersistentStorage = function() {
	        "use strict";
	        var LOCAL_STORAGE;
	        try {
	            LOCAL_STORAGE = window.localStorage;
	            LOCAL_STORAGE.setItem("~~~", "!");
	            LOCAL_STORAGE.removeItem("~~~");
	        } catch (err) {
	            LOCAL_STORAGE = null;
	        }
	        function PersistentStorage(namespace, override) {
	            this.prefix = [ "__", namespace, "__" ].join("");
	            this.ttlKey = "__ttl__";
	            this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
	            this.ls = override || LOCAL_STORAGE;
	            !this.ls && this._noop();
	        }
	        _.mixin(PersistentStorage.prototype, {
	            _prefix: function(key) {
	                return this.prefix + key;
	            },
	            _ttlKey: function(key) {
	                return this._prefix(key) + this.ttlKey;
	            },
	            _noop: function() {
	                this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
	            },
	            _safeSet: function(key, val) {
	                try {
	                    this.ls.setItem(key, val);
	                } catch (err) {
	                    if (err.name === "QuotaExceededError") {
	                        this.clear();
	                        this._noop();
	                    }
	                }
	            },
	            get: function(key) {
	                if (this.isExpired(key)) {
	                    this.remove(key);
	                }
	                return decode(this.ls.getItem(this._prefix(key)));
	            },
	            set: function(key, val, ttl) {
	                if (_.isNumber(ttl)) {
	                    this._safeSet(this._ttlKey(key), encode(now() + ttl));
	                } else {
	                    this.ls.removeItem(this._ttlKey(key));
	                }
	                return this._safeSet(this._prefix(key), encode(val));
	            },
	            remove: function(key) {
	                this.ls.removeItem(this._ttlKey(key));
	                this.ls.removeItem(this._prefix(key));
	                return this;
	            },
	            clear: function() {
	                var i, keys = gatherMatchingKeys(this.keyMatcher);
	                for (i = keys.length; i--; ) {
	                    this.remove(keys[i]);
	                }
	                return this;
	            },
	            isExpired: function(key) {
	                var ttl = decode(this.ls.getItem(this._ttlKey(key)));
	                return _.isNumber(ttl) && now() > ttl ? true : false;
	            }
	        });
	        return PersistentStorage;
	        function now() {
	            return new Date().getTime();
	        }
	        function encode(val) {
	            return JSON.stringify(_.isUndefined(val) ? null : val);
	        }
	        function decode(val) {
	            return $.parseJSON(val);
	        }
	        function gatherMatchingKeys(keyMatcher) {
	            var i, key, keys = [], len = LOCAL_STORAGE.length;
	            for (i = 0; i < len; i++) {
	                if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
	                    keys.push(key.replace(keyMatcher, ""));
	                }
	            }
	            return keys;
	        }
	    }();
	    var Transport = function() {
	        "use strict";
	        var pendingRequestsCount = 0, pendingRequests = {}, sharedCache = new LruCache(10);
	        function Transport(o) {
	            o = o || {};
	            this.maxPendingRequests = o.maxPendingRequests || 6;
	            this.cancelled = false;
	            this.lastReq = null;
	            this._send = o.transport;
	            this._get = o.limiter ? o.limiter(this._get) : this._get;
	            this._cache = o.cache === false ? new LruCache(0) : sharedCache;
	        }
	        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
	            this.maxPendingRequests = num;
	        };
	        Transport.resetCache = function resetCache() {
	            sharedCache.reset();
	        };
	        _.mixin(Transport.prototype, {
	            _fingerprint: function fingerprint(o) {
	                o = o || {};
	                return o.url + o.type + $.param(o.data || {});
	            },
	            _get: function(o, cb) {
	                var that = this, fingerprint, jqXhr;
	                fingerprint = this._fingerprint(o);
	                if (this.cancelled || fingerprint !== this.lastReq) {
	                    return;
	                }
	                if (jqXhr = pendingRequests[fingerprint]) {
	                    jqXhr.done(done).fail(fail);
	                } else if (pendingRequestsCount < this.maxPendingRequests) {
	                    pendingRequestsCount++;
	                    pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
	                } else {
	                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
	                }
	                function done(resp) {
	                    cb(null, resp);
	                    that._cache.set(fingerprint, resp);
	                }
	                function fail() {
	                    cb(true);
	                }
	                function always() {
	                    pendingRequestsCount--;
	                    delete pendingRequests[fingerprint];
	                    if (that.onDeckRequestArgs) {
	                        that._get.apply(that, that.onDeckRequestArgs);
	                        that.onDeckRequestArgs = null;
	                    }
	                }
	            },
	            get: function(o, cb) {
	                var resp, fingerprint;
	                cb = cb || $.noop;
	                o = _.isString(o) ? {
	                    url: o
	                } : o || {};
	                fingerprint = this._fingerprint(o);
	                this.cancelled = false;
	                this.lastReq = fingerprint;
	                if (resp = this._cache.get(fingerprint)) {
	                    cb(null, resp);
	                } else {
	                    this._get(o, cb);
	                }
	            },
	            cancel: function() {
	                this.cancelled = true;
	            }
	        });
	        return Transport;
	    }();
	    var SearchIndex = window.SearchIndex = function() {
	        "use strict";
	        var CHILDREN = "c", IDS = "i";
	        function SearchIndex(o) {
	            o = o || {};
	            if (!o.datumTokenizer || !o.queryTokenizer) {
	                $.error("datumTokenizer and queryTokenizer are both required");
	            }
	            this.identify = o.identify || _.stringify;
	            this.datumTokenizer = o.datumTokenizer;
	            this.queryTokenizer = o.queryTokenizer;
	            this.matchAnyQueryToken = o.matchAnyQueryToken;
	            this.reset();
	        }
	        _.mixin(SearchIndex.prototype, {
	            bootstrap: function bootstrap(o) {
	                this.datums = o.datums;
	                this.trie = o.trie;
	            },
	            add: function(data) {
	                var that = this;
	                data = _.isArray(data) ? data : [ data ];
	                _.each(data, function(datum) {
	                    var id, tokens;
	                    that.datums[id = that.identify(datum)] = datum;
	                    tokens = normalizeTokens(that.datumTokenizer(datum));
	                    _.each(tokens, function(token) {
	                        var node, chars, ch;
	                        node = that.trie;
	                        chars = token.split("");
	                        while (ch = chars.shift()) {
	                            node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
	                            node[IDS].push(id);
	                        }
	                    });
	                });
	            },
	            get: function get(ids) {
	                var that = this;
	                return _.map(ids, function(id) {
	                    return that.datums[id];
	                });
	            },
	            search: function search(query) {
	                var that = this, tokens, matches;
	                tokens = normalizeTokens(this.queryTokenizer(query));
	                _.each(tokens, function(token) {
	                    var node, chars, ch, ids;
	                    if (matches && matches.length === 0 && !that.matchAnyQueryToken) {
	                        return false;
	                    }
	                    node = that.trie;
	                    chars = token.split("");
	                    while (node && (ch = chars.shift())) {
	                        node = node[CHILDREN][ch];
	                    }
	                    if (node && chars.length === 0) {
	                        ids = node[IDS].slice(0);
	                        matches = matches ? getIntersection(matches, ids) : ids;
	                    } else {
	                        if (!that.matchAnyQueryToken) {
	                            matches = [];
	                            return false;
	                        }
	                    }
	                });
	                return matches ? _.map(unique(matches), function(id) {
	                    return that.datums[id];
	                }) : [];
	            },
	            all: function all() {
	                var values = [];
	                for (var key in this.datums) {
	                    values.push(this.datums[key]);
	                }
	                return values;
	            },
	            reset: function reset() {
	                this.datums = {};
	                this.trie = newNode();
	            },
	            serialize: function serialize() {
	                return {
	                    datums: this.datums,
	                    trie: this.trie
	                };
	            }
	        });
	        return SearchIndex;
	        function normalizeTokens(tokens) {
	            tokens = _.filter(tokens, function(token) {
	                return !!token;
	            });
	            tokens = _.map(tokens, function(token) {
	                return token.toLowerCase();
	            });
	            return tokens;
	        }
	        function newNode() {
	            var node = {};
	            node[IDS] = [];
	            node[CHILDREN] = {};
	            return node;
	        }
	        function unique(array) {
	            var seen = {}, uniques = [];
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (!seen[array[i]]) {
	                    seen[array[i]] = true;
	                    uniques.push(array[i]);
	                }
	            }
	            return uniques;
	        }
	        function getIntersection(arrayA, arrayB) {
	            var ai = 0, bi = 0, intersection = [];
	            arrayA = arrayA.sort();
	            arrayB = arrayB.sort();
	            var lenArrayA = arrayA.length, lenArrayB = arrayB.length;
	            while (ai < lenArrayA && bi < lenArrayB) {
	                if (arrayA[ai] < arrayB[bi]) {
	                    ai++;
	                } else if (arrayA[ai] > arrayB[bi]) {
	                    bi++;
	                } else {
	                    intersection.push(arrayA[ai]);
	                    ai++;
	                    bi++;
	                }
	            }
	            return intersection;
	        }
	    }();
	    var Prefetch = function() {
	        "use strict";
	        var keys;
	        keys = {
	            data: "data",
	            protocol: "protocol",
	            thumbprint: "thumbprint"
	        };
	        function Prefetch(o) {
	            this.url = o.url;
	            this.ttl = o.ttl;
	            this.cache = o.cache;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = o.transport;
	            this.thumbprint = o.thumbprint;
	            this.storage = new PersistentStorage(o.cacheKey);
	        }
	        _.mixin(Prefetch.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            store: function store(data) {
	                if (!this.cache) {
	                    return;
	                }
	                this.storage.set(keys.data, data, this.ttl);
	                this.storage.set(keys.protocol, location.protocol, this.ttl);
	                this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
	            },
	            fromCache: function fromCache() {
	                var stored = {}, isExpired;
	                if (!this.cache) {
	                    return null;
	                }
	                stored.data = this.storage.get(keys.data);
	                stored.protocol = this.storage.get(keys.protocol);
	                stored.thumbprint = this.storage.get(keys.thumbprint);
	                isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
	                return stored.data && !isExpired ? stored.data : null;
	            },
	            fromNetwork: function(cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                settings = this.prepare(this._settings());
	                this.transport(settings).fail(onError).done(onResponse);
	                function onError() {
	                    cb(true);
	                }
	                function onResponse(resp) {
	                    cb(null, that.transform(resp));
	                }
	            },
	            clear: function clear() {
	                this.storage.clear();
	                return this;
	            }
	        });
	        return Prefetch;
	    }();
	    var Remote = function() {
	        "use strict";
	        function Remote(o) {
	            this.url = o.url;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.indexResponse = o.indexResponse;
	            this.transport = new Transport({
	                cache: o.cache,
	                limiter: o.limiter,
	                transport: o.transport,
	                maxPendingRequests: o.maxPendingRequests
	            });
	        }
	        _.mixin(Remote.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            get: function get(query, cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                query = query || "";
	                settings = this.prepare(query, this._settings());
	                return this.transport.get(settings, onResponse);
	                function onResponse(err, resp) {
	                    err ? cb([]) : cb(that.transform(resp));
	                }
	            },
	            cancelLastRequest: function cancelLastRequest() {
	                this.transport.cancel();
	            }
	        });
	        return Remote;
	    }();
	    var oParser = function() {
	        "use strict";
	        return function parse(o) {
	            var defaults, sorter;
	            defaults = {
	                initialize: true,
	                identify: _.stringify,
	                datumTokenizer: null,
	                queryTokenizer: null,
	                matchAnyQueryToken: false,
	                sufficient: 5,
	                indexRemote: false,
	                sorter: null,
	                local: [],
	                prefetch: null,
	                remote: null
	            };
	            o = _.mixin(defaults, o || {});
	            !o.datumTokenizer && $.error("datumTokenizer is required");
	            !o.queryTokenizer && $.error("queryTokenizer is required");
	            sorter = o.sorter;
	            o.sorter = sorter ? function(x) {
	                return x.sort(sorter);
	            } : _.identity;
	            o.local = _.isFunction(o.local) ? o.local() : o.local;
	            o.prefetch = parsePrefetch(o.prefetch);
	            o.remote = parseRemote(o.remote);
	            return o;
	        };
	        function parsePrefetch(o) {
	            var defaults;
	            if (!o) {
	                return null;
	            }
	            defaults = {
	                url: null,
	                ttl: 24 * 60 * 60 * 1e3,
	                cache: true,
	                cacheKey: null,
	                thumbprint: "",
	                prepare: _.identity,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("prefetch requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.cacheKey = o.cacheKey || o.url;
	            o.thumbprint = VERSION + o.thumbprint;
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            return o;
	        }
	        function parseRemote(o) {
	            var defaults;
	            if (!o) {
	                return;
	            }
	            defaults = {
	                url: null,
	                cache: true,
	                prepare: null,
	                replace: null,
	                wildcard: null,
	                limiter: null,
	                rateLimitBy: "debounce",
	                rateLimitWait: 300,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("remote requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.prepare = toRemotePrepare(o);
	            o.limiter = toLimiter(o);
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            delete o.replace;
	            delete o.wildcard;
	            delete o.rateLimitBy;
	            delete o.rateLimitWait;
	            return o;
	        }
	        function toRemotePrepare(o) {
	            var prepare, replace, wildcard;
	            prepare = o.prepare;
	            replace = o.replace;
	            wildcard = o.wildcard;
	            if (prepare) {
	                return prepare;
	            }
	            if (replace) {
	                prepare = prepareByReplace;
	            } else if (o.wildcard) {
	                prepare = prepareByWildcard;
	            } else {
	                prepare = identityPrepare;
	            }
	            return prepare;
	            function prepareByReplace(query, settings) {
	                settings.url = replace(settings.url, query);
	                return settings;
	            }
	            function prepareByWildcard(query, settings) {
	                settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
	                return settings;
	            }
	            function identityPrepare(query, settings) {
	                return settings;
	            }
	        }
	        function toLimiter(o) {
	            var limiter, method, wait;
	            limiter = o.limiter;
	            method = o.rateLimitBy;
	            wait = o.rateLimitWait;
	            if (!limiter) {
	                limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
	            }
	            return limiter;
	            function debounce(wait) {
	                return function debounce(fn) {
	                    return _.debounce(fn, wait);
	                };
	            }
	            function throttle(wait) {
	                return function throttle(fn) {
	                    return _.throttle(fn, wait);
	                };
	            }
	        }
	        function callbackToDeferred(fn) {
	            return function wrapper(o) {
	                var deferred = $.Deferred();
	                fn(o, onSuccess, onError);
	                return deferred;
	                function onSuccess(resp) {
	                    _.defer(function() {
	                        deferred.resolve(resp);
	                    });
	                }
	                function onError(err) {
	                    _.defer(function() {
	                        deferred.reject(err);
	                    });
	                }
	            };
	        }
	    }();
	    var Bloodhound = function() {
	        "use strict";
	        var old;
	        old = window && window.Bloodhound;
	        function Bloodhound(o) {
	            o = oParser(o);
	            this.sorter = o.sorter;
	            this.identify = o.identify;
	            this.sufficient = o.sufficient;
	            this.indexRemote = o.indexRemote;
	            this.local = o.local;
	            this.remote = o.remote ? new Remote(o.remote) : null;
	            this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
	            this.index = new SearchIndex({
	                identify: this.identify,
	                datumTokenizer: o.datumTokenizer,
	                queryTokenizer: o.queryTokenizer
	            });
	            o.initialize !== false && this.initialize();
	        }
	        Bloodhound.noConflict = function noConflict() {
	            window && (window.Bloodhound = old);
	            return Bloodhound;
	        };
	        Bloodhound.tokenizers = tokenizers;
	        _.mixin(Bloodhound.prototype, {
	            __ttAdapter: function ttAdapter() {
	                var that = this;
	                return this.remote ? withAsync : withoutAsync;
	                function withAsync(query, sync, async) {
	                    return that.search(query, sync, async);
	                }
	                function withoutAsync(query, sync) {
	                    return that.search(query, sync);
	                }
	            },
	            _loadPrefetch: function loadPrefetch() {
	                var that = this, deferred, serialized;
	                deferred = $.Deferred();
	                if (!this.prefetch) {
	                    deferred.resolve();
	                } else if (serialized = this.prefetch.fromCache()) {
	                    this.index.bootstrap(serialized);
	                    deferred.resolve();
	                } else {
	                    this.prefetch.fromNetwork(done);
	                }
	                return deferred.promise();
	                function done(err, data) {
	                    if (err) {
	                        return deferred.reject();
	                    }
	                    that.add(data);
	                    that.prefetch.store(that.index.serialize());
	                    deferred.resolve();
	                }
	            },
	            _initialize: function initialize() {
	                var that = this, deferred;
	                this.clear();
	                (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
	                return this.initPromise;
	                function addLocalToIndex() {
	                    that.add(that.local);
	                }
	            },
	            initialize: function initialize(force) {
	                return !this.initPromise || force ? this._initialize() : this.initPromise;
	            },
	            add: function add(data) {
	                this.index.add(data);
	                return this;
	            },
	            get: function get(ids) {
	                ids = _.isArray(ids) ? ids : [].slice.call(arguments);
	                return this.index.get(ids);
	            },
	            search: function search(query, sync, async) {
	                var that = this, local;
	                sync = sync || _.noop;
	                async = async || _.noop;
	                local = this.sorter(this.index.search(query));
	                sync(this.remote ? local.slice() : local);
	                if (this.remote && local.length < this.sufficient) {
	                    this.remote.get(query, processRemote);
	                } else if (this.remote) {
	                    this.remote.cancelLastRequest();
	                }
	                return this;
	                function processRemote(remote) {
	                    var nonDuplicates = [];
	                    _.each(remote, function(r) {
	                        !_.some(local, function(l) {
	                            return that.identify(r) === that.identify(l);
	                        }) && nonDuplicates.push(r);
	                    });
	                    that.indexRemote && that.add(nonDuplicates);
	                    async(nonDuplicates);
	                }
	            },
	            all: function all() {
	                return this.index.all();
	            },
	            clear: function clear() {
	                this.index.reset();
	                return this;
	            },
	            clearPrefetchCache: function clearPrefetchCache() {
	                this.prefetch && this.prefetch.clear();
	                return this;
	            },
	            clearRemoteCache: function clearRemoteCache() {
	                Transport.resetCache();
	                return this;
	            },
	            ttAdapter: function ttAdapter() {
	                return this.__ttAdapter();
	            }
	        });
	        return Bloodhound;
	    }();
	    return Bloodhound;
	});
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(require("jquery"));
	    } else {
	        factory(root["jQuery"]);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            guid: function() {
	                function _p8(s) {
	                    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
	                    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
	                }
	                return "tt-" + _p8() + _p8(true) + _p8(true) + _p8();
	            },
	            noop: function() {}
	        };
	    }();
	    var WWW = function() {
	        "use strict";
	        var defaultClassNames = {
	            wrapper: "twitter-typeahead",
	            input: "tt-input",
	            hint: "tt-hint",
	            menu: "tt-menu",
	            dataset: "tt-dataset",
	            suggestion: "tt-suggestion",
	            selectable: "tt-selectable",
	            empty: "tt-empty",
	            open: "tt-open",
	            cursor: "tt-cursor",
	            highlight: "tt-highlight"
	        };
	        return build;
	        function build(o) {
	            var www, classes;
	            classes = _.mixin({}, defaultClassNames, o);
	            www = {
	                css: buildCss(),
	                classes: classes,
	                html: buildHtml(classes),
	                selectors: buildSelectors(classes)
	            };
	            return {
	                css: www.css,
	                html: www.html,
	                classes: www.classes,
	                selectors: www.selectors,
	                mixin: function(o) {
	                    _.mixin(o, www);
	                }
	            };
	        }
	        function buildHtml(c) {
	            return {
	                wrapper: '<span class="' + c.wrapper + '"></span>',
	                menu: '<div role="listbox" class="' + c.menu + '"></div>'
	            };
	        }
	        function buildSelectors(classes) {
	            var selectors = {};
	            _.each(classes, function(v, k) {
	                selectors[k] = "." + v;
	            });
	            return selectors;
	        }
	        function buildCss() {
	            var css = {
	                wrapper: {
	                    position: "relative",
	                    display: "inline-block"
	                },
	                hint: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    borderColor: "transparent",
	                    boxShadow: "none",
	                    opacity: "1"
	                },
	                input: {
	                    position: "relative",
	                    verticalAlign: "top",
	                    backgroundColor: "transparent"
	                },
	                inputWithNoHint: {
	                    position: "relative",
	                    verticalAlign: "top"
	                },
	                menu: {
	                    position: "absolute",
	                    top: "100%",
	                    left: "0",
	                    zIndex: "100",
	                    display: "none"
	                },
	                ltr: {
	                    left: "0",
	                    right: "auto"
	                },
	                rtl: {
	                    left: "auto",
	                    right: " 0"
	                }
	            };
	            if (_.isMsie()) {
	                _.mixin(css.input, {
	                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
	                });
	            }
	            return css;
	        }
	    }();
	    var EventBus = function() {
	        "use strict";
	        var namespace, deprecationMap;
	        namespace = "typeahead:";
	        deprecationMap = {
	            render: "rendered",
	            cursorchange: "cursorchanged",
	            select: "selected",
	            autocomplete: "autocompleted"
	        };
	        function EventBus(o) {
	            if (!o || !o.el) {
	                $.error("EventBus initialized without el");
	            }
	            this.$el = $(o.el);
	        }
	        _.mixin(EventBus.prototype, {
	            _trigger: function(type, args) {
	                var $e = $.Event(namespace + type);
	                this.$el.trigger.call(this.$el, $e, args || []);
	                return $e;
	            },
	            before: function(type) {
	                var args, $e;
	                args = [].slice.call(arguments, 1);
	                $e = this._trigger("before" + type, args);
	                return $e.isDefaultPrevented();
	            },
	            trigger: function(type) {
	                var deprecatedType;
	                this._trigger(type, [].slice.call(arguments, 1));
	                if (deprecatedType = deprecationMap[type]) {
	                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
	                }
	            }
	        });
	        return EventBus;
	    }();
	    var EventEmitter = function() {
	        "use strict";
	        var splitter = /\s+/, nextTick = getNextTick();
	        return {
	            onSync: onSync,
	            onAsync: onAsync,
	            off: off,
	            trigger: trigger
	        };
	        function on(method, types, cb, context) {
	            var type;
	            if (!cb) {
	                return this;
	            }
	            types = types.split(splitter);
	            cb = context ? bindContext(cb, context) : cb;
	            this._callbacks = this._callbacks || {};
	            while (type = types.shift()) {
	                this._callbacks[type] = this._callbacks[type] || {
	                    sync: [],
	                    async: []
	                };
	                this._callbacks[type][method].push(cb);
	            }
	            return this;
	        }
	        function onAsync(types, cb, context) {
	            return on.call(this, "async", types, cb, context);
	        }
	        function onSync(types, cb, context) {
	            return on.call(this, "sync", types, cb, context);
	        }
	        function off(types) {
	            var type;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            while (type = types.shift()) {
	                delete this._callbacks[type];
	            }
	            return this;
	        }
	        function trigger(types) {
	            var type, callbacks, args, syncFlush, asyncFlush;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            args = [].slice.call(arguments, 1);
	            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
	                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
	                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
	                syncFlush() && nextTick(asyncFlush);
	            }
	            return this;
	        }
	        function getFlush(callbacks, context, args) {
	            return flush;
	            function flush() {
	                var cancelled;
	                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
	                    cancelled = callbacks[i].apply(context, args) === false;
	                }
	                return !cancelled;
	            }
	        }
	        function getNextTick() {
	            var nextTickFn;
	            if (window.setImmediate) {
	                nextTickFn = function nextTickSetImmediate(fn) {
	                    setImmediate(function() {
	                        fn();
	                    });
	                };
	            } else {
	                nextTickFn = function nextTickSetTimeout(fn) {
	                    setTimeout(function() {
	                        fn();
	                    }, 0);
	                };
	            }
	            return nextTickFn;
	        }
	        function bindContext(fn, context) {
	            return fn.bind ? fn.bind(context) : function() {
	                fn.apply(context, [].slice.call(arguments, 0));
	            };
	        }
	    }();
	    var highlight = function(doc) {
	        "use strict";
	        var defaults = {
	            node: null,
	            pattern: null,
	            tagName: "strong",
	            className: null,
	            wordsOnly: false,
	            caseSensitive: false,
	            diacriticInsensitive: false
	        };
	        var accented = {
	            A: "[AaªÀ-Åà-åĀ-ąǍǎȀ-ȃȦȧᴬᵃḀḁẚẠ-ảₐ℀℁℻⒜Ⓐⓐ㍱-㍴㎀-㎄㎈㎉㎩-㎯㏂㏊㏟㏿Ａａ]",
	            B: "[BbᴮᵇḂ-ḇℬ⒝Ⓑⓑ㍴㎅-㎇㏃㏈㏔㏝Ｂｂ]",
	            C: "[CcÇçĆ-čᶜ℀ℂ℃℅℆ℭⅭⅽ⒞Ⓒⓒ㍶㎈㎉㎝㎠㎤㏄-㏇Ｃｃ]",
	            D: "[DdĎďǄ-ǆǱ-ǳᴰᵈḊ-ḓⅅⅆⅮⅾ⒟Ⓓⓓ㋏㍲㍷-㍹㎗㎭-㎯㏅㏈Ｄｄ]",
	            E: "[EeÈ-Ëè-ëĒ-ěȄ-ȇȨȩᴱᵉḘ-ḛẸ-ẽₑ℡ℯℰⅇ⒠Ⓔⓔ㉐㋍㋎Ｅｅ]",
	            F: "[FfᶠḞḟ℉ℱ℻⒡Ⓕⓕ㎊-㎌㎙ﬀ-ﬄＦｆ]",
	            G: "[GgĜ-ģǦǧǴǵᴳᵍḠḡℊ⒢Ⓖⓖ㋌㋍㎇㎍-㎏㎓㎬㏆㏉㏒㏿Ｇｇ]",
	            H: "[HhĤĥȞȟʰᴴḢ-ḫẖℋ-ℎ⒣Ⓗⓗ㋌㍱㎐-㎔㏊㏋㏗Ｈｈ]",
	            I: "[IiÌ-Ïì-ïĨ-İĲĳǏǐȈ-ȋᴵᵢḬḭỈ-ịⁱℐℑℹⅈⅠ-ⅣⅥ-ⅨⅪⅫⅰ-ⅳⅵ-ⅸⅺⅻ⒤Ⓘⓘ㍺㏌㏕ﬁﬃＩｉ]",
	            J: "[JjĲ-ĵǇ-ǌǰʲᴶⅉ⒥ⒿⓙⱼＪｊ]",
	            K: "[KkĶķǨǩᴷᵏḰ-ḵK⒦Ⓚⓚ㎄㎅㎉㎏㎑㎘㎞㎢㎦㎪㎸㎾㏀㏆㏍-㏏Ｋｋ]",
	            L: "[LlĹ-ŀǇ-ǉˡᴸḶḷḺ-ḽℒℓ℡Ⅼⅼ⒧Ⓛⓛ㋏㎈㎉㏐-㏓㏕㏖㏿ﬂﬄＬｌ]",
	            M: "[MmᴹᵐḾ-ṃ℠™ℳⅯⅿ⒨Ⓜⓜ㍷-㍹㎃㎆㎎㎒㎖㎙-㎨㎫㎳㎷㎹㎽㎿㏁㏂㏎㏐㏔-㏖㏘㏙㏞㏟Ｍｍ]",
	            N: "[NnÑñŃ-ŉǊ-ǌǸǹᴺṄ-ṋⁿℕ№⒩Ⓝⓝ㎁㎋㎚㎱㎵㎻㏌㏑Ｎｎ]",
	            O: "[OoºÒ-Öò-öŌ-őƠơǑǒǪǫȌ-ȏȮȯᴼᵒỌ-ỏₒ℅№ℴ⒪Ⓞⓞ㍵㏇㏒㏖Ｏｏ]",
	            P: "[PpᴾᵖṔ-ṗℙ⒫Ⓟⓟ㉐㍱㍶㎀㎊㎩-㎬㎰㎴㎺㏋㏗-㏚Ｐｐ]",
	            Q: "[Qqℚ⒬Ⓠⓠ㏃Ｑｑ]",
	            R: "[RrŔ-řȐ-ȓʳᴿᵣṘ-ṛṞṟ₨ℛ-ℝ⒭Ⓡⓡ㋍㍴㎭-㎯㏚㏛Ｒｒ]",
	            S: "[SsŚ-šſȘșˢṠ-ṣ₨℁℠⒮Ⓢⓢ㎧㎨㎮-㎳㏛㏜ﬆＳｓ]",
	            T: "[TtŢ-ťȚțᵀᵗṪ-ṱẗ℡™⒯Ⓣⓣ㉐㋏㎔㏏ﬅﬆＴｔ]",
	            U: "[UuÙ-Üù-üŨ-ųƯưǓǔȔ-ȗᵁᵘᵤṲ-ṷỤ-ủ℆⒰Ⓤⓤ㍳㍺Ｕｕ]",
	            V: "[VvᵛᵥṼ-ṿⅣ-Ⅷⅳ-ⅷ⒱Ⓥⓥⱽ㋎㍵㎴-㎹㏜㏞Ｖｖ]",
	            W: "[WwŴŵʷᵂẀ-ẉẘ⒲Ⓦⓦ㎺-㎿㏝Ｗｗ]",
	            X: "[XxˣẊ-ẍₓ℻Ⅸ-Ⅻⅸ-ⅻ⒳Ⓧⓧ㏓Ｘｘ]",
	            Y: "[YyÝýÿŶ-ŸȲȳʸẎẏẙỲ-ỹ⒴Ⓨⓨ㏉Ｙｙ]",
	            Z: "[ZzŹ-žǱ-ǳᶻẐ-ẕℤℨ⒵Ⓩⓩ㎐-㎔Ｚｚ]"
	        };
	        return function hightlight(o) {
	            var regex;
	            o = _.mixin({}, defaults, o);
	            if (!o.node || !o.pattern) {
	                return;
	            }
	            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
	            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly, o.diacriticInsensitive);
	            traverse(o.node, hightlightTextNode);
	            function hightlightTextNode(textNode) {
	                var match, patternNode, wrapperNode;
	                if (match = regex.exec(textNode.data)) {
	                    wrapperNode = doc.createElement(o.tagName);
	                    o.className && (wrapperNode.className = o.className);
	                    patternNode = textNode.splitText(match.index);
	                    patternNode.splitText(match[0].length);
	                    wrapperNode.appendChild(patternNode.cloneNode(true));
	                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
	                }
	                return !!match;
	            }
	            function traverse(el, hightlightTextNode) {
	                var childNode, TEXT_NODE_TYPE = 3;
	                for (var i = 0; i < el.childNodes.length; i++) {
	                    childNode = el.childNodes[i];
	                    if (childNode.nodeType === TEXT_NODE_TYPE) {
	                        i += hightlightTextNode(childNode) ? 1 : 0;
	                    } else {
	                        traverse(childNode, hightlightTextNode);
	                    }
	                }
	            }
	        };
	        function accent_replacer(chr) {
	            return accented[chr.toUpperCase()] || chr;
	        }
	        function getRegex(patterns, caseSensitive, wordsOnly, diacriticInsensitive) {
	            var escapedPatterns = [], regexStr;
	            for (var i = 0, len = patterns.length; i < len; i++) {
	                var escapedWord = _.escapeRegExChars(patterns[i]);
	                if (diacriticInsensitive) {
	                    escapedWord = escapedWord.replace(/\S/g, accent_replacer);
	                }
	                escapedPatterns.push(escapedWord);
	            }
	            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
	            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
	        }
	    }(window.document);
	    var Input = function() {
	        "use strict";
	        var specialKeyCodeMap;
	        specialKeyCodeMap = {
	            9: "tab",
	            27: "esc",
	            37: "left",
	            39: "right",
	            13: "enter",
	            38: "up",
	            40: "down"
	        };
	        function Input(o, www) {
	            var id;
	            o = o || {};
	            if (!o.input) {
	                $.error("input is missing");
	            }
	            www.mixin(this);
	            this.$hint = $(o.hint);
	            this.$input = $(o.input);
	            this.$menu = $(o.menu);
	            id = this.$input.attr("id") || _.guid();
	            this.$menu.attr("id", id + "_listbox");
	            this.$hint.attr({
	                "aria-hidden": true
	            });
	            this.$input.attr({
	                "aria-owns": id + "_listbox",
	                role: "combobox",
	                "aria-autocomplete": "list",
	                "aria-expanded": false
	            });
	            this.query = this.$input.val();
	            this.queryWhenFocused = this.hasFocus() ? this.query : null;
	            this.$overflowHelper = buildOverflowHelper(this.$input);
	            this._checkLanguageDirection();
	            if (this.$hint.length === 0) {
	                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
	            }
	            this.onSync("cursorchange", this._updateDescendent);
	        }
	        Input.normalizeQuery = function(str) {
	            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
	        };
	        _.mixin(Input.prototype, EventEmitter, {
	            _onBlur: function onBlur() {
	                this.resetInputValue();
	                this.trigger("blurred");
	            },
	            _onFocus: function onFocus() {
	                this.queryWhenFocused = this.query;
	                this.trigger("focused");
	            },
	            _onKeydown: function onKeydown($e) {
	                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
	                this._managePreventDefault(keyName, $e);
	                if (keyName && this._shouldTrigger(keyName, $e)) {
	                    this.trigger(keyName + "Keyed", $e);
	                }
	            },
	            _onInput: function onInput() {
	                this._setQuery(this.getInputValue());
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            _managePreventDefault: function managePreventDefault(keyName, $e) {
	                var preventDefault;
	                switch (keyName) {
	                  case "up":
	                  case "down":
	                    preventDefault = !withModifier($e);
	                    break;
	
	                  default:
	                    preventDefault = false;
	                }
	                preventDefault && $e.preventDefault();
	            },
	            _shouldTrigger: function shouldTrigger(keyName, $e) {
	                var trigger;
	                switch (keyName) {
	                  case "tab":
	                    trigger = !withModifier($e);
	                    break;
	
	                  default:
	                    trigger = true;
	                }
	                return trigger;
	            },
	            _checkLanguageDirection: function checkLanguageDirection() {
	                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.$hint.attr("dir", dir);
	                    this.trigger("langDirChanged", dir);
	                }
	            },
	            _setQuery: function setQuery(val, silent) {
	                var areEquivalent, hasDifferentWhitespace;
	                areEquivalent = areQueriesEquivalent(val, this.query);
	                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
	                this.query = val;
	                if (!silent && !areEquivalent) {
	                    this.trigger("queryChanged", this.query);
	                } else if (!silent && hasDifferentWhitespace) {
	                    this.trigger("whitespaceChanged", this.query);
	                }
	            },
	            _updateDescendent: function updateDescendent(event, id) {
	                this.$input.attr("aria-activedescendant", id);
	            },
	            bind: function() {
	                var that = this, onBlur, onFocus, onKeydown, onInput;
	                onBlur = _.bind(this._onBlur, this);
	                onFocus = _.bind(this._onFocus, this);
	                onKeydown = _.bind(this._onKeydown, this);
	                onInput = _.bind(this._onInput, this);
	                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
	                if (!_.isMsie() || _.isMsie() > 9) {
	                    this.$input.on("input.tt", onInput);
	                } else {
	                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
	                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
	                            return;
	                        }
	                        _.defer(_.bind(that._onInput, that, $e));
	                    });
	                }
	                return this;
	            },
	            focus: function focus() {
	                this.$input.focus();
	            },
	            blur: function blur() {
	                this.$input.blur();
	            },
	            getLangDir: function getLangDir() {
	                return this.dir;
	            },
	            getQuery: function getQuery() {
	                return this.query || "";
	            },
	            setQuery: function setQuery(val, silent) {
	                this.setInputValue(val);
	                this._setQuery(val, silent);
	            },
	            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
	                return this.query !== this.queryWhenFocused;
	            },
	            getInputValue: function getInputValue() {
	                return this.$input.val();
	            },
	            setInputValue: function setInputValue(value) {
	                this.$input.val(value);
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            resetInputValue: function resetInputValue() {
	                this.setInputValue(this.query);
	            },
	            getHint: function getHint() {
	                return this.$hint.val();
	            },
	            setHint: function setHint(value) {
	                this.$hint.val(value);
	            },
	            clearHint: function clearHint() {
	                this.setHint("");
	            },
	            clearHintIfInvalid: function clearHintIfInvalid() {
	                var val, hint, valIsPrefixOfHint, isValid;
	                val = this.getInputValue();
	                hint = this.getHint();
	                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
	                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
	                !isValid && this.clearHint();
	            },
	            hasFocus: function hasFocus() {
	                return this.$input.is(":focus");
	            },
	            hasOverflow: function hasOverflow() {
	                var constraint = this.$input.width() - 2;
	                this.$overflowHelper.text(this.getInputValue());
	                return this.$overflowHelper.width() >= constraint;
	            },
	            isCursorAtEnd: function() {
	                var valueLength, selectionStart, range;
	                valueLength = this.$input.val().length;
	                selectionStart = this.$input[0].selectionStart;
	                if (_.isNumber(selectionStart)) {
	                    return selectionStart === valueLength;
	                } else if (document.selection) {
	                    range = document.selection.createRange();
	                    range.moveStart("character", -valueLength);
	                    return valueLength === range.text.length;
	                }
	                return true;
	            },
	            destroy: function destroy() {
	                this.$hint.off(".tt");
	                this.$input.off(".tt");
	                this.$overflowHelper.remove();
	                this.$hint = this.$input = this.$overflowHelper = $("<div>");
	            },
	            setAriaExpanded: function setAriaExpanded(value) {
	                this.$input.attr("aria-expanded", value);
	            }
	        });
	        return Input;
	        function buildOverflowHelper($input) {
	            return $('<pre aria-hidden="true"></pre>').css({
	                position: "absolute",
	                visibility: "hidden",
	                whiteSpace: "pre",
	                fontFamily: $input.css("font-family"),
	                fontSize: $input.css("font-size"),
	                fontStyle: $input.css("font-style"),
	                fontVariant: $input.css("font-variant"),
	                fontWeight: $input.css("font-weight"),
	                wordSpacing: $input.css("word-spacing"),
	                letterSpacing: $input.css("letter-spacing"),
	                textIndent: $input.css("text-indent"),
	                textRendering: $input.css("text-rendering"),
	                textTransform: $input.css("text-transform")
	            }).insertAfter($input);
	        }
	        function areQueriesEquivalent(a, b) {
	            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
	        }
	        function withModifier($e) {
	            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
	        }
	    }();
	    var Dataset = function() {
	        "use strict";
	        var keys, nameGenerator;
	        keys = {
	            dataset: "tt-selectable-dataset",
	            val: "tt-selectable-display",
	            obj: "tt-selectable-object"
	        };
	        nameGenerator = _.getIdGenerator();
	        function Dataset(o, www) {
	            o = o || {};
	            o.templates = o.templates || {};
	            o.templates.notFound = o.templates.notFound || o.templates.empty;
	            if (!o.source) {
	                $.error("missing source");
	            }
	            if (!o.node) {
	                $.error("missing node");
	            }
	            if (o.name && !isValidName(o.name)) {
	                $.error("invalid dataset name: " + o.name);
	            }
	            www.mixin(this);
	            this.highlight = !!o.highlight;
	            this.name = _.toStr(o.name || nameGenerator());
	            this.limit = o.limit || 5;
	            this.displayFn = getDisplayFn(o.display || o.displayKey);
	            this.templates = getTemplates(o.templates, this.displayFn);
	            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
	            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
	            this._resetLastSuggestion();
	            this.$el = $(o.node).attr("role", "presentation").addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
	        }
	        Dataset.extractData = function extractData(el) {
	            var $el = $(el);
	            if ($el.data(keys.obj)) {
	                return {
	                    dataset: $el.data(keys.dataset) || "",
	                    val: $el.data(keys.val) || "",
	                    obj: $el.data(keys.obj) || null
	                };
	            }
	            return null;
	        };
	        _.mixin(Dataset.prototype, EventEmitter, {
	            _overwrite: function overwrite(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (this.async && this.templates.pending) {
	                    this._renderPending(query);
	                } else if (!this.async && this.templates.notFound) {
	                    this._renderNotFound(query);
	                } else {
	                    this._empty();
	                }
	                this.trigger("rendered", suggestions, false, this.name);
	            },
	            _append: function append(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length && this.$lastSuggestion.length) {
	                    this._appendSuggestions(query, suggestions);
	                } else if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
	                    this._renderNotFound(query);
	                }
	                this.trigger("rendered", suggestions, true, this.name);
	            },
	            _renderSuggestions: function renderSuggestions(query, suggestions) {
	                var $fragment;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                this.$lastSuggestion = $fragment.children().last();
	                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
	            },
	            _appendSuggestions: function appendSuggestions(query, suggestions) {
	                var $fragment, $lastSuggestion;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                $lastSuggestion = $fragment.children().last();
	                this.$lastSuggestion.after($fragment);
	                this.$lastSuggestion = $lastSuggestion;
	            },
	            _renderPending: function renderPending(query) {
	                var template = this.templates.pending;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _renderNotFound: function renderNotFound(query) {
	                var template = this.templates.notFound;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _empty: function empty() {
	                this.$el.empty();
	                this._resetLastSuggestion();
	            },
	            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
	                var that = this, fragment;
	                fragment = document.createDocumentFragment();
	                _.each(suggestions, function getSuggestionNode(suggestion) {
	                    var $el, context;
	                    context = that._injectQuery(query, suggestion);
	                    $el = $(that.templates.suggestion(context)).data(keys.dataset, that.name).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
	                    fragment.appendChild($el[0]);
	                });
	                this.highlight && highlight({
	                    className: this.classes.highlight,
	                    node: fragment,
	                    pattern: query
	                });
	                return $(fragment);
	            },
	            _getFooter: function getFooter(query, suggestions) {
	                return this.templates.footer ? this.templates.footer({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _getHeader: function getHeader(query, suggestions) {
	                return this.templates.header ? this.templates.header({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _resetLastSuggestion: function resetLastSuggestion() {
	                this.$lastSuggestion = $();
	            },
	            _injectQuery: function injectQuery(query, obj) {
	                return _.isObject(obj) ? _.mixin({
	                    _query: query
	                }, obj) : obj;
	            },
	            update: function update(query) {
	                var that = this, canceled = false, syncCalled = false, rendered = 0;
	                this.cancel();
	                this.cancel = function cancel() {
	                    canceled = true;
	                    that.cancel = $.noop;
	                    that.async && that.trigger("asyncCanceled", query, that.name);
	                };
	                this.source(query, sync, async);
	                !syncCalled && sync([]);
	                function sync(suggestions) {
	                    if (syncCalled) {
	                        return;
	                    }
	                    syncCalled = true;
	                    suggestions = (suggestions || []).slice(0, that.limit);
	                    rendered = suggestions.length;
	                    that._overwrite(query, suggestions);
	                    if (rendered < that.limit && that.async) {
	                        that.trigger("asyncRequested", query, that.name);
	                    }
	                }
	                function async(suggestions) {
	                    suggestions = suggestions || [];
	                    if (!canceled && rendered < that.limit) {
	                        that.cancel = $.noop;
	                        var idx = Math.abs(rendered - that.limit);
	                        rendered += idx;
	                        that._append(query, suggestions.slice(0, idx));
	                        that.async && that.trigger("asyncReceived", query, that.name);
	                    }
	                }
	            },
	            cancel: $.noop,
	            clear: function clear() {
	                this._empty();
	                this.cancel();
	                this.trigger("cleared");
	            },
	            isEmpty: function isEmpty() {
	                return this.$el.is(":empty");
	            },
	            destroy: function destroy() {
	                this.$el = $("<div>");
	            }
	        });
	        return Dataset;
	        function getDisplayFn(display) {
	            display = display || _.stringify;
	            return _.isFunction(display) ? display : displayFn;
	            function displayFn(obj) {
	                return obj[display];
	            }
	        }
	        function getTemplates(templates, displayFn) {
	            return {
	                notFound: templates.notFound && _.templatify(templates.notFound),
	                pending: templates.pending && _.templatify(templates.pending),
	                header: templates.header && _.templatify(templates.header),
	                footer: templates.footer && _.templatify(templates.footer),
	                suggestion: templates.suggestion ? userSuggestionTemplate : suggestionTemplate
	            };
	            function userSuggestionTemplate(context) {
	                var template = templates.suggestion;
	                return $(template(context)).attr("id", _.guid());
	            }
	            function suggestionTemplate(context) {
	                return $('<div role="option">').attr("id", _.guid()).text(displayFn(context));
	            }
	        }
	        function isValidName(str) {
	            return /^[_a-zA-Z0-9-]+$/.test(str);
	        }
	    }();
	    var Menu = function() {
	        "use strict";
	        function Menu(o, www) {
	            var that = this;
	            o = o || {};
	            if (!o.node) {
	                $.error("node is required");
	            }
	            www.mixin(this);
	            this.$node = $(o.node);
	            this.query = null;
	            this.datasets = _.map(o.datasets, initializeDataset);
	            function initializeDataset(oDataset) {
	                var node = that.$node.find(oDataset.node).first();
	                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
	                return new Dataset(oDataset, www);
	            }
	        }
	        _.mixin(Menu.prototype, EventEmitter, {
	            _onSelectableClick: function onSelectableClick($e) {
	                this.trigger("selectableClicked", $($e.currentTarget));
	            },
	            _onRendered: function onRendered(type, dataset, suggestions, async) {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetRendered", dataset, suggestions, async);
	            },
	            _onCleared: function onCleared() {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetCleared");
	            },
	            _propagate: function propagate() {
	                this.trigger.apply(this, arguments);
	            },
	            _allDatasetsEmpty: function allDatasetsEmpty() {
	                return _.every(this.datasets, _.bind(function isDatasetEmpty(dataset) {
	                    var isEmpty = dataset.isEmpty();
	                    this.$node.attr("aria-expanded", !isEmpty);
	                    return isEmpty;
	                }, this));
	            },
	            _getSelectables: function getSelectables() {
	                return this.$node.find(this.selectors.selectable);
	            },
	            _removeCursor: function _removeCursor() {
	                var $selectable = this.getActiveSelectable();
	                $selectable && $selectable.removeClass(this.classes.cursor);
	            },
	            _ensureVisible: function ensureVisible($el) {
	                var elTop, elBottom, nodeScrollTop, nodeHeight;
	                elTop = $el.position().top;
	                elBottom = elTop + $el.outerHeight(true);
	                nodeScrollTop = this.$node.scrollTop();
	                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
	                if (elTop < 0) {
	                    this.$node.scrollTop(nodeScrollTop + elTop);
	                } else if (nodeHeight < elBottom) {
	                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
	                }
	            },
	            bind: function() {
	                var that = this, onSelectableClick;
	                onSelectableClick = _.bind(this._onSelectableClick, this);
	                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
	                this.$node.on("mouseover", this.selectors.selectable, function() {
	                    that.setCursor($(this));
	                });
	                this.$node.on("mouseleave", function() {
	                    that._removeCursor();
	                });
	                _.each(this.datasets, function(dataset) {
	                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                return this.$node.hasClass(this.classes.open);
	            },
	            open: function open() {
	                this.$node.scrollTop(0);
	                this.$node.addClass(this.classes.open);
	            },
	            close: function close() {
	                this.$node.attr("aria-expanded", false);
	                this.$node.removeClass(this.classes.open);
	                this._removeCursor();
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.attr("dir", dir);
	            },
	            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
	                var $selectables, $oldCursor, oldIndex, newIndex;
	                $oldCursor = this.getActiveSelectable();
	                $selectables = this._getSelectables();
	                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
	                newIndex = oldIndex + delta;
	                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
	                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
	                return newIndex === -1 ? null : $selectables.eq(newIndex);
	            },
	            setCursor: function setCursor($selectable) {
	                this._removeCursor();
	                if ($selectable = $selectable && $selectable.first()) {
	                    $selectable.addClass(this.classes.cursor);
	                    this._ensureVisible($selectable);
	                }
	            },
	            getSelectableData: function getSelectableData($el) {
	                return $el && $el.length ? Dataset.extractData($el) : null;
	            },
	            getActiveSelectable: function getActiveSelectable() {
	                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
	                return $selectable.length ? $selectable : null;
	            },
	            getTopSelectable: function getTopSelectable() {
	                var $selectable = this._getSelectables().first();
	                return $selectable.length ? $selectable : null;
	            },
	            update: function update(query) {
	                var isValidUpdate = query !== this.query;
	                if (isValidUpdate) {
	                    this.query = query;
	                    _.each(this.datasets, updateDataset);
	                }
	                return isValidUpdate;
	                function updateDataset(dataset) {
	                    dataset.update(query);
	                }
	            },
	            empty: function empty() {
	                _.each(this.datasets, clearDataset);
	                this.query = null;
	                this.$node.addClass(this.classes.empty);
	                function clearDataset(dataset) {
	                    dataset.clear();
	                }
	            },
	            destroy: function destroy() {
	                this.$node.off(".tt");
	                this.$node = $("<div>");
	                _.each(this.datasets, destroyDataset);
	                function destroyDataset(dataset) {
	                    dataset.destroy();
	                }
	            }
	        });
	        return Menu;
	    }();
	    var Status = function() {
	        "use strict";
	        function Status(options) {
	            this.$el = $("<span></span>", {
	                role: "status",
	                "aria-live": "polite"
	            }).css({
	                position: "absolute",
	                padding: "0",
	                border: "0",
	                height: "1px",
	                width: "1px",
	                "margin-bottom": "-1px",
	                "margin-right": "-1px",
	                overflow: "hidden",
	                clip: "rect(0 0 0 0)",
	                "white-space": "nowrap"
	            });
	            options.$input.after(this.$el);
	            _.each(options.menu.datasets, _.bind(function(dataset) {
	                if (dataset.onSync) {
	                    dataset.onSync("rendered", _.bind(this.update, this));
	                    dataset.onSync("cleared", _.bind(this.cleared, this));
	                }
	            }, this));
	        }
	        _.mixin(Status.prototype, {
	            update: function update(event, suggestions) {
	                var length = suggestions.length;
	                var words;
	                if (length === 1) {
	                    words = {
	                        result: "result",
	                        is: "is"
	                    };
	                } else {
	                    words = {
	                        result: "results",
	                        is: "are"
	                    };
	                }
	                this.$el.text(length + " " + words.result + " " + words.is + " available, use up and down arrow keys to navigate.");
	            },
	            cleared: function() {
	                this.$el.text("");
	            }
	        });
	        return Status;
	    }();
	    var DefaultMenu = function() {
	        "use strict";
	        var s = Menu.prototype;
	        function DefaultMenu() {
	            Menu.apply(this, [].slice.call(arguments, 0));
	        }
	        _.mixin(DefaultMenu.prototype, Menu.prototype, {
	            open: function open() {
	                !this._allDatasetsEmpty() && this._show();
	                return s.open.apply(this, [].slice.call(arguments, 0));
	            },
	            close: function close() {
	                this._hide();
	                return s.close.apply(this, [].slice.call(arguments, 0));
	            },
	            _onRendered: function onRendered() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onRendered.apply(this, [].slice.call(arguments, 0));
	            },
	            _onCleared: function onCleared() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onCleared.apply(this, [].slice.call(arguments, 0));
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
	                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
	            },
	            _hide: function hide() {
	                this.$node.hide();
	            },
	            _show: function show() {
	                this.$node.css("display", "block");
	            }
	        });
	        return DefaultMenu;
	    }();
	    var Typeahead = function() {
	        "use strict";
	        function Typeahead(o, www) {
	            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
	            o = o || {};
	            if (!o.input) {
	                $.error("missing input");
	            }
	            if (!o.menu) {
	                $.error("missing menu");
	            }
	            if (!o.eventBus) {
	                $.error("missing event bus");
	            }
	            www.mixin(this);
	            this.eventBus = o.eventBus;
	            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
	            this.input = o.input;
	            this.menu = o.menu;
	            this.enabled = true;
	            this.autoselect = !!o.autoselect;
	            this.active = false;
	            this.input.hasFocus() && this.activate();
	            this.dir = this.input.getLangDir();
	            this._hacks();
	            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
	            onFocused = c(this, "activate", "open", "_onFocused");
	            onBlurred = c(this, "deactivate", "_onBlurred");
	            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
	            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
	            onEscKeyed = c(this, "isActive", "_onEscKeyed");
	            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
	            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
	            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
	            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
	            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
	            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
	            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
	        }
	        _.mixin(Typeahead.prototype, {
	            _hacks: function hacks() {
	                var $input, $menu;
	                $input = this.input.$input || $("<div>");
	                $menu = this.menu.$node || $("<div>");
	                $input.on("blur.tt", function($e) {
	                    var active, isActive, hasActive;
	                    active = document.activeElement;
	                    isActive = $menu.is(active);
	                    hasActive = $menu.has(active).length > 0;
	                    if (_.isMsie() && (isActive || hasActive)) {
	                        $e.preventDefault();
	                        $e.stopImmediatePropagation();
	                        _.defer(function() {
	                            $input.focus();
	                        });
	                    }
	                });
	                $menu.on("mousedown.tt", function($e) {
	                    $e.preventDefault();
	                });
	            },
	            _onSelectableClicked: function onSelectableClicked(type, $el) {
	                this.select($el);
	            },
	            _onDatasetCleared: function onDatasetCleared() {
	                this._updateHint();
	            },
	            _onDatasetRendered: function onDatasetRendered(type, suggestions, async, dataset) {
	                this._updateHint();
	                if (this.autoselect) {
	                    var cursorClass = this.selectors.cursor.substr(1);
	                    this.menu.$node.find(this.selectors.suggestion).first().addClass(cursorClass);
	                }
	                this.eventBus.trigger("render", suggestions, async, dataset);
	            },
	            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
	                this.eventBus.trigger("asyncrequest", query, dataset);
	            },
	            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
	                this.eventBus.trigger("asynccancel", query, dataset);
	            },
	            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
	                this.eventBus.trigger("asyncreceive", query, dataset);
	            },
	            _onFocused: function onFocused() {
	                this._minLengthMet() && this.menu.update(this.input.getQuery());
	            },
	            _onBlurred: function onBlurred() {
	                if (this.input.hasQueryChangedSinceLastFocus()) {
	                    this.eventBus.trigger("change", this.input.getQuery());
	                }
	            },
	            _onEnterKeyed: function onEnterKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    if (this.select($selectable)) {
	                        $e.preventDefault();
	                        $e.stopPropagation();
	                    }
	                } else if (this.autoselect) {
	                    if (this.select(this.menu.getTopSelectable())) {
	                        $e.preventDefault();
	                        $e.stopPropagation();
	                    }
	                }
	            },
	            _onTabKeyed: function onTabKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                } else if (this.autoselect) {
	                    if ($selectable = this.menu.getTopSelectable()) {
	                        this.autocomplete($selectable) && $e.preventDefault();
	                    }
	                }
	            },
	            _onEscKeyed: function onEscKeyed() {
	                this.close();
	            },
	            _onUpKeyed: function onUpKeyed() {
	                this.moveCursor(-1);
	            },
	            _onDownKeyed: function onDownKeyed() {
	                this.moveCursor(+1);
	            },
	            _onLeftKeyed: function onLeftKeyed() {
	                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getActiveSelectable() || this.menu.getTopSelectable());
	                }
	            },
	            _onRightKeyed: function onRightKeyed() {
	                if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getActiveSelectable() || this.menu.getTopSelectable());
	                }
	            },
	            _onQueryChanged: function onQueryChanged(e, query) {
	                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
	            },
	            _onWhitespaceChanged: function onWhitespaceChanged() {
	                this._updateHint();
	            },
	            _onLangDirChanged: function onLangDirChanged(e, dir) {
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.menu.setLanguageDirection(dir);
	                }
	            },
	            _openIfActive: function openIfActive() {
	                this.isActive() && this.open();
	            },
	            _minLengthMet: function minLengthMet(query) {
	                query = _.isString(query) ? query : this.input.getQuery() || "";
	                return query.length >= this.minLength;
	            },
	            _updateHint: function updateHint() {
	                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
	                $selectable = this.menu.getTopSelectable();
	                data = this.menu.getSelectableData($selectable);
	                val = this.input.getInputValue();
	                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
	                    query = Input.normalizeQuery(val);
	                    escapedQuery = _.escapeRegExChars(query);
	                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
	                    match = frontMatchRegEx.exec(data.val);
	                    match && this.input.setHint(val + match[1]);
	                } else {
	                    this.input.clearHint();
	                }
	            },
	            isEnabled: function isEnabled() {
	                return this.enabled;
	            },
	            enable: function enable() {
	                this.enabled = true;
	            },
	            disable: function disable() {
	                this.enabled = false;
	            },
	            isActive: function isActive() {
	                return this.active;
	            },
	            activate: function activate() {
	                if (this.isActive()) {
	                    return true;
	                } else if (!this.isEnabled() || this.eventBus.before("active")) {
	                    return false;
	                } else {
	                    this.active = true;
	                    this.eventBus.trigger("active");
	                    return true;
	                }
	            },
	            deactivate: function deactivate() {
	                if (!this.isActive()) {
	                    return true;
	                } else if (this.eventBus.before("idle")) {
	                    return false;
	                } else {
	                    this.active = false;
	                    this.close();
	                    this.eventBus.trigger("idle");
	                    return true;
	                }
	            },
	            isOpen: function isOpen() {
	                return this.menu.isOpen();
	            },
	            open: function open() {
	                if (!this.isOpen() && !this.eventBus.before("open")) {
	                    this.input.setAriaExpanded(true);
	                    this.menu.open();
	                    this._updateHint();
	                    this.eventBus.trigger("open");
	                }
	                return this.isOpen();
	            },
	            close: function close() {
	                if (this.isOpen() && !this.eventBus.before("close")) {
	                    this.input.setAriaExpanded(false);
	                    this.menu.close();
	                    this.input.clearHint();
	                    this.input.resetInputValue();
	                    this.eventBus.trigger("close");
	                }
	                return !this.isOpen();
	            },
	            setVal: function setVal(val) {
	                this.input.setQuery(_.toStr(val));
	            },
	            getVal: function getVal() {
	                return this.input.getQuery();
	            },
	            select: function select($selectable) {
	                var data = this.menu.getSelectableData($selectable);
	                if (data && !this.eventBus.before("select", data.obj, data.dataset)) {
	                    this.input.setQuery(data.val, true);
	                    this.eventBus.trigger("select", data.obj, data.dataset);
	                    this.close();
	                    return true;
	                }
	                return false;
	            },
	            autocomplete: function autocomplete($selectable) {
	                var query, data, isValid;
	                query = this.input.getQuery();
	                data = this.menu.getSelectableData($selectable);
	                isValid = data && query !== data.val;
	                if (isValid && !this.eventBus.before("autocomplete", data.obj, data.dataset)) {
	                    this.input.setQuery(data.val);
	                    this.eventBus.trigger("autocomplete", data.obj, data.dataset);
	                    return true;
	                }
	                return false;
	            },
	            moveCursor: function moveCursor(delta) {
	                var query, $candidate, data, suggestion, datasetName, cancelMove, id;
	                query = this.input.getQuery();
	                $candidate = this.menu.selectableRelativeToCursor(delta);
	                data = this.menu.getSelectableData($candidate);
	                suggestion = data ? data.obj : null;
	                datasetName = data ? data.dataset : null;
	                id = $candidate ? $candidate.attr("id") : null;
	                this.input.trigger("cursorchange", id);
	                cancelMove = this._minLengthMet() && this.menu.update(query);
	                if (!cancelMove && !this.eventBus.before("cursorchange", suggestion, datasetName)) {
	                    this.menu.setCursor($candidate);
	                    if (data) {
	                        if (typeof data.val === "string") {
	                            this.input.setInputValue(data.val);
	                        }
	                    } else {
	                        this.input.resetInputValue();
	                        this._updateHint();
	                    }
	                    this.eventBus.trigger("cursorchange", suggestion, datasetName);
	                    return true;
	                }
	                return false;
	            },
	            destroy: function destroy() {
	                this.input.destroy();
	                this.menu.destroy();
	            }
	        });
	        return Typeahead;
	        function c(ctx) {
	            var methods = [].slice.call(arguments, 1);
	            return function() {
	                var args = [].slice.call(arguments);
	                _.each(methods, function(method) {
	                    return ctx[method].apply(ctx, args);
	                });
	            };
	        }
	    }();
	    (function() {
	        "use strict";
	        var old, keys, methods;
	        old = $.fn.typeahead;
	        keys = {
	            www: "tt-www",
	            attrs: "tt-attrs",
	            typeahead: "tt-typeahead"
	        };
	        methods = {
	            initialize: function initialize(o, datasets) {
	                var www;
	                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
	                o = o || {};
	                www = WWW(o.classNames);
	                return this.each(attach);
	                function attach() {
	                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, status, typeahead, MenuConstructor;
	                    _.each(datasets, function(d) {
	                        d.highlight = !!o.highlight;
	                    });
	                    $input = $(this);
	                    $wrapper = $(www.html.wrapper);
	                    $hint = $elOrNull(o.hint);
	                    $menu = $elOrNull(o.menu);
	                    defaultHint = o.hint !== false && !$hint;
	                    defaultMenu = o.menu !== false && !$menu;
	                    defaultHint && ($hint = buildHintFromInput($input, www));
	                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
	                    $hint && $hint.val("");
	                    $input = prepInput($input, www);
	                    if (defaultHint || defaultMenu) {
	                        $wrapper.css(www.css.wrapper);
	                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
	                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
	                    }
	                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
	                    eventBus = new EventBus({
	                        el: $input
	                    });
	                    input = new Input({
	                        hint: $hint,
	                        input: $input,
	                        menu: $menu
	                    }, www);
	                    menu = new MenuConstructor({
	                        node: $menu,
	                        datasets: datasets
	                    }, www);
	                    status = new Status({
	                        $input: $input,
	                        menu: menu
	                    });
	                    typeahead = new Typeahead({
	                        input: input,
	                        menu: menu,
	                        eventBus: eventBus,
	                        minLength: o.minLength,
	                        autoselect: o.autoselect
	                    }, www);
	                    $input.data(keys.www, www);
	                    $input.data(keys.typeahead, typeahead);
	                }
	            },
	            isEnabled: function isEnabled() {
	                var enabled;
	                ttEach(this.first(), function(t) {
	                    enabled = t.isEnabled();
	                });
	                return enabled;
	            },
	            enable: function enable() {
	                ttEach(this, function(t) {
	                    t.enable();
	                });
	                return this;
	            },
	            disable: function disable() {
	                ttEach(this, function(t) {
	                    t.disable();
	                });
	                return this;
	            },
	            isActive: function isActive() {
	                var active;
	                ttEach(this.first(), function(t) {
	                    active = t.isActive();
	                });
	                return active;
	            },
	            activate: function activate() {
	                ttEach(this, function(t) {
	                    t.activate();
	                });
	                return this;
	            },
	            deactivate: function deactivate() {
	                ttEach(this, function(t) {
	                    t.deactivate();
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                var open;
	                ttEach(this.first(), function(t) {
	                    open = t.isOpen();
	                });
	                return open;
	            },
	            open: function open() {
	                ttEach(this, function(t) {
	                    t.open();
	                });
	                return this;
	            },
	            close: function close() {
	                ttEach(this, function(t) {
	                    t.close();
	                });
	                return this;
	            },
	            select: function select(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.select($el);
	                });
	                return success;
	            },
	            autocomplete: function autocomplete(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.autocomplete($el);
	                });
	                return success;
	            },
	            moveCursor: function moveCursoe(delta) {
	                var success = false;
	                ttEach(this.first(), function(t) {
	                    success = t.moveCursor(delta);
	                });
	                return success;
	            },
	            val: function val(newVal) {
	                var query;
	                if (!arguments.length) {
	                    ttEach(this.first(), function(t) {
	                        query = t.getVal();
	                    });
	                    return query;
	                } else {
	                    ttEach(this, function(t) {
	                        t.setVal(_.toStr(newVal));
	                    });
	                    return this;
	                }
	            },
	            destroy: function destroy() {
	                ttEach(this, function(typeahead, $input) {
	                    revert($input);
	                    typeahead.destroy();
	                });
	                return this;
	            }
	        };
	        $.fn.typeahead = function(method) {
	            if (methods[method]) {
	                return methods[method].apply(this, [].slice.call(arguments, 1));
	            } else {
	                return methods.initialize.apply(this, arguments);
	            }
	        };
	        $.fn.typeahead.noConflict = function noConflict() {
	            $.fn.typeahead = old;
	            return this;
	        };
	        function ttEach($els, fn) {
	            $els.each(function() {
	                var $input = $(this), typeahead;
	                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
	            });
	        }
	        function buildHintFromInput($input, www) {
	            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop({
	                readonly: true,
	                required: false
	            }).removeAttr("id name placeholder").removeClass("required").attr({
	                spellcheck: "false",
	                tabindex: -1
	            });
	        }
	        function prepInput($input, www) {
	            $input.data(keys.attrs, {
	                dir: $input.attr("dir"),
	                autocomplete: $input.attr("autocomplete"),
	                spellcheck: $input.attr("spellcheck"),
	                style: $input.attr("style")
	            });
	            $input.addClass(www.classes.input).attr({
	                spellcheck: false
	            });
	            try {
	                !$input.attr("dir") && $input.attr("dir", "auto");
	            } catch (e) {}
	            return $input;
	        }
	        function getBackgroundStyles($el) {
	            return {
	                backgroundAttachment: $el.css("background-attachment"),
	                backgroundClip: $el.css("background-clip"),
	                backgroundColor: $el.css("background-color"),
	                backgroundImage: $el.css("background-image"),
	                backgroundOrigin: $el.css("background-origin"),
	                backgroundPosition: $el.css("background-position"),
	                backgroundRepeat: $el.css("background-repeat"),
	                backgroundSize: $el.css("background-size")
	            };
	        }
	        function revert($input) {
	            var www, $wrapper;
	            www = $input.data(keys.www);
	            $wrapper = $input.parent().filter(www.selectors.wrapper);
	            _.each($input.data(keys.attrs), function(val, key) {
	                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
	            });
	            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
	            if ($wrapper.length) {
	                $input.detach().insertAfter($wrapper);
	                $wrapper.remove();
	            }
	        }
	        function $elOrNull(obj) {
	            var isValid, $el;
	            isValid = _.isJQuery(obj) || _.isElement(obj);
	            $el = isValid ? $(obj).first() : [];
	            return $el.length ? $el : null;
	        }
	    })();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73).setImmediate))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 62,
		"./de-at": 60,
		"./de-at.js": 60,
		"./de-ch": 61,
		"./de-ch.js": 61,
		"./de.js": 62,
		"./en-ca": 63,
		"./en-ca.js": 63,
		"./en-gb": 64,
		"./en-gb.js": 64,
		"./en-ie": 65,
		"./en-ie.js": 65,
		"./fr": 68,
		"./fr-ca": 66,
		"./fr-ca.js": 66,
		"./fr-ch": 67,
		"./fr-ch.js": 67,
		"./fr.js": 68,
		"./gom-deva": 69,
		"./gom-deva.js": 69,
		"./hu": 70,
		"./hu.js": 70,
		"./it": 72,
		"./it-ch": 71,
		"./it-ch.js": 71,
		"./it.js": 72
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 91;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe - v4.1.3 - 2019-01-08
	* http://photoswipe.com
	* Copyright (c) 2019 Dmitry Semenov; */
	(function (root, factory) { 
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipe = factory();
		}
	})(this, function () {
	
		'use strict';
		var PhotoSwipe = function(template, UiClass, items, options){
	
	/*>>framework-bridge*/
	/**
	 *
	 * Set of generic functions used by gallery.
	 * 
	 * You're free to modify anything here as long as functionality is kept.
	 * 
	 */
	var framework = {
		features: null,
		bind: function(target, type, listener, unbind) {
			var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
			type = type.split(' ');
			for(var i = 0; i < type.length; i++) {
				if(type[i]) {
					target[methodName]( type[i], listener, false);
				}
			}
		},
		isArray: function(obj) {
			return (obj instanceof Array);
		},
		createEl: function(classes, tag) {
			var el = document.createElement(tag || 'div');
			if(classes) {
				el.className = classes;
			}
			return el;
		},
		getScrollY: function() {
			var yOffset = window.pageYOffset;
			return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
		},
		unbind: function(target, type, listener) {
			framework.bind(target,type,listener,true);
		},
		removeClass: function(el, className) {
			var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
			el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, ''); 
		},
		addClass: function(el, className) {
			if( !framework.hasClass(el,className) ) {
				el.className += (el.className ? ' ' : '') + className;
			}
		},
		hasClass: function(el, className) {
			return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
		},
		getChildByClass: function(parentEl, childClassName) {
			var node = parentEl.firstChild;
			while(node) {
				if( framework.hasClass(node, childClassName) ) {
					return node;
				}
				node = node.nextSibling;
			}
		},
		arraySearch: function(array, value, key) {
			var i = array.length;
			while(i--) {
				if(array[i][key] === value) {
					return i;
				} 
			}
			return -1;
		},
		extend: function(o1, o2, preventOverwrite) {
			for (var prop in o2) {
				if (o2.hasOwnProperty(prop)) {
					if(preventOverwrite && o1.hasOwnProperty(prop)) {
						continue;
					}
					o1[prop] = o2[prop];
				}
			}
		},
		easing: {
			sine: {
				out: function(k) {
					return Math.sin(k * (Math.PI / 2));
				},
				inOut: function(k) {
					return - (Math.cos(Math.PI * k) - 1) / 2;
				}
			},
			cubic: {
				out: function(k) {
					return --k * k * k + 1;
				}
			}
			/*
				elastic: {
					out: function ( k ) {
	
						var s, a = 0.1, p = 0.4;
						if ( k === 0 ) return 0;
						if ( k === 1 ) return 1;
						if ( !a || a < 1 ) { a = 1; s = p / 4; }
						else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
						return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
	
					},
				},
				back: {
					out: function ( k ) {
						var s = 1.70158;
						return --k * k * ( ( s + 1 ) * k + s ) + 1;
					}
				}
			*/
		},
	
		/**
		 * 
		 * @return {object}
		 * 
		 * {
		 *  raf : request animation frame function
		 *  caf : cancel animation frame function
		 *  transfrom : transform property key (with vendor), or null if not supported
		 *  oldIE : IE8 or below
		 * }
		 * 
		 */
		detectFeatures: function() {
			if(framework.features) {
				return framework.features;
			}
			var helperEl = framework.createEl(),
				helperStyle = helperEl.style,
				vendor = '',
				features = {};
	
			// IE8 and below
			features.oldIE = document.all && !document.addEventListener;
	
			features.touch = 'ontouchstart' in window;
	
			if(window.requestAnimationFrame) {
				features.raf = window.requestAnimationFrame;
				features.caf = window.cancelAnimationFrame;
			}
	
			features.pointerEvent = !!(window.PointerEvent) || navigator.msPointerEnabled;
	
			// fix false-positive detection of old Android in new IE
			// (IE11 ua string contains "Android 4.0")
			
			if(!features.pointerEvent) { 
	
				var ua = navigator.userAgent;
	
				// Detect if device is iPhone or iPod and if it's older than iOS 8
				// http://stackoverflow.com/a/14223920
				// 
				// This detection is made because of buggy top/bottom toolbars
				// that don't trigger window.resize event.
				// For more info refer to _isFixedPosition variable in core.js
	
				if (/iP(hone|od)/.test(navigator.platform)) {
					var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
					if(v && v.length > 0) {
						v = parseInt(v[1], 10);
						if(v >= 1 && v < 8 ) {
							features.isOldIOSPhone = true;
						}
					}
				}
	
				// Detect old Android (before KitKat)
				// due to bugs related to position:fixed
				// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
				
				var match = ua.match(/Android\s([0-9\.]*)/);
				var androidversion =  match ? match[1] : 0;
				androidversion = parseFloat(androidversion);
				if(androidversion >= 1 ) {
					if(androidversion < 4.4) {
						features.isOldAndroid = true; // for fixed position bug & performance
					}
					features.androidVersion = androidversion; // for touchend bug
				}	
				features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
	
				// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
			}
			
			var styleChecks = ['transform', 'perspective', 'animationName'],
				vendors = ['', 'webkit','Moz','ms','O'],
				styleCheckItem,
				styleName;
	
			for(var i = 0; i < 4; i++) {
				vendor = vendors[i];
	
				for(var a = 0; a < 3; a++) {
					styleCheckItem = styleChecks[a];
	
					// uppercase first letter of property name, if vendor is present
					styleName = vendor + (vendor ? 
											styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : 
											styleCheckItem);
				
					if(!features[styleCheckItem] && styleName in helperStyle ) {
						features[styleCheckItem] = styleName;
					}
				}
	
				if(vendor && !features.raf) {
					vendor = vendor.toLowerCase();
					features.raf = window[vendor+'RequestAnimationFrame'];
					if(features.raf) {
						features.caf = window[vendor+'CancelAnimationFrame'] || 
										window[vendor+'CancelRequestAnimationFrame'];
					}
				}
			}
				
			if(!features.raf) {
				var lastTime = 0;
				features.raf = function(fn) {
					var currTime = new Date().getTime();
					var timeToCall = Math.max(0, 16 - (currTime - lastTime));
					var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
					lastTime = currTime + timeToCall;
					return id;
				};
				features.caf = function(id) { clearTimeout(id); };
			}
	
			// Detect SVG support
			features.svg = !!document.createElementNS && 
							!!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
	
			framework.features = features;
	
			return features;
		}
	};
	
	framework.detectFeatures();
	
	// Override addEventListener for old versions of IE
	if(framework.features.oldIE) {
	
		framework.bind = function(target, type, listener, unbind) {
			
			type = type.split(' ');
	
			var methodName = (unbind ? 'detach' : 'attach') + 'Event',
				evName,
				_handleEv = function() {
					listener.handleEvent.call(listener);
				};
	
			for(var i = 0; i < type.length; i++) {
				evName = type[i];
				if(evName) {
	
					if(typeof listener === 'object' && listener.handleEvent) {
						if(!unbind) {
							listener['oldIE' + evName] = _handleEv;
						} else {
							if(!listener['oldIE' + evName]) {
								return false;
							}
						}
	
						target[methodName]( 'on' + evName, listener['oldIE' + evName]);
					} else {
						target[methodName]( 'on' + evName, listener);
					}
	
				}
			}
		};
		
	}
	
	/*>>framework-bridge*/
	
	/*>>core*/
	//function(template, UiClass, items, options)
	
	var self = this;
	
	/**
	 * Static vars, don't change unless you know what you're doing.
	 */
	var DOUBLE_TAP_RADIUS = 25, 
		NUM_HOLDERS = 3;
	
	/**
	 * Options
	 */
	var _options = {
		allowPanToNext:true,
		spacing: 0.12,
		bgOpacity: 1,
		mouseUsed: false,
		loop: true,
		pinchToClose: true,
		closeOnScroll: true,
		closeOnVerticalDrag: true,
		verticalDragRange: 0.75,
		hideAnimationDuration: 333,
		showAnimationDuration: 333,
		showHideOpacity: false,
		focus: true,
		escKey: true,
		arrowKeys: true,
		mainScrollEndFriction: 0.35,
		panEndFriction: 0.35,
		isClickableElement: function(el) {
	        return el.tagName === 'A';
	    },
	    getDoubleTapZoom: function(isMouseClick, item) {
	    	if(isMouseClick) {
	    		return 1;
	    	} else {
	    		return item.initialZoomLevel < 0.7 ? 1 : 1.33;
	    	}
	    },
	    maxSpreadZoom: 1.33,
		modal: true,
	
		// not fully implemented yet
		scaleMode: 'fit' // TODO
	};
	framework.extend(_options, options);
	
	
	/**
	 * Private helper variables & functions
	 */
	
	var _getEmptyPoint = function() { 
			return {x:0,y:0}; 
		};
	
	var _isOpen,
		_isDestroying,
		_closedByScroll,
		_currentItemIndex,
		_containerStyle,
		_containerShiftIndex,
		_currPanDist = _getEmptyPoint(),
		_startPanOffset = _getEmptyPoint(),
		_panOffset = _getEmptyPoint(),
		_upMoveEvents, // drag move, drag end & drag cancel events array
		_downEvents, // drag start events array
		_globalEventHandlers,
		_viewportSize = {},
		_currZoomLevel,
		_startZoomLevel,
		_translatePrefix,
		_translateSufix,
		_updateSizeInterval,
		_itemsNeedUpdate,
		_currPositionIndex = 0,
		_offset = {},
		_slideSize = _getEmptyPoint(), // size of slide area, including spacing
		_itemHolders,
		_prevItemIndex,
		_indexDiff = 0, // difference of indexes since last content update
		_dragStartEvent,
		_dragMoveEvent,
		_dragEndEvent,
		_dragCancelEvent,
		_transformKey,
		_pointerEventEnabled,
		_isFixedPosition = true,
		_likelyTouchDevice,
		_modules = [],
		_requestAF,
		_cancelAF,
		_initalClassName,
		_initalWindowScrollY,
		_oldIE,
		_currentWindowScrollY,
		_features,
		_windowVisibleSize = {},
		_renderMaxResolution = false,
		_orientationChangeTimeout,
	
	
		// Registers PhotoSWipe module (History, Controller ...)
		_registerModule = function(name, module) {
			framework.extend(self, module.publicMethods);
			_modules.push(name);
		},
	
		_getLoopedId = function(index) {
			var numSlides = _getNumItems();
			if(index > numSlides - 1) {
				return index - numSlides;
			} else  if(index < 0) {
				return numSlides + index;
			}
			return index;
		},
		
		// Micro bind/trigger
		_listeners = {},
		_listen = function(name, fn) {
			if(!_listeners[name]) {
				_listeners[name] = [];
			}
			return _listeners[name].push(fn);
		},
		_shout = function(name) {
			var listeners = _listeners[name];
	
			if(listeners) {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
	
				for(var i = 0; i < listeners.length; i++) {
					listeners[i].apply(self, args);
				}
			}
		},
	
		_getCurrentTime = function() {
			return new Date().getTime();
		},
		_applyBgOpacity = function(opacity) {
			_bgOpacity = opacity;
			self.bg.style.opacity = opacity * _options.bgOpacity;
		},
	
		_applyZoomTransform = function(styleObj,x,y,zoom,item) {
			if(!_renderMaxResolution || (item && item !== self.currItem) ) {
				zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);	
			}
				
			styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
		},
		_applyCurrentZoomPan = function( allowRenderResolution ) {
			if(_currZoomElementStyle) {
	
				if(allowRenderResolution) {
					if(_currZoomLevel > self.currItem.fitRatio) {
						if(!_renderMaxResolution) {
							_setImageSize(self.currItem, false, true);
							_renderMaxResolution = true;
						}
					} else {
						if(_renderMaxResolution) {
							_setImageSize(self.currItem);
							_renderMaxResolution = false;
						}
					}
				}
				
	
				_applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
			}
		},
		_applyZoomPanToItem = function(item) {
			if(item.container) {
	
				_applyZoomTransform(item.container.style, 
									item.initialPosition.x, 
									item.initialPosition.y, 
									item.initialZoomLevel,
									item);
			}
		},
		_setTranslateX = function(x, elStyle) {
			elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
		},
		_moveMainScroll = function(x, dragging) {
	
			if(!_options.loop && dragging) {
				var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
					delta = Math.round(x - _mainScrollPos.x);
	
				if( (newSlideIndexOffset < 0 && delta > 0) || 
					(newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
					x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
				} 
			}
			
			_mainScrollPos.x = x;
			_setTranslateX(x, _containerStyle);
		},
		_calculatePanOffset = function(axis, zoomLevel) {
			var m = _midZoomPoint[axis] - _offset[axis];
			return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
		},
		
		_equalizePoints = function(p1, p2) {
			p1.x = p2.x;
			p1.y = p2.y;
			if(p2.id) {
				p1.id = p2.id;
			}
		},
		_roundPoint = function(p) {
			p.x = Math.round(p.x);
			p.y = Math.round(p.y);
		},
	
		_mouseMoveTimeout = null,
		_onFirstMouseMove = function() {
			// Wait until mouse move event is fired at least twice during 100ms
			// We do this, because some mobile browsers trigger it on touchstart
			if(_mouseMoveTimeout ) { 
				framework.unbind(document, 'mousemove', _onFirstMouseMove);
				framework.addClass(template, 'pswp--has_mouse');
				_options.mouseUsed = true;
				_shout('mouseUsed');
			}
			_mouseMoveTimeout = setTimeout(function() {
				_mouseMoveTimeout = null;
			}, 100);
		},
	
		_bindEvents = function() {
			framework.bind(document, 'keydown', self);
	
			if(_features.transform) {
				// don't bind click event in browsers that don't support transform (mostly IE8)
				framework.bind(self.scrollWrap, 'click', self);
			}
			
	
			if(!_options.mouseUsed) {
				framework.bind(document, 'mousemove', _onFirstMouseMove);
			}
	
			framework.bind(window, 'resize scroll orientationchange', self);
	
			_shout('bindEvents');
		},
	
		_unbindEvents = function() {
			framework.unbind(window, 'resize scroll orientationchange', self);
			framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
			framework.unbind(document, 'keydown', self);
			framework.unbind(document, 'mousemove', _onFirstMouseMove);
	
			if(_features.transform) {
				framework.unbind(self.scrollWrap, 'click', self);
			}
	
			if(_isDragging) {
				framework.unbind(window, _upMoveEvents, self);
			}
	
			clearTimeout(_orientationChangeTimeout);
	
			_shout('unbindEvents');
		},
		
		_calculatePanBounds = function(zoomLevel, update) {
			var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
			if(update) {
				_currPanBounds = bounds;
			}
			return bounds;
		},
		
		_getMinZoomLevel = function(item) {
			if(!item) {
				item = self.currItem;
			}
			return item.initialZoomLevel;
		},
		_getMaxZoomLevel = function(item) {
			if(!item) {
				item = self.currItem;
			}
			return item.w > 0 ? _options.maxSpreadZoom : 1;
		},
	
		// Return true if offset is out of the bounds
		_modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
			if(destZoomLevel === self.currItem.initialZoomLevel) {
				destPanOffset[axis] = self.currItem.initialPosition[axis];
				return true;
			} else {
				destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel); 
	
				if(destPanOffset[axis] > destPanBounds.min[axis]) {
					destPanOffset[axis] = destPanBounds.min[axis];
					return true;
				} else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
					destPanOffset[axis] = destPanBounds.max[axis];
					return true;
				}
			}
			return false;
		},
	
		_setupTransforms = function() {
	
			if(_transformKey) {
				// setup 3d transforms
				var allow3dTransform = _features.perspective && !_likelyTouchDevice;
				_translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
				_translateSufix = _features.perspective ? ', 0px)' : ')';	
				return;
			}
	
			// Override zoom/pan/move functions in case old browser is used (most likely IE)
			// (so they use left/top/width/height, instead of CSS transform)
		
			_transformKey = 'left';
			framework.addClass(template, 'pswp--ie');
	
			_setTranslateX = function(x, elStyle) {
				elStyle.left = x + 'px';
			};
			_applyZoomPanToItem = function(item) {
	
				var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					s = item.container.style,
					w = zoomRatio * item.w,
					h = zoomRatio * item.h;
	
				s.width = w + 'px';
				s.height = h + 'px';
				s.left = item.initialPosition.x + 'px';
				s.top = item.initialPosition.y + 'px';
	
			};
			_applyCurrentZoomPan = function() {
				if(_currZoomElementStyle) {
	
					var s = _currZoomElementStyle,
						item = self.currItem,
						zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
						w = zoomRatio * item.w,
						h = zoomRatio * item.h;
	
					s.width = w + 'px';
					s.height = h + 'px';
	
	
					s.left = _panOffset.x + 'px';
					s.top = _panOffset.y + 'px';
				}
				
			};
		},
	
		_onKeyDown = function(e) {
			var keydownAction = '';
			if(_options.escKey && e.keyCode === 27) { 
				keydownAction = 'close';
			} else if(_options.arrowKeys) {
				if(e.keyCode === 37) {
					keydownAction = 'prev';
				} else if(e.keyCode === 39) { 
					keydownAction = 'next';
				}
			}
	
			if(keydownAction) {
				// don't do anything if special key pressed to prevent from overriding default browser actions
				// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
				if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
					if(e.preventDefault) {
						e.preventDefault();
					} else {
						e.returnValue = false;
					} 
					self[keydownAction]();
				}
			}
		},
	
		_onGlobalClick = function(e) {
			if(!e) {
				return;
			}
	
			// don't allow click event to pass through when triggering after drag or some other gesture
			if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
	
		_updatePageScrollOffset = function() {
			self.setScrollOffset(0, framework.getScrollY());		
		};
		
	
	
		
	
	
	
	// Micro animation engine
	var _animations = {},
		_numAnimations = 0,
		_stopAnimation = function(name) {
			if(_animations[name]) {
				if(_animations[name].raf) {
					_cancelAF( _animations[name].raf );
				}
				_numAnimations--;
				delete _animations[name];
			}
		},
		_registerStartAnimation = function(name) {
			if(_animations[name]) {
				_stopAnimation(name);
			}
			if(!_animations[name]) {
				_numAnimations++;
				_animations[name] = {};
			}
		},
		_stopAllAnimations = function() {
			for (var prop in _animations) {
	
				if( _animations.hasOwnProperty( prop ) ) {
					_stopAnimation(prop);
				} 
				
			}
		},
		_animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
			var startAnimTime = _getCurrentTime(), t;
			_registerStartAnimation(name);
	
			var animloop = function(){
				if ( _animations[name] ) {
					
					t = _getCurrentTime() - startAnimTime; // time diff
					//b - beginning (start prop)
					//d - anim duration
	
					if ( t >= d ) {
						_stopAnimation(name);
						onUpdate(endProp);
						if(onComplete) {
							onComplete();
						}
						return;
					}
					onUpdate( (endProp - b) * easingFn(t/d) + b );
	
					_animations[name].raf = _requestAF(animloop);
				}
			};
			animloop();
		};
		
	
	
	var publicMethods = {
	
		// make a few local variables and functions public
		shout: _shout,
		listen: _listen,
		viewportSize: _viewportSize,
		options: _options,
	
		isMainScrollAnimating: function() {
			return _mainScrollAnimating;
		},
		getZoomLevel: function() {
			return _currZoomLevel;
		},
		getCurrentIndex: function() {
			return _currentItemIndex;
		},
		isDragging: function() {
			return _isDragging;
		},	
		isZooming: function() {
			return _isZooming;
		},
		setScrollOffset: function(x,y) {
			_offset.x = x;
			_currentWindowScrollY = _offset.y = y;
			_shout('updateScrollOffset', _offset);
		},
		applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {
			_panOffset.x = panX;
			_panOffset.y = panY;
			_currZoomLevel = zoomLevel;
			_applyCurrentZoomPan( allowRenderResolution );
		},
	
		init: function() {
	
			if(_isOpen || _isDestroying) {
				return;
			}
	
			var i;
	
			self.framework = framework; // basic functionality
			self.template = template; // root DOM element of PhotoSwipe
			self.bg = framework.getChildByClass(template, 'pswp__bg');
	
			_initalClassName = template.className;
			_isOpen = true;
					
			_features = framework.detectFeatures();
			_requestAF = _features.raf;
			_cancelAF = _features.caf;
			_transformKey = _features.transform;
			_oldIE = _features.oldIE;
			
			self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
			self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
	
			_containerStyle = self.container.style; // for fast access
	
			// Objects that hold slides (there are only 3 in DOM)
			self.itemHolders = _itemHolders = [
				{el:self.container.children[0] , wrap:0, index: -1},
				{el:self.container.children[1] , wrap:0, index: -1},
				{el:self.container.children[2] , wrap:0, index: -1}
			];
	
			// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
			_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
	
			_setupTransforms();
	
			// Setup global events
			_globalEventHandlers = {
				resize: self.updateSize,
	
				// Fixes: iOS 10.3 resize event
				// does not update scrollWrap.clientWidth instantly after resize
				// https://github.com/dimsemenov/PhotoSwipe/issues/1315
				orientationchange: function() {
					clearTimeout(_orientationChangeTimeout);
					_orientationChangeTimeout = setTimeout(function() {
						if(_viewportSize.x !== self.scrollWrap.clientWidth) {
							self.updateSize();
						}
					}, 500);
				},
				scroll: _updatePageScrollOffset,
				keydown: _onKeyDown,
				click: _onGlobalClick
			};
	
			// disable show/hide effects on old browsers that don't support CSS animations or transforms, 
			// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
			var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
			if(!_features.animationName || !_features.transform || oldPhone) {
				_options.showAnimationDuration = _options.hideAnimationDuration = 0;
			}
	
			// init modules
			for(i = 0; i < _modules.length; i++) {
				self['init' + _modules[i]]();
			}
			
			// init
			if(UiClass) {
				var ui = self.ui = new UiClass(self, framework);
				ui.init();
			}
	
			_shout('firstUpdate');
			_currentItemIndex = _currentItemIndex || _options.index || 0;
			// validate index
			if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
				_currentItemIndex = 0;
			}
			self.currItem = _getItemAt( _currentItemIndex );
	
			
			if(_features.isOldIOSPhone || _features.isOldAndroid) {
				_isFixedPosition = false;
			}
			
			template.setAttribute('aria-hidden', 'false');
			if(_options.modal) {
				if(!_isFixedPosition) {
					template.style.position = 'absolute';
					template.style.top = framework.getScrollY() + 'px';
				} else {
					template.style.position = 'fixed';
				}
			}
	
			if(_currentWindowScrollY === undefined) {
				_shout('initialLayout');
				_currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
			}
			
			// add classes to root element of PhotoSwipe
			var rootClasses = 'pswp--open ';
			if(_options.mainClass) {
				rootClasses += _options.mainClass + ' ';
			}
			if(_options.showHideOpacity) {
				rootClasses += 'pswp--animate_opacity ';
			}
			rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
			rootClasses += _features.animationName ? ' pswp--css_animation' : '';
			rootClasses += _features.svg ? ' pswp--svg' : '';
			framework.addClass(template, rootClasses);
	
			self.updateSize();
	
			// initial update
			_containerShiftIndex = -1;
			_indexDiff = null;
			for(i = 0; i < NUM_HOLDERS; i++) {
				_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
			}
	
			if(!_oldIE) {
				framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
			}	
	
			_listen('initialZoomInEnd', function() {
				self.setContent(_itemHolders[0], _currentItemIndex-1);
				self.setContent(_itemHolders[2], _currentItemIndex+1);
	
				_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
	
				if(_options.focus) {
					// focus causes layout, 
					// which causes lag during the animation, 
					// that's why we delay it untill the initial zoom transition ends
					template.focus();
				}
				 
	
				_bindEvents();
			});
	
			// set content for center slide (first time)
			self.setContent(_itemHolders[1], _currentItemIndex);
			
			self.updateCurrItem();
	
			_shout('afterInit');
	
			if(!_isFixedPosition) {
	
				// On all versions of iOS lower than 8.0, we check size of viewport every second.
				// 
				// This is done to detect when Safari top & bottom bars appear, 
				// as this action doesn't trigger any events (like resize). 
				// 
				// On iOS8 they fixed this.
				// 
				// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
				
				_updateSizeInterval = setInterval(function() {
					if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
						self.updateSize();
					}
				}, 1000);
			}
	
			framework.addClass(template, 'pswp--visible');
		},
	
		// Close the gallery, then destroy it
		close: function() {
			if(!_isOpen) {
				return;
			}
	
			_isOpen = false;
			_isDestroying = true;
			_shout('close');
			_unbindEvents();
	
			_showOrHide(self.currItem, null, true, self.destroy);
		},
	
		// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
		destroy: function() {
			_shout('destroy');
	
			if(_showOrHideTimeout) {
				clearTimeout(_showOrHideTimeout);
			}
			
			template.setAttribute('aria-hidden', 'true');
			template.className = _initalClassName;
	
			if(_updateSizeInterval) {
				clearInterval(_updateSizeInterval);
			}
	
			framework.unbind(self.scrollWrap, _downEvents, self);
	
			// we unbind scroll event at the end, as closing animation may depend on it
			framework.unbind(window, 'scroll', self);
	
			_stopDragUpdateLoop();
	
			_stopAllAnimations();
	
			_listeners = null;
		},
	
		/**
		 * Pan image to position
		 * @param {Number} x     
		 * @param {Number} y     
		 * @param {Boolean} force Will ignore bounds if set to true.
		 */
		panTo: function(x,y,force) {
			if(!force) {
				if(x > _currPanBounds.min.x) {
					x = _currPanBounds.min.x;
				} else if(x < _currPanBounds.max.x) {
					x = _currPanBounds.max.x;
				}
	
				if(y > _currPanBounds.min.y) {
					y = _currPanBounds.min.y;
				} else if(y < _currPanBounds.max.y) {
					y = _currPanBounds.max.y;
				}
			}
			
			_panOffset.x = x;
			_panOffset.y = y;
			_applyCurrentZoomPan();
		},
		
		handleEvent: function (e) {
			e = e || window.event;
			if(_globalEventHandlers[e.type]) {
				_globalEventHandlers[e.type](e);
			}
		},
	
	
		goTo: function(index) {
	
			index = _getLoopedId(index);
	
			var diff = index - _currentItemIndex;
			_indexDiff = diff;
	
			_currentItemIndex = index;
			self.currItem = _getItemAt( _currentItemIndex );
			_currPositionIndex -= diff;
			
			_moveMainScroll(_slideSize.x * _currPositionIndex);
			
	
			_stopAllAnimations();
			_mainScrollAnimating = false;
	
			self.updateCurrItem();
		},
		next: function() {
			self.goTo( _currentItemIndex + 1);
		},
		prev: function() {
			self.goTo( _currentItemIndex - 1);
		},
	
		// update current zoom/pan objects
		updateCurrZoomItem: function(emulateSetContent) {
			if(emulateSetContent) {
				_shout('beforeChange', 0);
			}
	
			// itemHolder[1] is middle (current) item
			if(_itemHolders[1].el.children.length) {
				var zoomElement = _itemHolders[1].el.children[0];
				if( framework.hasClass(zoomElement, 'pswp__zoom-wrap') ) {
					_currZoomElementStyle = zoomElement.style;
				} else {
					_currZoomElementStyle = null;
				}
			} else {
				_currZoomElementStyle = null;
			}
			
			_currPanBounds = self.currItem.bounds;	
			_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
	
			_panOffset.x = _currPanBounds.center.x;
			_panOffset.y = _currPanBounds.center.y;
	
			if(emulateSetContent) {
				_shout('afterChange');
			}
		},
	
	
		invalidateCurrItems: function() {
			_itemsNeedUpdate = true;
			for(var i = 0; i < NUM_HOLDERS; i++) {
				if( _itemHolders[i].item ) {
					_itemHolders[i].item.needsUpdate = true;
				}
			}
		},
	
		updateCurrItem: function(beforeAnimation) {
	
			if(_indexDiff === 0) {
				return;
			}
	
			var diffAbs = Math.abs(_indexDiff),
				tempHolder;
	
			if(beforeAnimation && diffAbs < 2) {
				return;
			}
	
	
			self.currItem = _getItemAt( _currentItemIndex );
			_renderMaxResolution = false;
			
			_shout('beforeChange', _indexDiff);
	
			if(diffAbs >= NUM_HOLDERS) {
				_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
				diffAbs = NUM_HOLDERS;
			}
			for(var i = 0; i < diffAbs; i++) {
				if(_indexDiff > 0) {
					tempHolder = _itemHolders.shift();
					_itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last
	
					_containerShiftIndex++;
					_setTranslateX( (_containerShiftIndex+2) * _slideSize.x, tempHolder.el.style);
					self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
				} else {
					tempHolder = _itemHolders.pop();
					_itemHolders.unshift( tempHolder ); // move last to first
	
					_containerShiftIndex--;
					_setTranslateX( _containerShiftIndex * _slideSize.x, tempHolder.el.style);
					self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
				}
				
			}
	
			// reset zoom/pan on previous item
			if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
	
				var prevItem = _getItemAt(_prevItemIndex);
				if(prevItem.initialZoomLevel !== _currZoomLevel) {
					_calculateItemSize(prevItem , _viewportSize );
					_setImageSize(prevItem);
					_applyZoomPanToItem( prevItem ); 				
				}
	
			}
	
			// reset diff after update
			_indexDiff = 0;
	
			self.updateCurrZoomItem();
	
			_prevItemIndex = _currentItemIndex;
	
			_shout('afterChange');
			
		},
	
	
	
		updateSize: function(force) {
			
			if(!_isFixedPosition && _options.modal) {
				var windowScrollY = framework.getScrollY();
				if(_currentWindowScrollY !== windowScrollY) {
					template.style.top = windowScrollY + 'px';
					_currentWindowScrollY = windowScrollY;
				}
				if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
					return;
				}
				_windowVisibleSize.x = window.innerWidth;
				_windowVisibleSize.y = window.innerHeight;
	
				//template.style.width = _windowVisibleSize.x + 'px';
				template.style.height = _windowVisibleSize.y + 'px';
			}
	
	
	
			_viewportSize.x = self.scrollWrap.clientWidth;
			_viewportSize.y = self.scrollWrap.clientHeight;
	
			_updatePageScrollOffset();
	
			_slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
			_slideSize.y = _viewportSize.y;
	
			_moveMainScroll(_slideSize.x * _currPositionIndex);
	
			_shout('beforeResize'); // even may be used for example to switch image sources
	
	
			// don't re-calculate size on inital size update
			if(_containerShiftIndex !== undefined) {
	
				var holder,
					item,
					hIndex;
	
				for(var i = 0; i < NUM_HOLDERS; i++) {
					holder = _itemHolders[i];
					_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, holder.el.style);
	
					hIndex = _currentItemIndex+i-1;
	
					if(_options.loop && _getNumItems() > 2) {
						hIndex = _getLoopedId(hIndex);
					}
	
					// update zoom level on items and refresh source (if needsUpdate)
					item = _getItemAt( hIndex );
	
					// re-render gallery item if `needsUpdate`,
					// or doesn't have `bounds` (entirely new slide object)
					if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {
	
						self.cleanSlide( item );
						
						self.setContent( holder, hIndex );
	
						// if "center" slide
						if(i === 1) {
							self.currItem = item;
							self.updateCurrZoomItem(true);
						}
	
						item.needsUpdate = false;
	
					} else if(holder.index === -1 && hIndex >= 0) {
						// add content first time
						self.setContent( holder, hIndex );
					}
					if(item && item.container) {
						_calculateItemSize(item, _viewportSize);
						_setImageSize(item);
						_applyZoomPanToItem( item );
					}
					
				}
				_itemsNeedUpdate = false;
			}	
	
			_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
			_currPanBounds = self.currItem.bounds;
	
			if(_currPanBounds) {
				_panOffset.x = _currPanBounds.center.x;
				_panOffset.y = _currPanBounds.center.y;
				_applyCurrentZoomPan( true );
			}
			
			_shout('resize');
		},
		
		// Zoom current item to
		zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
			/*
				if(destZoomLevel === 'fit') {
					destZoomLevel = self.currItem.fitRatio;
				} else if(destZoomLevel === 'fill') {
					destZoomLevel = self.currItem.fillRatio;
				}
			*/
	
			if(centerPoint) {
				_startZoomLevel = _currZoomLevel;
				_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
				_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
				_equalizePoints(_startPanOffset, _panOffset);
			}
	
			var destPanBounds = _calculatePanBounds(destZoomLevel, false),
				destPanOffset = {};
	
			_modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
			_modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
	
			var initialZoomLevel = _currZoomLevel;
			var initialPanOffset = {
				x: _panOffset.x,
				y: _panOffset.y
			};
	
			_roundPoint(destPanOffset);
	
			var onUpdate = function(now) {
				if(now === 1) {
					_currZoomLevel = destZoomLevel;
					_panOffset.x = destPanOffset.x;
					_panOffset.y = destPanOffset.y;
				} else {
					_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
					_panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
					_panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
				}
	
				if(updateFn) {
					updateFn(now);
				}
	
				_applyCurrentZoomPan( now === 1 );
			};
	
			if(speed) {
				_animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
			} else {
				onUpdate(1);
			}
		}
	
	
	};
	
	
	/*>>core*/
	
	/*>>gestures*/
	/**
	 * Mouse/touch/pointer event handlers.
	 * 
	 * separated from @core.js for readability
	 */
	
	var MIN_SWIPE_DISTANCE = 30,
		DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
	
	var _gestureStartTime,
		_gestureCheckSpeedTime,
	
		// pool of objects that are used during dragging of zooming
		p = {}, // first point
		p2 = {}, // second point (for zoom gesture)
		delta = {},
		_currPoint = {},
		_startPoint = {},
		_currPointers = [],
		_startMainScrollPos = {},
		_releaseAnimData,
		_posPoints = [], // array of points during dragging, used to determine type of gesture
		_tempPoint = {},
	
		_isZoomingIn,
		_verticalDragInitiated,
		_oldAndroidTouchEndTimeout,
		_currZoomedItemIndex = 0,
		_centerPoint = _getEmptyPoint(),
		_lastReleaseTime = 0,
		_isDragging, // at least one pointer is down
		_isMultitouch, // at least two _pointers are down
		_zoomStarted, // zoom level changed during zoom gesture
		_moved,
		_dragAnimFrame,
		_mainScrollShifted,
		_currentPoints, // array of current touch points
		_isZooming,
		_currPointsDistance,
		_startPointsDistance,
		_currPanBounds,
		_mainScrollPos = _getEmptyPoint(),
		_currZoomElementStyle,
		_mainScrollAnimating, // true, if animation after swipe gesture is running
		_midZoomPoint = _getEmptyPoint(),
		_currCenterPoint = _getEmptyPoint(),
		_direction,
		_isFirstMove,
		_opacityChanged,
		_bgOpacity,
		_wasOverInitialZoom,
	
		_isEqualPoints = function(p1, p2) {
			return p1.x === p2.x && p1.y === p2.y;
		},
		_isNearbyPoints = function(touch0, touch1) {
			return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
		},
		_calculatePointsDistance = function(p1, p2) {
			_tempPoint.x = Math.abs( p1.x - p2.x );
			_tempPoint.y = Math.abs( p1.y - p2.y );
			return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
		},
		_stopDragUpdateLoop = function() {
			if(_dragAnimFrame) {
				_cancelAF(_dragAnimFrame);
				_dragAnimFrame = null;
			}
		},
		_dragUpdateLoop = function() {
			if(_isDragging) {
				_dragAnimFrame = _requestAF(_dragUpdateLoop);
				_renderMovement();
			}
		},
		_canPan = function() {
			return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
		},
		
		// find the closest parent DOM element
		_closestElement = function(el, fn) {
		  	if(!el || el === document) {
		  		return false;
		  	}
	
		  	// don't search elements above pswp__scroll-wrap
		  	if(el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1 ) {
		  		return false;
		  	}
	
		  	if( fn(el) ) {
		  		return el;
		  	}
	
		  	return _closestElement(el.parentNode, fn);
		},
	
		_preventObj = {},
		_preventDefaultEventBehaviour = function(e, isDown) {
		    _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
	
			_shout('preventDragEvent', e, isDown, _preventObj);
			return _preventObj.prevent;
	
		},
		_convertTouchToPoint = function(touch, p) {
			p.x = touch.pageX;
			p.y = touch.pageY;
			p.id = touch.identifier;
			return p;
		},
		_findCenterOfPoints = function(p1, p2, pCenter) {
			pCenter.x = (p1.x + p2.x) * 0.5;
			pCenter.y = (p1.y + p2.y) * 0.5;
		},
		_pushPosPoint = function(time, x, y) {
			if(time - _gestureCheckSpeedTime > 50) {
				var o = _posPoints.length > 2 ? _posPoints.shift() : {};
				o.x = x;
				o.y = y; 
				_posPoints.push(o);
				_gestureCheckSpeedTime = time;
			}
		},
	
		_calculateVerticalDragOpacityRatio = function() {
			var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
			return 1 -  Math.abs( yOffset / (_viewportSize.y / 2)  );
		},
	
		
		// points pool, reused during touch events
		_ePoint1 = {},
		_ePoint2 = {},
		_tempPointsArr = [],
		_tempCounter,
		_getTouchPoints = function(e) {
			// clean up previous points, without recreating array
			while(_tempPointsArr.length > 0) {
				_tempPointsArr.pop();
			}
	
			if(!_pointerEventEnabled) {
				if(e.type.indexOf('touch') > -1) {
	
					if(e.touches && e.touches.length > 0) {
						_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
						if(e.touches.length > 1) {
							_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
						}
					}
					
				} else {
					_ePoint1.x = e.pageX;
					_ePoint1.y = e.pageY;
					_ePoint1.id = '';
					_tempPointsArr[0] = _ePoint1;//_ePoint1;
				}
			} else {
				_tempCounter = 0;
				// we can use forEach, as pointer events are supported only in modern browsers
				_currPointers.forEach(function(p) {
					if(_tempCounter === 0) {
						_tempPointsArr[0] = p;
					} else if(_tempCounter === 1) {
						_tempPointsArr[1] = p;
					}
					_tempCounter++;
	
				});
			}
			return _tempPointsArr;
		},
	
		_panOrMoveMainScroll = function(axis, delta) {
	
			var panFriction,
				overDiff = 0,
				newOffset = _panOffset[axis] + delta[axis],
				startOverDiff,
				dir = delta[axis] > 0,
				newMainScrollPosition = _mainScrollPos.x + delta.x,
				mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
				newPanPos,
				newMainScrollPos;
	
			// calculate fdistance over the bounds and friction
			if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
				panFriction = _options.panEndFriction;
				// Linear increasing of friction, so at 1/4 of viewport it's at max value. 
				// Looks not as nice as was expected. Left for history.
				// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
			} else {
				panFriction = 1;
			}
			
			newOffset = _panOffset[axis] + delta[axis] * panFriction;
	
			// move main scroll or start panning
			if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
	
	
				if(!_currZoomElementStyle) {
					
					newMainScrollPos = newMainScrollPosition;
	
				} else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {
					
					if(dir) {
						if(newOffset > _currPanBounds.min[axis]) {
							panFriction = _options.panEndFriction;
							overDiff = _currPanBounds.min[axis] - newOffset;
							startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
						}
						
						// drag right
						if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
							newMainScrollPos = newMainScrollPosition;
							if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
								newMainScrollPos = _startMainScrollPos.x;
							}
						} else {
							if(_currPanBounds.min.x !== _currPanBounds.max.x) {
								newPanPos = newOffset;
							}
							
						}
	
					} else {
	
						if(newOffset < _currPanBounds.max[axis] ) {
							panFriction =_options.panEndFriction;
							overDiff = newOffset - _currPanBounds.max[axis];
							startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
						}
	
						if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
							newMainScrollPos = newMainScrollPosition;
	
							if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
								newMainScrollPos = _startMainScrollPos.x;
							}
	
						} else {
							if(_currPanBounds.min.x !== _currPanBounds.max.x) {
								newPanPos = newOffset;
							}
						}
	
					}
	
	
					//
				}
	
				if(axis === 'x') {
	
					if(newMainScrollPos !== undefined) {
						_moveMainScroll(newMainScrollPos, true);
						if(newMainScrollPos === _startMainScrollPos.x) {
							_mainScrollShifted = false;
						} else {
							_mainScrollShifted = true;
						}
					}
	
					if(_currPanBounds.min.x !== _currPanBounds.max.x) {
						if(newPanPos !== undefined) {
							_panOffset.x = newPanPos;
						} else if(!_mainScrollShifted) {
							_panOffset.x += delta.x * panFriction;
						}
					}
	
					return newMainScrollPos !== undefined;
				}
	
			}
	
			if(!_mainScrollAnimating) {
				
				if(!_mainScrollShifted) {
					if(_currZoomLevel > self.currItem.fitRatio) {
						_panOffset[axis] += delta[axis] * panFriction;
					
					}
				}
	
				
			}
			
		},
	
		// Pointerdown/touchstart/mousedown handler
		_onDragStart = function(e) {
	
			// Allow dragging only via left mouse button.
			// As this handler is not added in IE8 - we ignore e.which
			// 
			// http://www.quirksmode.org/js/events_properties.html
			// https://developer.mozilla.org/en-US/docs/Web/API/event.button
			if(e.type === 'mousedown' && e.button > 0  ) {
				return;
			}
	
			if(_initialZoomRunning) {
				e.preventDefault();
				return;
			}
	
			if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
				return;
			}
	
			if(_preventDefaultEventBehaviour(e, true)) {
				e.preventDefault();
			}
	
	
	
			_shout('pointerDown');
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				if(pointerIndex < 0) {
					pointerIndex = _currPointers.length;
				}
				_currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, id: e.pointerId};
			}
			
	
	
			var startPointsList = _getTouchPoints(e),
				numPoints = startPointsList.length;
	
			_currentPoints = null;
	
			_stopAllAnimations();
	
			// init drag
			if(!_isDragging || numPoints === 1) {
	
				
	
				_isDragging = _isFirstMove = true;
				framework.bind(window, _upMoveEvents, self);
	
				_isZoomingIn = 
					_wasOverInitialZoom = 
					_opacityChanged = 
					_verticalDragInitiated = 
					_mainScrollShifted = 
					_moved = 
					_isMultitouch = 
					_zoomStarted = false;
	
				_direction = null;
	
				_shout('firstTouchStart', startPointsList);
	
				_equalizePoints(_startPanOffset, _panOffset);
	
				_currPanDist.x = _currPanDist.y = 0;
				_equalizePoints(_currPoint, startPointsList[0]);
				_equalizePoints(_startPoint, _currPoint);
	
				//_equalizePoints(_startMainScrollPos, _mainScrollPos);
				_startMainScrollPos.x = _slideSize.x * _currPositionIndex;
	
				_posPoints = [{
					x: _currPoint.x,
					y: _currPoint.y
				}];
	
				_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
	
				//_mainScrollAnimationEnd(true);
				_calculatePanBounds( _currZoomLevel, true );
				
				// Start rendering
				_stopDragUpdateLoop();
				_dragUpdateLoop();
				
			}
	
			// init zoom
			if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
				_startZoomLevel = _currZoomLevel;
				_zoomStarted = false; // true if zoom changed at least once
	
				_isZooming = _isMultitouch = true;
				_currPanDist.y = _currPanDist.x = 0;
	
				_equalizePoints(_startPanOffset, _panOffset);
	
				_equalizePoints(p, startPointsList[0]);
				_equalizePoints(p2, startPointsList[1]);
	
				_findCenterOfPoints(p, p2, _currCenterPoint);
	
				_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
				_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
				_currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
			}
	
	
		},
	
		// Pointermove/touchmove/mousemove handler
		_onDragMove = function(e) {
	
			e.preventDefault();
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				if(pointerIndex > -1) {
					var p = _currPointers[pointerIndex];
					p.x = e.pageX;
					p.y = e.pageY; 
				}
			}
	
			if(_isDragging) {
				var touchesList = _getTouchPoints(e);
				if(!_direction && !_moved && !_isZooming) {
	
					if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
						// if main scroll position is shifted – direction is always horizontal
						_direction = 'h';
					} else {
						var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
						// check the direction of movement
						if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
							_direction = diff > 0 ? 'h' : 'v';
							_currentPoints = touchesList;
						}
					}
					
				} else {
					_currentPoints = touchesList;
				}
			}	
		},
		// 
		_renderMovement =  function() {
	
			if(!_currentPoints) {
				return;
			}
	
			var numPoints = _currentPoints.length;
	
			if(numPoints === 0) {
				return;
			}
	
			_equalizePoints(p, _currentPoints[0]);
	
			delta.x = p.x - _currPoint.x;
			delta.y = p.y - _currPoint.y;
	
			if(_isZooming && numPoints > 1) {
				// Handle behaviour for more than 1 point
	
				_currPoint.x = p.x;
				_currPoint.y = p.y;
			
				// check if one of two points changed
				if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
					return;
				}
	
				_equalizePoints(p2, _currentPoints[1]);
	
	
				if(!_zoomStarted) {
					_zoomStarted = true;
					_shout('zoomGestureStarted');
				}
				
				// Distance between two points
				var pointsDistance = _calculatePointsDistance(p,p2);
	
				var zoomLevel = _calculateZoomLevel(pointsDistance);
	
				// slightly over the of initial zoom level
				if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
					_wasOverInitialZoom = true;
				}
	
				// Apply the friction if zoom level is out of the bounds
				var zoomFriction = 1,
					minZoomLevel = _getMinZoomLevel(),
					maxZoomLevel = _getMaxZoomLevel();
	
				if ( zoomLevel < minZoomLevel ) {
					
					if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
						// fade out background if zooming out
						var minusDiff = minZoomLevel - zoomLevel;
						var percent = 1 - minusDiff / (minZoomLevel / 1.2);
	
						_applyBgOpacity(percent);
						_shout('onPinchClose', percent);
						_opacityChanged = true;
					} else {
						zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
						if(zoomFriction > 1) {
							zoomFriction = 1;
						}
						zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
					}
					
				} else if ( zoomLevel > maxZoomLevel ) {
					// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
					zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
					if(zoomFriction > 1) {
						zoomFriction = 1;
					}
					zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
				}
	
				if(zoomFriction < 0) {
					zoomFriction = 0;
				}
	
				// distance between touch points after friction is applied
				_currPointsDistance = pointsDistance;
	
				// _centerPoint - The point in the middle of two pointers
				_findCenterOfPoints(p, p2, _centerPoint);
			
				// paning with two pointers pressed
				_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
				_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
				_equalizePoints(_currCenterPoint, _centerPoint);
	
				_panOffset.x = _calculatePanOffset('x', zoomLevel);
				_panOffset.y = _calculatePanOffset('y', zoomLevel);
	
				_isZoomingIn = zoomLevel > _currZoomLevel;
				_currZoomLevel = zoomLevel;
				_applyCurrentZoomPan();
	
			} else {
	
				// handle behaviour for one point (dragging or panning)
	
				if(!_direction) {
					return;
				}
	
				if(_isFirstMove) {
					_isFirstMove = false;
	
					// subtract drag distance that was used during the detection direction  
	
					if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
						delta.x -= _currentPoints[0].x - _startPoint.x;
					}
					
					if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
						delta.y -= _currentPoints[0].y - _startPoint.y;
					}
				}
	
				_currPoint.x = p.x;
				_currPoint.y = p.y;
	
				// do nothing if pointers position hasn't changed
				if(delta.x === 0 && delta.y === 0) {
					return;
				}
	
				if(_direction === 'v' && _options.closeOnVerticalDrag) {
					if(!_canPan()) {
						_currPanDist.y += delta.y;
						_panOffset.y += delta.y;
	
						var opacityRatio = _calculateVerticalDragOpacityRatio();
	
						_verticalDragInitiated = true;
						_shout('onVerticalDrag', opacityRatio);
	
						_applyBgOpacity(opacityRatio);
						_applyCurrentZoomPan();
						return ;
					}
				}
	
				_pushPosPoint(_getCurrentTime(), p.x, p.y);
	
				_moved = true;
				_currPanBounds = self.currItem.bounds;
				
				var mainScrollChanged = _panOrMoveMainScroll('x', delta);
				if(!mainScrollChanged) {
					_panOrMoveMainScroll('y', delta);
	
					_roundPoint(_panOffset);
					_applyCurrentZoomPan();
				}
	
			}
	
		},
		
		// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
		_onDragRelease = function(e) {
	
			if(_features.isOldAndroid ) {
	
				if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
					return;
				}
	
				// on Android (v4.1, 4.2, 4.3 & possibly older) 
				// ghost mousedown/up event isn't preventable via e.preventDefault,
				// which causes fake mousedown event
				// so we block mousedown/up for 600ms
				if( e.type.indexOf('touch') > -1 ) {
					clearTimeout(_oldAndroidTouchEndTimeout);
					_oldAndroidTouchEndTimeout = setTimeout(function() {
						_oldAndroidTouchEndTimeout = 0;
					}, 600);
				}
				
			}
	
			_shout('pointerUp');
	
			if(_preventDefaultEventBehaviour(e, false)) {
				e.preventDefault();
			}
	
			var releasePoint;
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				
				if(pointerIndex > -1) {
					releasePoint = _currPointers.splice(pointerIndex, 1)[0];
	
					if(navigator.msPointerEnabled) {
						var MSPOINTER_TYPES = {
							4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
							2: 'touch', // event.MSPOINTER_TYPE_TOUCH 
							3: 'pen' // event.MSPOINTER_TYPE_PEN
						};
						releasePoint.type = MSPOINTER_TYPES[e.pointerType];
	
						if(!releasePoint.type) {
							releasePoint.type = e.pointerType || 'mouse';
						}
					} else {
						releasePoint.type = e.pointerType || 'mouse';
					}
	
				}
			}
	
			var touchList = _getTouchPoints(e),
				gestureType,
				numPoints = touchList.length;
	
			if(e.type === 'mouseup') {
				numPoints = 0;
			}
	
			// Do nothing if there were 3 touch points or more
			if(numPoints === 2) {
				_currentPoints = null;
				return true;
			}
	
			// if second pointer released
			if(numPoints === 1) {
				_equalizePoints(_startPoint, touchList[0]);
			}				
	
	
			// pointer hasn't moved, send "tap release" point
			if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
				if(!releasePoint) {
					if(e.type === 'mouseup') {
						releasePoint = {x: e.pageX, y: e.pageY, type:'mouse'};
					} else if(e.changedTouches && e.changedTouches[0]) {
						releasePoint = {x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type:'touch'};
					}		
				}
	
				_shout('touchRelease', e, releasePoint);
			}
	
			// Difference in time between releasing of two last touch points (zoom gesture)
			var releaseTimeDiff = -1;
	
			// Gesture completed, no pointers left
			if(numPoints === 0) {
				_isDragging = false;
				framework.unbind(window, _upMoveEvents, self);
	
				_stopDragUpdateLoop();
	
				if(_isZooming) {
					// Two points released at the same time
					releaseTimeDiff = 0;
				} else if(_lastReleaseTime !== -1) {
					releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
				}
			}
			_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
			
			if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
				gestureType = 'zoom';
			} else {
				gestureType = 'swipe';
			}
	
			if(_isZooming && numPoints < 2) {
				_isZooming = false;
	
				// Only second point released
				if(numPoints === 1) {
					gestureType = 'zoomPointerUp';
				}
				_shout('zoomGestureEnded');
			}
	
			_currentPoints = null;
			if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
				// nothing to animate
				return;
			}
		
			_stopAllAnimations();
	
			
			if(!_releaseAnimData) {
				_releaseAnimData = _initDragReleaseAnimationData();
			}
			
			_releaseAnimData.calculateSwipeSpeed('x');
	
	
			if(_verticalDragInitiated) {
	
				var opacityRatio = _calculateVerticalDragOpacityRatio();
	
				if(opacityRatio < _options.verticalDragRange) {
					self.close();
				} else {
					var initalPanY = _panOffset.y,
						initialBgOpacity = _bgOpacity;
	
					_animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
						
						_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
	
						_applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
						_applyCurrentZoomPan();
					});
	
					_shout('onVerticalDrag', 1);
				}
	
				return;
			}
	
	
			// main scroll 
			if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
				var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
				if(itemChanged) {
					return;
				}
				gestureType = 'zoomPointerUp';
			}
	
			// prevent zoom/pan animation when main scroll animation runs
			if(_mainScrollAnimating) {
				return;
			}
			
			// Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
			if(gestureType !== 'swipe') {
				_completeZoomGesture();
				return;
			}
		
			// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
			if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
				_completePanGesture(_releaseAnimData);
			}
		},
	
	
		// Returns object with data about gesture
		// It's created only once and then reused
		_initDragReleaseAnimationData  = function() {
			// temp local vars
			var lastFlickDuration,
				tempReleasePos;
	
			// s = this
			var s = {
				lastFlickOffset: {},
				lastFlickDist: {},
				lastFlickSpeed: {},
				slowDownRatio:  {},
				slowDownRatioReverse:  {},
				speedDecelerationRatio:  {},
				speedDecelerationRatioAbs:  {},
				distanceOffset:  {},
				backAnimDestination: {},
				backAnimStarted: {},
				calculateSwipeSpeed: function(axis) {
					
	
					if( _posPoints.length > 1) {
						lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
						tempReleasePos = _posPoints[_posPoints.length-2][axis];
					} else {
						lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
						tempReleasePos = _startPoint[axis];
					}
					s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
					s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
					if(s.lastFlickDist[axis] > 20) {
						s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
					} else {
						s.lastFlickSpeed[axis] = 0;
					}
					if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
						s.lastFlickSpeed[axis] = 0;
					}
					
					s.slowDownRatio[axis] = 0.95;
					s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
					s.speedDecelerationRatio[axis] = 1;
				},
	
				calculateOverBoundsAnimOffset: function(axis, speed) {
					if(!s.backAnimStarted[axis]) {
	
						if(_panOffset[axis] > _currPanBounds.min[axis]) {
							s.backAnimDestination[axis] = _currPanBounds.min[axis];
							
						} else if(_panOffset[axis] < _currPanBounds.max[axis]) {
							s.backAnimDestination[axis] = _currPanBounds.max[axis];
						}
	
						if(s.backAnimDestination[axis] !== undefined) {
							s.slowDownRatio[axis] = 0.7;
							s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
							if(s.speedDecelerationRatioAbs[axis] < 0.05) {
	
								s.lastFlickSpeed[axis] = 0;
								s.backAnimStarted[axis] = true;
	
								_animateProp('bounceZoomPan'+axis,_panOffset[axis], 
									s.backAnimDestination[axis], 
									speed || 300, 
									framework.easing.sine.out, 
									function(pos) {
										_panOffset[axis] = pos;
										_applyCurrentZoomPan();
									}
								);
	
							}
						}
					}
				},
	
				// Reduces the speed by slowDownRatio (per 10ms)
				calculateAnimOffset: function(axis) {
					if(!s.backAnimStarted[axis]) {
						s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + 
													s.slowDownRatioReverse[axis] - 
													s.slowDownRatioReverse[axis] * s.timeDiff / 10);
	
						s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
						s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
						_panOffset[axis] += s.distanceOffset[axis];
	
					}
				},
	
				panAnimLoop: function() {
					if ( _animations.zoomPan ) {
						_animations.zoomPan.raf = _requestAF(s.panAnimLoop);
	
						s.now = _getCurrentTime();
						s.timeDiff = s.now - s.lastNow;
						s.lastNow = s.now;
						
						s.calculateAnimOffset('x');
						s.calculateAnimOffset('y');
	
						_applyCurrentZoomPan();
						
						s.calculateOverBoundsAnimOffset('x');
						s.calculateOverBoundsAnimOffset('y');
	
	
						if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
	
							// round pan position
							_panOffset.x = Math.round(_panOffset.x);
							_panOffset.y = Math.round(_panOffset.y);
							_applyCurrentZoomPan();
							
							_stopAnimation('zoomPan');
							return;
						}
					}
	
				}
			};
			return s;
		},
	
		_completePanGesture = function(animData) {
			// calculate swipe speed for Y axis (paanning)
			animData.calculateSwipeSpeed('y');
	
			_currPanBounds = self.currItem.bounds;
			
			animData.backAnimDestination = {};
			animData.backAnimStarted = {};
	
			// Avoid acceleration animation if speed is too low
			if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
				animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
	
				// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
				animData.calculateOverBoundsAnimOffset('x');
				animData.calculateOverBoundsAnimOffset('y');
				return true;
			}
	
			// Animation loop that controls the acceleration after pan gesture ends
			_registerStartAnimation('zoomPan');
			animData.lastNow = _getCurrentTime();
			animData.panAnimLoop();
		},
	
	
		_finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
			var itemChanged;
			if(!_mainScrollAnimating) {
				_currZoomedItemIndex = _currentItemIndex;
			}
	
	
			
			var itemsDiff;
	
			if(gestureType === 'swipe') {
				var totalShiftDist = _currPoint.x - _startPoint.x,
					isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
	
				// if container is shifted for more than MIN_SWIPE_DISTANCE, 
				// and last flick gesture was in right direction
				if(totalShiftDist > MIN_SWIPE_DISTANCE && 
					(isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
					// go to prev item
					itemsDiff = -1;
				} else if(totalShiftDist < -MIN_SWIPE_DISTANCE && 
					(isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
					// go to next item
					itemsDiff = 1;
				}
			}
	
			var nextCircle;
	
			if(itemsDiff) {
				
				_currentItemIndex += itemsDiff;
	
				if(_currentItemIndex < 0) {
					_currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
					nextCircle = true;
				} else if(_currentItemIndex >= _getNumItems()) {
					_currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
					nextCircle = true;
				}
	
				if(!nextCircle || _options.loop) {
					_indexDiff += itemsDiff;
					_currPositionIndex -= itemsDiff;
					itemChanged = true;
				}
				
	
				
			}
	
			var animateToX = _slideSize.x * _currPositionIndex;
			var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
			var finishAnimDuration;
	
	
			if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
				// "return to current" duration, e.g. when dragging from slide 0 to -1
				finishAnimDuration = 333; 
			} else {
				finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? 
										animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 
										333;
	
				finishAnimDuration = Math.min(finishAnimDuration, 400);
				finishAnimDuration = Math.max(finishAnimDuration, 250);
			}
	
			if(_currZoomedItemIndex === _currentItemIndex) {
				itemChanged = false;
			}
			
			_mainScrollAnimating = true;
			
			_shout('mainScrollAnimStart');
	
			_animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, 
				_moveMainScroll,
				function() {
					_stopAllAnimations();
					_mainScrollAnimating = false;
					_currZoomedItemIndex = -1;
					
					if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
						self.updateCurrItem();
					}
					
					_shout('mainScrollAnimComplete');
				}
			);
	
			if(itemChanged) {
				self.updateCurrItem(true);
			}
	
			return itemChanged;
		},
	
		_calculateZoomLevel = function(touchesDistance) {
			return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
		},
	
		// Resets zoom if it's out of bounds
		_completeZoomGesture = function() {
			var destZoomLevel = _currZoomLevel,
				minZoomLevel = _getMinZoomLevel(),
				maxZoomLevel = _getMaxZoomLevel();
	
			if ( _currZoomLevel < minZoomLevel ) {
				destZoomLevel = minZoomLevel;
			} else if ( _currZoomLevel > maxZoomLevel ) {
				destZoomLevel = maxZoomLevel;
			}
	
			var destOpacity = 1,
				onUpdate,
				initialOpacity = _bgOpacity;
	
			if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
				//_closedByScroll = true;
				self.close();
				return true;
			}
	
			if(_opacityChanged) {
				onUpdate = function(now) {
					_applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
				};
			}
	
			self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
			return true;
		};
	
	
	_registerModule('Gestures', {
		publicMethods: {
	
			initGestures: function() {
	
				// helper function that builds touch/pointer/mouse events
				var addEventNames = function(pref, down, move, up, cancel) {
					_dragStartEvent = pref + down;
					_dragMoveEvent = pref + move;
					_dragEndEvent = pref + up;
					if(cancel) {
						_dragCancelEvent = pref + cancel;
					} else {
						_dragCancelEvent = '';
					}
				};
	
				_pointerEventEnabled = _features.pointerEvent;
				if(_pointerEventEnabled && _features.touch) {
					// we don't need touch events, if browser supports pointer events
					_features.touch = false;
				}
	
				if(_pointerEventEnabled) {
					if(navigator.msPointerEnabled) {
						// IE10 pointer events are case-sensitive
						addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
					} else {
						addEventNames('pointer', 'down', 'move', 'up', 'cancel');
					}
				} else if(_features.touch) {
					addEventNames('touch', 'start', 'move', 'end', 'cancel');
					_likelyTouchDevice = true;
				} else {
					addEventNames('mouse', 'down', 'move', 'up');	
				}
	
				_upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
				_downEvents = _dragStartEvent;
	
				if(_pointerEventEnabled && !_likelyTouchDevice) {
					_likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
				}
				// make variable public
				self.likelyTouchDevice = _likelyTouchDevice; 
				
				_globalEventHandlers[_dragStartEvent] = _onDragStart;
				_globalEventHandlers[_dragMoveEvent] = _onDragMove;
				_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
	
				if(_dragCancelEvent) {
					_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
				}
	
				// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
				if(_features.touch) {
					_downEvents += ' mousedown';
					_upMoveEvents += ' mousemove mouseup';
					_globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
					_globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
					_globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
				}
	
				if(!_likelyTouchDevice) {
					// don't allow pan to next slide from zoomed state on Desktop
					_options.allowPanToNext = false;
				}
			}
	
		}
	});
	
	
	/*>>gestures*/
	
	/*>>show-hide-transition*/
	/**
	 * show-hide-transition.js:
	 *
	 * Manages initial opening or closing transition.
	 *
	 * If you're not planning to use transition for gallery at all,
	 * you may set options hideAnimationDuration and showAnimationDuration to 0,
	 * and just delete startAnimation function.
	 * 
	 */
	
	
	var _showOrHideTimeout,
		_showOrHide = function(item, img, out, completeFn) {
	
			if(_showOrHideTimeout) {
				clearTimeout(_showOrHideTimeout);
			}
	
			_initialZoomRunning = true;
			_initialContentSet = true;
			
			// dimensions of small thumbnail {x:,y:,w:}.
			// Height is optional, as calculated based on large image.
			var thumbBounds; 
			if(item.initialLayout) {
				thumbBounds = item.initialLayout;
				item.initialLayout = null;
			} else {
				thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
			}
	
			var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
	
			var onComplete = function() {
				_stopAnimation('initialZoom');
				if(!out) {
					_applyBgOpacity(1);
					if(img) {
						img.style.display = 'block';
					}
					framework.addClass(template, 'pswp--animated-in');
					_shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
				} else {
					self.template.removeAttribute('style');
					self.bg.removeAttribute('style');
				}
	
				if(completeFn) {
					completeFn();
				}
				_initialZoomRunning = false;
			};
	
			// if bounds aren't provided, just open gallery without animation
			if(!duration || !thumbBounds || thumbBounds.x === undefined) {
	
				_shout('initialZoom' + (out ? 'Out' : 'In') );
	
				_currZoomLevel = item.initialZoomLevel;
				_equalizePoints(_panOffset,  item.initialPosition );
				_applyCurrentZoomPan();
	
				template.style.opacity = out ? 0 : 1;
				_applyBgOpacity(1);
	
				if(duration) {
					setTimeout(function() {
						onComplete();
					}, duration);
				} else {
					onComplete();
				}
	
				return;
			}
	
			var startAnimation = function() {
				var closeWithRaf = _closedByScroll,
					fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
				
				// apply hw-acceleration to image
				if(item.miniImg) {
					item.miniImg.style.webkitBackfaceVisibility = 'hidden';
				}
	
				if(!out) {
					_currZoomLevel = thumbBounds.w / item.w;
					_panOffset.x = thumbBounds.x;
					_panOffset.y = thumbBounds.y - _initalWindowScrollY;
	
					self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
					_applyCurrentZoomPan();
				}
	
				_registerStartAnimation('initialZoom');
				
				if(out && !closeWithRaf) {
					framework.removeClass(template, 'pswp--animated-in');
				}
	
				if(fadeEverything) {
					if(out) {
						framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'pswp--animate_opacity');
					} else {
						setTimeout(function() {
							framework.addClass(template, 'pswp--animate_opacity');
						}, 30);
					}
				}
	
				_showOrHideTimeout = setTimeout(function() {
	
					_shout('initialZoom' + (out ? 'Out' : 'In') );
					
	
					if(!out) {
	
						// "in" animation always uses CSS transitions (instead of rAF).
						// CSS transition work faster here, 
						// as developer may also want to animate other things, 
						// like ui on top of sliding area, which can be animated just via CSS
						
						_currZoomLevel = item.initialZoomLevel;
						_equalizePoints(_panOffset,  item.initialPosition );
						_applyCurrentZoomPan();
						_applyBgOpacity(1);
	
						if(fadeEverything) {
							template.style.opacity = 1;
						} else {
							_applyBgOpacity(1);
						}
	
						_showOrHideTimeout = setTimeout(onComplete, duration + 20);
					} else {
	
						// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
						var destZoomLevel = thumbBounds.w / item.w,
							initialPanOffset = {
								x: _panOffset.x,
								y: _panOffset.y
							},
							initialZoomLevel = _currZoomLevel,
							initalBgOpacity = _bgOpacity,
							onUpdate = function(now) {
								
								if(now === 1) {
									_currZoomLevel = destZoomLevel;
									_panOffset.x = thumbBounds.x;
									_panOffset.y = thumbBounds.y  - _currentWindowScrollY;
								} else {
									_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
									_panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
									_panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
								}
								
								_applyCurrentZoomPan();
								if(fadeEverything) {
									template.style.opacity = 1 - now;
								} else {
									_applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
								}
							};
	
						if(closeWithRaf) {
							_animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
						} else {
							onUpdate(1);
							_showOrHideTimeout = setTimeout(onComplete, duration + 20);
						}
					}
				
				}, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
						// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
						// Which avoids lag at the beginning of scale transition.
			};
			startAnimation();
	
			
		};
	
	/*>>show-hide-transition*/
	
	/*>>items-controller*/
	/**
	*
	* Controller manages gallery items, their dimensions, and their content.
	* 
	*/
	
	var _items,
		_tempPanAreaSize = {},
		_imagesToAppendPool = [],
		_initialContentSet,
		_initialZoomRunning,
		_controllerDefaultOptions = {
			index: 0,
			errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
			forceProgressiveLoading: false, // TODO
			preload: [1,1],
			getNumItemsFn: function() {
				return _items.length;
			}
		};
	
	
	var _getItemAt,
		_getNumItems,
		_initialIsLoop,
		_getZeroBounds = function() {
			return {
				center:{x:0,y:0}, 
				max:{x:0,y:0}, 
				min:{x:0,y:0}
			};
		},
		_calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {
			var bounds = item.bounds;
	
			// position of element when it's centered
			bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
			bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
	
			// maximum pan position
			bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ? 
								Math.round(_tempPanAreaSize.x - realPanElementW) : 
								bounds.center.x;
			
			bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ? 
								Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : 
								bounds.center.y;
			
			// minimum pan position
			bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? 0 : bounds.center.x;
			bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
		},
		_calculateItemSize = function(item, viewportSize, zoomLevel) {
	
			if (item.src && !item.loadError) {
				var isInitial = !zoomLevel;
				
				if(isInitial) {
					if(!item.vGap) {
						item.vGap = {top:0,bottom:0};
					}
					// allows overriding vertical margin for individual items
					_shout('parseVerticalMargin', item);
				}
	
	
				_tempPanAreaSize.x = viewportSize.x;
				_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
	
				if (isInitial) {
					var hRatio = _tempPanAreaSize.x / item.w;
					var vRatio = _tempPanAreaSize.y / item.h;
	
					item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
					//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
	
					var scaleMode = _options.scaleMode;
	
					if (scaleMode === 'orig') {
						zoomLevel = 1;
					} else if (scaleMode === 'fit') {
						zoomLevel = item.fitRatio;
					}
	
					if (zoomLevel > 1) {
						zoomLevel = 1;
					}
	
					item.initialZoomLevel = zoomLevel;
					
					if(!item.bounds) {
						// reuse bounds object
						item.bounds = _getZeroBounds(); 
					}
				}
	
				if(!zoomLevel) {
					return;
				}
	
				_calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
	
				if (isInitial && zoomLevel === item.initialZoomLevel) {
					item.initialPosition = item.bounds.center;
				}
	
				return item.bounds;
			} else {
				item.w = item.h = 0;
				item.initialZoomLevel = item.fitRatio = 1;
				item.bounds = _getZeroBounds();
				item.initialPosition = item.bounds.center;
	
				// if it's not image, we return zero bounds (content is not zoomable)
				return item.bounds;
			}
			
		},
	
		
	
	
		_appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
			
	
			if(item.loadError) {
				return;
			}
	
			if(img) {
	
				item.imageAppended = true;
				_setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );
				
				baseDiv.appendChild(img);
	
				if(keepPlaceholder) {
					setTimeout(function() {
						if(item && item.loaded && item.placeholder) {
							item.placeholder.style.display = 'none';
							item.placeholder = null;
						}
					}, 500);
				}
			}
		},
		
	
	
		_preloadImage = function(item) {
			item.loading = true;
			item.loaded = false;
			var img = item.img = framework.createEl('pswp__img', 'img');
			var onComplete = function() {
				item.loading = false;
				item.loaded = true;
	
				if(item.loadComplete) {
					item.loadComplete(item);
				} else {
					item.img = null; // no need to store image object
				}
				img.onload = img.onerror = null;
				img = null;
			};
			img.onload = onComplete;
			img.onerror = function() {
				item.loadError = true;
				onComplete();
			};		
	
			img.src = item.src;// + '?a=' + Math.random();
	
			return img;
		},
		_checkForError = function(item, cleanUp) {
			if(item.src && item.loadError && item.container) {
	
				if(cleanUp) {
					item.container.innerHTML = '';
				}
	
				item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
				return true;
				
			}
		},
		_setImageSize = function(item, img, maxRes) {
			if(!item.src) {
				return;
			}
	
			if(!img) {
				img = item.container.lastChild;
			}
	
			var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
				h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
			
			if(item.placeholder && !item.loaded) {
				item.placeholder.style.width = w + 'px';
				item.placeholder.style.height = h + 'px';
			}
	
			img.style.width = w + 'px';
			img.style.height = h + 'px';
		},
		_appendImagesPool = function() {
	
			if(_imagesToAppendPool.length) {
				var poolItem;
	
				for(var i = 0; i < _imagesToAppendPool.length; i++) {
					poolItem = _imagesToAppendPool[i];
					if( poolItem.holder.index === poolItem.index ) {
						_appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
					}
				}
				_imagesToAppendPool = [];
			}
		};
		
	
	
	_registerModule('Controller', {
	
		publicMethods: {
	
			lazyLoadItem: function(index) {
				index = _getLoopedId(index);
				var item = _getItemAt(index);
	
				if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
					return;
				}
	
				_shout('gettingData', index, item);
	
				if (!item.src) {
					return;
				}
	
				_preloadImage(item);
			},
			initController: function() {
				framework.extend(_options, _controllerDefaultOptions, true);
				self.items = _items = items;
				_getItemAt = self.getItemAt;
				_getNumItems = _options.getNumItemsFn; //self.getNumItems;
	
	
	
				_initialIsLoop = _options.loop;
				if(_getNumItems() < 3) {
					_options.loop = false; // disable loop if less then 3 items
				}
	
				_listen('beforeChange', function(diff) {
	
					var p = _options.preload,
						isNext = diff === null ? true : (diff >= 0),
						preloadBefore = Math.min(p[0], _getNumItems() ),
						preloadAfter = Math.min(p[1], _getNumItems() ),
						i;
	
	
					for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
						self.lazyLoadItem(_currentItemIndex+i);
					}
					for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
						self.lazyLoadItem(_currentItemIndex-i);
					}
				});
	
				_listen('initialLayout', function() {
					self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
				});
	
				_listen('mainScrollAnimComplete', _appendImagesPool);
				_listen('initialZoomInEnd', _appendImagesPool);
	
	
	
				_listen('destroy', function() {
					var item;
					for(var i = 0; i < _items.length; i++) {
						item = _items[i];
						// remove reference to DOM elements, for GC
						if(item.container) {
							item.container = null; 
						}
						if(item.placeholder) {
							item.placeholder = null;
						}
						if(item.img) {
							item.img = null;
						}
						if(item.preloader) {
							item.preloader = null;
						}
						if(item.loadError) {
							item.loaded = item.loadError = false;
						}
					}
					_imagesToAppendPool = null;
				});
			},
	
	
			getItemAt: function(index) {
				if (index >= 0) {
					return _items[index] !== undefined ? _items[index] : false;
				}
				return false;
			},
	
			allowProgressiveImg: function() {
				// 1. Progressive image loading isn't working on webkit/blink 
				//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
				//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
				//    
				// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
				//    That's why it's disabled on touch devices (mainly because of swipe transition)
				//    
				// 3. Progressive image loading sometimes doesn't work in IE (up to 11).
	
				// Don't allow progressive loading on non-large touch devices
				return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200; 
				// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
			},
	
			setContent: function(holder, index) {
	
				if(_options.loop) {
					index = _getLoopedId(index);
				}
	
				var prevItem = self.getItemAt(holder.index);
				if(prevItem) {
					prevItem.container = null;
				}
		
				var item = self.getItemAt(index),
					img;
				
				if(!item) {
					holder.el.innerHTML = '';
					return;
				}
	
				// allow to override data
				_shout('gettingData', index, item);
	
				holder.index = index;
				holder.item = item;
	
				// base container DIV is created only once for each of 3 holders
				var baseDiv = item.container = framework.createEl('pswp__zoom-wrap'); 
	
				
	
				if(!item.src && item.html) {
					if(item.html.tagName) {
						baseDiv.appendChild(item.html);
					} else {
						baseDiv.innerHTML = item.html;
					}
				}
	
				_checkForError(item);
	
				_calculateItemSize(item, _viewportSize);
				
				if(item.src && !item.loadError && !item.loaded) {
	
					item.loadComplete = function(item) {
	
						// gallery closed before image finished loading
						if(!_isOpen) {
							return;
						}
	
						// check if holder hasn't changed while image was loading
						if(holder && holder.index === index ) {
							if( _checkForError(item, true) ) {
								item.loadComplete = item.img = null;
								_calculateItemSize(item, _viewportSize);
								_applyZoomPanToItem(item);
	
								if(holder.index === _currentItemIndex) {
									// recalculate dimensions
									self.updateCurrZoomItem();
								}
								return;
							}
							if( !item.imageAppended ) {
								if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
									_imagesToAppendPool.push({
										item:item,
										baseDiv:baseDiv,
										img:item.img,
										index:index,
										holder:holder,
										clearPlaceholder:true
									});
								} else {
									_appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
								}
							} else {
								// remove preloader & mini-img
								if(!_initialZoomRunning && item.placeholder) {
									item.placeholder.style.display = 'none';
									item.placeholder = null;
								}
							}
						}
	
						item.loadComplete = null;
						item.img = null; // no need to store image element after it's added
	
						_shout('imageLoadComplete', index, item);
					};
	
					if(framework.features.transform) {
						
						var placeholderClassName = 'pswp__img pswp__img--placeholder'; 
						placeholderClassName += (item.msrc ? '' : ' pswp__img--placeholder--blank');
	
						var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
						if(item.msrc) {
							placeholder.src = item.msrc;
						}
						
						_setImageSize(item, placeholder);
	
						baseDiv.appendChild(placeholder);
						item.placeholder = placeholder;
	
					}
					
	
					
	
					if(!item.loading) {
						_preloadImage(item);
					}
	
	
					if( self.allowProgressiveImg() ) {
						// just append image
						if(!_initialContentSet && _features.transform) {
							_imagesToAppendPool.push({
								item:item, 
								baseDiv:baseDiv, 
								img:item.img, 
								index:index, 
								holder:holder
							});
						} else {
							_appendImage(index, item, baseDiv, item.img, true, true);
						}
					}
					
				} else if(item.src && !item.loadError) {
					// image object is created every time, due to bugs of image loading & delay when switching images
					img = framework.createEl('pswp__img', 'img');
					img.style.opacity = 1;
					img.src = item.src;
					_setImageSize(item, img);
					_appendImage(index, item, baseDiv, img, true);
				}
				
	
				if(!_initialContentSet && index === _currentItemIndex) {
					_currZoomElementStyle = baseDiv.style;
					_showOrHide(item, (img ||item.img) );
				} else {
					_applyZoomPanToItem(item);
				}
	
				holder.el.innerHTML = '';
				holder.el.appendChild(baseDiv);
			},
	
			cleanSlide: function( item ) {
				if(item.img ) {
					item.img.onload = item.img.onerror = null;
				}
				item.loaded = item.loading = item.img = item.imageAppended = false;
			}
	
		}
	});
	
	/*>>items-controller*/
	
	/*>>tap*/
	/**
	 * tap.js:
	 *
	 * Displatches tap and double-tap events.
	 * 
	 */
	
	var tapTimer,
		tapReleasePoint = {},
		_dispatchTapEvent = function(origEvent, releasePoint, pointerType) {		
			var e = document.createEvent( 'CustomEvent' ),
				eDetail = {
					origEvent:origEvent, 
					target:origEvent.target, 
					releasePoint: releasePoint, 
					pointerType:pointerType || 'touch'
				};
	
			e.initCustomEvent( 'pswpTap', true, true, eDetail );
			origEvent.target.dispatchEvent(e);
		};
	
	_registerModule('Tap', {
		publicMethods: {
			initTap: function() {
				_listen('firstTouchStart', self.onTapStart);
				_listen('touchRelease', self.onTapRelease);
				_listen('destroy', function() {
					tapReleasePoint = {};
					tapTimer = null;
				});
			},
			onTapStart: function(touchList) {
				if(touchList.length > 1) {
					clearTimeout(tapTimer);
					tapTimer = null;
				}
			},
			onTapRelease: function(e, releasePoint) {
				if(!releasePoint) {
					return;
				}
	
				if(!_moved && !_isMultitouch && !_numAnimations) {
					var p0 = releasePoint;
					if(tapTimer) {
						clearTimeout(tapTimer);
						tapTimer = null;
	
						// Check if taped on the same place
						if ( _isNearbyPoints(p0, tapReleasePoint) ) {
							_shout('doubleTap', p0);
							return;
						}
					}
	
					if(releasePoint.type === 'mouse') {
						_dispatchTapEvent(e, releasePoint, 'mouse');
						return;
					}
	
					var clickedTagName = e.target.tagName.toUpperCase();
					// avoid double tap delay on buttons and elements that have class pswp__single-tap
					if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap') ) {
						_dispatchTapEvent(e, releasePoint);
						return;
					}
	
					_equalizePoints(tapReleasePoint, p0);
	
					tapTimer = setTimeout(function() {
						_dispatchTapEvent(e, releasePoint);
						tapTimer = null;
					}, 300);
				}
			}
		}
	});
	
	/*>>tap*/
	
	/*>>desktop-zoom*/
	/**
	 *
	 * desktop-zoom.js:
	 *
	 * - Binds mousewheel event for paning zoomed image.
	 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
	 *   (which are used for cursors and zoom icon)
	 * - Adds toggleDesktopZoom function.
	 * 
	 */
	
	var _wheelDelta;
		
	_registerModule('DesktopZoom', {
	
		publicMethods: {
	
			initDesktopZoom: function() {
	
				if(_oldIE) {
					// no zoom for old IE (<=8)
					return;
				}
	
				if(_likelyTouchDevice) {
					// if detected hardware touch support, we wait until mouse is used,
					// and only then apply desktop-zoom features
					_listen('mouseUsed', function() {
						self.setupDesktopZoom();
					});
				} else {
					self.setupDesktopZoom(true);
				}
	
			},
	
			setupDesktopZoom: function(onInit) {
	
				_wheelDelta = {};
	
				var events = 'wheel mousewheel DOMMouseScroll';
				
				_listen('bindEvents', function() {
					framework.bind(template, events,  self.handleMouseWheel);
				});
	
				_listen('unbindEvents', function() {
					if(_wheelDelta) {
						framework.unbind(template, events, self.handleMouseWheel);
					}
				});
	
				self.mouseZoomedIn = false;
	
				var hasDraggingClass,
					updateZoomable = function() {
						if(self.mouseZoomedIn) {
							framework.removeClass(template, 'pswp--zoomed-in');
							self.mouseZoomedIn = false;
						}
						if(_currZoomLevel < 1) {
							framework.addClass(template, 'pswp--zoom-allowed');
						} else {
							framework.removeClass(template, 'pswp--zoom-allowed');
						}
						removeDraggingClass();
					},
					removeDraggingClass = function() {
						if(hasDraggingClass) {
							framework.removeClass(template, 'pswp--dragging');
							hasDraggingClass = false;
						}
					};
	
				_listen('resize' , updateZoomable);
				_listen('afterChange' , updateZoomable);
				_listen('pointerDown', function() {
					if(self.mouseZoomedIn) {
						hasDraggingClass = true;
						framework.addClass(template, 'pswp--dragging');
					}
				});
				_listen('pointerUp', removeDraggingClass);
	
				if(!onInit) {
					updateZoomable();
				}
				
			},
	
			handleMouseWheel: function(e) {
	
				if(_currZoomLevel <= self.currItem.fitRatio) {
					if( _options.modal ) {
	
						if (!_options.closeOnScroll || _numAnimations || _isDragging) {
							e.preventDefault();
						} else if(_transformKey && Math.abs(e.deltaY) > 2) {
							// close PhotoSwipe
							// if browser supports transforms & scroll changed enough
							_closedByScroll = true;
							self.close();
						}
	
					}
					return true;
				}
	
				// allow just one event to fire
				e.stopPropagation();
	
				// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
				_wheelDelta.x = 0;
	
				if('deltaX' in e) {
					if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
						// 18 - average line height
						_wheelDelta.x = e.deltaX * 18;
						_wheelDelta.y = e.deltaY * 18;
					} else {
						_wheelDelta.x = e.deltaX;
						_wheelDelta.y = e.deltaY;
					}
				} else if('wheelDelta' in e) {
					if(e.wheelDeltaX) {
						_wheelDelta.x = -0.16 * e.wheelDeltaX;
					}
					if(e.wheelDeltaY) {
						_wheelDelta.y = -0.16 * e.wheelDeltaY;
					} else {
						_wheelDelta.y = -0.16 * e.wheelDelta;
					}
				} else if('detail' in e) {
					_wheelDelta.y = e.detail;
				} else {
					return;
				}
	
				_calculatePanBounds(_currZoomLevel, true);
	
				var newPanX = _panOffset.x - _wheelDelta.x,
					newPanY = _panOffset.y - _wheelDelta.y;
	
				// only prevent scrolling in nonmodal mode when not at edges
				if (_options.modal ||
					(
					newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
					newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
					) ) {
					e.preventDefault();
				}
	
				// TODO: use rAF instead of mousewheel?
				self.panTo(newPanX, newPanY);
			},
	
			toggleDesktopZoom: function(centerPoint) {
				centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };
	
				var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
				var zoomOut = _currZoomLevel === doubleTapZoomLevel;
				
				self.mouseZoomedIn = !zoomOut;
	
				self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
				framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
			}
	
		}
	});
	
	
	/*>>desktop-zoom*/
	
	/*>>history*/
	/**
	 *
	 * history.js:
	 *
	 * - Back button to close gallery.
	 * 
	 * - Unique URL for each slide: example.com/&pid=1&gid=3
	 *   (where PID is picture index, and GID and gallery index)
	 *   
	 * - Switch URL when slides change.
	 * 
	 */
	
	
	var _historyDefaultOptions = {
		history: true,
		galleryUID: 1
	};
	
	var _historyUpdateTimeout,
		_hashChangeTimeout,
		_hashAnimCheckTimeout,
		_hashChangedByScript,
		_hashChangedByHistory,
		_hashReseted,
		_initialHash,
		_historyChanged,
		_closedFromURL,
		_urlChangedOnce,
		_windowLoc,
	
		_supportsPushState,
	
		_getHash = function() {
			return _windowLoc.hash.substring(1);
		},
		_cleanHistoryTimeouts = function() {
	
			if(_historyUpdateTimeout) {
				clearTimeout(_historyUpdateTimeout);
			}
	
			if(_hashAnimCheckTimeout) {
				clearTimeout(_hashAnimCheckTimeout);
			}
		},
	
		// pid - Picture index
		// gid - Gallery index
		_parseItemIndexFromURL = function() {
			var hash = _getHash(),
				params = {};
	
			if(hash.length < 5) { // pid=1
				return params;
			}
	
			var i, vars = hash.split('&');
			for (i = 0; i < vars.length; i++) {
				if(!vars[i]) {
					continue;
				}
				var pair = vars[i].split('=');	
				if(pair.length < 2) {
					continue;
				}
				params[pair[0]] = pair[1];
			}
			if(_options.galleryPIDs) {
				// detect custom pid in hash and search for it among the items collection
				var searchfor = params.pid;
				params.pid = 0; // if custom pid cannot be found, fallback to the first item
				for(i = 0; i < _items.length; i++) {
					if(_items[i].pid === searchfor) {
						params.pid = i;
						break;
					}
				}
			} else {
				params.pid = parseInt(params.pid,10)-1;
			}
			if( params.pid < 0 ) {
				params.pid = 0;
			}
			return params;
		},
		_updateHash = function() {
	
			if(_hashAnimCheckTimeout) {
				clearTimeout(_hashAnimCheckTimeout);
			}
	
	
			if(_numAnimations || _isDragging) {
				// changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
				// that's why we update hash only when no animations running
				_hashAnimCheckTimeout = setTimeout(_updateHash, 500);
				return;
			}
			
			if(_hashChangedByScript) {
				clearTimeout(_hashChangeTimeout);
			} else {
				_hashChangedByScript = true;
			}
	
	
			var pid = (_currentItemIndex + 1);
			var item = _getItemAt( _currentItemIndex );
			if(item.hasOwnProperty('pid')) {
				// carry forward any custom pid assigned to the item
				pid = item.pid;
			}
			var newHash = _initialHash + '&'  +  'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
	
			if(!_historyChanged) {
				if(_windowLoc.hash.indexOf(newHash) === -1) {
					_urlChangedOnce = true;
				}
				// first time - add new hisory record, then just replace
			}
	
			var newURL = _windowLoc.href.split('#')[0] + '#' +  newHash;
	
			if( _supportsPushState ) {
	
				if('#' + newHash !== window.location.hash) {
					history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
				}
	
			} else {
				if(_historyChanged) {
					_windowLoc.replace( newURL );
				} else {
					_windowLoc.hash = newHash;
				}
			}
			
			
	
			_historyChanged = true;
			_hashChangeTimeout = setTimeout(function() {
				_hashChangedByScript = false;
			}, 60);
		};
	
	
	
		
	
	_registerModule('History', {
	
		
	
		publicMethods: {
			initHistory: function() {
	
				framework.extend(_options, _historyDefaultOptions, true);
	
				if( !_options.history ) {
					return;
				}
	
	
				_windowLoc = window.location;
				_urlChangedOnce = false;
				_closedFromURL = false;
				_historyChanged = false;
				_initialHash = _getHash();
				_supportsPushState = ('pushState' in history);
	
	
				if(_initialHash.indexOf('gid=') > -1) {
					_initialHash = _initialHash.split('&gid=')[0];
					_initialHash = _initialHash.split('?gid=')[0];
				}
				
	
				_listen('afterChange', self.updateURL);
				_listen('unbindEvents', function() {
					framework.unbind(window, 'hashchange', self.onHashChange);
				});
	
	
				var returnToOriginal = function() {
					_hashReseted = true;
					if(!_closedFromURL) {
	
						if(_urlChangedOnce) {
							history.back();
						} else {
	
							if(_initialHash) {
								_windowLoc.hash = _initialHash;
							} else {
								if (_supportsPushState) {
	
									// remove hash from url without refreshing it or scrolling to top
									history.pushState('', document.title,  _windowLoc.pathname + _windowLoc.search );
								} else {
									_windowLoc.hash = '';
								}
							}
						}
						
					}
	
					_cleanHistoryTimeouts();
				};
	
	
				_listen('unbindEvents', function() {
					if(_closedByScroll) {
						// if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
						// this is done to keep the scroll position
						returnToOriginal();
					}
				});
				_listen('destroy', function() {
					if(!_hashReseted) {
						returnToOriginal();
					}
				});
				_listen('firstUpdate', function() {
					_currentItemIndex = _parseItemIndexFromURL().pid;
				});
	
				
	
				
				var index = _initialHash.indexOf('pid=');
				if(index > -1) {
					_initialHash = _initialHash.substring(0, index);
					if(_initialHash.slice(-1) === '&') {
						_initialHash = _initialHash.slice(0, -1);
					}
				}
				
	
				setTimeout(function() {
					if(_isOpen) { // hasn't destroyed yet
						framework.bind(window, 'hashchange', self.onHashChange);
					}
				}, 40);
				
			},
			onHashChange: function() {
	
				if(_getHash() === _initialHash) {
	
					_closedFromURL = true;
					self.close();
					return;
				}
				if(!_hashChangedByScript) {
	
					_hashChangedByHistory = true;
					self.goTo( _parseItemIndexFromURL().pid );
					_hashChangedByHistory = false;
				}
				
			},
			updateURL: function() {
	
				// Delay the update of URL, to avoid lag during transition, 
				// and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
				
				_cleanHistoryTimeouts();
				
	
				if(_hashChangedByHistory) {
					return;
				}
	
				if(!_historyChanged) {
					_updateHash(); // first time
				} else {
					_historyUpdateTimeout = setTimeout(_updateHash, 800);
				}
			}
		
		}
	});
	
	
	/*>>history*/
		framework.extend(self, publicMethods); };
		return PhotoSwipe;
	});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	*
	* UI on top of main sliding area (caption, arrows, close button, etc.).
	* Built just using public methods/properties of PhotoSwipe.
	* 
	*/
	(function (root, factory) { 
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipeUI_Default = factory();
		}
	})(this, function () {
	
		'use strict';
	
	
	
	var PhotoSwipeUI_Default =
	 function(pswp, framework) {
	
		var ui = this;
		var _overlayUIUpdated = false,
			_controlsVisible = true,
			_fullscrenAPI,
			_controls,
			_captionContainer,
			_fakeCaptionContainer,
			_indexIndicator,
			_shareButton,
			_shareModal,
			_shareModalHidden = true,
			_initalCloseOnScrollValue,
			_isIdle,
			_listen,
	
			_loadingIndicator,
			_loadingIndicatorHidden,
			_loadingIndicatorTimeout,
	
			_galleryHasOneSlide,
	
			_options,
			_defaultUIOptions = {
				barsSize: {top:44, bottom:'auto'},
				closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'], 
				timeToIdle: 4000, 
				timeToIdleOutside: 1000,
				loadingIndicatorDelay: 1000, // 2s
				
				addCaptionHTMLFn: function(item, captionEl /*, isFake */) {
					if(!item.title) {
						captionEl.children[0].innerHTML = '';
						return false;
					}
					captionEl.children[0].innerHTML = item.title;
					return true;
				},
	
				closeEl:true,
				captionEl: true,
				fullscreenEl: true,
				zoomEl: true,
				shareEl: true,
				counterEl: true,
				arrowEl: true,
				preloaderEl: true,
	
				tapToClose: false,
				tapToToggleControls: true,
	
				clickToCloseNonZoomable: true,
	
				shareButtons: [
					{id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
					{id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
					{id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/'+
														'?url={{url}}&media={{image_url}}&description={{text}}'},
					{id:'download', label:'Download image', url:'{{raw_image_url}}', download:true}
				],
				getImageURLForShare: function( /* shareButtonData */ ) {
					return pswp.currItem.src || '';
				},
				getPageURLForShare: function( /* shareButtonData */ ) {
					return window.location.href;
				},
				getTextForShare: function( /* shareButtonData */ ) {
					return pswp.currItem.title || '';
				},
					
				indexIndicatorSep: ' / ',
				fitControlsWidth: 1200
	
			},
			_blockControlsTap,
			_blockControlsTapTimeout;
	
	
	
		var _onControlsTap = function(e) {
				if(_blockControlsTap) {
					return true;
				}
	
	
				e = e || window.event;
	
				if(_options.timeToIdle && _options.mouseUsed && !_isIdle) {
					// reset idle timer
					_onIdleMouseMove();
				}
	
	
				var target = e.target || e.srcElement,
					uiElement,
					clickedClass = target.getAttribute('class') || '',
					found;
	
				for(var i = 0; i < _uiElements.length; i++) {
					uiElement = _uiElements[i];
					if(uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name ) > -1 ) {
						uiElement.onTap();
						found = true;
	
					}
				}
	
				if(found) {
					if(e.stopPropagation) {
						e.stopPropagation();
					}
					_blockControlsTap = true;
	
					// Some versions of Android don't prevent ghost click event 
					// when preventDefault() was called on touchstart and/or touchend.
					// 
					// This happens on v4.3, 4.2, 4.1, 
					// older versions strangely work correctly, 
					// but just in case we add delay on all of them)	
					var tapDelay = framework.features.isOldAndroid ? 600 : 30;
					_blockControlsTapTimeout = setTimeout(function() {
						_blockControlsTap = false;
					}, tapDelay);
				}
	
			},
			_fitControlsInViewport = function() {
				return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
			},
			_togglePswpClass = function(el, cName, add) {
				framework[ (add ? 'add' : 'remove') + 'Class' ](el, 'pswp__' + cName);
			},
	
			// add class when there is just one item in the gallery
			// (by default it hides left/right arrows and 1ofX counter)
			_countNumItems = function() {
				var hasOneSlide = (_options.getNumItemsFn() === 1);
	
				if(hasOneSlide !== _galleryHasOneSlide) {
					_togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
					_galleryHasOneSlide = hasOneSlide;
				}
			},
			_toggleShareModalClass = function() {
				_togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
			},
			_toggleShareModal = function() {
	
				_shareModalHidden = !_shareModalHidden;
				
				
				if(!_shareModalHidden) {
					_toggleShareModalClass();
					setTimeout(function() {
						if(!_shareModalHidden) {
							framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
						}
					}, 30);
				} else {
					framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
					setTimeout(function() {
						if(_shareModalHidden) {
							_toggleShareModalClass();
						}
					}, 300);
				}
				
				if(!_shareModalHidden) {
					_updateShareURLs();
				}
				return false;
			},
	
			_openWindowPopup = function(e) {
				e = e || window.event;
				var target = e.target || e.srcElement;
	
				pswp.shout('shareLinkClick', e, target);
	
				if(!target.href) {
					return false;
				}
	
				if( target.hasAttribute('download') ) {
					return true;
				}
	
				window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,'+
											'location=yes,width=550,height=420,top=100,left=' + 
											(window.screen ? Math.round(screen.width / 2 - 275) : 100)  );
	
				if(!_shareModalHidden) {
					_toggleShareModal();
				}
				
				return false;
			},
			_updateShareURLs = function() {
				var shareButtonOut = '',
					shareButtonData,
					shareURL,
					image_url,
					page_url,
					share_text;
	
				for(var i = 0; i < _options.shareButtons.length; i++) {
					shareButtonData = _options.shareButtons[i];
	
					image_url = _options.getImageURLForShare(shareButtonData);
					page_url = _options.getPageURLForShare(shareButtonData);
					share_text = _options.getTextForShare(shareButtonData);
	
					shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url) )
										.replace('{{image_url}}', encodeURIComponent(image_url) )
										.replace('{{raw_image_url}}', image_url )
										.replace('{{text}}', encodeURIComponent(share_text) );
	
					shareButtonOut += '<a href="' + shareURL + '" target="_blank" '+
										'class="pswp__share--' + shareButtonData.id + '"' +
										(shareButtonData.download ? 'download' : '') + '>' + 
										shareButtonData.label + '</a>';
	
					if(_options.parseShareButtonOut) {
						shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
					}
				}
				_shareModal.children[0].innerHTML = shareButtonOut;
				_shareModal.children[0].onclick = _openWindowPopup;
	
			},
			_hasCloseClass = function(target) {
				for(var  i = 0; i < _options.closeElClasses.length; i++) {
					if( framework.hasClass(target, 'pswp__' + _options.closeElClasses[i]) ) {
						return true;
					}
				}
			},
			_idleInterval,
			_idleTimer,
			_idleIncrement = 0,
			_onIdleMouseMove = function() {
				clearTimeout(_idleTimer);
				_idleIncrement = 0;
				if(_isIdle) {
					ui.setIdle(false);
				}
			},
			_onMouseLeaveWindow = function(e) {
				e = e ? e : window.event;
				var from = e.relatedTarget || e.toElement;
				if (!from || from.nodeName === 'HTML') {
					clearTimeout(_idleTimer);
					_idleTimer = setTimeout(function() {
						ui.setIdle(true);
					}, _options.timeToIdleOutside);
				}
			},
			_setupFullscreenAPI = function() {
				if(_options.fullscreenEl && !framework.features.isOldAndroid) {
					if(!_fullscrenAPI) {
						_fullscrenAPI = ui.getFullscreenAPI();
					}
					if(_fullscrenAPI) {
						framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
						ui.updateFullscreen();
						framework.addClass(pswp.template, 'pswp--supports-fs');
					} else {
						framework.removeClass(pswp.template, 'pswp--supports-fs');
					}
				}
			},
			_setupLoadingIndicator = function() {
				// Setup loading indicator
				if(_options.preloaderEl) {
				
					_toggleLoadingIndicator(true);
	
					_listen('beforeChange', function() {
	
						clearTimeout(_loadingIndicatorTimeout);
	
						// display loading indicator with delay
						_loadingIndicatorTimeout = setTimeout(function() {
	
							if(pswp.currItem && pswp.currItem.loading) {
	
								if( !pswp.allowProgressiveImg() || (pswp.currItem.img && !pswp.currItem.img.naturalWidth)  ) {
									// show preloader if progressive loading is not enabled, 
									// or image width is not defined yet (because of slow connection)
									_toggleLoadingIndicator(false); 
									// items-controller.js function allowProgressiveImg
								}
								
							} else {
								_toggleLoadingIndicator(true); // hide preloader
							}
	
						}, _options.loadingIndicatorDelay);
						
					});
					_listen('imageLoadComplete', function(index, item) {
						if(pswp.currItem === item) {
							_toggleLoadingIndicator(true);
						}
					});
	
				}
			},
			_toggleLoadingIndicator = function(hide) {
				if( _loadingIndicatorHidden !== hide ) {
					_togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
					_loadingIndicatorHidden = hide;
				}
			},
			_applyNavBarGaps = function(item) {
				var gap = item.vGap;
	
				if( _fitControlsInViewport() ) {
					
					var bars = _options.barsSize; 
					if(_options.captionEl && bars.bottom === 'auto') {
						if(!_fakeCaptionContainer) {
							_fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
							_fakeCaptionContainer.appendChild( framework.createEl('pswp__caption__center') );
							_controls.insertBefore(_fakeCaptionContainer, _captionContainer);
							framework.addClass(_controls, 'pswp__ui--fit');
						}
						if( _options.addCaptionHTMLFn(item, _fakeCaptionContainer, true) ) {
	
							var captionSize = _fakeCaptionContainer.clientHeight;
							gap.bottom = parseInt(captionSize,10) || 44;
						} else {
							gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
						}
					} else {
						gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
					}
					
					// height of top bar is static, no need to calculate it
					gap.top = bars.top;
				} else {
					gap.top = gap.bottom = 0;
				}
			},
			_setupIdle = function() {
				// Hide controls when mouse is used
				if(_options.timeToIdle) {
					_listen('mouseUsed', function() {
						
						framework.bind(document, 'mousemove', _onIdleMouseMove);
						framework.bind(document, 'mouseout', _onMouseLeaveWindow);
	
						_idleInterval = setInterval(function() {
							_idleIncrement++;
							if(_idleIncrement === 2) {
								ui.setIdle(true);
							}
						}, _options.timeToIdle / 2);
					});
				}
			},
			_setupHidingControlsDuringGestures = function() {
	
				// Hide controls on vertical drag
				_listen('onVerticalDrag', function(now) {
					if(_controlsVisible && now < 0.95) {
						ui.hideControls();
					} else if(!_controlsVisible && now >= 0.95) {
						ui.showControls();
					}
				});
	
				// Hide controls when pinching to close
				var pinchControlsHidden;
				_listen('onPinchClose' , function(now) {
					if(_controlsVisible && now < 0.9) {
						ui.hideControls();
						pinchControlsHidden = true;
					} else if(pinchControlsHidden && !_controlsVisible && now > 0.9) {
						ui.showControls();
					}
				});
	
				_listen('zoomGestureEnded', function() {
					pinchControlsHidden = false;
					if(pinchControlsHidden && !_controlsVisible) {
						ui.showControls();
					}
				});
	
			};
	
	
	
		var _uiElements = [
			{ 
				name: 'caption', 
				option: 'captionEl',
				onInit: function(el) {  
					_captionContainer = el; 
				} 
			},
			{ 
				name: 'share-modal', 
				option: 'shareEl',
				onInit: function(el) {  
					_shareModal = el;
				},
				onTap: function() {
					_toggleShareModal();
				} 
			},
			{ 
				name: 'button--share', 
				option: 'shareEl',
				onInit: function(el) { 
					_shareButton = el;
				},
				onTap: function() {
					_toggleShareModal();
				} 
			},
			{ 
				name: 'button--zoom', 
				option: 'zoomEl',
				onTap: pswp.toggleDesktopZoom
			},
			{ 
				name: 'counter', 
				option: 'counterEl',
				onInit: function(el) {  
					_indexIndicator = el;
				} 
			},
			{ 
				name: 'button--close', 
				option: 'closeEl',
				onTap: pswp.close
			},
			{ 
				name: 'button--arrow--left', 
				option: 'arrowEl',
				onTap: pswp.prev
			},
			{ 
				name: 'button--arrow--right', 
				option: 'arrowEl',
				onTap: pswp.next
			},
			{ 
				name: 'button--fs', 
				option: 'fullscreenEl',
				onTap: function() {  
					if(_fullscrenAPI.isFullscreen()) {
						_fullscrenAPI.exit();
					} else {
						_fullscrenAPI.enter();
					}
				} 
			},
			{ 
				name: 'preloader', 
				option: 'preloaderEl',
				onInit: function(el) {  
					_loadingIndicator = el;
				} 
			}
	
		];
	
		var _setupUIElements = function() {
			var item,
				classAttr,
				uiElement;
	
			var loopThroughChildElements = function(sChildren) {
				if(!sChildren) {
					return;
				}
	
				var l = sChildren.length;
				for(var i = 0; i < l; i++) {
					item = sChildren[i];
					classAttr = item.className;
	
					for(var a = 0; a < _uiElements.length; a++) {
						uiElement = _uiElements[a];
	
						if(classAttr.indexOf('pswp__' + uiElement.name) > -1  ) {
	
							if( _options[uiElement.option] ) { // if element is not disabled from options
								
								framework.removeClass(item, 'pswp__element--disabled');
								if(uiElement.onInit) {
									uiElement.onInit(item);
								}
								
								//item.style.display = 'block';
							} else {
								framework.addClass(item, 'pswp__element--disabled');
								//item.style.display = 'none';
							}
						}
					}
				}
			};
			loopThroughChildElements(_controls.children);
	
			var topBar =  framework.getChildByClass(_controls, 'pswp__top-bar');
			if(topBar) {
				loopThroughChildElements( topBar.children );
			}
		};
	
	
		
	
		ui.init = function() {
	
			// extend options
			framework.extend(pswp.options, _defaultUIOptions, true);
	
			// create local link for fast access
			_options = pswp.options;
	
			// find pswp__ui element
			_controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');
	
			// create local link
			_listen = pswp.listen;
	
	
			_setupHidingControlsDuringGestures();
	
			// update controls when slides change
			_listen('beforeChange', ui.update);
	
			// toggle zoom on double-tap
			_listen('doubleTap', function(point) {
				var initialZoomLevel = pswp.currItem.initialZoomLevel;
				if(pswp.getZoomLevel() !== initialZoomLevel) {
					pswp.zoomTo(initialZoomLevel, point, 333);
				} else {
					pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
				}
			});
	
			// Allow text selection in caption
			_listen('preventDragEvent', function(e, isDown, preventObj) {
				var t = e.target || e.srcElement;
				if(
					t && 
					t.getAttribute('class') && e.type.indexOf('mouse') > -1 && 
					( t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName) ) 
				) {
					preventObj.prevent = false;
				}
			});
	
			// bind events for UI
			_listen('bindEvents', function() {
				framework.bind(_controls, 'pswpTap click', _onControlsTap);
				framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
	
				if(!pswp.likelyTouchDevice) {
					framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
				}
			});
	
			// unbind events for UI
			_listen('unbindEvents', function() {
				if(!_shareModalHidden) {
					_toggleShareModal();
				}
	
				if(_idleInterval) {
					clearInterval(_idleInterval);
				}
				framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
				framework.unbind(document, 'mousemove', _onIdleMouseMove);
				framework.unbind(_controls, 'pswpTap click', _onControlsTap);
				framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
				framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
	
				if(_fullscrenAPI) {
					framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
					if(_fullscrenAPI.isFullscreen()) {
						_options.hideAnimationDuration = 0;
						_fullscrenAPI.exit();
					}
					_fullscrenAPI = null;
				}
			});
	
	
			// clean up things when gallery is destroyed
			_listen('destroy', function() {
				if(_options.captionEl) {
					if(_fakeCaptionContainer) {
						_controls.removeChild(_fakeCaptionContainer);
					}
					framework.removeClass(_captionContainer, 'pswp__caption--empty');
				}
	
				if(_shareModal) {
					_shareModal.children[0].onclick = null;
				}
				framework.removeClass(_controls, 'pswp__ui--over-close');
				framework.addClass( _controls, 'pswp__ui--hidden');
				ui.setIdle(false);
			});
			
	
			if(!_options.showAnimationDuration) {
				framework.removeClass( _controls, 'pswp__ui--hidden');
			}
			_listen('initialZoomIn', function() {
				if(_options.showAnimationDuration) {
					framework.removeClass( _controls, 'pswp__ui--hidden');
				}
			});
			_listen('initialZoomOut', function() {
				framework.addClass( _controls, 'pswp__ui--hidden');
			});
	
			_listen('parseVerticalMargin', _applyNavBarGaps);
			
			_setupUIElements();
	
			if(_options.shareEl && _shareButton && _shareModal) {
				_shareModalHidden = true;
			}
	
			_countNumItems();
	
			_setupIdle();
	
			_setupFullscreenAPI();
	
			_setupLoadingIndicator();
		};
	
		ui.setIdle = function(isIdle) {
			_isIdle = isIdle;
			_togglePswpClass(_controls, 'ui--idle', isIdle);
		};
	
		ui.update = function() {
			// Don't update UI if it's hidden
			if(_controlsVisible && pswp.currItem) {
				
				ui.updateIndexIndicator();
	
				if(_options.captionEl) {
					_options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
	
					_togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
				}
	
				_overlayUIUpdated = true;
	
			} else {
				_overlayUIUpdated = false;
			}
	
			if(!_shareModalHidden) {
				_toggleShareModal();
			}
	
			_countNumItems();
		};
	
		ui.updateFullscreen = function(e) {
	
			if(e) {
				// some browsers change window scroll position during the fullscreen
				// so PhotoSwipe updates it just in case
				setTimeout(function() {
					pswp.setScrollOffset( 0, framework.getScrollY() );
				}, 50);
			}
			
			// toogle pswp--fs class on root element
			framework[ (_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class' ](pswp.template, 'pswp--fs');
		};
	
		ui.updateIndexIndicator = function() {
			if(_options.counterEl) {
				_indexIndicator.innerHTML = (pswp.getCurrentIndex()+1) + 
											_options.indexIndicatorSep + 
											_options.getNumItemsFn();
			}
		};
		
		ui.onGlobalTap = function(e) {
			e = e || window.event;
			var target = e.target || e.srcElement;
	
			if(_blockControlsTap) {
				return;
			}
	
			if(e.detail && e.detail.pointerType === 'mouse') {
	
				// close gallery if clicked outside of the image
				if(_hasCloseClass(target)) {
					pswp.close();
					return;
				}
	
				if(framework.hasClass(target, 'pswp__img')) {
					if(pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
						if(_options.clickToCloseNonZoomable) {
							pswp.close();
						}
					} else {
						pswp.toggleDesktopZoom(e.detail.releasePoint);
					}
				}
				
			} else {
	
				// tap anywhere (except buttons) to toggle visibility of controls
				if(_options.tapToToggleControls) {
					if(_controlsVisible) {
						ui.hideControls();
					} else {
						ui.showControls();
					}
				}
	
				// tap to close gallery
				if(_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target)) ) {
					pswp.close();
					return;
				}
				
			}
		};
		ui.onMouseOver = function(e) {
			e = e || window.event;
			var target = e.target || e.srcElement;
	
			// add class when mouse is over an element that should close the gallery
			_togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
		};
	
		ui.hideControls = function() {
			framework.addClass(_controls,'pswp__ui--hidden');
			_controlsVisible = false;
		};
	
		ui.showControls = function() {
			_controlsVisible = true;
			if(!_overlayUIUpdated) {
				ui.update();
			}
			framework.removeClass(_controls,'pswp__ui--hidden');
		};
	
		ui.supportsFullscreen = function() {
			var d = document;
			return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
		};
	
		ui.getFullscreenAPI = function() {
			var dE = document.documentElement,
				api,
				tF = 'fullscreenchange';
	
			if (dE.requestFullscreen) {
				api = {
					enterK: 'requestFullscreen',
					exitK: 'exitFullscreen',
					elementK: 'fullscreenElement',
					eventK: tF
				};
	
			} else if(dE.mozRequestFullScreen ) {
				api = {
					enterK: 'mozRequestFullScreen',
					exitK: 'mozCancelFullScreen',
					elementK: 'mozFullScreenElement',
					eventK: 'moz' + tF
				};
	
				
	
			} else if(dE.webkitRequestFullscreen) {
				api = {
					enterK: 'webkitRequestFullscreen',
					exitK: 'webkitExitFullscreen',
					elementK: 'webkitFullscreenElement',
					eventK: 'webkit' + tF
				};
	
			} else if(dE.msRequestFullscreen) {
				api = {
					enterK: 'msRequestFullscreen',
					exitK: 'msExitFullscreen',
					elementK: 'msFullscreenElement',
					eventK: 'MSFullscreenChange'
				};
			}
	
			if(api) {
				api.enter = function() { 
					// disable close-on-scroll in fullscreen
					_initalCloseOnScrollValue = _options.closeOnScroll; 
					_options.closeOnScroll = false; 
	
					if(this.enterK === 'webkitRequestFullscreen') {
						pswp.template[this.enterK]( Element.ALLOW_KEYBOARD_INPUT );
					} else {
						return pswp.template[this.enterK](); 
					}
				};
				api.exit = function() { 
					_options.closeOnScroll = _initalCloseOnScrollValue;
	
					return document[this.exitK](); 
	
				};
				api.isFullscreen = function() { return document[this.elementK]; };
			}
	
			return api;
		};
	
	
	
	};
	return PhotoSwipeUI_Default;
	
	
	});


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(94)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * callback validator
	 *
	 * @link        http://formvalidation.io/validators/callback/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            callback: {
	                'default': 'Please enter a valid value'
	            }
	        }
	    });
	
	    FormValidation.Validator.callback = {
	        priority: 999,
	
	        html5Attributes: {
	            message: 'message',
	            callback: 'callback'
	        },
	
	        /**
	         * Return result from the callback method
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Can consist of the following keys:
	         * - callback: The callback method that passes parameters:
	         *      callback: function(fieldValue, validator, $field) {
	         *          // fieldValue is the value of field
	         *          // validator is instance of FormValidation.Base
	         *          // $field is the field element
	         *      }
	         * - message: The invalid message
	         * @returns {Deferred}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value  = validator.getFieldValue($field, validatorName),
	                dfd    = new $.Deferred(),
	                result = { valid: true };
	
	            if (options.callback) {
	                var response = FormValidation.Helper.call(options.callback, [value, validator, $field]);
	                result = ('boolean' === typeof response || null === response) ? { valid: response } : response;
	            }
	
	            dfd.resolve($field, validatorName, result);
	            return dfd;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * date validator
	 *
	 * @link        http://formvalidation.io/validators/date/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            date: {
	                'default': 'Please enter a valid date',
	                min: 'Please enter a date after %s',
	                max: 'Please enter a date before %s',
	                range: 'Please enter a date in the range %s - %s'
	            }
	        }
	    });
	
	    FormValidation.Validator.date = {
	        html5Attributes: {
	            message: 'message',
	            format: 'format',
	            min: 'min',
	            max: 'max',
	            separator: 'separator'
	        },
	
	        /**
	         * Return true if the input value is valid date
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Can consist of the following keys:
	         * - message: The invalid message
	         * - min: the minimum date
	         * - max: the maximum date
	         * - separator: Use to separate the date, month, and year.
	         * By default, it is /
	         * - format: The date format. Default is MM/DD/YYYY
	         * The format can be:
	         *
	         * i) date: Consist of DD, MM, YYYY parts which are separated by the separator option
	         * ii) date and time:
	         * The time can consist of h, m, s parts which are separated by :
	         * ii) date, time and A (indicating AM or PM)
	         * @returns {Boolean|Object}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (value === '') {
	                return true;
	            }
	
	            options.format = options.format || 'MM/DD/YYYY';
	
	            // #683: Force the format to YYYY-MM-DD as the default browser behaviour when using type="date" attribute
	            if ($field.attr('type') === 'date') {
	                options.format = 'YYYY-MM-DD';
	            }
	
	            var locale     = validator.getLocale(),
	                message    = options.message || FormValidation.I18n[locale].date['default'],
	                formats    = options.format.split(' '),
	                dateFormat = formats[0],
	                timeFormat = (formats.length > 1) ? formats[1] : null,
	                amOrPm     = (formats.length > 2) ? formats[2] : null,
	                sections   = value.split(' '),
	                date       = sections[0],
	                time       = (sections.length > 1) ? sections[1] : null;
	
	            if (formats.length !== sections.length) {
	                return {
	                    valid: false,
	                    message: message
	                };
	            }
	
	            // Determine the separator
	            var separator = options.separator;
	            if (!separator) {
	                separator = (date.indexOf('/') !== -1)
	                            ? '/'
	                            : ((date.indexOf('-') !== -1) ? '-' : ((date.indexOf('.') !== -1) ? '.' : null));
	            }
	            if (separator === null || date.indexOf(separator) === -1) {
	                return {
	                    valid: false,
	                    message: message
	                };
	            }
	
	            // Determine the date
	            date       = date.split(separator);
	            dateFormat = dateFormat.split(separator);
	            if (date.length !== dateFormat.length) {
	                return {
	                    valid: false,
	                    message: message
	                };
	            }
	
	            var year  = date[$.inArray('YYYY', dateFormat)],
	                month = date[$.inArray('MM', dateFormat)],
	                day   = date[$.inArray('DD', dateFormat)];
	
	            if (!year || !month || !day || year.length !== 4) {
	                return {
	                    valid: false,
	                    message: message
	                };
	            }
	
	            // Determine the time
	            var minutes = null, hours = null, seconds = null;
	            if (timeFormat) {
	                timeFormat = timeFormat.split(':');
	                time       = time.split(':');
	
	                if (timeFormat.length !== time.length) {
	                    return {
	                        valid: false,
	                        message: message
	                    };
	                }
	
	                hours   = time.length > 0 ? time[0] : null;
	                minutes = time.length > 1 ? time[1] : null;
	                seconds = time.length > 2 ? time[2] : null;
	
	                if (hours === '' || minutes === '' || seconds === '') {
	                    return {
	                        valid: false,
	                        message: message
	                    };
	                }
	
	                // Validate seconds
	                if (seconds) {
	                    if (isNaN(seconds) || seconds.length > 2) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                    seconds = parseInt(seconds, 10);
	                    if (seconds < 0 || seconds > 60) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                }
	
	                // Validate hours
	                if (hours) {
	                    if (isNaN(hours) || hours.length > 2) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                    hours = parseInt(hours, 10);
	                    if (hours < 0 || hours >= 24 || (amOrPm && hours > 12)) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                }
	
	                // Validate minutes
	                if (minutes) {
	                    if (isNaN(minutes) || minutes.length > 2) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                    minutes = parseInt(minutes, 10);
	                    if (minutes < 0 || minutes > 59) {
	                        return {
	                            valid: false,
	                            message: message
	                        };
	                    }
	                }
	            }
	
	            // Validate day, month, and year
	            var valid     = FormValidation.Helper.date(year, month, day),
	                min       = null,
	                max       = null,
	                minOption = options.min,
	                maxOption = options.max;
	
	            if (minOption) {
	                min = (minOption instanceof Date)
	                    ? minOption
	                    : (this._parseDate(minOption, dateFormat, separator) ||
	                       this._parseDate(validator.getDynamicOption($field, minOption), dateFormat, separator));
	
	                // In order to avoid displaying a date string like "Mon Dec 08 2014 19:14:12 GMT+0000 (WET)"
	                minOption = this._formatDate(min, options.format);
	            }
	
	            if (maxOption) {
	                max = (maxOption instanceof Date)
	                    ? maxOption
	                    : (this._parseDate(maxOption, dateFormat, separator) ||
	                       this._parseDate(validator.getDynamicOption($field, maxOption), dateFormat, separator));
	
	                // In order to avoid displaying a date string like "Mon Dec 08 2014 19:14:12 GMT+0000 (WET)"
	                maxOption = this._formatDate(max, options.format);
	            }
	
	            date = new Date(year, month -1, day, hours, minutes, seconds);
	
	            switch (true) {
	                case (minOption && !maxOption && valid):
	                    valid   = date.getTime() >= min.getTime();
	                    message = options.message || FormValidation.Helper.format(FormValidation.I18n[locale].date.min, minOption);
	                    break;
	
	                case (maxOption && !minOption && valid):
	                    valid   = date.getTime() <= max.getTime();
	                    message = options.message || FormValidation.Helper.format(FormValidation.I18n[locale].date.max, maxOption);
	                    break;
	
	                case (maxOption && minOption && valid):
	                    valid   = date.getTime() <= max.getTime() && date.getTime() >= min.getTime();
	                    message = options.message || FormValidation.Helper.format(FormValidation.I18n[locale].date.range, [minOption, maxOption]);
	                    break;
	
	                default:
	                    break;
	            }
	
	            return {
	                valid: valid,
	                date: date,
	                message: message
	            };
	        },
	
	        /**
	         * Return a date object after parsing the date string
	         *
	         * @param {Date|String} date   The date string to parse
	         * @param {String} format The date format
	         * The format can be:
	         *   - date: Consist of DD, MM, YYYY parts which are separated by the separator option
	         *   - date and time:
	         *     The time can consist of h, m, s parts which are separated by :
	         * @param {String} separator The separator used to separate the date, month, and year
	         * @returns {Date}
	         */
	        _parseDate: function(date, format, separator) {
	            if (date instanceof Date) {
	                return date;
	            }
	            if (typeof date !== 'string') {
	                return null;
	            }
	
	            // Ensure that the format must consist of year, month and day patterns
	            var yearIndex   = $.inArray('YYYY', format),
	                monthIndex  = $.inArray('MM', format),
	                dayIndex    = $.inArray('DD', format);
	            if (yearIndex === -1 || monthIndex === -1 || dayIndex === -1) {
	                return null;
	            }
	
	            var minutes     = 0, hours = 0, seconds = 0,
	                sections    = date.split(' '),
	                dateSection = sections[0].split(separator);
	            if (dateSection.length < 3) {
	                return null;
	            }
	
	            if (sections.length > 1) {
	                var timeSection = sections[1].split(':');
	                hours   = timeSection.length > 0 ? timeSection[0] : null;
	                minutes = timeSection.length > 1 ? timeSection[1] : null;
	                seconds = timeSection.length > 2 ? timeSection[2] : null;
	            }
	
	            return new Date(dateSection[yearIndex], dateSection[monthIndex] - 1, dateSection[dayIndex],
	                            hours, minutes, seconds);
	        },
	
	        /**
	         * Format date
	         *
	         * @param {Date} date The date object to format
	         * @param {String} format The date format
	         * The format can consist of the following tokens:
	         *      d       Day of the month without leading zeros (1 through 31)
	         *      dd      Day of the month with leading zeros (01 through 31)
	         *      m       Month without leading zeros (1 through 12)
	         *      mm      Month with leading zeros (01 through 12)
	         *      yy      Last two digits of year (for example: 14)
	         *      yyyy    Full four digits of year (for example: 2014)
	         *      h       Hours without leading zeros (1 through 12)
	         *      hh      Hours with leading zeros (01 through 12)
	         *      H       Hours without leading zeros (0 through 23)
	         *      HH      Hours with leading zeros (00 through 23)
	         *      M       Minutes without leading zeros (0 through 59)
	         *      MM      Minutes with leading zeros (00 through 59)
	         *      s       Seconds without leading zeros (0 through 59)
	         *      ss      Seconds with leading zeros (00 through 59)
	         * @returns {String}
	         */
	        _formatDate: function(date, format) {
	            format = format
	                        .replace(/Y/g, 'y')
	                        .replace(/M/g, 'm')
	                        .replace(/D/g, 'd')
	                        .replace(/:m/g, ':M')
	                        .replace(/:mm/g, ':MM')
	                        .replace(/:S/, ':s')
	                        .replace(/:SS/, ':ss');
	
	            var replacer = {
	                d: function(date) {
	                    return date.getDate();
	                },
	                dd: function(date) {
	                    var d = date.getDate();
	                    return (d < 10) ? '0' + d : d;
	                },
	                m: function(date) {
	                    return date.getMonth() + 1;
	                },
	                mm: function(date) {
	                    var m = date.getMonth() + 1;
	                    return m < 10 ? '0' + m : m;
	                },
	                yy: function(date) {
	                    return ('' + date.getFullYear()).substr(2);
	                },
	                yyyy: function(date) {
	                    return date.getFullYear();
	                },
	                h: function(date) {
	                    return date.getHours() % 12 || 12;
	                },
	                hh: function(date) {
	                    var h = date.getHours() % 12 || 12;
	                    return h < 10 ? '0' + h : h;
	                },
	                H: function(date) {
	                    return date.getHours();
	                },
	                HH: function(date) {
	                    var H = date.getHours();
	                    return H < 10 ? '0' + H : H;
	                },
	                M: function(date) {
	                    return date.getMinutes();
	                },
	                MM: function(date) {
	                    var M = date.getMinutes();
	                    return M < 10 ? '0' + M : M;
	                },
	                s: function(date) {
	                    return date.getSeconds();
	                },
	                ss: function(date) {
	                    var s = date.getSeconds();
	                    return s < 10 ? '0' + s : s;
	                }
	            };
	
	            return format.replace(/d{1,4}|m{1,4}|yy(?:yy)?|([HhMs])\1?|"[^"]*"|'[^']*'/g, function(match) {
	                return replacer[match] ? replacer[match](date) : match.slice(1, match.length - 1);
	            });
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * different validator
	 *
	 * @link        http://formvalidation.io/validators/different/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            different: {
	                'default': 'Please enter a different value'
	            }
	        }
	    });
	
	    FormValidation.Validator.different = {
	        html5Attributes: {
	            message: 'message',
	            field: 'field'
	        },
	
	        /**
	         * Bind the validator on the live change of the field to compare with current one
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         */
	        init: function(validator, $field, options, validatorName) {
	            var fields = options.field.split(',');
	            for (var i = 0; i < fields.length; i++) {
	                var compareWith = validator.getFieldElements($.trim(fields[i]));
	                validator.onLiveChange(compareWith, 'live_' + validatorName, function() {
	                    var status = validator.getStatus($field, validatorName);
	                    if (status !== validator.STATUS_NOT_VALIDATED) {
	                        validator.revalidateField($field);
	                    }
	                });
	            }
	        },
	
	        /**
	         * Unbind the validator on the live change of the field to compare with current one
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         */
	        destroy: function(validator, $field, options, validatorName) {
	            var fields = options.field.split(',');
	            for (var i = 0; i < fields.length; i++) {
	                var compareWith = validator.getFieldElements($.trim(fields[i]));
	                validator.offLiveChange(compareWith, 'live_' + validatorName);
	            }
	        },
	
	        /**
	         * Return true if the input value is different with given field's value
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         * - message: The invalid message
	         * @returns {Boolean}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (value === '') {
	                return true;
	            }
	
	            var fields  = options.field.split(','),
	                isValid = true;
	
	            for (var i = 0; i < fields.length; i++) {
	                var compareWith = validator.getFieldElements($.trim(fields[i]));
	                if (compareWith == null || compareWith.length === 0) {
	                    continue;
	                }
	
	                var compareValue = validator.getFieldValue(compareWith, validatorName);
	                if (value === compareValue) {
	                    isValid = false;
	                } else if (compareValue !== '') {
	                    validator.updateStatus(compareWith, validator.STATUS_VALID, validatorName);
	                }
	            }
	
	            return isValid;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * emailAddress validator
	 *
	 * @link        http://formvalidation.io/validators/emailAddress/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            emailAddress: {
	                'default': 'Please enter a valid email address'
	            }
	        }
	    });
	
	    FormValidation.Validator.emailAddress = {
	        html5Attributes: {
	            message: 'message',
	            multiple: 'multiple',
	            separator: 'separator'
	        },
	
	        enableByHtml5: function($field) {
	            return ('email' === $field.attr('type'));
	        },
	
	        /**
	         * Return true if and only if the input value is a valid email address
	         *
	         * @param {FormValidation.Base} validator Validate plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} [options]
	         * - multiple: Allow multiple email addresses, separated by a comma or semicolon; default is false.
	         * - separator: Regex for character or characters expected as separator between addresses; default is comma /[,;]/, i.e. comma or semicolon.
	         * @returns {Boolean}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (value === '') {
	                return true;
	            }
	
	            // Email address regular expression
	            // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
	            var emailRegExp   = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
	                allowMultiple = options.multiple === true || options.multiple === 'true';
	
	            if (allowMultiple) {
	                var separator = options.separator || /[,;]/,
	                    addresses = this._splitEmailAddresses(value, separator);
	
	                for (var i = 0; i < addresses.length; i++) {
	                    if (!emailRegExp.test(addresses[i])) {
	                        return false;
	                    }
	                }
	
	                return true;
	            } else {
	                return emailRegExp.test(value);
	            }
	        },
	
	        _splitEmailAddresses: function(emailAddresses, separator) {
	            var quotedFragments     = emailAddresses.split(/"/),
	                quotedFragmentCount = quotedFragments.length,
	                emailAddressArray   = [],
	                nextEmailAddress    = '';
	
	            for (var i = 0; i < quotedFragmentCount; i++) {
	                if (i % 2 === 0) {
	                    var splitEmailAddressFragments     = quotedFragments[i].split(separator),
	                        splitEmailAddressFragmentCount = splitEmailAddressFragments.length;
	
	                    if (splitEmailAddressFragmentCount === 1) {
	                        nextEmailAddress += splitEmailAddressFragments[0];
	                    } else {
	                        emailAddressArray.push(nextEmailAddress + splitEmailAddressFragments[0]);
	
	                        for (var j = 1; j < splitEmailAddressFragmentCount - 1; j++) {
	                            emailAddressArray.push(splitEmailAddressFragments[j]);
	                        }
	                        nextEmailAddress = splitEmailAddressFragments[splitEmailAddressFragmentCount - 1];
	                    }
	                } else {
	                    nextEmailAddress += '"' + quotedFragments[i];
	                    if (i < quotedFragmentCount - 1) {
	                        nextEmailAddress += '"';
	                    }
	                }
	            }
	
	            emailAddressArray.push(nextEmailAddress);
	            return emailAddressArray;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * identical validator
	 *
	 * @link        http://formvalidation.io/validators/identical/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            identical: {
	                'default': 'Please enter the same value'
	            }
	        }
	    });
	
	    FormValidation.Validator.identical = {
	        html5Attributes: {
	            message: 'message',
	            field: 'field'
	        },
	
	        /**
	         * Bind the validator on the live change of the field to compare with current one
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         */
	        init: function(validator, $field, options, validatorName) {
	            var compareWith = validator.getFieldElements(options.field);
	            validator.onLiveChange(compareWith, 'live_' + validatorName, function() {
	                var status = validator.getStatus($field, validatorName);
	                if (status !== validator.STATUS_NOT_VALIDATED) {
	                    validator.revalidateField($field);
	                }
	            });
	        },
	
	        /**
	         * Unbind the validator on the live change of the field to compare with current one
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         */
	        destroy: function(validator, $field, options, validatorName) {
	            var compareWith = validator.getFieldElements(options.field);
	            validator.offLiveChange(compareWith, 'live_' + validatorName);
	        },
	
	        /**
	         * Check if input value equals to value of particular one
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - field: The name of field that will be used to compare with current one
	         * @returns {Boolean}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value       = validator.getFieldValue($field, validatorName),
	                compareWith = validator.getFieldElements(options.field);
	            if (compareWith === null || compareWith.length === 0) {
	                return true;
	            }
	
	            var compareValue = validator.getFieldValue(compareWith, validatorName);
	            if (value === compareValue) {
	                validator.updateStatus(compareWith, validator.STATUS_VALID, validatorName);
	                return true;
	            }
	
	            return false;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * promise validator
	 *
	 * @link        http://formvalidation.io/validators/promise/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            promise: {
	                'default': 'Please enter a valid value'
	            }
	        }
	    });
	
	    FormValidation.Validator.promise = {
	        priority: 999,
	
	        html5Attributes: {
	            message: 'message',
	            promise: 'promise'
	        },
	
	        /**
	         * Return result from a jQuery's Deferred object
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Can consist of the following keys:
	         * - promise: The method that passes parameters:
	         *      promise: function(fieldValue, validator, $field) {
	         *          // fieldValue is the value of field
	         *          // validator is instance of FormValidation.Base
	         *          // $field is the field element
	         *
	         *          var dfd = new $.Deferred();
	         *
	         *          // Do something ...
	         *
	         *          // Resolve when particular task is done
	         *          dfd.resolve({
	         *              valid: true or false,       // Required
	         *              message: 'Other message',   // Optional
	         *              key: value                  // You can attach more data to reuse later
	         *          });
	         *
	         *          // You can reject if there's error
	         *          dfd.reject({
	         *              message: 'Other message',   // Optional
	         *              key: value                  // You can attach more data to reuse later
	         *          });
	         *
	         *          return dfd.promise();
	         *      }
	         * - message: The invalid message
	         * @returns {Deferred}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value   = validator.getFieldValue($field, validatorName),
	                dfd     = new $.Deferred(),
	                promise = FormValidation.Helper.call(options.promise, [value, validator, $field]);
	
	            promise
	                .done(function(result) {
	                    dfd.resolve($field, validatorName, result);
	                })
	                .fail(function(result) {
	                    result = result || {};
	                    result.valid = false;
	                    dfd.resolve($field, validatorName, result);
	                });
	
	            return dfd;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * regexp validator
	 *
	 * @link        http://formvalidation.io/validators/regexp/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            regexp: {
	                'default': 'Please enter a value matching the pattern'
	            }
	        }
	    });
	
	    FormValidation.Validator.regexp = {
	        html5Attributes: {
	            message: 'message',
	            flags: 'flags',
	            regexp: 'regexp'
	        },
	
	        enableByHtml5: function($field) {
	            var pattern = $field.attr('pattern');
	            if (pattern) {
	                return {
	                    regexp: pattern
	                };
	            }
	
	            return false;
	        },
	
	        /**
	         * Check if the element value matches given regular expression
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of the following key:
	         * - regexp: The regular expression you need to check
	         * - flags: If specified, flags can have any combination of Javascript regular expression flags such as:
	         *      g: global match
	         *      i: ignore case
	         *      m: multiple line
	         * @returns {Boolean}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (value === '') {
	                return true;
	            }
	
	            var regexp = ('string' === typeof options.regexp)
	                        ? (options.flags ? new RegExp(options.regexp, options.flags) : new RegExp(options.regexp))
	                        : options.regexp;
	            return regexp.test(value);
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * stringLength validator
	 *
	 * @link        http://formvalidation.io/validators/stringLength/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            stringLength: {
	                'default': 'Please enter a value with valid length',
	                less: 'Please enter less than %s characters',
	                more: 'Please enter more than %s characters',
	                between: 'Please enter value between %s and %s characters long'
	            }
	        }
	    });
	
	    FormValidation.Validator.stringLength = {
	        html5Attributes: {
	            message: 'message',
	            min: 'min',
	            max: 'max',
	            trim: 'trim',
	            utf8bytes: 'utf8Bytes'
	        },
	
	        enableByHtml5: function($field) {
	            var options   = {},
	                maxLength = $field.attr('maxlength'),
	                minLength = $field.attr('minlength');
	            if (maxLength) {
	                options.max = parseInt(maxLength, 10);
	            }
	            if (minLength) {
	                options.min = parseInt(minLength, 10);
	            }
	
	            return $.isEmptyObject(options) ? false : options;
	        },
	
	        /**
	         * Check if the length of element value is less or more than given number
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consists of following keys:
	         * - min
	         * - max
	         * At least one of two keys is required
	         * The min, max keys define the number which the field value compares to. min, max can be
	         *      - A number
	         *      - Name of field which its value defines the number
	         *      - Name of callback function that returns the number
	         *      - A callback function that returns the number
	         *
	         * - message: The invalid message
	         * - trim: Indicate the length will be calculated after trimming the value or not. It is false, by default
	         * - utf8bytes: Evaluate string length in UTF-8 bytes, default to false
	         * @returns {Object}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (options.trim === true || options.trim === 'true') {
	                value = $.trim(value);
	            }
	
	            if (value === '') {
	                return true;
	            }
	
	            var locale     = validator.getLocale(),
	                min        = $.isNumeric(options.min) ? options.min : validator.getDynamicOption($field, options.min),
	                max        = $.isNumeric(options.max) ? options.max : validator.getDynamicOption($field, options.max),
	                // Credit to http://stackoverflow.com/a/23329386 (@lovasoa) for UTF-8 byte length code
	                utf8Length = function(str) {
	                                 var s = str.length;
	                                 for (var i = str.length - 1; i >= 0; i--) {
	                                     var code = str.charCodeAt(i);
	                                     if (code > 0x7f && code <= 0x7ff) {
	                                         s++;
	                                     } else if (code > 0x7ff && code <= 0xffff) {
	                                         s += 2;
	                                     }
	                                     if (code >= 0xDC00 && code <= 0xDFFF) {
	                                         i--;
	                                     }
	                                 }
	                                 return s;
	                             },
	                length     = options.utf8Bytes ? utf8Length(value) : value.length,
	                isValid    = true,
	                message    = options.message || FormValidation.I18n[locale].stringLength['default'];
	
	            if ((min && length < parseInt(min, 10)) || (max && length > parseInt(max, 10))) {
	                isValid = false;
	            }
	
	            switch (true) {
	                case (!!min && !!max):
	                    message = FormValidation.Helper.format(options.message || FormValidation.I18n[locale].stringLength.between, [parseInt(min, 10), parseInt(max, 10)]);
	                    break;
	
	                case (!!min):
	                    message = FormValidation.Helper.format(options.message || FormValidation.I18n[locale].stringLength.more, parseInt(min, 10) - 1);
	                    break;
	
	                case (!!max):
	                    message = FormValidation.Helper.format(options.message || FormValidation.I18n[locale].stringLength.less, parseInt(max, 10) + 1);
	                    break;
	
	                default:
	                    break;
	            }
	
	            return {
	                valid: isValid,
	                message: message
	            };
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * zipCode validator
	 *
	 * @link        http://formvalidation.io/validators/zipCode/
	 * @author      https://twitter.com/formvalidation
	 * @copyright   (c) 2013 - 2016 Nguyen Huu Phuoc
	 * @license     http://formvalidation.io/license/
	 */
	(function($) {
	    FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
	        'en_US': {
	            zipCode: {
	                'default': 'Please enter a valid postal code',
	                country: 'Please enter a valid postal code in %s',
	                countries: {
	                    AT: 'Austria',
	                    BG: 'Bulgaria',
	                    BR: 'Brazil',
	                    CA: 'Canada',
	                    CH: 'Switzerland',
	                    CZ: 'Czech Republic',
	                    DE: 'Germany',
	                    DK: 'Denmark',
	                    ES: 'Spain',
	                    FR: 'France',
	                    GB: 'United Kingdom',
	                    IE: 'Ireland',
	                    IN: 'India',
	                    IT: 'Italy',
	                    MA: 'Morocco',
	                    NL: 'Netherlands',
	                    PL: 'Poland',
	                    PT: 'Portugal',
	                    RO: 'Romania',
	                    RU: 'Russia',
	                    SE: 'Sweden',
	                    SG: 'Singapore',
	                    SK: 'Slovakia',
	                    US: 'USA'
	                }
	            }
	        }
	    });
	
	    FormValidation.Validator.zipCode = {
	        html5Attributes: {
	            message: 'message',
	            country: 'country'
	        },
	
	        COUNTRY_CODES: ['AT', 'BG', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IN', 'IT', 'MA', 'NL', 'PL', 'PT', 'RO', 'RU', 'SE', 'SG', 'SK', 'US'],
	
	        /**
	         * Return true if and only if the input value is a valid country zip code
	         *
	         * @param {FormValidation.Base} validator The validator plugin instance
	         * @param {jQuery} $field Field element
	         * @param {Object} options Consist of key:
	         * - message: The invalid message
	         * - country: The country
	         *
	         * The country can be defined by:
	         * - An ISO 3166 country code
	         * - Name of field which its value defines the country code
	         * - Name of callback function that returns the country code
	         * - A callback function that returns the country code
	         *
	         *  callback: function(value, validator, $field) {
	         *      // value is the value of field
	         *      // validator is the FormValidation.Base instance
	         *      // $field is jQuery element representing the field
	         *  }
	         *
	         * @returns {Boolean|Object}
	         */
	        validate: function(validator, $field, options, validatorName) {
	            var value = validator.getFieldValue($field, validatorName);
	            if (value === '' || !options.country) {
	                return true;
	            }
	
	            var locale  = validator.getLocale(),
	                country = options.country;
	            if (typeof country !== 'string' || $.inArray(country, this.COUNTRY_CODES) === -1) {
	                // Try to determine the country
	                country = validator.getDynamicOption($field, country);
	            }
	
	            if (!country || $.inArray(country.toUpperCase(), this.COUNTRY_CODES) === -1) {
	                return true;
	            }
	
	            var isValid = false;
	            country = country.toUpperCase();
	            switch (country) {
	                // http://en.wikipedia.org/wiki/List_of_postal_codes_in_Austria
	                case 'AT':
	                    isValid = /^([1-9]{1})(\d{3})$/.test(value);
	                    break;
	
	                case 'BG':
	                    isValid = /^([1-9]{1}[0-9]{3})$/.test($.trim(value));
	                    break;
	
	                case 'BR':
	                    isValid = /^(\d{2})([\.]?)(\d{3})([\-]?)(\d{3})$/.test(value);
	                    break;
	
	                case 'CA':
	                    isValid = /^(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|X|Y){1}[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}\s?[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}[0-9]{1}$/i.test(value);
	                    break;
	
	                case 'CH':
	                    isValid = /^([1-9]{1})(\d{3})$/.test(value);
	                    break;
	
	                case 'CZ':
	                    // Test: http://regexr.com/39hhr
	                    isValid = /^(\d{3})([ ]?)(\d{2})$/.test(value);
	                    break;
	
	                // http://stackoverflow.com/questions/7926687/regular-expression-german-zip-codes
	                case 'DE':
	                    isValid = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/.test(value);
	                    break;
	
	                case 'DK':
	                    isValid = /^(DK(-|\s)?)?\d{4}$/i.test(value);
	                    break;
	
	                // Zip codes in Spain go from 01XXX to 52XXX.
	                // Test: http://refiddle.com/1ufo
	                case 'ES':
	                    isValid = /^(?:0[1-9]|[1-4][0-9]|5[0-2])\d{3}$/.test(value);
	                    break;
	
	                // http://en.wikipedia.org/wiki/Postal_codes_in_France
	                case 'FR':
	                    isValid = /^[0-9]{5}$/i.test(value);
	                    break;
	
	                case 'GB':
	                    isValid = this._gb(value);
	                    break;
	
	                // Indian PIN (Postal Index Number) validation
	                // http://en.wikipedia.org/wiki/Postal_Index_Number
	                // Test: http://regex101.com/r/kV0vH3/1
	                case 'IN':
	                    isValid = /^\d{3}\s?\d{3}$/.test(value);
	                    break;
	
	                // http://www.eircode.ie/docs/default-source/Common/prepare-your-business-for-eircode---published-v2.pdf?sfvrsn=2
	                // Test: http://refiddle.com/1kpl
	                case 'IE':
	                    isValid = /^(D6W|[ACDEFHKNPRTVWXY]\d{2})\s[0-9ACDEFHKNPRTVWXY]{4}$/.test(value);
	                    break;
	
	                // http://en.wikipedia.org/wiki/List_of_postal_codes_in_Italy
	                case 'IT':
	                    isValid = /^(I-|IT-)?\d{5}$/i.test(value);
	                    break;
	
	                // http://en.wikipedia.org/wiki/List_of_postal_codes_in_Morocco
	                case 'MA':
	                    isValid = /^[1-9][0-9]{4}$/i.test(value);
	                    break;
	
	                // http://en.wikipedia.org/wiki/Postal_codes_in_the_Netherlands
	                case 'NL':
	                    isValid = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(value);
	                    break;
	
	                // http://en.wikipedia.org/wiki/List_of_postal_codes_in_Poland
	                case 'PL':
	                    isValid = /^[0-9]{2}\-[0-9]{3}$/.test(value);
	                    break;
	
	                // Test: http://refiddle.com/1l2t
	                case 'PT':
	                    isValid = /^[1-9]\d{3}-\d{3}$/.test(value);
	                    break;
	
	                case 'RO':
	                    isValid = /^(0[1-8]{1}|[1-9]{1}[0-5]{1})?[0-9]{4}$/i.test(value);
	                    break;
	
	                case 'RU':
	                    isValid = /^[0-9]{6}$/i.test(value);
	                    break;
	
	                case 'SE':
	                    isValid = /^(S-)?\d{3}\s?\d{2}$/i.test(value);
	                    break;
	
	                case 'SG':
	                    isValid = /^([0][1-9]|[1-6][0-9]|[7]([0-3]|[5-9])|[8][0-2])(\d{4})$/i.test(value);
	                    break;
	
	                case 'SK':
	                    // Test: http://regexr.com/39hhr
	                    isValid = /^(\d{3})([ ]?)(\d{2})$/.test(value);
	                    break;
	
	                case 'US':
	                /* falls through */
	                default:
	                    isValid = /^\d{4,5}([\-]?\d{4})?$/.test(value);
	                    break;
	            }
	
	            return {
	                valid: isValid,
	                message: FormValidation.Helper.format(options.message || FormValidation.I18n[locale].zipCode.country, FormValidation.I18n[locale].zipCode.countries[country])
	            };
	        },
	
	        /**
	         * Validate United Kingdom postcode
	         *
	         * @see http://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom
	         * @param {String} value The postcode
	         * @returns {Boolean}
	         */
	        _gb: function(value) {
	            var firstChar  = '[ABCDEFGHIJKLMNOPRSTUWYZ]',     // Does not accept QVX
	                secondChar = '[ABCDEFGHKLMNOPQRSTUVWXY]',     // Does not accept IJZ
	                thirdChar  = '[ABCDEFGHJKPMNRSTUVWXY]',
	                fourthChar = '[ABEHMNPRVWXY]',
	                fifthChar  = '[ABDEFGHJLNPQRSTUWXYZ]',
	                regexps    = [
	                    // AN NAA, ANN NAA, AAN NAA, AANN NAA format
	                    new RegExp('^(' + firstChar + '{1}' + secondChar + '?[0-9]{1,2})(\\s*)([0-9]{1}' + fifthChar + '{2})$', 'i'),
	                    // ANA NAA
	                    new RegExp('^(' + firstChar + '{1}[0-9]{1}' + thirdChar + '{1})(\\s*)([0-9]{1}' + fifthChar + '{2})$', 'i'),
	                    // AANA NAA
	                    new RegExp('^(' + firstChar + '{1}' + secondChar + '{1}?[0-9]{1}' + fourthChar + '{1})(\\s*)([0-9]{1}' + fifthChar + '{2})$', 'i'),
	
	                    new RegExp('^(BF1)(\\s*)([0-6]{1}[ABDEFGHJLNPQRST]{1}[ABDEFGHJLNPQRSTUWZYZ]{1})$', 'i'),        // BFPO postcodes
	                    /^(GIR)(\s*)(0AA)$/i,                       // Special postcode GIR 0AA
	                    /^(BFPO)(\s*)([0-9]{1,4})$/i,               // Standard BFPO numbers
	                    /^(BFPO)(\s*)(c\/o\s*[0-9]{1,3})$/i,        // c/o BFPO numbers
	                    /^([A-Z]{4})(\s*)(1ZZ)$/i,                  // Overseas Territories
	                    /^(AI-2640)$/i                              // Anguilla
	                ];
	            for (var i = 0; i < regexps.length; i++) {
	                if (regexps[i].test(value)) {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	    };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })
]);


// WEBPACK FOOTER //
// vendor.610a1c30b90ee8a79fb8.js